// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"4M9rV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordion", ()=>(0, _accordion.Accordion));
parcelHelpers.export(exports, "AccordionContext", ()=>(0, _accordion.AccordionContext));
parcelHelpers.export(exports, "ActionButton", ()=>(0, _actionButton.ActionButton));
parcelHelpers.export(exports, "ActionButtonContext", ()=>(0, _actionButton.ActionButtonContext));
parcelHelpers.export(exports, "ActionButtonGroup", ()=>(0, _actionButtonGroup.ActionButtonGroup));
parcelHelpers.export(exports, "ActionButtonGroupContext", ()=>(0, _actionButtonGroup.ActionButtonGroupContext));
parcelHelpers.export(exports, "ActionMenu", ()=>(0, _actionMenu.ActionMenu));
parcelHelpers.export(exports, "ActionMenuContext", ()=>(0, _actionMenu.ActionMenuContext));
parcelHelpers.export(exports, "AlertDialog", ()=>(0, _alertDialog.AlertDialog));
parcelHelpers.export(exports, "Avatar", ()=>(0, _avatar.Avatar));
parcelHelpers.export(exports, "AvatarContext", ()=>(0, _avatar.AvatarContext));
parcelHelpers.export(exports, "AvatarGroup", ()=>(0, _avatarGroup.AvatarGroup));
parcelHelpers.export(exports, "AvatarGroupContext", ()=>(0, _avatarGroup.AvatarGroupContext));
parcelHelpers.export(exports, "Badge", ()=>(0, _badge.Badge));
parcelHelpers.export(exports, "BadgeContext", ()=>(0, _badge.BadgeContext));
parcelHelpers.export(exports, "Breadcrumbs", ()=>(0, _breadcrumbs.Breadcrumbs));
parcelHelpers.export(exports, "Breadcrumb", ()=>(0, _breadcrumbs.Breadcrumb));
parcelHelpers.export(exports, "BreadcrumbsContext", ()=>(0, _breadcrumbs.BreadcrumbsContext));
parcelHelpers.export(exports, "Button", ()=>(0, _button.Button));
parcelHelpers.export(exports, "LinkButton", ()=>(0, _button.LinkButton));
parcelHelpers.export(exports, "ButtonContext", ()=>(0, _button.ButtonContext));
parcelHelpers.export(exports, "LinkButtonContext", ()=>(0, _button.LinkButtonContext));
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttonGroup.ButtonGroup));
parcelHelpers.export(exports, "ButtonGroupContext", ()=>(0, _buttonGroup.ButtonGroupContext));
parcelHelpers.export(exports, "Card", ()=>(0, _card.Card));
parcelHelpers.export(exports, "CardPreview", ()=>(0, _card.CardPreview));
parcelHelpers.export(exports, "CollectionCardPreview", ()=>(0, _card.CollectionCardPreview));
parcelHelpers.export(exports, "AssetCard", ()=>(0, _card.AssetCard));
parcelHelpers.export(exports, "UserCard", ()=>(0, _card.UserCard));
parcelHelpers.export(exports, "ProductCard", ()=>(0, _card.ProductCard));
parcelHelpers.export(exports, "CardContext", ()=>(0, _card.CardContext));
parcelHelpers.export(exports, "CardView", ()=>(0, _cardView.CardView));
parcelHelpers.export(exports, "CardViewContext", ()=>(0, _cardView.CardViewContext));
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkbox.Checkbox));
parcelHelpers.export(exports, "CheckboxContext", ()=>(0, _checkbox.CheckboxContext));
parcelHelpers.export(exports, "CheckboxGroup", ()=>(0, _checkboxGroup.CheckboxGroup));
parcelHelpers.export(exports, "CheckboxGroupContext", ()=>(0, _checkboxGroup.CheckboxGroupContext));
parcelHelpers.export(exports, "CloseButton", ()=>(0, _closeButton.CloseButton));
parcelHelpers.export(exports, "ColorArea", ()=>(0, _colorArea.ColorArea));
parcelHelpers.export(exports, "ColorAreaContext", ()=>(0, _colorArea.ColorAreaContext));
parcelHelpers.export(exports, "ColorField", ()=>(0, _colorField.ColorField));
parcelHelpers.export(exports, "ColorFieldContext", ()=>(0, _colorField.ColorFieldContext));
parcelHelpers.export(exports, "ColorSlider", ()=>(0, _colorSlider.ColorSlider));
parcelHelpers.export(exports, "ColorSliderContext", ()=>(0, _colorSlider.ColorSliderContext));
parcelHelpers.export(exports, "ColorSwatch", ()=>(0, _colorSwatch.ColorSwatch));
parcelHelpers.export(exports, "ColorSwatchContext", ()=>(0, _colorSwatch.ColorSwatchContext));
parcelHelpers.export(exports, "ColorSwatchPicker", ()=>(0, _colorSwatchPicker.ColorSwatchPicker));
parcelHelpers.export(exports, "ColorSwatchPickerContext", ()=>(0, _colorSwatchPicker.ColorSwatchPickerContext));
parcelHelpers.export(exports, "ColorWheel", ()=>(0, _colorWheel.ColorWheel));
parcelHelpers.export(exports, "ColorWheelContext", ()=>(0, _colorWheel.ColorWheelContext));
parcelHelpers.export(exports, "ComboBox", ()=>(0, _comboBox.ComboBox));
parcelHelpers.export(exports, "ComboBoxItem", ()=>(0, _comboBox.ComboBoxItem));
parcelHelpers.export(exports, "ComboBoxSection", ()=>(0, _comboBox.ComboBoxSection));
parcelHelpers.export(exports, "ComboBoxContext", ()=>(0, _comboBox.ComboBoxContext));
parcelHelpers.export(exports, "ContextualHelp", ()=>(0, _contextualHelp.ContextualHelp));
parcelHelpers.export(exports, "ContextualHelpContext", ()=>(0, _contextualHelp.ContextualHelpContext));
parcelHelpers.export(exports, "DisclosureHeader", ()=>(0, _disclosure.DisclosureHeader));
parcelHelpers.export(exports, "Disclosure", ()=>(0, _disclosure.Disclosure));
parcelHelpers.export(exports, "DisclosurePanel", ()=>(0, _disclosure.DisclosurePanel));
parcelHelpers.export(exports, "DisclosureContext", ()=>(0, _disclosure.DisclosureContext));
parcelHelpers.export(exports, "DisclosureTitle", ()=>(0, _disclosure.DisclosureTitle));
parcelHelpers.export(exports, "Heading", ()=>(0, _content.Heading));
parcelHelpers.export(exports, "HeadingContext", ()=>(0, _content.HeadingContext));
parcelHelpers.export(exports, "Header", ()=>(0, _content.Header));
parcelHelpers.export(exports, "HeaderContext", ()=>(0, _content.HeaderContext));
parcelHelpers.export(exports, "Content", ()=>(0, _content.Content));
parcelHelpers.export(exports, "ContentContext", ()=>(0, _content.ContentContext));
parcelHelpers.export(exports, "Footer", ()=>(0, _content.Footer));
parcelHelpers.export(exports, "FooterContext", ()=>(0, _content.FooterContext));
parcelHelpers.export(exports, "Text", ()=>(0, _content.Text));
parcelHelpers.export(exports, "TextContext", ()=>(0, _content.TextContext));
parcelHelpers.export(exports, "Keyboard", ()=>(0, _content.Keyboard));
parcelHelpers.export(exports, "KeyboardContext", ()=>(0, _content.KeyboardContext));
parcelHelpers.export(exports, "Dialog", ()=>(0, _dialog.Dialog));
parcelHelpers.export(exports, "CustomDialog", ()=>(0, _customDialog.CustomDialog));
parcelHelpers.export(exports, "FullscreenDialog", ()=>(0, _fullscreenDialog.FullscreenDialog));
parcelHelpers.export(exports, "DialogTrigger", ()=>(0, _dialogTrigger.DialogTrigger));
parcelHelpers.export(exports, "DialogContainer", ()=>(0, _dialogContainer.DialogContainer));
parcelHelpers.export(exports, "useDialogContainer", ()=>(0, _dialogContainer.useDialogContainer));
parcelHelpers.export(exports, "Divider", ()=>(0, _divider.Divider));
parcelHelpers.export(exports, "DividerContext", ()=>(0, _divider.DividerContext));
parcelHelpers.export(exports, "DropZone", ()=>(0, _dropZone.DropZone));
parcelHelpers.export(exports, "DropZoneContext", ()=>(0, _dropZone.DropZoneContext));
parcelHelpers.export(exports, "Form", ()=>(0, _form.Form));
parcelHelpers.export(exports, "createIcon", ()=>(0, _icon.createIcon));
parcelHelpers.export(exports, "IconContext", ()=>(0, _icon.IconContext));
parcelHelpers.export(exports, "IllustrationContext", ()=>(0, _icon.IllustrationContext));
parcelHelpers.export(exports, "IllustratedMessage", ()=>(0, _illustratedMessage.IllustratedMessage));
parcelHelpers.export(exports, "IllustratedMessageContext", ()=>(0, _illustratedMessage.IllustratedMessageContext));
parcelHelpers.export(exports, "Image", ()=>(0, _image.Image));
parcelHelpers.export(exports, "ImageContext", ()=>(0, _image.ImageContext));
parcelHelpers.export(exports, "ImageCoordinator", ()=>(0, _imageCoordinator.ImageCoordinator));
parcelHelpers.export(exports, "InlineAlert", ()=>(0, _inlineAlert.InlineAlert));
parcelHelpers.export(exports, "InlineAlertContext", ()=>(0, _inlineAlert.InlineAlertContext));
parcelHelpers.export(exports, "Link", ()=>(0, _link.Link));
parcelHelpers.export(exports, "LinkContext", ()=>(0, _link.LinkContext));
parcelHelpers.export(exports, "MenuItem", ()=>(0, _menu.MenuItem));
parcelHelpers.export(exports, "MenuTrigger", ()=>(0, _menu.MenuTrigger));
parcelHelpers.export(exports, "Menu", ()=>(0, _menu.Menu));
parcelHelpers.export(exports, "MenuSection", ()=>(0, _menu.MenuSection));
parcelHelpers.export(exports, "SubmenuTrigger", ()=>(0, _menu.SubmenuTrigger));
parcelHelpers.export(exports, "MenuContext", ()=>(0, _menu.MenuContext));
parcelHelpers.export(exports, "Meter", ()=>(0, _meter.Meter));
parcelHelpers.export(exports, "MeterContext", ()=>(0, _meter.MeterContext));
parcelHelpers.export(exports, "NumberField", ()=>(0, _numberField.NumberField));
parcelHelpers.export(exports, "NumberFieldContext", ()=>(0, _numberField.NumberFieldContext));
parcelHelpers.export(exports, "Picker", ()=>(0, _picker.Picker));
parcelHelpers.export(exports, "PickerItem", ()=>(0, _picker.PickerItem));
parcelHelpers.export(exports, "PickerSection", ()=>(0, _picker.PickerSection));
parcelHelpers.export(exports, "PickerContext", ()=>(0, _picker.PickerContext));
parcelHelpers.export(exports, "Popover", ()=>(0, _popover.Popover));
parcelHelpers.export(exports, "ProgressBar", ()=>(0, _progressBar.ProgressBar));
parcelHelpers.export(exports, "ProgressBarContext", ()=>(0, _progressBar.ProgressBarContext));
parcelHelpers.export(exports, "ProgressCircle", ()=>(0, _progressCircle.ProgressCircle));
parcelHelpers.export(exports, "ProgressCircleContext", ()=>(0, _progressCircle.ProgressCircleContext));
parcelHelpers.export(exports, "Provider", ()=>(0, _provider.Provider));
parcelHelpers.export(exports, "Radio", ()=>(0, _radio.Radio));
parcelHelpers.export(exports, "RadioGroup", ()=>(0, _radioGroup.RadioGroup));
parcelHelpers.export(exports, "RadioGroupContext", ()=>(0, _radioGroup.RadioGroupContext));
parcelHelpers.export(exports, "RangeSlider", ()=>(0, _rangeSlider.RangeSlider));
parcelHelpers.export(exports, "RangeSliderContext", ()=>(0, _rangeSlider.RangeSliderContext));
parcelHelpers.export(exports, "SearchField", ()=>(0, _searchField.SearchField));
parcelHelpers.export(exports, "SearchFieldContext", ()=>(0, _searchField.SearchFieldContext));
parcelHelpers.export(exports, "SegmentedControl", ()=>(0, _segmentedControl.SegmentedControl));
parcelHelpers.export(exports, "SegmentedControlItem", ()=>(0, _segmentedControl.SegmentedControlItem));
parcelHelpers.export(exports, "SegmentedControlContext", ()=>(0, _segmentedControl.SegmentedControlContext));
parcelHelpers.export(exports, "Slider", ()=>(0, _slider.Slider));
parcelHelpers.export(exports, "SliderContext", ()=>(0, _slider.SliderContext));
parcelHelpers.export(exports, "Skeleton", ()=>(0, _skeleton.Skeleton));
parcelHelpers.export(exports, "useIsSkeleton", ()=>(0, _skeleton.useIsSkeleton));
parcelHelpers.export(exports, "SkeletonCollection", ()=>(0, _skeletonCollection.SkeletonCollection));
parcelHelpers.export(exports, "StatusLight", ()=>(0, _statusLight.StatusLight));
parcelHelpers.export(exports, "StatusLightContext", ()=>(0, _statusLight.StatusLightContext));
parcelHelpers.export(exports, "Switch", ()=>(0, _switch.Switch));
parcelHelpers.export(exports, "SwitchContext", ()=>(0, _switch.SwitchContext));
parcelHelpers.export(exports, "TableView", ()=>(0, _tableView.TableView));
parcelHelpers.export(exports, "TableHeader", ()=>(0, _tableView.TableHeader));
parcelHelpers.export(exports, "TableBody", ()=>(0, _tableView.TableBody));
parcelHelpers.export(exports, "Row", ()=>(0, _tableView.Row));
parcelHelpers.export(exports, "Cell", ()=>(0, _tableView.Cell));
parcelHelpers.export(exports, "Column", ()=>(0, _tableView.Column));
parcelHelpers.export(exports, "TableContext", ()=>(0, _tableView.TableContext));
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabs.Tabs));
parcelHelpers.export(exports, "TabList", ()=>(0, _tabs.TabList));
parcelHelpers.export(exports, "Tab", ()=>(0, _tabs.Tab));
parcelHelpers.export(exports, "TabPanel", ()=>(0, _tabs.TabPanel));
parcelHelpers.export(exports, "TabsContext", ()=>(0, _tabs.TabsContext));
parcelHelpers.export(exports, "TagGroup", ()=>(0, _tagGroup.TagGroup));
parcelHelpers.export(exports, "Tag", ()=>(0, _tagGroup.Tag));
parcelHelpers.export(exports, "TagGroupContext", ()=>(0, _tagGroup.TagGroupContext));
parcelHelpers.export(exports, "TextArea", ()=>(0, _textField.TextArea));
parcelHelpers.export(exports, "TextField", ()=>(0, _textField.TextField));
parcelHelpers.export(exports, "TextAreaContext", ()=>(0, _textField.TextAreaContext));
parcelHelpers.export(exports, "TextFieldContext", ()=>(0, _textField.TextFieldContext));
parcelHelpers.export(exports, "ToggleButton", ()=>(0, _toggleButton.ToggleButton));
parcelHelpers.export(exports, "ToggleButtonContext", ()=>(0, _toggleButton.ToggleButtonContext));
parcelHelpers.export(exports, "ToggleButtonGroup", ()=>(0, _toggleButtonGroup.ToggleButtonGroup));
parcelHelpers.export(exports, "ToggleButtonGroupContext", ()=>(0, _toggleButtonGroup.ToggleButtonGroupContext));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltip.Tooltip));
parcelHelpers.export(exports, "TooltipTrigger", ()=>(0, _tooltip.TooltipTrigger));
parcelHelpers.export(exports, "pressScale", ()=>(0, _pressScale.pressScale));
parcelHelpers.export(exports, "Collection", ()=>(0, _reactAriaComponents.Collection));
parcelHelpers.export(exports, "FileTrigger", ()=>(0, _reactAriaComponents.FileTrigger));
var _accordion = require("./Accordion");
var _actionButton = require("./ActionButton");
var _actionButtonGroup = require("./ActionButtonGroup");
var _actionMenu = require("./ActionMenu");
var _alertDialog = require("./AlertDialog");
var _avatar = require("./Avatar");
var _avatarGroup = require("./AvatarGroup");
var _badge = require("./Badge");
var _breadcrumbs = require("./Breadcrumbs");
var _button = require("./Button");
var _buttonGroup = require("./ButtonGroup");
var _card = require("./Card");
var _cardView = require("./CardView");
var _checkbox = require("./Checkbox");
var _checkboxGroup = require("./CheckboxGroup");
var _closeButton = require("./CloseButton");
var _colorArea = require("./ColorArea");
var _colorField = require("./ColorField");
var _colorSlider = require("./ColorSlider");
var _colorSwatch = require("./ColorSwatch");
var _colorSwatchPicker = require("./ColorSwatchPicker");
var _colorWheel = require("./ColorWheel");
var _comboBox = require("./ComboBox");
var _contextualHelp = require("./ContextualHelp");
var _disclosure = require("./Disclosure");
var _content = require("./Content");
var _dialog = require("./Dialog");
var _customDialog = require("./CustomDialog");
var _fullscreenDialog = require("./FullscreenDialog");
var _dialogTrigger = require("./DialogTrigger");
var _dialogContainer = require("./DialogContainer");
var _divider = require("./Divider");
var _dropZone = require("./DropZone");
var _form = require("./Form");
var _icon = require("./Icon");
var _illustratedMessage = require("./IllustratedMessage");
var _image = require("./Image");
var _imageCoordinator = require("./ImageCoordinator");
var _inlineAlert = require("./InlineAlert");
var _link = require("./Link");
var _menu = require("./Menu");
var _meter = require("./Meter");
var _numberField = require("./NumberField");
var _picker = require("./Picker");
var _popover = require("./Popover");
var _progressBar = require("./ProgressBar");
var _progressCircle = require("./ProgressCircle");
var _provider = require("./Provider");
var _radio = require("./Radio");
var _radioGroup = require("./RadioGroup");
var _rangeSlider = require("./RangeSlider");
var _searchField = require("./SearchField");
var _segmentedControl = require("./SegmentedControl");
var _slider = require("./Slider");
var _skeleton = require("./Skeleton");
var _skeletonCollection = require("./SkeletonCollection");
var _statusLight = require("./StatusLight");
var _switch = require("./Switch");
var _tableView = require("./TableView");
var _tabs = require("./Tabs");
var _tagGroup = require("./TagGroup");
var _textField = require("./TextField");
var _toggleButton = require("./ToggleButton");
var _toggleButtonGroup = require("./ToggleButtonGroup");
var _tooltip = require("./Tooltip");
var _pressScale = require("./pressScale");
var _reactAriaComponents = require("react-aria-components");
try {
    // @ts-ignore
    _Accordion.displayName = "_Accordion";
    // @ts-ignore
    _Accordion.__docgenInfo = {
        "description": "An accordion is a container for multiple disclosures.",
        "displayName": "_Accordion",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The disclosure elements in the accordion.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "allowsMultipleExpanded": {
                "defaultValue": null,
                "description": "Whether multiple items can be expanded at the same time.",
                "name": "allowsMultipleExpanded",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "defaultExpandedKeys": {
                "defaultValue": null,
                "description": "The initial expanded keys in the group (uncontrolled).",
                "name": "defaultExpandedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of space between the disclosure items.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "expandedKeys": {
                "defaultValue": null,
                "description": "The currently expanded keys in the group (controlled).",
                "name": "expandedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether all items are disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the accordion should be displayed with a quiet style.",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the accordion.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onExpandedChange": {
                "defaultValue": null,
                "description": "Handler that is called when items are expanded or collapsed.",
                "name": "onExpandedChange",
                "required": false,
                "type": {
                    "name": "((keys: Set<Key>) => any)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Accordion"] = {
        docgenInfo: _Accordion.__docgenInfo,
        name: "_Accordion",
        path: "packages/@react-spectrum/s2/src/index.ts#_Accordion"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ActionButton.displayName = "_ActionButton";
    // @ts-ignore
    _ActionButton.__docgenInfo = {
        "description": "ActionButtons allow users to perform an action.\nThey\u2019re used for similar, task-based options within a workflow, and are ideal for interfaces where buttons aren\u2019t meant to draw a lot of attention.",
        "displayName": "_ActionButton",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The content to display in the ActionButton.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "form": {
                "defaultValue": null,
                "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.",
                "name": "form",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formAction": {
                "defaultValue": null,
                "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
                "name": "formAction",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formEncType": {
                "defaultValue": null,
                "description": "Indicates how to encode the form data that is submitted.",
                "name": "formEncType",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formMethod": {
                "defaultValue": null,
                "description": "Indicates the HTTP method used to submit the form.",
                "name": "formMethod",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formNoValidate": {
                "defaultValue": null,
                "description": "Indicates that the form is not to be validated when it is submitted.",
                "name": "formNoValidate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "formTarget": {
                "defaultValue": null,
                "description": "Overrides the target attribute of the button's form owner.",
                "name": "formTarget",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the button is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "Submitted as a pair with the button's value as part of the form data.",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "preventFocusOnPress": {
                "defaultValue": null,
                "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
                "name": "preventFocusOnPress",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ActionButton.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the ActionButton appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "type": {
                "defaultValue": {
                    value: "'button'"
                },
                "description": "The behavior of the button when used in an HTML form.",
                "name": "type",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"button\""
                        },
                        {
                            "value": "\"submit\""
                        },
                        {
                            "value": "\"reset\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The value associated with the button's name when it's submitted with the form data.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onPress": {
                "defaultValue": null,
                "description": "Handler that is called when the press is released over the target.",
                "name": "onPress",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressChange": {
                "defaultValue": null,
                "description": "Handler that is called when the press state changes.",
                "name": "onPressChange",
                "required": false,
                "type": {
                    "name": "((isPressed: boolean) => void)"
                }
            },
            "onPressEnd": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
                "name": "onPressEnd",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressStart": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction starts.",
                "name": "onPressStart",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressUp": {
                "defaultValue": null,
                "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
                "name": "onPressUp",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ActionButton"] = {
        docgenInfo: _ActionButton.__docgenInfo,
        name: "_ActionButton",
        path: "packages/@react-spectrum/s2/src/index.ts#_ActionButton"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ActionButtonGroup.displayName = "_ActionButtonGroup";
    // @ts-ignore
    _ActionButtonGroup.__docgenInfo = {
        "description": "An ActionButtonGroup is a grouping of related ActionButtons.",
        "displayName": "_ActionButtonGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the group.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "density": {
                "defaultValue": {
                    value: "\"regular\""
                },
                "description": "Spacing between the buttons.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the group is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isJustified": {
                "defaultValue": null,
                "description": "Whether the buttons should divide the container width equally.",
                "name": "isJustified",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'horizontal'"
                },
                "description": "The axis the group should align with.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "\"M\""
                },
                "description": "Size of the buttons.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<HTMLDivElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ActionButtonGroup"] = {
        docgenInfo: _ActionButtonGroup.__docgenInfo,
        name: "_ActionButtonGroup",
        path: "packages/@react-spectrum/s2/src/index.ts#_ActionButtonGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ActionMenu.displayName = "_ActionMenu";
    // @ts-ignore
    _ActionMenu.__docgenInfo = {
        "description": "ActionMenu combines an ActionButton with a Menu for simple \"more actions\" use cases.",
        "displayName": "_ActionMenu",
        "props": {
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "Alignment of the menu relative to the trigger.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "direction": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "Where the Menu opens relative to its trigger.",
                "name": "direction",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the button is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "menuSize": {
                "defaultValue": null,
                "description": "",
                "name": "menuSize",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the menu should automatically flip direction when space is limited.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ActionButton.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when an item is selected.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ActionMenu"] = {
        docgenInfo: _ActionMenu.__docgenInfo,
        name: "_ActionMenu",
        path: "packages/@react-spectrum/s2/src/index.ts#_ActionMenu"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _AlertDialog.displayName = "_AlertDialog";
    // @ts-ignore
    _AlertDialog.__docgenInfo = {
        "description": "AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.",
        "displayName": "_AlertDialog",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the AlertDialog.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "primaryActionLabel": {
                "defaultValue": null,
                "description": "The label to display within the confirm button.",
                "name": "primaryActionLabel",
                "required": true,
                "type": {
                    "name": "string"
                }
            },
            "title": {
                "defaultValue": null,
                "description": "The title of the AlertDialog.",
                "name": "title",
                "required": true,
                "type": {
                    "name": "string"
                }
            },
            "autoFocusButton": {
                "defaultValue": null,
                "description": "Button to focus by default when the dialog opens.",
                "name": "autoFocusButton",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"cancel\""
                        }
                    ]
                }
            },
            "cancelLabel": {
                "defaultValue": null,
                "description": "The label to display within the cancel button.",
                "name": "cancelLabel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isPrimaryActionDisabled": {
                "defaultValue": null,
                "description": "Whether the primary button is disabled.",
                "name": "isPrimaryActionDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isSecondaryActionDisabled": {
                "defaultValue": null,
                "description": "Whether the secondary button is disabled.",
                "name": "isSecondaryActionDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "secondaryActionLabel": {
                "defaultValue": null,
                "description": "The label to display within the secondary button.",
                "name": "secondaryActionLabel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Dialog.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": null,
                "description": "The [visual style](https://spectrum.adobe.com/page/alert-dialog/#Options) of the AlertDialog.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"confirmation\""
                        },
                        {
                            "value": "\"information\""
                        },
                        {
                            "value": "\"destructive\""
                        },
                        {
                            "value": "\"error\""
                        },
                        {
                            "value": "\"warning\""
                        }
                    ]
                }
            },
            "onCancel": {
                "defaultValue": null,
                "description": "Handler that is called when the cancel button is pressed.",
                "name": "onCancel",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onPrimaryAction": {
                "defaultValue": null,
                "description": "Handler that is called when the primary button is pressed.",
                "name": "onPrimaryAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onSecondaryAction": {
                "defaultValue": null,
                "description": "Handler that is called when the secondary button is pressed.",
                "name": "onSecondaryAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_AlertDialog"] = {
        docgenInfo: _AlertDialog.__docgenInfo,
        name: "_AlertDialog",
        path: "packages/@react-spectrum/s2/src/index.ts#_AlertDialog"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Avatar.displayName = "_Avatar";
    // @ts-ignore
    _Avatar.__docgenInfo = {
        "description": "An avatar is a thumbnail representation of an entity, such as a user or an organization.",
        "displayName": "_Avatar",
        "props": {
            "alt": {
                "defaultValue": null,
                "description": "Text description of the avatar.",
                "name": "alt",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isOverBackground": {
                "defaultValue": null,
                "description": "Whether the avatar is over a color background.",
                "name": "isOverBackground",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "24"
                },
                "description": "The size of the avatar.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "16 | 20 | 24 | 28 | 32 | 36 | 40 | 44 | 48 | 56 | 64 | 80 | 96 | 112 | (number & {})"
                }
            },
            "src": {
                "defaultValue": null,
                "description": "The image URL for the avatar.",
                "name": "src",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithoutWidth"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLImageElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Avatar"] = {
        docgenInfo: _Avatar.__docgenInfo,
        name: "_Avatar",
        path: "packages/@react-spectrum/s2/src/index.ts#_Avatar"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _AvatarGroup.displayName = "_AvatarGroup";
    // @ts-ignore
    _AvatarGroup.__docgenInfo = {
        "description": "An avatar group is a grouping of avatars that are related to each other.",
        "displayName": "_AvatarGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Avatar children of the avatar group.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The label for the avatar group.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "24"
                },
                "description": "The size of the avatar group.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "16"
                        },
                        {
                            "value": "20"
                        },
                        {
                            "value": "24"
                        },
                        {
                            "value": "28"
                        },
                        {
                            "value": "32"
                        },
                        {
                            "value": "36"
                        },
                        {
                            "value": "40"
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithoutWidth"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_AvatarGroup"] = {
        docgenInfo: _AvatarGroup.__docgenInfo,
        name: "_AvatarGroup",
        path: "packages/@react-spectrum/s2/src/index.ts#_AvatarGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Badge.displayName = "_Badge";
    // @ts-ignore
    _Badge.__docgenInfo = {
        "description": "Badges are used for showing a small amount of color-categorized metadata, ideal for getting a user's attention.",
        "displayName": "_Badge",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the badge.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "fillStyle": {
                "defaultValue": {
                    value: "'bold'"
                },
                "description": "The fill of the badge.",
                "name": "fillStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"outline\""
                        },
                        {
                            "value": "\"bold\""
                        },
                        {
                            "value": "\"subtle\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'S'"
                },
                "description": "The size of the badge.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'neutral'"
                },
                "description": "The variant changes the background color of the badge. When badge has a semantic meaning, they should use the variant for semantic colors.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"red\""
                        },
                        {
                            "value": "\"green\""
                        },
                        {
                            "value": "\"blue\""
                        },
                        {
                            "value": "\"accent\""
                        },
                        {
                            "value": "\"negative\""
                        },
                        {
                            "value": "\"informative\""
                        },
                        {
                            "value": "\"neutral\""
                        },
                        {
                            "value": "\"positive\""
                        },
                        {
                            "value": "\"notice\""
                        },
                        {
                            "value": "\"gray\""
                        },
                        {
                            "value": "\"orange\""
                        },
                        {
                            "value": "\"yellow\""
                        },
                        {
                            "value": "\"charteuse\""
                        },
                        {
                            "value": "\"celery\""
                        },
                        {
                            "value": "\"seafoam\""
                        },
                        {
                            "value": "\"cyan\""
                        },
                        {
                            "value": "\"indigo\""
                        },
                        {
                            "value": "\"purple\""
                        },
                        {
                            "value": "\"fuchsia\""
                        },
                        {
                            "value": "\"magenta\""
                        },
                        {
                            "value": "\"pink\""
                        },
                        {
                            "value": "\"turquoise\""
                        },
                        {
                            "value": "\"brown\""
                        },
                        {
                            "value": "\"cinnamon\""
                        },
                        {
                            "value": "\"silver\""
                        }
                    ]
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Badge"] = {
        docgenInfo: _Badge.__docgenInfo,
        name: "_Badge",
        path: "packages/@react-spectrum/s2/src/index.ts#_Badge"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Breadcrumbs.displayName = "_Breadcrumbs";
    // @ts-ignore
    _Breadcrumbs.__docgenInfo = {
        "description": "Breadcrumbs show hierarchy and navigational context for a user\u2019s location within an application.",
        "displayName": "_Breadcrumbs",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the Breadcrumbs.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the breadcrumbs are disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "Size of the Breadcrumbs including spacing and layout.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a breadcrumb is clicked.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLOListElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Breadcrumbs"] = {
        docgenInfo: _Breadcrumbs.__docgenInfo,
        name: "_Breadcrumbs",
        path: "packages/@react-spectrum/s2/src/index.ts#_Breadcrumbs"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Button.displayName = "_Button";
    // @ts-ignore
    _Button.__docgenInfo = {
        "description": "Buttons allow users to perform an action.\nThey have multiple styles for various needs, and are ideal for calling attention to\nwhere a user needs to do something in order to move forward in a flow.",
        "displayName": "_Button",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The content to display in the Button.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "fillStyle": {
                "defaultValue": {
                    value: "'fill'"
                },
                "description": "The background style of the Button.",
                "name": "fillStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"fill\""
                        },
                        {
                            "value": "\"outline\""
                        }
                    ]
                }
            },
            "form": {
                "defaultValue": null,
                "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.",
                "name": "form",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formAction": {
                "defaultValue": null,
                "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
                "name": "formAction",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formEncType": {
                "defaultValue": null,
                "description": "Indicates how to encode the form data that is submitted.",
                "name": "formEncType",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formMethod": {
                "defaultValue": null,
                "description": "Indicates the HTTP method used to submit the form.",
                "name": "formMethod",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formNoValidate": {
                "defaultValue": null,
                "description": "Indicates that the form is not to be validated when it is submitted.",
                "name": "formNoValidate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "formTarget": {
                "defaultValue": null,
                "description": "Overrides the target attribute of the button's form owner.",
                "name": "formTarget",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the button is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isPending": {
                "defaultValue": null,
                "description": "Whether the button is in a pending state. This disables press and hover events\nwhile retaining focusability, and announces the pending state to screen readers.",
                "name": "isPending",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "Submitted as a pair with the button's value as part of the form data.",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "preventFocusOnPress": {
                "defaultValue": null,
                "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
                "name": "preventFocusOnPress",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Button.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the Button appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "type": {
                "defaultValue": {
                    value: "'button'"
                },
                "description": "The behavior of the button when used in an HTML form.",
                "name": "type",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"button\""
                        },
                        {
                            "value": "\"submit\""
                        },
                        {
                            "value": "\"reset\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The value associated with the button's name when it's submitted with the form data.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The [visual style](https://spectrum.adobe.com/page/button/#Options) of the button.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"accent\""
                        },
                        {
                            "value": "\"negative\""
                        }
                    ]
                }
            },
            "onPress": {
                "defaultValue": null,
                "description": "Handler that is called when the press is released over the target.",
                "name": "onPress",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressChange": {
                "defaultValue": null,
                "description": "Handler that is called when the press state changes.",
                "name": "onPressChange",
                "required": false,
                "type": {
                    "name": "((isPressed: boolean) => void)"
                }
            },
            "onPressEnd": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
                "name": "onPressEnd",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressStart": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction starts.",
                "name": "onPressStart",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressUp": {
                "defaultValue": null,
                "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
                "name": "onPressUp",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Button"] = {
        docgenInfo: _Button.__docgenInfo,
        name: "_Button",
        path: "packages/@react-spectrum/s2/src/index.ts#_Button"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _LinkButton.displayName = "_LinkButton";
    // @ts-ignore
    _LinkButton.__docgenInfo = {
        "description": "A LinkButton combines the functionality of a link with the appearance of a button. Useful for allowing users to navigate to another page.",
        "displayName": "_LinkButton",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The content to display in the Button.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "fillStyle": {
                "defaultValue": {
                    value: "'fill'"
                },
                "description": "The background style of the Button.",
                "name": "fillStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"fill\""
                        },
                        {
                            "value": "\"outline\""
                        }
                    ]
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the link is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Button.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the Button appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The [visual style](https://spectrum.adobe.com/page/button/#Options) of the button.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"accent\""
                        },
                        {
                            "value": "\"negative\""
                        }
                    ]
                }
            },
            "onPress": {
                "defaultValue": null,
                "description": "Handler that is called when the press is released over the target.",
                "name": "onPress",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressChange": {
                "defaultValue": null,
                "description": "Handler that is called when the press state changes.",
                "name": "onPressChange",
                "required": false,
                "type": {
                    "name": "((isPressed: boolean) => void)"
                }
            },
            "onPressEnd": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
                "name": "onPressEnd",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressStart": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction starts.",
                "name": "onPressStart",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressUp": {
                "defaultValue": null,
                "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
                "name": "onPressUp",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLAnchorElement, HTMLAnchorElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_LinkButton"] = {
        docgenInfo: _LinkButton.__docgenInfo,
        name: "_LinkButton",
        path: "packages/@react-spectrum/s2/src/index.ts#_LinkButton"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ButtonGroup.displayName = "_ButtonGroup";
    // @ts-ignore
    _ButtonGroup.__docgenInfo = {
        "description": "ButtonGroup handles overflow for a grouping of buttons whose actions are related to each other.",
        "displayName": "_ButtonGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The Buttons contained within the ButtonGroup.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The alignment of the Buttons within the ButtonGroup.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"center\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the Buttons in the ButtonGroup are all disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'horizontal'"
                },
                "description": "The axis the ButtonGroup should align with. Setting this to 'vertical' will prevent\nany switching behaviors between 'vertical' and 'horizontal'.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Buttons within the ButtonGroup.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ButtonGroup"] = {
        docgenInfo: _ButtonGroup.__docgenInfo,
        name: "_ButtonGroup",
        path: "packages/@react-spectrum/s2/src/index.ts#_ButtonGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    Card.displayName = "Card";
    // @ts-ignore
    Card.__docgenInfo = {
        "description": "",
        "displayName": "Card",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the Card.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode | ((renderProps: CardRenderProps) => ReactNode)"
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of internal padding within the Card.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Card.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The visual style of the Card.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"tertiary\""
                        },
                        {
                            "value": "\"quiet\""
                        }
                    ]
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#Card"] = {
        docgenInfo: Card.__docgenInfo,
        name: "Card",
        path: "packages/@react-spectrum/s2/src/index.ts#Card"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    CardPreview.displayName = "CardPreview";
    // @ts-ignore
    CardPreview.__docgenInfo = {
        "description": "",
        "displayName": "CardPreview",
        "props": {
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#CardPreview"] = {
        docgenInfo: CardPreview.__docgenInfo,
        name: "CardPreview",
        path: "packages/@react-spectrum/s2/src/index.ts#CardPreview"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    CollectionCardPreview.displayName = "CollectionCardPreview";
    // @ts-ignore
    CollectionCardPreview.__docgenInfo = {
        "description": "",
        "displayName": "CollectionCardPreview",
        "props": {
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#CollectionCardPreview"] = {
        docgenInfo: CollectionCardPreview.__docgenInfo,
        name: "CollectionCardPreview",
        path: "packages/@react-spectrum/s2/src/index.ts#CollectionCardPreview"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    AssetCard.displayName = "AssetCard";
    // @ts-ignore
    AssetCard.__docgenInfo = {
        "description": "",
        "displayName": "AssetCard",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the Card.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode | ((renderProps: CardRenderProps) => ReactNode)"
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Card.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The visual style of the Card.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"tertiary\""
                        },
                        {
                            "value": "\"quiet\""
                        }
                    ]
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#AssetCard"] = {
        docgenInfo: AssetCard.__docgenInfo,
        name: "AssetCard",
        path: "packages/@react-spectrum/s2/src/index.ts#AssetCard"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    UserCard.displayName = "UserCard";
    // @ts-ignore
    UserCard.__docgenInfo = {
        "description": "",
        "displayName": "UserCard",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the Card.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode | ((renderProps: CardRenderProps) => ReactNode)"
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of internal padding within the Card.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Card.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The visual style of the Card.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"tertiary\""
                        },
                        {
                            "value": "\"quiet\""
                        }
                    ]
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#UserCard"] = {
        docgenInfo: UserCard.__docgenInfo,
        name: "UserCard",
        path: "packages/@react-spectrum/s2/src/index.ts#UserCard"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    ProductCard.displayName = "ProductCard";
    // @ts-ignore
    ProductCard.__docgenInfo = {
        "description": "",
        "displayName": "ProductCard",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the Card.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode | ((renderProps: CardRenderProps) => ReactNode)"
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Card.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "variant": {
                "defaultValue": null,
                "description": "",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"tertiary\""
                        }
                    ]
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#ProductCard"] = {
        docgenInfo: ProductCard.__docgenInfo,
        name: "ProductCard",
        path: "packages/@react-spectrum/s2/src/index.ts#ProductCard"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _CardView.displayName = "_CardView";
    // @ts-ignore
    _CardView.__docgenInfo = {
        "description": "",
        "displayName": "_CardView",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of space between the cards.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "disabledBehavior": {
                "defaultValue": null,
                "description": "Whether `disabledKeys` applies to all interactions, or only selection.",
                "name": "disabledBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"all\""
                        },
                        {
                            "value": "\"selection\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "dragAndDropHooks": {
                "defaultValue": null,
                "description": "The drag and drop hooks returned by `useDragAndDrop` used to enable drag and drop behavior for the GridList.",
                "name": "dragAndDropHooks",
                "required": false,
                "type": {
                    "name": "DragAndDropHooks"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "layout": {
                "defaultValue": {
                    value: "'grid'"
                },
                "description": "The layout of the cards.",
                "name": "layout",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"grid\""
                        },
                        {
                            "value": "\"waterfall\""
                        }
                    ]
                }
            },
            "loadingState": {
                "defaultValue": null,
                "description": "The loading state of the CardView.",
                "name": "loadingState",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"error\""
                        },
                        {
                            "value": "\"loading\""
                        },
                        {
                            "value": "\"sorting\""
                        },
                        {
                            "value": "\"loadingMore\""
                        },
                        {
                            "value": "\"idle\""
                        },
                        {
                            "value": "\"filtering\""
                        }
                    ]
                }
            },
            "renderEmptyState": {
                "defaultValue": null,
                "description": "Provides content to display when there are no items in the list.",
                "name": "renderEmptyState",
                "required": false,
                "type": {
                    "name": "((props: GridListRenderProps) => ReactNode)"
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "The type of selection that is allowed in the collection.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "selectionStyle": {
                "defaultValue": {
                    value: "'checkbox'"
                },
                "description": "How selection should be displayed.",
                "name": "selectionStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"checkbox\""
                        },
                        {
                            "value": "\"highlight\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the cards.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The visual style of the cards.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"tertiary\""
                        },
                        {
                            "value": "\"quiet\""
                        }
                    ]
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on an item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "onLoadMore": {
                "defaultValue": null,
                "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
                "name": "onLoadMore",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Selection) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_CardView"] = {
        docgenInfo: _CardView.__docgenInfo,
        name: "_CardView",
        path: "packages/@react-spectrum/s2/src/index.ts#_CardView"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Checkbox.displayName = "_Checkbox";
    // @ts-ignore
    _Checkbox.__docgenInfo = {
        "description": "Checkboxes allow users to select multiple items from a list of individual items,\nor to mark one individual item as selected.",
        "displayName": "_Checkbox",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The label for the element.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelected": {
                "defaultValue": null,
                "description": "Whether the element should be selected (uncontrolled).",
                "name": "defaultSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inputRef": {
                "defaultValue": null,
                "description": "A ref for the HTML input element.",
                "name": "inputRef",
                "required": false,
                "type": {
                    "name": "RefObject<HTMLInputElement | null>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Checkbox should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isIndeterminate": {
                "defaultValue": null,
                "description": "Indeterminism is presentational only.\nThe indeterminate visual representation remains regardless of user interaction.",
                "name": "isIndeterminate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isSelected": {
                "defaultValue": null,
                "description": "Whether the element should be selected (controlled).",
                "name": "isSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Checkbox.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: boolean) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the element's selection state changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((isSelected: boolean) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLLabelElement, HTMLLabelElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Checkbox"] = {
        docgenInfo: _Checkbox.__docgenInfo,
        name: "_Checkbox",
        path: "packages/@react-spectrum/s2/src/index.ts#_Checkbox"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _CheckboxGroup.displayName = "_CheckboxGroup";
    // @ts-ignore
    _CheckboxGroup.__docgenInfo = {
        "description": "A CheckboxGroup allows users to select one or more items from a list of choices.",
        "displayName": "_CheckboxGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The Checkboxes contained within the CheckboxGroup.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string[]"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "By default, checkboxes are not emphasized (gray).\nThe emphasized (blue) version provides visual prominence.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'vertical'"
                },
                "description": "The axis the checkboxes should align with.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Checkboxes in the CheckboxGroup.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: string[]) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string[]"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: string[]) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_CheckboxGroup"] = {
        docgenInfo: _CheckboxGroup.__docgenInfo,
        name: "_CheckboxGroup",
        path: "packages/@react-spectrum/s2/src/index.ts#_CheckboxGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _CloseButton.displayName = "_CloseButton";
    // @ts-ignore
    _CloseButton.__docgenInfo = {
        "description": "A CloseButton allows a user to dismiss a dialog.",
        "displayName": "_CloseButton",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the button is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the CloseButton.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the Button appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_CloseButton"] = {
        docgenInfo: _CloseButton.__docgenInfo,
        name: "_CloseButton",
        path: "packages/@react-spectrum/s2/src/index.ts#_CloseButton"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ColorArea.displayName = "_ColorArea";
    // @ts-ignore
    _ColorArea.__docgenInfo = {
        "description": "A ColorArea allows users to adjust two channels of an RGB, HSL or HSB color value against a two-dimensional gradient background.",
        "displayName": "_ColorArea",
        "props": {
            "colorSpace": {
                "defaultValue": null,
                "description": "The color space that the color area operates in. The `xChannel` and `yChannel` must be in this color space.\nIf not provided, this defaults to the color space of the `color` or `defaultColor` value.",
                "name": "colorSpace",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"rgb\""
                        },
                        {
                            "value": "\"hsl\""
                        },
                        {
                            "value": "\"hsb\""
                        }
                    ]
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string | Color"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the ColorArea is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string | Color"
                }
            },
            "xChannel": {
                "defaultValue": null,
                "description": "Color channel for the horizontal axis.",
                "name": "xChannel",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"hue\""
                        },
                        {
                            "value": "\"saturation\""
                        },
                        {
                            "value": "\"brightness\""
                        },
                        {
                            "value": "\"lightness\""
                        },
                        {
                            "value": "\"red\""
                        },
                        {
                            "value": "\"green\""
                        },
                        {
                            "value": "\"blue\""
                        },
                        {
                            "value": "\"alpha\""
                        }
                    ]
                }
            },
            "xName": {
                "defaultValue": null,
                "description": "The name of the x channel input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "xName",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "yChannel": {
                "defaultValue": null,
                "description": "Color channel for the vertical axis.",
                "name": "yChannel",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"hue\""
                        },
                        {
                            "value": "\"saturation\""
                        },
                        {
                            "value": "\"brightness\""
                        },
                        {
                            "value": "\"lightness\""
                        },
                        {
                            "value": "\"red\""
                        },
                        {
                            "value": "\"green\""
                        },
                        {
                            "value": "\"blue\""
                        },
                        {
                            "value": "\"alpha\""
                        }
                    ]
                }
            },
            "yName": {
                "defaultValue": null,
                "description": "The name of the y channel input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "yName",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes, as the user drags.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: Color) => void)"
                }
            },
            "onChangeEnd": {
                "defaultValue": null,
                "description": "Handler that is called when the user stops dragging.",
                "name": "onChangeEnd",
                "required": false,
                "type": {
                    "name": "((value: Color) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ColorArea"] = {
        docgenInfo: _ColorArea.__docgenInfo,
        name: "_ColorArea",
        path: "packages/@react-spectrum/s2/src/index.ts#_ColorArea"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ColorField.displayName = "_ColorField";
    // @ts-ignore
    _ColorField.__docgenInfo = {
        "description": "A color field allows users to edit a hex color or individual color channel value.",
        "displayName": "_ColorField",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "channel": {
                "defaultValue": null,
                "description": "The color channel that this field edits. If not provided, \nthe color is edited as a hex value.",
                "name": "channel",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"hue\""
                        },
                        {
                            "value": "\"saturation\""
                        },
                        {
                            "value": "\"brightness\""
                        },
                        {
                            "value": "\"lightness\""
                        },
                        {
                            "value": "\"red\""
                        },
                        {
                            "value": "\"green\""
                        },
                        {
                            "value": "\"blue\""
                        },
                        {
                            "value": "\"alpha\""
                        }
                    ]
                }
            },
            "colorSpace": {
                "defaultValue": null,
                "description": "The color space that the color field operates in if a `channel` prop is provided.\nIf no `channel` is provided, the color field always displays the color as an RGB hex value.",
                "name": "colorSpace",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"rgb\""
                        },
                        {
                            "value": "\"hsl\""
                        },
                        {
                            "value": "\"hsb\""
                        }
                    ]
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string | Color | null"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isWheelDisabled": {
                "defaultValue": null,
                "description": "Enables or disables changing the value with scroll.",
                "name": "isWheelDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the color field.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: Color | null) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string | Color | null"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((color: Color | null) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ColorField"] = {
        docgenInfo: _ColorField.__docgenInfo,
        name: "_ColorField",
        path: "packages/@react-spectrum/s2/src/index.ts#_ColorField"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ColorSlider.displayName = "_ColorSlider";
    // @ts-ignore
    _ColorSlider.__docgenInfo = {
        "description": "A ColorSlider allows users to adjust an individual channel of a color value.",
        "displayName": "_ColorSlider",
        "props": {
            "channel": {
                "defaultValue": null,
                "description": "The color channel that the slider manipulates.",
                "name": "channel",
                "required": true,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"hue\""
                        },
                        {
                            "value": "\"saturation\""
                        },
                        {
                            "value": "\"brightness\""
                        },
                        {
                            "value": "\"lightness\""
                        },
                        {
                            "value": "\"red\""
                        },
                        {
                            "value": "\"green\""
                        },
                        {
                            "value": "\"blue\""
                        },
                        {
                            "value": "\"alpha\""
                        }
                    ]
                }
            },
            "colorSpace": {
                "defaultValue": null,
                "description": "The color space that the slider operates in. The `channel` must be in this color space.\nIf not provided, this defaults to the color space of the `color` or `defaultColor` value.",
                "name": "colorSpace",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"rgb\""
                        },
                        {
                            "value": "\"hsl\""
                        },
                        {
                            "value": "\"hsb\""
                        }
                    ]
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string | Color"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the whole Slider is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "",
                "name": "label",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'horizontal'"
                },
                "description": "The orientation of the Slider.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string | Color"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes, as the user drags.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: Color) => void)"
                }
            },
            "onChangeEnd": {
                "defaultValue": null,
                "description": "Handler that is called when the user stops dragging.",
                "name": "onChangeEnd",
                "required": false,
                "type": {
                    "name": "((value: Color) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ColorSlider"] = {
        docgenInfo: _ColorSlider.__docgenInfo,
        name: "_ColorSlider",
        path: "packages/@react-spectrum/s2/src/index.ts#_ColorSlider"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ColorSwatch.displayName = "_ColorSwatch";
    // @ts-ignore
    _ColorSwatch.__docgenInfo = {
        "description": "A ColorSwatch displays a preview of a selected color.",
        "displayName": "_ColorSwatch",
        "props": {
            "color": {
                "defaultValue": null,
                "description": "The color value to display in the swatch.",
                "name": "color",
                "required": false,
                "type": {
                    "name": "string | Color"
                }
            },
            "colorName": {
                "defaultValue": null,
                "description": "A localized accessible name for the color.\nBy default, a description is generated from the color value,\nbut this can be overridden if you have a more specific color\nname (e.g. Pantone colors).",
                "name": "colorName",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "rounding": {
                "defaultValue": {
                    value: "'default'"
                },
                "description": "The corner rounding of the ColorSwatch.",
                "name": "rounding",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"default\""
                        },
                        {
                            "value": "\"full\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ColorSwatch.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ColorSwatch"] = {
        docgenInfo: _ColorSwatch.__docgenInfo,
        name: "_ColorSwatch",
        path: "packages/@react-spectrum/s2/src/index.ts#_ColorSwatch"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ColorSwatchPicker.displayName = "_ColorSwatchPicker";
    // @ts-ignore
    _ColorSwatchPicker.__docgenInfo = {
        "description": "A ColorSwatchPicker displays a list of color swatches and allows a user to select one of them.",
        "displayName": "_ColorSwatchPicker",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The ColorSwatches within the ColorSwatchPicker.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string | Color"
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of padding between the swatches.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "rounding": {
                "defaultValue": {
                    value: "'none'"
                },
                "description": "The corner rounding of the color swatches.",
                "name": "rounding",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"default\""
                        },
                        {
                            "value": "\"full\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the color swatches.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string | Color"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: Color) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ColorSwatchPicker"] = {
        docgenInfo: _ColorSwatchPicker.__docgenInfo,
        name: "_ColorSwatchPicker",
        path: "packages/@react-spectrum/s2/src/index.ts#_ColorSwatchPicker"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ColorWheel.displayName = "_ColorWheel";
    // @ts-ignore
    _ColorWheel.__docgenInfo = {
        "description": "A ColorWheel allows users to adjust the hue of an HSL or HSB color value on a circular track.",
        "displayName": "_ColorWheel",
        "props": {
            "defaultValue": {
                "defaultValue": {
                    value: "'hsl(0, 100%, 50%)'"
                },
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string | Color"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the ColorWheel is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "192"
                },
                "description": "",
                "name": "size",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string | Color"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes, as the user drags.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: Color) => void)"
                }
            },
            "onChangeEnd": {
                "defaultValue": null,
                "description": "Handler that is called when the user stops dragging.",
                "name": "onChangeEnd",
                "required": false,
                "type": {
                    "name": "((value: Color) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ColorWheel"] = {
        docgenInfo: _ColorWheel.__docgenInfo,
        name: "_ColorWheel",
        path: "packages/@react-spectrum/s2/src/index.ts#_ColorWheel"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ComboBox.displayName = "_ComboBox";
    // @ts-ignore
    _ComboBox.__docgenInfo = {
        "description": "ComboBox allow users to choose a single option from a collapsible list of options when space is limited.",
        "displayName": "_ComboBox",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "Alignment of the menu relative to the input target.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "allowsCustomValue": {
                "defaultValue": null,
                "description": "Whether the ComboBox allows a non-item matching input value to be set.",
                "name": "allowsCustomValue",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultInputValue": {
                "defaultValue": null,
                "description": "The default value of the ComboBox input (uncontrolled).",
                "name": "defaultInputValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "defaultItems": {
                "defaultValue": null,
                "description": "The list of ComboBox items (uncontrolled).",
                "name": "defaultItems",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "defaultSelectedKey": {
                "defaultValue": null,
                "description": "The initial selected key in the collection (uncontrolled).",
                "name": "defaultSelectedKey",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "direction": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "Direction the menu will render relative to the Picker.",
                "name": "direction",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "formValue": {
                "defaultValue": {
                    value: "'key'"
                },
                "description": "Whether the text or key of the selected item is submitted as part of an HTML form.\nWhen `allowsCustomValue` is `true`, this option does not apply and the text is always submitted.",
                "name": "formValue",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"key\""
                        },
                        {
                            "value": "\"text\""
                        }
                    ]
                }
            },
            "inputValue": {
                "defaultValue": null,
                "description": "The value of the ComboBox input (controlled).",
                "name": "inputValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "The list of ComboBox items (controlled).",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "menuTrigger": {
                "defaultValue": {
                    value: "'input'"
                },
                "description": "The interaction required to display the ComboBox menu.",
                "name": "menuTrigger",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"focus\""
                        },
                        {
                            "value": "\"input\""
                        },
                        {
                            "value": "\"manual\""
                        }
                    ]
                }
            },
            "menuWidth": {
                "defaultValue": null,
                "description": "Width of the menu. By default, matches width of the trigger. Note that the minimum width of the dropdown is always equal to the trigger's width.",
                "name": "menuWidth",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "selectedKey": {
                "defaultValue": null,
                "description": "The currently selected key in the collection (controlled).",
                "name": "selectedKey",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "shouldFocusWrap": {
                "defaultValue": null,
                "description": "Whether keyboard navigation is circular.",
                "name": "shouldFocusWrap",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Combobox.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: ComboBoxValidationValue) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "onInputChange": {
                "defaultValue": null,
                "description": "Handler that is called when the ComboBox input value changes.",
                "name": "onInputChange",
                "required": false,
                "type": {
                    "name": "((value: string) => void)"
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Method that is called when the open state of the menu changes. Returns the new open state and the action that caused the opening of the menu.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean, menuTrigger?: MenuTriggerAction) => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((key: Key | null) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ComboBox"] = {
        docgenInfo: _ComboBox.__docgenInfo,
        name: "_ComboBox",
        path: "packages/@react-spectrum/s2/src/index.ts#_ComboBox"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    ComboBoxItem.displayName = "ComboBoxItem";
    // @ts-ignore
    ComboBoxItem.__docgenInfo = {
        "description": "",
        "displayName": "ComboBoxItem",
        "props": {
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#ComboBoxItem"] = {
        docgenInfo: ComboBoxItem.__docgenInfo,
        name: "ComboBoxItem",
        path: "packages/@react-spectrum/s2/src/index.ts#ComboBoxItem"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    ComboBoxSection.displayName = "ComboBoxSection";
    // @ts-ignore
    ComboBoxSection.__docgenInfo = {
        "description": "",
        "displayName": "ComboBoxSection",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Static child items or a function to render children.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactElement<unknown, string | JSXElementConstructor<any>>)"
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the section.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#ComboBoxSection"] = {
        docgenInfo: ComboBoxSection.__docgenInfo,
        name: "ComboBoxSection",
        path: "packages/@react-spectrum/s2/src/index.ts#ComboBoxSection"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ContextualHelp.displayName = "_ContextualHelp";
    // @ts-ignore
    _ContextualHelp.__docgenInfo = {
        "description": "Contextual help shows a user extra information about the state of an adjacent component, or a total view.",
        "displayName": "_ContextualHelp",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Contents of the Contextual Help popover.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "containerPadding": {
                "defaultValue": {
                    value: "12"
                },
                "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
                "name": "containerPadding",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "crossOffset": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
                "name": "crossOffset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "offset": {
                "defaultValue": {
                    value: "8"
                },
                "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
                "name": "offset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "placement": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "The placement of the element with respect to its anchor element.",
                "name": "placement",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        },
                        {
                            "value": "\"bottom left\""
                        },
                        {
                            "value": "\"bottom right\""
                        },
                        {
                            "value": "\"bottom start\""
                        },
                        {
                            "value": "\"bottom end\""
                        },
                        {
                            "value": "\"top left\""
                        },
                        {
                            "value": "\"top right\""
                        },
                        {
                            "value": "\"top start\""
                        },
                        {
                            "value": "\"top end\""
                        },
                        {
                            "value": "\"left top\""
                        },
                        {
                            "value": "\"left bottom\""
                        },
                        {
                            "value": "\"start top\""
                        },
                        {
                            "value": "\"start bottom\""
                        },
                        {
                            "value": "\"right top\""
                        },
                        {
                            "value": "\"right bottom\""
                        },
                        {
                            "value": "\"end top\""
                        },
                        {
                            "value": "\"end bottom\""
                        }
                    ]
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'XS'"
                },
                "description": "The size of the ActionButton.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'help'"
                },
                "description": "Indicates whether contents are informative or provides helpful guidance.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"info\""
                        },
                        {
                            "value": "\"help\""
                        }
                    ]
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ContextualHelp"] = {
        docgenInfo: _ContextualHelp.__docgenInfo,
        name: "_ContextualHelp",
        path: "packages/@react-spectrum/s2/src/index.ts#_ContextualHelp"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Disclosure.displayName = "_Disclosure";
    // @ts-ignore
    _Disclosure.__docgenInfo = {
        "description": "A disclosure is a collapsible section of content. It is composed of a a header with a heading and trigger button, and a panel that contains the content.",
        "displayName": "_Disclosure",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the disclosure, consisting of a DisclosureTitle and DisclosurePanel.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultExpanded": {
                "defaultValue": null,
                "description": "Whether the disclosure is expanded by default (uncontrolled).",
                "name": "defaultExpanded",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of space between the disclosures.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the disclosure is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isExpanded": {
                "defaultValue": null,
                "description": "Whether the disclosure is expanded (controlled).",
                "name": "isExpanded",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the disclosure should be displayed with a quiet style.",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the disclosure.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onExpandedChange": {
                "defaultValue": null,
                "description": "Handler that is called when the disclosure's expanded state changes.",
                "name": "onExpandedChange",
                "required": false,
                "type": {
                    "name": "((isExpanded: boolean) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Disclosure"] = {
        docgenInfo: _Disclosure.__docgenInfo,
        name: "_Disclosure",
        path: "packages/@react-spectrum/s2/src/index.ts#_Disclosure"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _DisclosurePanel.displayName = "_DisclosurePanel";
    // @ts-ignore
    _DisclosurePanel.__docgenInfo = {
        "description": "A disclosure panel is a collapsible section of content that is hidden until the disclosure is expanded.",
        "displayName": "_DisclosurePanel",
        "props": {
            "role": {
                "defaultValue": {
                    value: "'group'"
                },
                "description": "The accessibility role for the disclosure's panel.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"group\""
                        },
                        {
                            "value": "\"region\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_DisclosurePanel"] = {
        docgenInfo: _DisclosurePanel.__docgenInfo,
        name: "_DisclosurePanel",
        path: "packages/@react-spectrum/s2/src/index.ts#_DisclosurePanel"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _DisclosureTitle.displayName = "_DisclosureTitle";
    // @ts-ignore
    _DisclosureTitle.__docgenInfo = {
        "description": "A disclosure title consisting of a heading and a trigger button to expand/collapse the panel.",
        "displayName": "_DisclosureTitle",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the disclosure header.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "level": {
                "defaultValue": {
                    value: "3"
                },
                "description": "The heading level of the disclosure header.",
                "name": "level",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_DisclosureTitle"] = {
        docgenInfo: _DisclosureTitle.__docgenInfo,
        name: "_DisclosureTitle",
        path: "packages/@react-spectrum/s2/src/index.ts#_DisclosureTitle"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Heading.displayName = "_Heading";
    // @ts-ignore
    _Heading.__docgenInfo = {
        "description": "",
        "displayName": "_Heading",
        "props": {
            "isHidden": {
                "defaultValue": null,
                "description": "",
                "name": "isHidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "level": {
                "defaultValue": null,
                "description": "",
                "name": "level",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLHeadingElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Heading"] = {
        docgenInfo: _Heading.__docgenInfo,
        name: "_Heading",
        path: "packages/@react-spectrum/s2/src/index.ts#_Heading"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Header.displayName = "_Header";
    // @ts-ignore
    _Header.__docgenInfo = {
        "description": "",
        "displayName": "_Header",
        "props": {
            "isHidden": {
                "defaultValue": null,
                "description": "",
                "name": "isHidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Header"] = {
        docgenInfo: _Header.__docgenInfo,
        name: "_Header",
        path: "packages/@react-spectrum/s2/src/index.ts#_Header"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Content.displayName = "_Content";
    // @ts-ignore
    _Content.__docgenInfo = {
        "description": "",
        "displayName": "_Content",
        "props": {
            "isHidden": {
                "defaultValue": null,
                "description": "",
                "name": "isHidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Content"] = {
        docgenInfo: _Content.__docgenInfo,
        name: "_Content",
        path: "packages/@react-spectrum/s2/src/index.ts#_Content"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Footer.displayName = "_Footer";
    // @ts-ignore
    _Footer.__docgenInfo = {
        "description": "",
        "displayName": "_Footer",
        "props": {
            "isHidden": {
                "defaultValue": null,
                "description": "",
                "name": "isHidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Footer"] = {
        docgenInfo: _Footer.__docgenInfo,
        name: "_Footer",
        path: "packages/@react-spectrum/s2/src/index.ts#_Footer"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Text.displayName = "_Text";
    // @ts-ignore
    _Text.__docgenInfo = {
        "description": "",
        "displayName": "_Text",
        "props": {
            "isHidden": {
                "defaultValue": null,
                "description": "",
                "name": "isHidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Text"] = {
        docgenInfo: _Text.__docgenInfo,
        name: "_Text",
        path: "packages/@react-spectrum/s2/src/index.ts#_Text"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Keyboard.displayName = "_Keyboard";
    // @ts-ignore
    _Keyboard.__docgenInfo = {
        "description": "",
        "displayName": "_Keyboard",
        "props": {
            "isHidden": {
                "defaultValue": null,
                "description": "",
                "name": "isHidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Keyboard"] = {
        docgenInfo: _Keyboard.__docgenInfo,
        name: "_Keyboard",
        path: "packages/@react-spectrum/s2/src/index.ts#_Keyboard"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Dialog.displayName = "_Dialog";
    // @ts-ignore
    _Dialog.__docgenInfo = {
        "description": "Dialogs are windows containing contextual information, tasks, or workflows that appear over the user interface.\nDepending on the kind of Dialog, further interactions may be blocked until the Dialog is acknowledged.",
        "displayName": "_Dialog",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((opts: DialogRenderProps) => ReactNode)"
                }
            },
            "isDismissible": {
                "defaultValue": null,
                "description": "Whether the Dialog is dismissible.",
                "name": "isDismissible",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isKeyboardDismissDisabled": {
                "defaultValue": null,
                "description": "Whether pressing the escape key to close the dialog should be disabled.",
                "name": "isKeyboardDismissDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "role": {
                "defaultValue": {
                    value: "'dialog'"
                },
                "description": "The accessibility role for the dialog.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"dialog\""
                        },
                        {
                            "value": "\"alertdialog\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Dialog.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Dialog"] = {
        docgenInfo: _Dialog.__docgenInfo,
        name: "_Dialog",
        path: "packages/@react-spectrum/s2/src/index.ts#_Dialog"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _CustomDialog.displayName = "_CustomDialog";
    // @ts-ignore
    _CustomDialog.__docgenInfo = {
        "description": "A CustomDialog is a floating window with a custom layout.",
        "displayName": "_CustomDialog",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((opts: DialogRenderProps) => ReactNode)"
                }
            },
            "isDismissible": {
                "defaultValue": null,
                "description": "Whether the Dialog is dismissible.",
                "name": "isDismissible",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isKeyboardDismissDisabled": {
                "defaultValue": null,
                "description": "Whether pressing the escape key to close the dialog should be disabled.",
                "name": "isKeyboardDismissDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "padding": {
                "defaultValue": {
                    value: "'default'"
                },
                "description": "The amount of padding around the contents of the dialog.",
                "name": "padding",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"default\""
                        }
                    ]
                }
            },
            "role": {
                "defaultValue": {
                    value: "'dialog'"
                },
                "description": "The accessibility role for the dialog.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"dialog\""
                        },
                        {
                            "value": "\"alertdialog\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": null,
                "description": "The size of the Dialog.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"fullscreen\""
                        },
                        {
                            "value": "\"fullscreenTakeover\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_CustomDialog"] = {
        docgenInfo: _CustomDialog.__docgenInfo,
        name: "_CustomDialog",
        path: "packages/@react-spectrum/s2/src/index.ts#_CustomDialog"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _FullscreenDialog.displayName = "_FullscreenDialog";
    // @ts-ignore
    _FullscreenDialog.__docgenInfo = {
        "description": "Takeover dialogs are large types of dialogs. They use the totality of the screen and should be used for modal experiences with complex workflows.",
        "displayName": "_FullscreenDialog",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((opts: DialogRenderProps) => ReactNode)"
                }
            },
            "isKeyboardDismissDisabled": {
                "defaultValue": null,
                "description": "Whether pressing the escape key to close the dialog should be disabled.",
                "name": "isKeyboardDismissDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "role": {
                "defaultValue": {
                    value: "'dialog'"
                },
                "description": "The accessibility role for the dialog.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"dialog\""
                        },
                        {
                            "value": "\"alertdialog\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "\"fullscreen\""
                },
                "description": "The variant of fullscreen dialog to display.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"fullscreen\""
                        },
                        {
                            "value": "\"fullscreenTakeover\""
                        }
                    ]
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_FullscreenDialog"] = {
        docgenInfo: _FullscreenDialog.__docgenInfo,
        name: "_FullscreenDialog",
        path: "packages/@react-spectrum/s2/src/index.ts#_FullscreenDialog"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    DialogTrigger.displayName = "DialogTrigger";
    // @ts-ignore
    DialogTrigger.__docgenInfo = {
        "description": "DialogTrigger serves as a wrapper around a Dialog and its associated trigger, linking the Dialog's\nopen state with the trigger's press state. Additionally, it allows you to customize the type and\npositioning of the Dialog.",
        "displayName": "DialogTrigger",
        "props": {
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean) => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#DialogTrigger"] = {
        docgenInfo: DialogTrigger.__docgenInfo,
        name: "DialogTrigger",
        path: "packages/@react-spectrum/s2/src/index.ts#DialogTrigger"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    DialogContainer.displayName = "DialogContainer";
    // @ts-ignore
    DialogContainer.__docgenInfo = {
        "description": "A DialogContainer accepts a single Dialog as a child, and manages showing and hiding\nit in a modal. Useful in cases where there is no trigger element\nor when the trigger unmounts while the dialog is open.",
        "displayName": "DialogContainer",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The Dialog to display, if any.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "onDismiss": {
                "defaultValue": null,
                "description": "Handler that is called when the 'x' button of a dismissable Dialog is clicked.",
                "name": "onDismiss",
                "required": true,
                "type": {
                    "name": "() => void"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#DialogContainer"] = {
        docgenInfo: DialogContainer.__docgenInfo,
        name: "DialogContainer",
        path: "packages/@react-spectrum/s2/src/index.ts#DialogContainer"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Divider.displayName = "_Divider";
    // @ts-ignore
    _Divider.__docgenInfo = {
        "description": "Dividers bring clarity to a layout by grouping and dividing content in close proximity.\nThey can also be used to establish rhythm and hierarchy.",
        "displayName": "_Divider",
        "props": {
            "orientation": {
                "defaultValue": {
                    value: "'horizontal'"
                },
                "description": "How thick the Divider should be.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "How thick the Divider should be.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the Divider appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Divider"] = {
        docgenInfo: _Divider.__docgenInfo,
        name: "_Divider",
        path: "packages/@react-spectrum/s2/src/index.ts#_Divider"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _DropZone.displayName = "_DropZone";
    // @ts-ignore
    _DropZone.__docgenInfo = {
        "description": "A drop zone is an area into which one or multiple objects can be dragged and dropped.",
        "displayName": "_DropZone",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the drop zone.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "getDropOperation": {
                "defaultValue": null,
                "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
                "name": "getDropOperation",
                "required": false,
                "type": {
                    "name": "((types: DragTypes, allowedOperations: DropOperation[]) => DropOperation)"
                }
            },
            "isFilled": {
                "defaultValue": null,
                "description": "Whether the drop zone has been filled.",
                "name": "isFilled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "replaceMessage": {
                "defaultValue": null,
                "description": "The message to replace the default banner message that is shown when the drop zone is filled.",
                "name": "replaceMessage",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the DropZone.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onDrop": {
                "defaultValue": null,
                "description": "Handler that is called when a valid drag is dropped on the drop target.",
                "name": "onDrop",
                "required": false,
                "type": {
                    "name": "((e: DropEvent) => void)"
                }
            },
            "onDropActivate": {
                "defaultValue": null,
                "description": "Handler that is called after a valid drag is held over the drop target for a period of time.\nThis typically opens the item so that the user can drop within it.\n@private",
                "name": "onDropActivate",
                "required": false,
                "type": {
                    "name": "((e: DropActivateEvent) => void)"
                }
            },
            "onDropEnter": {
                "defaultValue": null,
                "description": "Handler that is called when a valid drag enters the drop target.",
                "name": "onDropEnter",
                "required": false,
                "type": {
                    "name": "((e: DropEnterEvent) => void)"
                }
            },
            "onDropExit": {
                "defaultValue": null,
                "description": "Handler that is called when a valid drag exits the drop target.",
                "name": "onDropExit",
                "required": false,
                "type": {
                    "name": "((e: DropExitEvent) => void)"
                }
            },
            "onDropMove": {
                "defaultValue": null,
                "description": "Handler that is called when a valid drag is moved within the drop target.",
                "name": "onDropMove",
                "required": false,
                "type": {
                    "name": "((e: DropMoveEvent) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_DropZone"] = {
        docgenInfo: _DropZone.__docgenInfo,
        name: "_DropZone",
        path: "packages/@react-spectrum/s2/src/index.ts#_DropZone"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Form.displayName = "_Form";
    // @ts-ignore
    _Form.__docgenInfo = {
        "description": "Forms allow users to enter data that can be submitted while providing alignment and styling for form fields.",
        "displayName": "_Form",
        "props": {
            "action": {
                "defaultValue": null,
                "description": "Where to send the form-data when the form is submitted.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#action).",
                "name": "action",
                "required": false,
                "type": {
                    "name": "string | ((formData: FormData) => void)"
                }
            },
            "autoCapitalize": {
                "defaultValue": null,
                "description": "Controls whether inputted text is automatically capitalized and, if so, in what manner. \nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/autocapitalize).",
                "name": "autoCapitalize",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"off\""
                        },
                        {
                            "value": "\"on\""
                        },
                        {
                            "value": "\"sentences\""
                        },
                        {
                            "value": "\"words\""
                        },
                        {
                            "value": "\"characters\""
                        }
                    ]
                }
            },
            "autoComplete": {
                "defaultValue": null,
                "description": "Indicates whether input elements can by default have their values automatically completed by the browser.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#autocomplete).",
                "name": "autoComplete",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"off\""
                        },
                        {
                            "value": "\"on\""
                        }
                    ]
                }
            },
            "encType": {
                "defaultValue": null,
                "description": "The enctype attribute specifies how the form-data should be encoded when submitting it to the server.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#enctype).",
                "name": "encType",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"application/x-www-form-urlencoded\""
                        },
                        {
                            "value": "\"multipart/form-data\""
                        },
                        {
                            "value": "\"text/plain\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the Form elements are disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Form elements are rendered with their emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether the label is labeling a required field or group.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "method": {
                "defaultValue": null,
                "description": "The HTTP method to submit the form with.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#method).",
                "name": "method",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"dialog\""
                        },
                        {
                            "value": "\"get\""
                        },
                        {
                            "value": "\"post\""
                        }
                    ]
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "role": {
                "defaultValue": null,
                "description": "An ARIA role override to apply to the form element.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"presentation\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "Size of the Form elements.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target attribute specifies a name or a keyword that indicates where to display the response that is received after submitting the form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"_self\""
                        },
                        {
                            "value": "\"_blank\""
                        },
                        {
                            "value": "\"_parent\""
                        },
                        {
                            "value": "\"_top\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen a field value is missing or invalid, or mark fields as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "validationErrors": {
                "defaultValue": null,
                "description": "Validation errors for the form, typically returned by a server.\nThis should be set to an object mapping from input names to errors.",
                "name": "validationErrors",
                "required": false,
                "type": {
                    "name": "ValidationErrors"
                }
            },
            "onInvalid": {
                "defaultValue": null,
                "description": "Triggered for each invalid field when a user submits the form.",
                "name": "onInvalid",
                "required": false,
                "type": {
                    "name": "((event: FormEvent<HTMLFormElement>) => void)"
                }
            },
            "onReset": {
                "defaultValue": null,
                "description": "Triggered when a user resets the form.",
                "name": "onReset",
                "required": false,
                "type": {
                    "name": "((event: FormEvent<HTMLFormElement>) => void)"
                }
            },
            "onSubmit": {
                "defaultValue": null,
                "description": "Triggered when a user submits the form.",
                "name": "onSubmit",
                "required": false,
                "type": {
                    "name": "((event: FormEvent<HTMLFormElement>) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLFormElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Form"] = {
        docgenInfo: _Form.__docgenInfo,
        name: "_Form",
        path: "packages/@react-spectrum/s2/src/index.ts#_Form"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _IllustratedMessage.displayName = "_IllustratedMessage";
    // @ts-ignore
    _IllustratedMessage.__docgenInfo = {
        "description": "An IllustratedMessage displays an illustration and a message, usually\nfor an empty state or an error page.",
        "displayName": "_IllustratedMessage",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the IllustratedMessage.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'vertical'"
                },
                "description": "The direction that the IllustratedMessage should be laid out in.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the IllustratedMessage.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_IllustratedMessage"] = {
        docgenInfo: _IllustratedMessage.__docgenInfo,
        name: "_IllustratedMessage",
        path: "packages/@react-spectrum/s2/src/index.ts#_IllustratedMessage"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Image.displayName = "_Image";
    // @ts-ignore
    _Image.__docgenInfo = {
        "description": "",
        "displayName": "_Image",
        "props": {
            "alt": {
                "defaultValue": null,
                "description": "Accessible alt text for the image.",
                "name": "alt",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "crossOrigin": {
                "defaultValue": null,
                "description": "Indicates if the fetching of the image must be done using a CORS request.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/crossorigin).",
                "name": "crossOrigin",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"anonymous\""
                        },
                        {
                            "value": "\"use-credentials\""
                        }
                    ]
                }
            },
            "decoding": {
                "defaultValue": null,
                "description": "Whether the browser should decode images synchronously or asynchronously.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#decoding).",
                "name": "decoding",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"async\""
                        },
                        {
                            "value": "\"auto\""
                        },
                        {
                            "value": "\"sync\""
                        }
                    ]
                }
            },
            "group": {
                "defaultValue": null,
                "description": "A group of images to coordinate between, matching the group passed to the `<ImageCoordinator>` component.\nIf not provided, the default image group is used.",
                "name": "group",
                "required": false,
                "type": {
                    "name": "ImageGroup"
                }
            },
            "loading": {
                "defaultValue": null,
                "description": "Whether the image should be loaded immediately or lazily when scrolled into view.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#loading).",
                "name": "loading",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"eager\""
                        },
                        {
                            "value": "\"lazy\""
                        }
                    ]
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "A string indicating which referrer to use when fetching the resource.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "renderError": {
                "defaultValue": null,
                "description": "A function that is called to render a fallback when the image fails to load.",
                "name": "renderError",
                "required": false,
                "type": {
                    "name": "(() => ReactNode)"
                }
            },
            "src": {
                "defaultValue": null,
                "description": "The URL of the image.",
                "name": "src",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<HTMLDivElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Image"] = {
        docgenInfo: _Image.__docgenInfo,
        name: "_Image",
        path: "packages/@react-spectrum/s2/src/index.ts#_Image"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    ImageCoordinator.displayName = "ImageCoordinator";
    // @ts-ignore
    ImageCoordinator.__docgenInfo = {
        "description": "An ImageCoordinator coordinates loading behavior for a group of images.\nImages within an ImageCoordinator are revealed together once all of them have loaded.",
        "displayName": "ImageCoordinator",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Children within the ImageCoordinator.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "group": {
                "defaultValue": null,
                "description": "A group of images to coordinate between, matching the group passed to the `<Image>` component.\nIf not provided, the default image group is used.",
                "name": "group",
                "required": false,
                "type": {
                    "name": "ImageGroup"
                }
            },
            "timeout": {
                "defaultValue": {
                    value: "5000"
                },
                "description": "Time in milliseconds after which images are always displayed, even if all images are not yet loaded.",
                "name": "timeout",
                "required": false,
                "type": {
                    "name": "number"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#ImageCoordinator"] = {
        docgenInfo: ImageCoordinator.__docgenInfo,
        name: "ImageCoordinator",
        path: "packages/@react-spectrum/s2/src/index.ts#ImageCoordinator"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _InlineAlert.displayName = "_InlineAlert";
    // @ts-ignore
    _InlineAlert.__docgenInfo = {
        "description": "Inline alerts display a non-modal message associated with objects in a view.\nThese are often used in form validation, providing a place to aggregate feedback related to multiple fields.",
        "displayName": "_InlineAlert",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the Inline Alert.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether to automatically focus the Inline Alert when it first renders.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "fillStyle": {
                "defaultValue": {
                    value: "border"
                },
                "description": "The visual style of the Inline Alert.",
                "name": "fillStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"border\""
                        },
                        {
                            "value": "\"subtleFill\""
                        },
                        {
                            "value": "\"boldFill\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "neutral"
                },
                "description": "The semantic tone of a Inline Alert.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"negative\""
                        },
                        {
                            "value": "\"informative\""
                        },
                        {
                            "value": "\"neutral\""
                        },
                        {
                            "value": "\"positive\""
                        },
                        {
                            "value": "\"notice\""
                        }
                    ]
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_InlineAlert"] = {
        docgenInfo: _InlineAlert.__docgenInfo,
        name: "_InlineAlert",
        path: "packages/@react-spectrum/s2/src/index.ts#_InlineAlert"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Link.displayName = "_Link";
    // @ts-ignore
    _Link.__docgenInfo = {
        "description": "Links allow users to navigate to a different location.\nThey can be presented inline inside a paragraph or as standalone text.",
        "displayName": "_Link",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the link should be displayed with a quiet style.",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isStandalone": {
                "defaultValue": null,
                "description": "Whether the link is on its own vs inside a longer string of text.",
                "name": "isStandalone",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the link appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The [visual style](https://spectrum.adobe.com/page/link/#Options) of the link.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        }
                    ]
                }
            },
            "onPress": {
                "defaultValue": null,
                "description": "Handler that is called when the press is released over the target.",
                "name": "onPress",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressChange": {
                "defaultValue": null,
                "description": "Handler that is called when the press state changes.",
                "name": "onPressChange",
                "required": false,
                "type": {
                    "name": "((isPressed: boolean) => void)"
                }
            },
            "onPressEnd": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
                "name": "onPressEnd",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressStart": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction starts.",
                "name": "onPressStart",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressUp": {
                "defaultValue": null,
                "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
                "name": "onPressUp",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLAnchorElement, HTMLAnchorElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Link"] = {
        docgenInfo: _Link.__docgenInfo,
        name: "_Link",
        path: "packages/@react-spectrum/s2/src/index.ts#_Link"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    MenuItem.displayName = "MenuItem";
    // @ts-ignore
    MenuItem.__docgenInfo = {
        "description": "",
        "displayName": "MenuItem",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the item.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when the item is selected.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#MenuItem"] = {
        docgenInfo: MenuItem.__docgenInfo,
        name: "MenuItem",
        path: "packages/@react-spectrum/s2/src/index.ts#MenuItem"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    MenuTrigger.displayName = "MenuTrigger";
    // @ts-ignore
    MenuTrigger.__docgenInfo = {
        "description": "The MenuTrigger serves as a wrapper around a Menu and its associated trigger,\nlinking the Menu's open state with the trigger's press state.",
        "displayName": "MenuTrigger",
        "props": {
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "Alignment of the menu relative to the trigger.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "direction": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "Where the Menu opens relative to its trigger.",
                "name": "direction",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        }
                    ]
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the menu should automatically flip direction when space is limited.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "trigger": {
                "defaultValue": {
                    value: "'press'"
                },
                "description": "How the menu is triggered.",
                "name": "trigger",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"press\""
                        },
                        {
                            "value": "\"longPress\""
                        }
                    ]
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean) => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#MenuTrigger"] = {
        docgenInfo: MenuTrigger.__docgenInfo,
        name: "MenuTrigger",
        path: "packages/@react-spectrum/s2/src/index.ts#MenuTrigger"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Menu.displayName = "_Menu";
    // @ts-ignore
    _Menu.__docgenInfo = {
        "description": "Menus display a list of actions or options that a user can choose.",
        "displayName": "_Menu",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Where the focus should be set.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean | FocusStrategy"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "The type of selection that is allowed in the collection.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "shouldFocusWrap": {
                "defaultValue": null,
                "description": "Whether keyboard navigation is circular.",
                "name": "shouldFocusWrap",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Menu.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when an item is selected.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "onClose": {
                "defaultValue": null,
                "description": "Handler that is called when the menu should close after selecting an item.",
                "name": "onClose",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Selection) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Menu"] = {
        docgenInfo: _Menu.__docgenInfo,
        name: "_Menu",
        path: "packages/@react-spectrum/s2/src/index.ts#_Menu"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    MenuSection.displayName = "MenuSection";
    // @ts-ignore
    MenuSection.__docgenInfo = {
        "description": "",
        "displayName": "MenuSection",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Static child items or a function to render children.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactElement<unknown, string | JSXElementConstructor<any>>)"
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The currently disabled keys in the collection (controlled).",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the section.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "The type of selection that is allowed in the collection.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Selection) => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#MenuSection"] = {
        docgenInfo: MenuSection.__docgenInfo,
        name: "MenuSection",
        path: "packages/@react-spectrum/s2/src/index.ts#MenuSection"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Meter.displayName = "_Meter";
    // @ts-ignore
    _Meter.__docgenInfo = {
        "description": "Meters are visual representations of a quantity or an achievement.\nTheir progress is determined by user actions, rather than system actions.",
        "displayName": "_Meter",
        "props": {
            "formatOptions": {
                "defaultValue": {
                    value: "{style: 'percent'}"
                },
                "description": "The display format of the value label.",
                "name": "formatOptions",
                "required": false,
                "type": {
                    "name": "NumberFormatOptions"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxValue": {
                "defaultValue": {
                    value: "100"
                },
                "description": "The largest value allowed for the input.",
                "name": "maxValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minValue": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The smallest value allowed for the input.",
                "name": "minValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Meter.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the button appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "valueLabel": {
                "defaultValue": null,
                "description": "The content to display as the value's label (e.g. 1 of 4).",
                "name": "valueLabel",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'informative'"
                },
                "description": "The [visual style](https://spectrum.adobe.com/page/meter/#-Options) of the Meter.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"negative\""
                        },
                        {
                            "value": "\"informative\""
                        },
                        {
                            "value": "\"positive\""
                        },
                        {
                            "value": "\"notice\""
                        }
                    ]
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Meter"] = {
        docgenInfo: _Meter.__docgenInfo,
        name: "_Meter",
        path: "packages/@react-spectrum/s2/src/index.ts#_Meter"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _NumberField.displayName = "_NumberField";
    // @ts-ignore
    _NumberField.__docgenInfo = {
        "description": "NumberFields allow users to input number values with a keyboard or increment/decrement with step buttons.",
        "displayName": "_NumberField",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "decrementAriaLabel": {
                "defaultValue": null,
                "description": "A custom aria-label for the decrement button. If not provided, the localized string \"Decrement\" is used.",
                "name": "decrementAriaLabel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "formatOptions": {
                "defaultValue": null,
                "description": "Formatting options for the value displayed in the number field.\nThis also affects what characters are allowed to be typed by the user.",
                "name": "formatOptions",
                "required": false,
                "type": {
                    "name": "NumberFormatOptions"
                }
            },
            "hideStepper": {
                "defaultValue": {
                    value: "false"
                },
                "description": "Whether to hide the increment and decrement buttons.",
                "name": "hideStepper",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "incrementAriaLabel": {
                "defaultValue": null,
                "description": "A custom aria-label for the increment button. If not provided, the localized string \"Increment\" is used.",
                "name": "incrementAriaLabel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isWheelDisabled": {
                "defaultValue": null,
                "description": "Enables or disables changing the value with scroll.",
                "name": "isWheelDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxValue": {
                "defaultValue": null,
                "description": "The largest value allowed for the input.",
                "name": "maxValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minValue": {
                "defaultValue": null,
                "description": "The smallest value allowed for the input.",
                "name": "minValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the NumberField.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "step": {
                "defaultValue": null,
                "description": "The amount that the input value changes with each increment or decrement \"tick\".",
                "name": "step",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: number) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: number) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_NumberField"] = {
        docgenInfo: _NumberField.__docgenInfo,
        name: "_NumberField",
        path: "packages/@react-spectrum/s2/src/index.ts#_NumberField"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Picker.displayName = "_Picker";
    // @ts-ignore
    _Picker.__docgenInfo = {
        "description": "Pickers allow users to choose a single option from a collapsible list of options when space is limited.",
        "displayName": "_Picker",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "Alignment of the menu relative to the input target.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "autoComplete": {
                "defaultValue": null,
                "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
                "name": "autoComplete",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Sets the default open state of the menu.",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "defaultSelectedKey": {
                "defaultValue": null,
                "description": "The initial selected key in the collection (uncontrolled).",
                "name": "defaultSelectedKey",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "direction": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "Direction the menu will render relative to the Picker.",
                "name": "direction",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Sets the open state of the menu.",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the picker should be displayed with a quiet style.\n@private",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "menuWidth": {
                "defaultValue": null,
                "description": "Width of the menu. By default, matches width of the trigger. Note that the minimum width of the dropdown is always equal to the trigger's width.",
                "name": "menuWidth",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input, used when submitting an HTML form.",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "placeholder": {
                "defaultValue": null,
                "description": "Temporary text that occupies the text input when it is empty.",
                "name": "placeholder",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "selectedKey": {
                "defaultValue": null,
                "description": "The currently selected key in the collection (controlled).",
                "name": "selectedKey",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Picker.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: Key) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Method that is called when the open state of the menu changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean) => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Picker"] = {
        docgenInfo: _Picker.__docgenInfo,
        name: "_Picker",
        path: "packages/@react-spectrum/s2/src/index.ts#_Picker"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    PickerItem.displayName = "PickerItem";
    // @ts-ignore
    PickerItem.__docgenInfo = {
        "description": "",
        "displayName": "PickerItem",
        "props": {
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#PickerItem"] = {
        docgenInfo: PickerItem.__docgenInfo,
        name: "PickerItem",
        path: "packages/@react-spectrum/s2/src/index.ts#PickerItem"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    PickerSection.displayName = "PickerSection";
    // @ts-ignore
    PickerSection.__docgenInfo = {
        "description": "",
        "displayName": "PickerSection",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Static child items or a function to render children.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactElement<unknown, string | JSXElementConstructor<any>>)"
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the section.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#PickerSection"] = {
        docgenInfo: PickerSection.__docgenInfo,
        name: "PickerSection",
        path: "packages/@react-spectrum/s2/src/index.ts#PickerSection"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Popover.displayName = "_Popover";
    // @ts-ignore
    _Popover.__docgenInfo = {
        "description": "A popover is an overlay element positioned relative to a trigger.",
        "displayName": "_Popover",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((opts: DialogRenderProps) => ReactNode)"
                }
            },
            "containerPadding": {
                "defaultValue": {
                    value: "12"
                },
                "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
                "name": "containerPadding",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "crossOffset": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
                "name": "crossOffset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "hideArrow": {
                "defaultValue": {
                    value: "false"
                },
                "description": "Whether a popover's arrow should be hidden.",
                "name": "hideArrow",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "offset": {
                "defaultValue": {
                    value: "8"
                },
                "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
                "name": "offset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "placement": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "The placement of the element with respect to its anchor element.",
                "name": "placement",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        },
                        {
                            "value": "\"bottom left\""
                        },
                        {
                            "value": "\"bottom right\""
                        },
                        {
                            "value": "\"bottom start\""
                        },
                        {
                            "value": "\"bottom end\""
                        },
                        {
                            "value": "\"top left\""
                        },
                        {
                            "value": "\"top right\""
                        },
                        {
                            "value": "\"top start\""
                        },
                        {
                            "value": "\"top end\""
                        },
                        {
                            "value": "\"left top\""
                        },
                        {
                            "value": "\"left bottom\""
                        },
                        {
                            "value": "\"start top\""
                        },
                        {
                            "value": "\"start bottom\""
                        },
                        {
                            "value": "\"right top\""
                        },
                        {
                            "value": "\"right bottom\""
                        },
                        {
                            "value": "\"end top\""
                        },
                        {
                            "value": "\"end bottom\""
                        }
                    ]
                }
            },
            "role": {
                "defaultValue": {
                    value: "'dialog'"
                },
                "description": "The accessibility role for the dialog.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"dialog\""
                        },
                        {
                            "value": "\"alertdialog\""
                        }
                    ]
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": null,
                "description": "The size of the Popover. If not specified, the popover fits its contents.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Popover"] = {
        docgenInfo: _Popover.__docgenInfo,
        name: "_Popover",
        path: "packages/@react-spectrum/s2/src/index.ts#_Popover"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ProgressBar.displayName = "_ProgressBar";
    // @ts-ignore
    _ProgressBar.__docgenInfo = {
        "description": "ProgressBars show the progression of a system operation: downloading, uploading, processing, etc., in a visual way.\nThey can represent either determinate or indeterminate progress.",
        "displayName": "_ProgressBar",
        "props": {
            "formatOptions": {
                "defaultValue": {
                    value: "{style: 'percent'}"
                },
                "description": "The display format of the value label.",
                "name": "formatOptions",
                "required": false,
                "type": {
                    "name": "NumberFormatOptions"
                }
            },
            "isIndeterminate": {
                "defaultValue": null,
                "description": "Whether presentation is indeterminate when progress isn't known.",
                "name": "isIndeterminate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxValue": {
                "defaultValue": {
                    value: "100"
                },
                "description": "The largest value allowed for the input.",
                "name": "maxValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minValue": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The smallest value allowed for the input.",
                "name": "minValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ProgressBar.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the button appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "valueLabel": {
                "defaultValue": null,
                "description": "The content to display as the value's label (e.g. 1 of 4).",
                "name": "valueLabel",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ProgressBar"] = {
        docgenInfo: _ProgressBar.__docgenInfo,
        name: "_ProgressBar",
        path: "packages/@react-spectrum/s2/src/index.ts#_ProgressBar"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ProgressCircle.displayName = "_ProgressCircle";
    // @ts-ignore
    _ProgressCircle.__docgenInfo = {
        "description": "ProgressCircles show the progression of a system operation such as downloading, uploading, or processing, in a visual way.\nThey can represent determinate or indeterminate progress.",
        "displayName": "_ProgressCircle",
        "props": {
            "isIndeterminate": {
                "defaultValue": null,
                "description": "Whether presentation is indeterminate when progress isn't known.",
                "name": "isIndeterminate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "maxValue": {
                "defaultValue": {
                    value: "100"
                },
                "description": "The largest value allowed for the input.",
                "name": "maxValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minValue": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The smallest value allowed for the input.",
                "name": "minValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ProgressCircle.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the button appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ProgressCircle"] = {
        docgenInfo: _ProgressCircle.__docgenInfo,
        name: "_ProgressCircle",
        path: "packages/@react-spectrum/s2/src/index.ts#_ProgressCircle"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    Provider.displayName = "Provider";
    // @ts-ignore
    Provider.__docgenInfo = {
        "description": "",
        "displayName": "Provider",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content of the Provider.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "background": {
                "defaultValue": null,
                "description": "The background for this provider. If not provided, the background is transparent.",
                "name": "background",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"base\""
                        },
                        {
                            "value": "\"layer-1\""
                        },
                        {
                            "value": "\"layer-2\""
                        }
                    ]
                }
            },
            "colorScheme": {
                "defaultValue": null,
                "description": "The color scheme for your application.\nDefaults to operating system preferences.",
                "name": "colorScheme",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"dark\""
                        },
                        {
                            "value": "\"light\""
                        }
                    ]
                }
            },
            "elementType": {
                "defaultValue": {
                    value: "div"
                },
                "description": "The DOM element to render.",
                "name": "elementType",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"symbol\""
                        },
                        {
                            "value": "\"object\""
                        },
                        {
                            "value": "\"style\""
                        },
                        {
                            "value": "\"button\""
                        },
                        {
                            "value": "\"form\""
                        },
                        {
                            "value": "\"slot\""
                        },
                        {
                            "value": "\"menu\""
                        },
                        {
                            "value": "\"dialog\""
                        },
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"pattern\""
                        },
                        {
                            "value": "\"text\""
                        },
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"map\""
                        },
                        {
                            "value": "\"filter\""
                        },
                        {
                            "value": "\"input\""
                        },
                        {
                            "value": "\"title\""
                        },
                        {
                            "value": "\"center\""
                        },
                        {
                            "value": "\"link\""
                        },
                        {
                            "value": "\"meter\""
                        },
                        {
                            "value": "\"textarea\""
                        },
                        {
                            "value": "\"progress\""
                        },
                        {
                            "value": "\"ruby\""
                        },
                        {
                            "value": "\"table\""
                        },
                        {
                            "value": "\"small\""
                        },
                        {
                            "value": "\"sub\""
                        },
                        {
                            "value": "\"circle\""
                        },
                        {
                            "value": "\"embed\""
                        },
                        {
                            "value": "\"pre\""
                        },
                        {
                            "value": "\"caption\""
                        },
                        {
                            "value": "\"menuitem\""
                        },
                        {
                            "value": "\"base\""
                        },
                        {
                            "value": "\"a\""
                        },
                        {
                            "value": "\"abbr\""
                        },
                        {
                            "value": "\"address\""
                        },
                        {
                            "value": "\"area\""
                        },
                        {
                            "value": "\"article\""
                        },
                        {
                            "value": "\"aside\""
                        },
                        {
                            "value": "\"audio\""
                        },
                        {
                            "value": "\"b\""
                        },
                        {
                            "value": "\"bdi\""
                        },
                        {
                            "value": "\"bdo\""
                        },
                        {
                            "value": "\"big\""
                        },
                        {
                            "value": "\"blockquote\""
                        },
                        {
                            "value": "\"body\""
                        },
                        {
                            "value": "\"br\""
                        },
                        {
                            "value": "\"canvas\""
                        },
                        {
                            "value": "\"cite\""
                        },
                        {
                            "value": "\"code\""
                        },
                        {
                            "value": "\"col\""
                        },
                        {
                            "value": "\"colgroup\""
                        },
                        {
                            "value": "\"data\""
                        },
                        {
                            "value": "\"datalist\""
                        },
                        {
                            "value": "\"dd\""
                        },
                        {
                            "value": "\"del\""
                        },
                        {
                            "value": "\"details\""
                        },
                        {
                            "value": "\"dfn\""
                        },
                        {
                            "value": "\"div\""
                        },
                        {
                            "value": "\"dl\""
                        },
                        {
                            "value": "\"dt\""
                        },
                        {
                            "value": "\"em\""
                        },
                        {
                            "value": "\"fieldset\""
                        },
                        {
                            "value": "\"figcaption\""
                        },
                        {
                            "value": "\"figure\""
                        },
                        {
                            "value": "\"footer\""
                        },
                        {
                            "value": "\"h1\""
                        },
                        {
                            "value": "\"h2\""
                        },
                        {
                            "value": "\"h3\""
                        },
                        {
                            "value": "\"h4\""
                        },
                        {
                            "value": "\"h5\""
                        },
                        {
                            "value": "\"h6\""
                        },
                        {
                            "value": "\"head\""
                        },
                        {
                            "value": "\"header\""
                        },
                        {
                            "value": "\"hgroup\""
                        },
                        {
                            "value": "\"hr\""
                        },
                        {
                            "value": "\"html\""
                        },
                        {
                            "value": "\"i\""
                        },
                        {
                            "value": "\"iframe\""
                        },
                        {
                            "value": "\"img\""
                        },
                        {
                            "value": "\"ins\""
                        },
                        {
                            "value": "\"kbd\""
                        },
                        {
                            "value": "\"keygen\""
                        },
                        {
                            "value": "\"legend\""
                        },
                        {
                            "value": "\"li\""
                        },
                        {
                            "value": "\"main\""
                        },
                        {
                            "value": "\"mark\""
                        },
                        {
                            "value": "\"meta\""
                        },
                        {
                            "value": "\"nav\""
                        },
                        {
                            "value": "\"noindex\""
                        },
                        {
                            "value": "\"noscript\""
                        },
                        {
                            "value": "\"ol\""
                        },
                        {
                            "value": "\"optgroup\""
                        },
                        {
                            "value": "\"option\""
                        },
                        {
                            "value": "\"output\""
                        },
                        {
                            "value": "\"p\""
                        },
                        {
                            "value": "\"param\""
                        },
                        {
                            "value": "\"picture\""
                        },
                        {
                            "value": "\"q\""
                        },
                        {
                            "value": "\"rp\""
                        },
                        {
                            "value": "\"rt\""
                        },
                        {
                            "value": "\"s\""
                        },
                        {
                            "value": "\"samp\""
                        },
                        {
                            "value": "\"script\""
                        },
                        {
                            "value": "\"section\""
                        },
                        {
                            "value": "\"select\""
                        },
                        {
                            "value": "\"source\""
                        },
                        {
                            "value": "\"span\""
                        },
                        {
                            "value": "\"strong\""
                        },
                        {
                            "value": "\"summary\""
                        },
                        {
                            "value": "\"sup\""
                        },
                        {
                            "value": "\"template\""
                        },
                        {
                            "value": "\"tbody\""
                        },
                        {
                            "value": "\"td\""
                        },
                        {
                            "value": "\"tfoot\""
                        },
                        {
                            "value": "\"th\""
                        },
                        {
                            "value": "\"thead\""
                        },
                        {
                            "value": "\"time\""
                        },
                        {
                            "value": "\"tr\""
                        },
                        {
                            "value": "\"track\""
                        },
                        {
                            "value": "\"u\""
                        },
                        {
                            "value": "\"ul\""
                        },
                        {
                            "value": "\"var\""
                        },
                        {
                            "value": "\"video\""
                        },
                        {
                            "value": "\"wbr\""
                        },
                        {
                            "value": "\"webview\""
                        },
                        {
                            "value": "\"svg\""
                        },
                        {
                            "value": "\"animate\""
                        },
                        {
                            "value": "\"animateMotion\""
                        },
                        {
                            "value": "\"animateTransform\""
                        },
                        {
                            "value": "\"clipPath\""
                        },
                        {
                            "value": "\"defs\""
                        },
                        {
                            "value": "\"desc\""
                        },
                        {
                            "value": "\"ellipse\""
                        },
                        {
                            "value": "\"feBlend\""
                        },
                        {
                            "value": "\"feColorMatrix\""
                        },
                        {
                            "value": "\"feComponentTransfer\""
                        },
                        {
                            "value": "\"feComposite\""
                        },
                        {
                            "value": "\"feConvolveMatrix\""
                        },
                        {
                            "value": "\"feDiffuseLighting\""
                        },
                        {
                            "value": "\"feDisplacementMap\""
                        },
                        {
                            "value": "\"feDistantLight\""
                        },
                        {
                            "value": "\"feDropShadow\""
                        },
                        {
                            "value": "\"feFlood\""
                        },
                        {
                            "value": "\"feFuncA\""
                        },
                        {
                            "value": "\"feFuncB\""
                        },
                        {
                            "value": "\"feFuncG\""
                        },
                        {
                            "value": "\"feFuncR\""
                        },
                        {
                            "value": "\"feGaussianBlur\""
                        },
                        {
                            "value": "\"feImage\""
                        },
                        {
                            "value": "\"feMerge\""
                        },
                        {
                            "value": "\"feMergeNode\""
                        },
                        {
                            "value": "\"feMorphology\""
                        },
                        {
                            "value": "\"feOffset\""
                        },
                        {
                            "value": "\"fePointLight\""
                        },
                        {
                            "value": "\"feSpecularLighting\""
                        },
                        {
                            "value": "\"feSpotLight\""
                        },
                        {
                            "value": "\"feTile\""
                        },
                        {
                            "value": "\"feTurbulence\""
                        },
                        {
                            "value": "\"foreignObject\""
                        },
                        {
                            "value": "\"g\""
                        },
                        {
                            "value": "\"image\""
                        },
                        {
                            "value": "\"line\""
                        },
                        {
                            "value": "\"linearGradient\""
                        },
                        {
                            "value": "\"marker\""
                        },
                        {
                            "value": "\"mask\""
                        },
                        {
                            "value": "\"metadata\""
                        },
                        {
                            "value": "\"mpath\""
                        },
                        {
                            "value": "\"path\""
                        },
                        {
                            "value": "\"polygon\""
                        },
                        {
                            "value": "\"polyline\""
                        },
                        {
                            "value": "\"radialGradient\""
                        },
                        {
                            "value": "\"rect\""
                        },
                        {
                            "value": "\"set\""
                        },
                        {
                            "value": "\"stop\""
                        },
                        {
                            "value": "\"switch\""
                        },
                        {
                            "value": "\"textPath\""
                        },
                        {
                            "value": "\"tspan\""
                        },
                        {
                            "value": "\"use\""
                        },
                        {
                            "value": "\"view\""
                        }
                    ]
                }
            },
            "locale": {
                "defaultValue": {
                    value: "'en-US'"
                },
                "description": "The locale for your application as a [BCP 47](https://www.ietf.org/rfc/bcp/bcp47.txt) language code.\nDefaults to the browser/OS language setting.",
                "name": "locale",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "router": {
                "defaultValue": null,
                "description": "Provides a client side router to all nested React Spectrum links to enable client side navigation.",
                "name": "router",
                "required": false,
                "type": {
                    "name": "Router"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#Provider"] = {
        docgenInfo: Provider.__docgenInfo,
        name: "Provider",
        path: "packages/@react-spectrum/s2/src/index.ts#Provider"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Radio.displayName = "_Radio";
    // @ts-ignore
    _Radio.__docgenInfo = {
        "description": "Radio buttons allow users to select a single option from a list of mutually exclusive options.\nAll possible options are exposed up front for users to compare.",
        "displayName": "_Radio",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "The value of the radio button, used when submitting an HTML form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio#Value).",
                "name": "value",
                "required": true,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The label for the element.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "inputRef": {
                "defaultValue": null,
                "description": "A ref for the HTML input element.",
                "name": "inputRef",
                "required": false,
                "type": {
                    "name": "RefObject<HTMLInputElement | null>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the radio button is disabled or not.\nShows that a selection exists, but is not available in that circumstance.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLLabelElement, HTMLLabelElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Radio"] = {
        docgenInfo: _Radio.__docgenInfo,
        name: "_Radio",
        path: "packages/@react-spectrum/s2/src/index.ts#_Radio"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _RadioGroup.displayName = "_RadioGroup";
    // @ts-ignore
    _RadioGroup.__docgenInfo = {
        "description": "Radio groups allow users to select a single option from a list of mutually exclusive options.\nAll possible options are exposed up front for users to compare.",
        "displayName": "_RadioGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The Radios contained within the RadioGroup.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string | null"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the RadioGroup should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'vertical'"
                },
                "description": "The axis the radio elements should align with.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the RadioGroup.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: string | null) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string | null"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: string) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_RadioGroup"] = {
        docgenInfo: _RadioGroup.__docgenInfo,
        name: "_RadioGroup",
        path: "packages/@react-spectrum/s2/src/index.ts#_RadioGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _RangeSlider.displayName = "_RangeSlider";
    // @ts-ignore
    _RangeSlider.__docgenInfo = {
        "description": "",
        "displayName": "_RangeSlider",
        "props": {
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "RangeValue<number>"
                }
            },
            "endName": {
                "defaultValue": null,
                "description": "The name of the end input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "endName",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formatOptions": {
                "defaultValue": null,
                "description": "The display format of the value label.",
                "name": "formatOptions",
                "required": false,
                "type": {
                    "name": "NumberFormatOptions"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the whole Slider is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Slider should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxValue": {
                "defaultValue": {
                    value: "100"
                },
                "description": "The slider's maximum value.",
                "name": "maxValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minValue": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The slider's minimum value.",
                "name": "minValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Slider.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "startName": {
                "defaultValue": null,
                "description": "The name of the start input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "startName",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "step": {
                "defaultValue": {
                    value: "1"
                },
                "description": "The slider's step value.",
                "name": "step",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "thumbStyle": {
                "defaultValue": {
                    value: "'default'"
                },
                "description": "The style of the Slider's thumb.",
                "name": "thumbStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"default\""
                        },
                        {
                            "value": "\"precise\""
                        }
                    ]
                }
            },
            "trackStyle": {
                "defaultValue": {
                    value: "'thin'"
                },
                "description": "The style of the Slider's track.",
                "name": "trackStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"thick\""
                        },
                        {
                            "value": "\"thin\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "RangeValue<number>"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: RangeValue<number>) => void)"
                }
            },
            "onChangeEnd": {
                "defaultValue": null,
                "description": "Fired when the slider stops moving, due to being let go.",
                "name": "onChangeEnd",
                "required": false,
                "type": {
                    "name": "((value: RangeValue<number>) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLDivElement, HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_RangeSlider"] = {
        docgenInfo: _RangeSlider.__docgenInfo,
        name: "_RangeSlider",
        path: "packages/@react-spectrum/s2/src/index.ts#_RangeSlider"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _SearchField.displayName = "_SearchField";
    // @ts-ignore
    _SearchField.__docgenInfo = {
        "description": "A SearchField is a text field designed for searches.",
        "displayName": "_SearchField",
        "props": {
            "autoComplete": {
                "defaultValue": null,
                "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
                "name": "autoComplete",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inputMode": {
                "defaultValue": null,
                "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
                "name": "inputMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"text\""
                        },
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"url\""
                        },
                        {
                            "value": "\"tel\""
                        },
                        {
                            "value": "\"email\""
                        },
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"numeric\""
                        },
                        {
                            "value": "\"decimal\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxLength": {
                "defaultValue": null,
                "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
                "name": "maxLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minLength": {
                "defaultValue": null,
                "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
                "name": "minLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "pattern": {
                "defaultValue": null,
                "description": "Regex pattern that the value of the input must match to be valid. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefpattern).",
                "name": "pattern",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the SearchField.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "type": {
                "defaultValue": null,
                "description": "The type of input to render. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdeftype).",
                "name": "type",
                "required": false,
                "type": {
                    "name": "(string & {}) | \"text\" | \"search\" | \"url\" | \"tel\" | \"email\" | \"password\""
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: string) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: string) => void)"
                }
            },
            "onClear": {
                "defaultValue": null,
                "description": "Handler that is called when the clear button is pressed.",
                "name": "onClear",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onSubmit": {
                "defaultValue": null,
                "description": "Handler that is called when the SearchField is submitted.",
                "name": "onSubmit",
                "required": false,
                "type": {
                    "name": "((value: string) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_SearchField"] = {
        docgenInfo: _SearchField.__docgenInfo,
        name: "_SearchField",
        path: "packages/@react-spectrum/s2/src/index.ts#_SearchField"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _SegmentedControl.displayName = "_SegmentedControl";
    // @ts-ignore
    _SegmentedControl.__docgenInfo = {
        "description": "A SegmentedControl is a mutually exclusive group of buttons used for view switching.",
        "displayName": "_SegmentedControl",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the segmented control.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelectedKey": {
                "defaultValue": null,
                "description": "The id of the initial selected item (uncontrolled).",
                "name": "defaultSelectedKey",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the segmented control is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isJustified": {
                "defaultValue": null,
                "description": "Whether the items should divide the container width equally.",
                "name": "isJustified",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "selectedKey": {
                "defaultValue": null,
                "description": "The id of the currently selected item (controlled).",
                "name": "selectedKey",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((id: Key) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_SegmentedControl"] = {
        docgenInfo: _SegmentedControl.__docgenInfo,
        name: "_SegmentedControl",
        path: "packages/@react-spectrum/s2/src/index.ts#_SegmentedControl"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _SegmentedControlItem.displayName = "_SegmentedControlItem";
    // @ts-ignore
    _SegmentedControlItem.__docgenInfo = {
        "description": "A SegmentedControlItem represents an option within a SegmentedControl.",
        "displayName": "_SegmentedControlItem",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the segmented control item.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled or not.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_SegmentedControlItem"] = {
        docgenInfo: _SegmentedControlItem.__docgenInfo,
        name: "_SegmentedControlItem",
        path: "packages/@react-spectrum/s2/src/index.ts#_SegmentedControlItem"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Slider.displayName = "_Slider";
    // @ts-ignore
    _Slider.__docgenInfo = {
        "description": "",
        "displayName": "_Slider",
        "props": {
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "fillOffset": {
                "defaultValue": null,
                "description": "The offset from which to start the fill.",
                "name": "fillOffset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "formatOptions": {
                "defaultValue": null,
                "description": "The display format of the value label.",
                "name": "formatOptions",
                "required": false,
                "type": {
                    "name": "NumberFormatOptions"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the whole Slider is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Slider should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxValue": {
                "defaultValue": {
                    value: "100"
                },
                "description": "The slider's maximum value.",
                "name": "maxValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minValue": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The slider's minimum value.",
                "name": "minValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Slider.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "step": {
                "defaultValue": {
                    value: "1"
                },
                "description": "The slider's step value.",
                "name": "step",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "thumbStyle": {
                "defaultValue": {
                    value: "'default'"
                },
                "description": "The style of the Slider's thumb.",
                "name": "thumbStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"default\""
                        },
                        {
                            "value": "\"precise\""
                        }
                    ]
                }
            },
            "trackStyle": {
                "defaultValue": {
                    value: "'thin'"
                },
                "description": "The style of the Slider's track.",
                "name": "trackStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"thick\""
                        },
                        {
                            "value": "\"thin\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: number) => void)"
                }
            },
            "onChangeEnd": {
                "defaultValue": null,
                "description": "Fired when the slider stops moving, due to being let go.",
                "name": "onChangeEnd",
                "required": false,
                "type": {
                    "name": "((value: number) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLDivElement, HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Slider"] = {
        docgenInfo: _Slider.__docgenInfo,
        name: "_Slider",
        path: "packages/@react-spectrum/s2/src/index.ts#_Slider"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    Skeleton.displayName = "Skeleton";
    // @ts-ignore
    Skeleton.__docgenInfo = {
        "description": "A Skeleton wraps around content to render it as a placeholder.",
        "displayName": "Skeleton",
        "props": {
            "isLoading": {
                "defaultValue": null,
                "description": "",
                "name": "isLoading",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#Skeleton"] = {
        docgenInfo: Skeleton.__docgenInfo,
        name: "Skeleton",
        path: "packages/@react-spectrum/s2/src/index.ts#Skeleton"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _StatusLight.displayName = "_StatusLight";
    // @ts-ignore
    _StatusLight.__docgenInfo = {
        "description": "Status lights are used to color code categories and labels commonly found in data visualization.\nWhen status lights have a semantic meaning, they should use semantic variant colors.",
        "displayName": "_StatusLight",
        "props": {
            "variant": {
                "defaultValue": null,
                "description": "The variant changes the color of the status light.\nWhen status lights have a semantic meaning, they should use the variant for semantic colors.",
                "name": "variant",
                "required": true,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"negative\""
                        },
                        {
                            "value": "\"informative\""
                        },
                        {
                            "value": "\"neutral\""
                        },
                        {
                            "value": "\"positive\""
                        },
                        {
                            "value": "\"notice\""
                        },
                        {
                            "value": "\"yellow\""
                        },
                        {
                            "value": "\"celery\""
                        },
                        {
                            "value": "\"seafoam\""
                        },
                        {
                            "value": "\"cyan\""
                        },
                        {
                            "value": "\"indigo\""
                        },
                        {
                            "value": "\"purple\""
                        },
                        {
                            "value": "\"fuchsia\""
                        },
                        {
                            "value": "\"magenta\""
                        },
                        {
                            "value": "\"pink\""
                        },
                        {
                            "value": "\"turquoise\""
                        },
                        {
                            "value": "\"brown\""
                        },
                        {
                            "value": "\"cinnamon\""
                        },
                        {
                            "value": "\"silver\""
                        },
                        {
                            "value": "\"chartreuse\""
                        }
                    ]
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "role": {
                "defaultValue": null,
                "description": "An accessibility role for the status light. Should be set when the status\ncan change at runtime, and no more than one status light will update simultaneously.\nFor cases where multiple statuses can change at the same time, use a Toast instead.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"status\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the StatusLight.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_StatusLight"] = {
        docgenInfo: _StatusLight.__docgenInfo,
        name: "_StatusLight",
        path: "packages/@react-spectrum/s2/src/index.ts#_StatusLight"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Switch.displayName = "_Switch";
    // @ts-ignore
    _Switch.__docgenInfo = {
        "description": "Switches allow users to turn an individual option on or off.\nThey are usually used to activate or deactivate a specific setting.",
        "displayName": "_Switch",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "defaultSelected": {
                "defaultValue": null,
                "description": "Whether the Switch should be selected (uncontrolled).",
                "name": "defaultSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inputRef": {
                "defaultValue": null,
                "description": "A ref for the HTML input element.",
                "name": "inputRef",
                "required": false,
                "type": {
                    "name": "RefObject<HTMLInputElement | null>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Switch should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isSelected": {
                "defaultValue": null,
                "description": "Whether the Switch should be selected (controlled).",
                "name": "isSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Switch.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the Switch's selection state changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((isSelected: boolean) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLLabelElement, HTMLLabelElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Switch"] = {
        docgenInfo: _Switch.__docgenInfo,
        name: "_Switch",
        path: "packages/@react-spectrum/s2/src/index.ts#_Switch"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _TableView.displayName = "_TableView";
    // @ts-ignore
    _TableView.__docgenInfo = {
        "description": "Tables are containers for displaying information. They allow users to quickly scan, sort, compare, and take action on large amounts of data.",
        "displayName": "_TableView",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The elements that make up the table. Includes the TableHeader, TableBody, Columns, and Rows.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "Sets the amount of vertical padding within each cell.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "A list of row keys to disable.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the Table should be displayed with a quiet style.",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "loadingState": {
                "defaultValue": null,
                "description": "The current loading state of the table.",
                "name": "loadingState",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"error\""
                        },
                        {
                            "value": "\"loading\""
                        },
                        {
                            "value": "\"sorting\""
                        },
                        {
                            "value": "\"loadingMore\""
                        },
                        {
                            "value": "\"idle\""
                        },
                        {
                            "value": "\"filtering\""
                        }
                    ]
                }
            },
            "overflowMode": {
                "defaultValue": {
                    value: "'truncate'"
                },
                "description": "Sets the overflow behavior for the cell contents.",
                "name": "overflowMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"wrap\""
                        },
                        {
                            "value": "\"truncate\""
                        }
                    ]
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "The type of selection that is allowed in the collection.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "sortDescriptor": {
                "defaultValue": null,
                "description": "The current sorted column and direction.",
                "name": "sortDescriptor",
                "required": false,
                "type": {
                    "name": "SortDescriptor"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on a row.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "onLoadMore": {
                "defaultValue": null,
                "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
                "name": "onLoadMore",
                "required": false,
                "type": {
                    "name": "(() => any)"
                }
            },
            "onResize": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs a column resize.\nCan be used with the width property on columns to put the column widths into\na controlled state.",
                "name": "onResize",
                "required": false,
                "type": {
                    "name": "((widths: Map<Key, ColumnSize>) => void)"
                }
            },
            "onResizeEnd": {
                "defaultValue": null,
                "description": "Handler that is called after a user performs a column resize.\nCan be used to store the widths of columns for another future session.",
                "name": "onResizeEnd",
                "required": false,
                "type": {
                    "name": "((widths: Map<Key, ColumnSize>) => void)"
                }
            },
            "onResizeStart": {
                "defaultValue": null,
                "description": "Handler that is called when a user starts a column resize.",
                "name": "onResizeStart",
                "required": false,
                "type": {
                    "name": "((widths: Map<Key, ColumnSize>) => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Selection) => void)"
                }
            },
            "onSortChange": {
                "defaultValue": null,
                "description": "Handler that is called when the sorted column or direction changes.",
                "name": "onSortChange",
                "required": false,
                "type": {
                    "name": "((descriptor: SortDescriptor) => any)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_TableView"] = {
        docgenInfo: _TableView.__docgenInfo,
        name: "_TableView",
        path: "packages/@react-spectrum/s2/src/index.ts#_TableView"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _TableHeader.displayName = "_TableHeader";
    // @ts-ignore
    _TableHeader.__docgenInfo = {
        "description": "A header within a `<Table>`, containing the table columns.",
        "displayName": "_TableHeader",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "A list of `Column(s)` or a function. If the latter, a list of columns must be provided using the `columns` prop.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactElement<unknown, string | JSXElementConstructor<any>>)"
                }
            },
            "columns": {
                "defaultValue": null,
                "description": "A list of table columns.",
                "name": "columns",
                "required": false,
                "type": {
                    "name": "T[]"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_TableHeader"] = {
        docgenInfo: _TableHeader.__docgenInfo,
        name: "_TableHeader",
        path: "packages/@react-spectrum/s2/src/index.ts#_TableHeader"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _TableBody.displayName = "_TableBody";
    // @ts-ignore
    _TableBody.__docgenInfo = {
        "description": "The body of a `<Table>`, containing the table rows.",
        "displayName": "_TableBody",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "renderEmptyState": {
                "defaultValue": null,
                "description": "Provides content to display when there are no rows in the table.",
                "name": "renderEmptyState",
                "required": false,
                "type": {
                    "name": "((props: TableBodyRenderProps) => ReactNode)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_TableBody"] = {
        docgenInfo: _TableBody.__docgenInfo,
        name: "_TableBody",
        path: "packages/@react-spectrum/s2/src/index.ts#_TableBody"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Row.displayName = "_Row";
    // @ts-ignore
    _Row.__docgenInfo = {
        "description": "A row within a `<Table>`.",
        "displayName": "_Row",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The cells within the row. Supports static items or a function for dynamic rendering.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactElement<unknown, string | JSXElementConstructor<any>>)"
                }
            },
            "columns": {
                "defaultValue": null,
                "description": "A list of columns used when dynamically rendering cells.",
                "name": "columns",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the row's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Row"] = {
        docgenInfo: _Row.__docgenInfo,
        name: "_Row",
        path: "packages/@react-spectrum/s2/src/index.ts#_Row"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    Cell.displayName = "Cell";
    // @ts-ignore
    Cell.__docgenInfo = {
        "description": "A cell within a table row.",
        "displayName": "Cell",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to render as the cell children.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The alignment of the column's contents relative to its allotted width.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"center\""
                        }
                    ]
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string | ((values: CellRenderProps & { defaultClassName: string; }) => string)"
                }
            },
            "isSticky": {
                "defaultValue": null,
                "description": "@private",
                "name": "isSticky",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "showDivider": {
                "defaultValue": null,
                "description": "Whether the column should render a divider between it and the next column.",
                "name": "showDivider",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties | ((values: CellRenderProps & { defaultStyle: CSSProperties; }) => CSSProperties)"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the cell's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#Cell"] = {
        docgenInfo: Cell.__docgenInfo,
        name: "Cell",
        path: "packages/@react-spectrum/s2/src/index.ts#Cell"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    Column.displayName = "Column";
    // @ts-ignore
    Column.__docgenInfo = {
        "description": "A column within a `<Table>`.",
        "displayName": "Column",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to render as the column header.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The alignment of the column's contents relative to its allotted width.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"center\""
                        }
                    ]
                }
            },
            "allowsResizing": {
                "defaultValue": null,
                "description": "Whether the column allows resizing.",
                "name": "allowsResizing",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "allowsSorting": {
                "defaultValue": null,
                "description": "Whether the column allows sorting.",
                "name": "allowsSorting",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string | ((values: ColumnRenderProps & { defaultClassName: string; }) => string)"
                }
            },
            "defaultWidth": {
                "defaultValue": null,
                "description": "The default width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
                "name": "defaultWidth",
                "required": false,
                "type": {
                    "name": "ColumnSize | null"
                }
            },
            "isRowHeader": {
                "defaultValue": null,
                "description": "Whether a column is a [row header](https://www.w3.org/TR/wai-aria-1.1/#rowheader) and should be announced by assistive technology during row navigation.",
                "name": "isRowHeader",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "maxWidth": {
                "defaultValue": null,
                "description": "The maximum width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
                "name": "maxWidth",
                "required": false,
                "type": {
                    "name": "ColumnStaticSize | null"
                }
            },
            "minWidth": {
                "defaultValue": null,
                "description": "The minimum width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
                "name": "minWidth",
                "required": false,
                "type": {
                    "name": "ColumnStaticSize | null"
                }
            },
            "showDivider": {
                "defaultValue": null,
                "description": "Whether the column should render a divider between it and the next column.",
                "name": "showDivider",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties | ((values: ColumnRenderProps & { defaultStyle: CSSProperties; }) => CSSProperties)"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the column's contents, used for accessibility announcements.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "width": {
                "defaultValue": null,
                "description": "The width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
                "name": "width",
                "required": false,
                "type": {
                    "name": "ColumnSize | null"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#Column"] = {
        docgenInfo: Column.__docgenInfo,
        name: "Column",
        path: "packages/@react-spectrum/s2/src/index.ts#Column"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Tabs.displayName = "_Tabs";
    // @ts-ignore
    _Tabs.__docgenInfo = {
        "description": "Tabs organize content into multiple sections and allow users to navigate between them. The content under the set of tabs should be related and form a coherent unit.",
        "displayName": "_Tabs",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the tabs.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelectedKey": {
                "defaultValue": null,
                "description": "The initial selected key in the collection (uncontrolled).",
                "name": "defaultSelectedKey",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of space between the tabs.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the TabList is disabled.\nShows that a selection exists, but is not available in that circumstance.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "keyboardActivation": {
                "defaultValue": {
                    value: "'automatic'"
                },
                "description": "Whether tabs are activated automatically on focus or manually.",
                "name": "keyboardActivation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"manual\""
                        },
                        {
                            "value": "\"automatic\""
                        }
                    ]
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'horizontal'"
                },
                "description": "The orientation of the tabs.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "selectedKey": {
                "defaultValue": null,
                "description": "The currently selected key in the collection (controlled).",
                "name": "selectedKey",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Tabs"] = {
        docgenInfo: _Tabs.__docgenInfo,
        name: "_Tabs",
        path: "packages/@react-spectrum/s2/src/index.ts#_Tabs"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    TabList.displayName = "TabList";
    // @ts-ignore
    TabList.__docgenInfo = {
        "description": "",
        "displayName": "TabList",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the tablist.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#TabList"] = {
        docgenInfo: TabList.__docgenInfo,
        name: "TabList",
        path: "packages/@react-spectrum/s2/src/index.ts#TabList"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    Tab.displayName = "Tab";
    // @ts-ignore
    Tab.__docgenInfo = {
        "description": "",
        "displayName": "Tab",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the tab.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the tab is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#Tab"] = {
        docgenInfo: Tab.__docgenInfo,
        name: "Tab",
        path: "packages/@react-spectrum/s2/src/index.ts#Tab"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    TabPanel.displayName = "TabPanel";
    // @ts-ignore
    TabPanel.__docgenInfo = {
        "description": "",
        "displayName": "TabPanel",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the tab panels.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "shouldForceMount": {
                "defaultValue": {
                    value: "false"
                },
                "description": "Whether to mount the tab panel in the DOM even when it is not currently selected.\nInactive tab panels are inert and cannot be interacted with. They must be styled appropriately so this is clear to the user visually.",
                "name": "shouldForceMount",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#TabPanel"] = {
        docgenInfo: TabPanel.__docgenInfo,
        name: "TabPanel",
        path: "packages/@react-spectrum/s2/src/index.ts#TabPanel"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _TagGroup.displayName = "_TagGroup";
    // @ts-ignore
    _TagGroup.__docgenInfo = {
        "description": "Tags allow users to categorize content. They can represent keywords or people, and are grouped to describe an item or a search request.",
        "displayName": "_TagGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the tag group.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "groupActionLabel": {
                "defaultValue": null,
                "description": "The label to display on the action button.",
                "name": "groupActionLabel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the tags are displayed in an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the tags are displayed in a error state.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxRows": {
                "defaultValue": null,
                "description": "Limit the number of rows initially shown. This will render a button that allows the user to expand to show all tags.",
                "name": "maxRows",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "renderEmptyState": {
                "defaultValue": null,
                "description": "Provides content to display when there are no items in the tag group.",
                "name": "renderEmptyState",
                "required": false,
                "type": {
                    "name": "(() => ReactNode)"
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "selectionBehavior": {
                "defaultValue": null,
                "description": "How multiple selection should behave in the collection.",
                "name": "selectionBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"toggle\""
                        },
                        {
                            "value": "\"replace\""
                        }
                    ]
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "The type of selection that is allowed in the collection.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the tag group.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onGroupAction": {
                "defaultValue": null,
                "description": "Handler that is called when the action button is pressed.",
                "name": "onGroupAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onRemove": {
                "defaultValue": null,
                "description": "Handler that is called when a user deletes a tag.",
                "name": "onRemove",
                "required": false,
                "type": {
                    "name": "((keys: Set<Key>) => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Selection) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_TagGroup"] = {
        docgenInfo: _TagGroup.__docgenInfo,
        name: "_TagGroup",
        path: "packages/@react-spectrum/s2/src/index.ts#_TagGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _TextArea.displayName = "_TextArea";
    // @ts-ignore
    _TextArea.__docgenInfo = {
        "description": "TextAreas are multiline text inputs, useful for cases where users have\na sizable amount of text to enter. They allow for all customizations that\nare available to text fields.",
        "displayName": "_TextArea",
        "props": {
            "autoComplete": {
                "defaultValue": null,
                "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
                "name": "autoComplete",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inputMode": {
                "defaultValue": null,
                "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
                "name": "inputMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"text\""
                        },
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"url\""
                        },
                        {
                            "value": "\"tel\""
                        },
                        {
                            "value": "\"email\""
                        },
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"numeric\""
                        },
                        {
                            "value": "\"decimal\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxLength": {
                "defaultValue": null,
                "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
                "name": "maxLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minLength": {
                "defaultValue": null,
                "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
                "name": "minLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the text field.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: string) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: string) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<TextFieldRef<HTMLTextAreaElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_TextArea"] = {
        docgenInfo: _TextArea.__docgenInfo,
        name: "_TextArea",
        path: "packages/@react-spectrum/s2/src/index.ts#_TextArea"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _TextField.displayName = "_TextField";
    // @ts-ignore
    _TextField.__docgenInfo = {
        "description": "TextFields are text inputs that allow users to input custom text entries\nwith a keyboard. Various decorations can be displayed around the field to\ncommunicate the entry requirements.",
        "displayName": "_TextField",
        "props": {
            "autoComplete": {
                "defaultValue": null,
                "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
                "name": "autoComplete",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inputMode": {
                "defaultValue": null,
                "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
                "name": "inputMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"text\""
                        },
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"url\""
                        },
                        {
                            "value": "\"tel\""
                        },
                        {
                            "value": "\"email\""
                        },
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"numeric\""
                        },
                        {
                            "value": "\"decimal\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxLength": {
                "defaultValue": null,
                "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
                "name": "maxLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minLength": {
                "defaultValue": null,
                "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
                "name": "minLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "pattern": {
                "defaultValue": null,
                "description": "Regex pattern that the value of the input must match to be valid. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefpattern).",
                "name": "pattern",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the text field.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "type": {
                "defaultValue": null,
                "description": "The type of input to render. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdeftype).",
                "name": "type",
                "required": false,
                "type": {
                    "name": "(string & {}) | \"text\" | \"search\" | \"url\" | \"tel\" | \"email\" | \"password\""
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: string) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: string) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_TextField"] = {
        docgenInfo: _TextField.__docgenInfo,
        name: "_TextField",
        path: "packages/@react-spectrum/s2/src/index.ts#_TextField"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ToggleButton.displayName = "_ToggleButton";
    // @ts-ignore
    _ToggleButton.__docgenInfo = {
        "description": "ToggleButtons allow users to toggle a selection on or off, for example\nswitching between two states or modes.",
        "displayName": "_ToggleButton",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The content to display in the button.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelected": {
                "defaultValue": null,
                "description": "Whether the element should be selected (uncontrolled).",
                "name": "defaultSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the button is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isSelected": {
                "defaultValue": null,
                "description": "Whether the element should be selected (controlled).",
                "name": "isSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "preventFocusOnPress": {
                "defaultValue": null,
                "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
                "name": "preventFocusOnPress",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ActionButton.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the ActionButton appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "type": {
                "defaultValue": {
                    value: "'button'"
                },
                "description": "The behavior of the button when used in an HTML form.",
                "name": "type",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"button\""
                        },
                        {
                            "value": "\"submit\""
                        },
                        {
                            "value": "\"reset\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the element's selection state changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((isSelected: boolean) => void)"
                }
            },
            "onPress": {
                "defaultValue": null,
                "description": "Handler that is called when the press is released over the target.",
                "name": "onPress",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressChange": {
                "defaultValue": null,
                "description": "Handler that is called when the press state changes.",
                "name": "onPressChange",
                "required": false,
                "type": {
                    "name": "((isPressed: boolean) => void)"
                }
            },
            "onPressEnd": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
                "name": "onPressEnd",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressStart": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction starts.",
                "name": "onPressStart",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressUp": {
                "defaultValue": null,
                "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
                "name": "onPressUp",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ToggleButton"] = {
        docgenInfo: _ToggleButton.__docgenInfo,
        name: "_ToggleButton",
        path: "packages/@react-spectrum/s2/src/index.ts#_ToggleButton"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ToggleButtonGroup.displayName = "_ToggleButtonGroup";
    // @ts-ignore
    _ToggleButtonGroup.__docgenInfo = {
        "description": "A ToggleButtonGroup is a grouping of related ToggleButtons, with single or multiple selection.",
        "displayName": "_ToggleButtonGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the group.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "density": {
                "defaultValue": {
                    value: "\"regular\""
                },
                "description": "Spacing between the buttons.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        }
                    ]
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the group is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isJustified": {
                "defaultValue": null,
                "description": "Whether the buttons should divide the container width equally.",
                "name": "isJustified",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'horizontal'"
                },
                "description": "The axis the group should align with.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "Whether single or multiple selection is enabled.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "\"M\""
                },
                "description": "Size of the buttons.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"XS\""
                        },
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Set<Key>) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<HTMLDivElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_ToggleButtonGroup"] = {
        docgenInfo: _ToggleButtonGroup.__docgenInfo,
        name: "_ToggleButtonGroup",
        path: "packages/@react-spectrum/s2/src/index.ts#_ToggleButtonGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Tooltip.displayName = "_Tooltip";
    // @ts-ignore
    _Tooltip.__docgenInfo = {
        "description": "Display container for Tooltip content. Has a directional arrow dependent on its placement.",
        "displayName": "_Tooltip",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content of the tooltip.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_Tooltip"] = {
        docgenInfo: _Tooltip.__docgenInfo,
        name: "_Tooltip",
        path: "packages/@react-spectrum/s2/src/index.ts#_Tooltip"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    TooltipTrigger.displayName = "TooltipTrigger";
    // @ts-ignore
    TooltipTrigger.__docgenInfo = {
        "description": "TooltipTrigger wraps around a trigger element and a Tooltip. It handles opening and closing\nthe Tooltip when the user hovers over or focuses the trigger, and positioning the Tooltip\nrelative to the trigger.",
        "displayName": "TooltipTrigger",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content of the tooltip.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "containerPadding": {
                "defaultValue": {
                    value: "12"
                },
                "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
                "name": "containerPadding",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "crossOffset": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
                "name": "crossOffset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "delay": {
                "defaultValue": {
                    value: "1500"
                },
                "description": "The delay time for the tooltip to show up. [See guidelines](https://spectrum.adobe.com/page/tooltip/#Immediate-or-delayed-appearance).",
                "name": "delay",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the tooltip should be disabled, independent from the trigger.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "offset": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
                "name": "offset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "placement": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The placement of the element with respect to its anchor element.",
                "name": "placement",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        }
                    ]
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "trigger": {
                "defaultValue": null,
                "description": "By default, opens for both focus and hover. Can be made to open only for focus.",
                "name": "trigger",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"focus\""
                        }
                    ]
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean) => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#TooltipTrigger"] = {
        docgenInfo: TooltipTrigger.__docgenInfo,
        name: "TooltipTrigger",
        path: "packages/@react-spectrum/s2/src/index.ts#TooltipTrigger"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    Collection.displayName = "Collection";
    // @ts-ignore
    Collection.__docgenInfo = {
        "description": "A Collection renders a list of items, automatically managing caching and keys.",
        "displayName": "Collection",
        "props": {
            "addIdAndValue": {
                "defaultValue": null,
                "description": "Whether to add `id` and `value` props to all child items.",
                "name": "addIdAndValue",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "idScope": {
                "defaultValue": null,
                "description": "A scope to prepend to all child item ids to ensure they are unique.",
                "name": "idScope",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#Collection"] = {
        docgenInfo: Collection.__docgenInfo,
        name: "Collection",
        path: "packages/@react-spectrum/s2/src/index.ts#Collection"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _FileTrigger.displayName = "_FileTrigger";
    // @ts-ignore
    _FileTrigger.__docgenInfo = {
        "description": "A FileTrigger allows a user to access the file system with any pressable React Aria or React Spectrum component, or custom components built with usePress.",
        "displayName": "_FileTrigger",
        "props": {
            "acceptDirectory": {
                "defaultValue": null,
                "description": "Enables the selection of directories instead of individual files.",
                "name": "acceptDirectory",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "acceptedFileTypes": {
                "defaultValue": null,
                "description": "Specifies what mime type of files are allowed.",
                "name": "acceptedFileTypes",
                "required": false,
                "type": {
                    "name": "string[]"
                }
            },
            "allowsMultiple": {
                "defaultValue": null,
                "description": "Whether multiple files can be selected.",
                "name": "allowsMultiple",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The children of the component.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultCamera": {
                "defaultValue": null,
                "description": "Specifies the use of a media capture mechanism to capture the media on the spot.",
                "name": "defaultCamera",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"user\""
                        },
                        {
                            "value": "\"environment\""
                        }
                    ]
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<HTMLInputElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/index.ts#_FileTrigger"] = {
        docgenInfo: _FileTrigger.__docgenInfo,
        name: "_FileTrigger",
        path: "packages/@react-spectrum/s2/src/index.ts#_FileTrigger"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"./Accordion":"eM4MJ","./ActionButton":"hbuyN","./ActionButtonGroup":"7E1Ly","./ActionMenu":"hqMHG","./AlertDialog":"aUSdB","./Avatar":"3UH45","./AvatarGroup":"5QOSi","./Badge":"bGDQa","./Breadcrumbs":"eRg7d","./Button":"lgKOs","./ButtonGroup":"bQ9CV","./Card":"l7EYo","./CardView":"2W2In","./Checkbox":"7w7or","./CheckboxGroup":"lihSA","./CloseButton":"6s57W","./ColorArea":false,"./ColorField":"aQBoD","./ColorSlider":"44ZUv","./ColorSwatch":false,"./ColorSwatchPicker":false,"./ColorWheel":false,"./ComboBox":"9w8CV","./ContextualHelp":"hfJsD","./Disclosure":"awRID","./Content":"aBWEm","./Dialog":"1TY9V","./CustomDialog":"cpdjl","./FullscreenDialog":"2ybS9","./DialogTrigger":"7SQlT","./DialogContainer":"4CN6y","./Divider":"cE2Z4","./DropZone":"jlcpx","./Form":"gJckc","./Icon":false,"./IllustratedMessage":"67Z4d","./Image":"l3wRP","./ImageCoordinator":false,"./InlineAlert":"cfqoF","./Link":"gBSeO","./Menu":"hGkxl","./Meter":"72J9Y","./NumberField":"atz6N","./Picker":"2JyaH","./Popover":"3Y0dA","./ProgressBar":"kqg2U","./ProgressCircle":"c4KdT","./Provider":"hIsCH","./Radio":"bI0vl","./RadioGroup":"8siyv","./RangeSlider":"axfe0","./SearchField":"kpN9o","./SegmentedControl":"5WxQe","./Slider":"i5lSP","./Skeleton":"2hWWB","./SkeletonCollection":"lVjiz","./StatusLight":"3dgNy","./Switch":"8IIR1","./TableView":"8ATnp","./Tabs":"lccv1","./TagGroup":"2NbbN","./TextField":"7UnVx","./ToggleButton":"adJsp","./ToggleButtonGroup":"7HzpN","./Tooltip":"cWXZX","./pressScale":false,"react-aria-components":"8nuKL","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"eM4MJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccordionContext", ()=>AccordionContext);
parcelHelpers.export(exports, "Accordion", ()=>_Accordion);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _disclosure = require("./Disclosure");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const accordion = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r|k|o|p)[^\s]+/g) || [];
    rules += matches.join('');
    rules += ' _Zd';
    rules += ' _6b';
    return rules;
};
const AccordionContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Accordion(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, AccordionContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { UNSAFE_style, UNSAFE_className = '', size = 'M', density = 'regular', isQuiet } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosure.DisclosureContext).Provider, {
        value: {
            size,
            isQuiet,
            density
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DisclosureGroup), {
            ...props,
            ref: domRef,
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + accordion(null, props.styles),
            children: props.children
        })
    });
}
/**
 * An accordion is a container for multiple disclosures.
 */ let _Accordion = /*#__PURE__*/ (0, _react.forwardRef)(Accordion);
try {
    // @ts-ignore
    AccordionContext.displayName = "AccordionContext";
    // @ts-ignore
    AccordionContext.__docgenInfo = {
        "description": "",
        "displayName": "AccordionContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<AccordionProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Accordion.tsx#AccordionContext"] = {
        docgenInfo: AccordionContext.__docgenInfo,
        name: "AccordionContext",
        path: "packages/@react-spectrum/s2/src/Accordion.tsx#AccordionContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Accordion.displayName = "_Accordion";
    // @ts-ignore
    _Accordion.__docgenInfo = {
        "description": "An accordion is a container for multiple disclosures.",
        "displayName": "_Accordion",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The disclosure elements in the accordion.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "allowsMultipleExpanded": {
                "defaultValue": null,
                "description": "Whether multiple items can be expanded at the same time.",
                "name": "allowsMultipleExpanded",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "defaultExpandedKeys": {
                "defaultValue": null,
                "description": "The initial expanded keys in the group (uncontrolled).",
                "name": "defaultExpandedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of space between the disclosure items.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "expandedKeys": {
                "defaultValue": null,
                "description": "The currently expanded keys in the group (controlled).",
                "name": "expandedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether all items are disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the accordion should be displayed with a quiet style.",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the accordion.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onExpandedChange": {
                "defaultValue": null,
                "description": "Handler that is called when items are expanded or collapsed.",
                "name": "onExpandedChange",
                "required": false,
                "type": {
                    "name": "((keys: Set<Key>) => any)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Accordion.tsx#_Accordion"] = {
        docgenInfo: _Accordion.__docgenInfo,
        name: "_Accordion",
        path: "packages/@react-spectrum/s2/src/Accordion.tsx#_Accordion"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"528o8","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./Disclosure":"awRID","react":"jEiK2","@react-spectrum/utils":"bebxO","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"528o8":[function() {},{}],"awRID":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DisclosureContext", ()=>DisclosureContext);
parcelHelpers.export(exports, "Disclosure", ()=>_Disclosure);
parcelHelpers.export(exports, "DisclosureHeader", ()=>DisclosureHeader);
parcelHelpers.export(exports, "DisclosureTitle", ()=>_DisclosureTitle);
parcelHelpers.export(exports, "DisclosurePanel", ()=>_DisclosurePanel);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DisclosureContext = /*#__PURE__*/ (0, _react.createContext)(null);
const disclosure = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $q = false;
    for (let p of matches)if (/^\s*q/.test(p)) $q = true;
    rules += ' ao';
    if (props.isQuiet) rules += ' ua';
    else rules += ' ub';
    if (props.isInGroup) {
        if (props.isQuiet) rules += ' v-uamghwa';
        else rules += ' v-uamghwb';
        rules += ' va';
    } else if (props.isQuiet) rules += ' va';
    else rules += ' vb';
    rules += ' sa';
    rules += ' ta';
    rules += ' wa';
    rules += ' ch';
    if (!$q) rules += ' q___C';
    return rules;
};
function Disclosure(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, DisclosureContext);
    let { size = 'M', density = 'regular', isQuiet, UNSAFE_style, UNSAFE_className = '' } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isInGroup = (0, _react.useContext)(DisclosureContext) !== null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                DisclosureContext,
                {
                    size,
                    isQuiet,
                    density
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Disclosure), {
            ...props,
            ref: domRef,
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + disclosure({
                isQuiet,
                isInGroup
            }, props.styles),
            children: props.children
        })
    });
}
/**
 * A disclosure is a collapsible section of content. It is composed of a a header with a heading and trigger button, and a panel that contains the content.
 */ let _Disclosure = /*#__PURE__*/ (0, _react.forwardRef)(Disclosure);
const headingStyle = " . Aa Ba ya za _9-3t1y _Zd _8-3t1y qo";
const buttonStyles = function anonymous(props) {
    let rules = " .";
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3hmpw';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbo';
        rules += ' _dn';
    } else if (props.size === "L") {
        rules += ' _dbm';
        rules += ' _dj';
    } else if (props.size === "M") {
        rules += ' _dbl';
        rules += ' _dk';
    } else if (props.size === "S") {
        rules += ' _dbj';
        rules += ' _di';
    }
    rules += ' _ed';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) rules += ' aj';
    else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' _Zd';
    rules += ' _9-3t1y';
    rules += ' _1d';
    rules += ' C-10cd9hn';
    rules += ' D-10cd9hn';
    rules += ' E-1dbqcch';
    rules += ' F-1dbqcch';
    rules += ' i-10cd9hn';
    rules += ' j-10cd9hn';
    rules += ' o-375tou';
    rules += ' lb';
    if (props.isPressed) rules += ' b-mufwl5';
    else if (props.isHovered) rules += ' b-1tgz9bq';
    else if (props.isFocusVisible) rules += ' b-1tgz9bq';
    else rules += ' ba';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' u-375tp0';
    rules += ' v-375tp1';
    rules += ' sa';
    rules += ' ta';
    if (props.isQuiet) rules += ' _vh';
    else if (props.isFocusVisible) rules += ' _vh';
    else rules += ' _va';
    if (props.isQuiet) rules += ' _wh';
    else if (props.isFocusVisible) rules += ' _wh';
    else rules += ' _wa';
    if (props.isQuiet) rules += ' _xh';
    else if (props.isFocusVisible) rules += ' _xh';
    else rules += ' _xa';
    if (props.isQuiet) rules += ' _yh';
    else if (props.isFocusVisible) rules += ' _yh';
    else rules += ' _ya';
    rules += ' _ja';
    rules += ' __R-yksgrp';
    if (props.size === "XL") {
        if (props.density === "spacious") rules += ' -_375tou_o-_q';
        else if (props.density === "regular") rules += ' -_375tou_o-_i';
        else if (props.density === "compact") rules += ' -_375tou_o-_a';
    } else if (props.size === "L") {
        if (props.density === "spacious") rules += ' -_375tou_o-_i';
        else if (props.density === "regular") rules += ' -_375tou_o-_a';
        else if (props.density === "compact") rules += ' -_375tou_o-2';
    } else if (props.size === "M") {
        if (props.density === "spacious") rules += ' -_375tou_o-_a';
        else if (props.density === "regular") rules += ' -_375tou_o-2';
        else if (props.density === "compact") rules += ' -_375tou_o-U';
    } else if (props.size === "S") {
        if (props.density === "spacious") rules += ' -_375tou_o-2';
        else if (props.density === "regular") rules += ' -_375tou_o-U';
        else if (props.density === "compact") rules += ' -_375tou_o-M';
    }
    rules += ' -_375tp0_u-a';
    rules += ' -_375tp1_v-a';
    return rules;
};
const chevronStyles = function anonymous(props) {
    let rules = " .";
    if (props.isExpanded) rules += ' R-3hn0u';
    else if (props.isRTL) rules += ' R-375xa6';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' -rwx0fg_e-b';
    rules += ' _8-3t1x';
    return rules;
};
const InternalDisclosureHeader = /*#__PURE__*/ (0, _react.createContext)(null);
function DisclosureHeaderWithForwardRef(props, ref) {
    let { UNSAFE_className, UNSAFE_style, children } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { size, isQuiet, density } = (0, _reactAriaComponents.useSlottedContext)(DisclosureContext);
    let mapSize = {
        S: 'XS',
        M: 'S',
        L: 'M',
        XL: 'L'
    };
    // maps to one size smaller in the compact density to ensure there is space between the top and bottom of the action button and container
    let newSize = size;
    if (density === 'compact') newSize = mapSize[size ?? 'M'];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _actionButton.ActionButtonContext),
                {
                    size: newSize,
                    isQuiet
                }
            ],
            [
                InternalDisclosureHeader,
                {}
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + " . _Zd _1c ic jc",
            ref: domRef,
            children: children
        })
    });
}
const DisclosureHeader = /*#__PURE__*/ (0, _react.forwardRef)(DisclosureHeaderWithForwardRef);
function DisclosureTitle(props, ref) {
    let { level = 3, UNSAFE_style, UNSAFE_className = '', ...otherProps } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    const domProps = (0, _utils.filterDOMProps)(otherProps);
    let { direction } = (0, _reactAriaComponents.useLocale)();
    let { isExpanded } = (0, _react.useContext)((0, _reactAriaComponents.DisclosureStateContext));
    let { size, density, isQuiet } = (0, _reactAriaComponents.useSlottedContext)(DisclosureContext);
    let isRTL = direction === 'rtl';
    let buttonTrigger = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
        ...domProps,
        level: level,
        ref: domRef,
        style: UNSAFE_style,
        className: (UNSAFE_className ?? '') + headingStyle,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Button), {
            className: (renderProps)=>buttonStyles({
                    ...renderProps,
                    size,
                    density,
                    isQuiet
                }),
            slot: "trigger",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                        size: size,
                        className: chevronStyles({
                            isExpanded,
                            isRTL
                        }),
                        "aria-hidden": "true"
                    })
                }),
                props.children
            ]
        })
    });
    let ctx = (0, _react.useContext)(InternalDisclosureHeader);
    if (ctx) return buttonTrigger;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DisclosureHeader, {
        children: buttonTrigger
    });
}
/**
 * A disclosure title consisting of a heading and a trigger button to expand/collapse the panel.
 */ let _DisclosureTitle = /*#__PURE__*/ (0, _react.forwardRef)(DisclosureTitle);
const panelStyles = function anonymous(props) {
    let rules = " .";
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    rules += ' _dbh';
    rules += ' _dg';
    rules += ' _eb';
    rules += ' _f-1x99dloc';
    rules += ' _fb';
    rules += ' an';
    if (props.isExpanded) rules += ' Ed';
    if (props.isExpanded) rules += ' Ff';
    if (props.isExpanded) {
        if (props.size === "XL") rules += ' Cundefined';
        else if (props.size === "L") rules += ' Ce';
        else if (props.size === "M") rules += ' Cundefined';
        else if (props.size === "S") rules += ' Cd';
    }
    if (props.isExpanded) {
        if (props.size === "XL") rules += ' Dundefined';
        else if (props.size === "L") rules += ' De';
        else if (props.size === "M") rules += ' Dundefined';
        else if (props.size === "S") rules += ' Dd';
    }
    return rules;
};
function DisclosurePanel(props, ref) {
    let { UNSAFE_style, UNSAFE_className = '', ...otherProps } = props;
    const domProps = (0, _utils.filterDOMProps)(otherProps);
    let { size } = (0, _reactAriaComponents.useSlottedContext)(DisclosureContext);
    let { isExpanded } = (0, _react.useContext)((0, _reactAriaComponents.DisclosureStateContext));
    let panelRef = (0, _utils1.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DisclosurePanel), {
        ...domProps,
        ref: panelRef,
        style: UNSAFE_style,
        className: (UNSAFE_className ?? '') + panelStyles({
            size,
            isExpanded
        }),
        children: props.children
    });
}
/**
 * A disclosure panel is a collapsible section of content that is hidden until the disclosure is expanded.
 */ let _DisclosurePanel = /*#__PURE__*/ (0, _react.forwardRef)(DisclosurePanel);
try {
    // @ts-ignore
    DisclosureContext.displayName = "DisclosureContext";
    // @ts-ignore
    DisclosureContext.__docgenInfo = {
        "description": "",
        "displayName": "DisclosureContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<Omit<DisclosureProps, \"children\">, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Disclosure.tsx#DisclosureContext"] = {
        docgenInfo: DisclosureContext.__docgenInfo,
        name: "DisclosureContext",
        path: "packages/@react-spectrum/s2/src/Disclosure.tsx#DisclosureContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Disclosure.displayName = "_Disclosure";
    // @ts-ignore
    _Disclosure.__docgenInfo = {
        "description": "A disclosure is a collapsible section of content. It is composed of a a header with a heading and trigger button, and a panel that contains the content.",
        "displayName": "_Disclosure",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the disclosure, consisting of a DisclosureTitle and DisclosurePanel.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultExpanded": {
                "defaultValue": null,
                "description": "Whether the disclosure is expanded by default (uncontrolled).",
                "name": "defaultExpanded",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of space between the disclosures.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the disclosure is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isExpanded": {
                "defaultValue": null,
                "description": "Whether the disclosure is expanded (controlled).",
                "name": "isExpanded",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the disclosure should be displayed with a quiet style.",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the disclosure.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onExpandedChange": {
                "defaultValue": null,
                "description": "Handler that is called when the disclosure's expanded state changes.",
                "name": "onExpandedChange",
                "required": false,
                "type": {
                    "name": "((isExpanded: boolean) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Disclosure.tsx#_Disclosure"] = {
        docgenInfo: _Disclosure.__docgenInfo,
        name: "_Disclosure",
        path: "packages/@react-spectrum/s2/src/Disclosure.tsx#_Disclosure"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    DisclosureHeader.displayName = "DisclosureHeader";
    // @ts-ignore
    DisclosureHeader.__docgenInfo = {
        "description": "A wrapper element for the disclosure title that can contain other elements not part of the trigger.",
        "displayName": "DisclosureHeader",
        "props": {
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Disclosure.tsx#DisclosureHeader"] = {
        docgenInfo: DisclosureHeader.__docgenInfo,
        name: "DisclosureHeader",
        path: "packages/@react-spectrum/s2/src/Disclosure.tsx#DisclosureHeader"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _DisclosureTitle.displayName = "_DisclosureTitle";
    // @ts-ignore
    _DisclosureTitle.__docgenInfo = {
        "description": "A disclosure title consisting of a heading and a trigger button to expand/collapse the panel.",
        "displayName": "_DisclosureTitle",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the disclosure header.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "level": {
                "defaultValue": {
                    value: "3"
                },
                "description": "The heading level of the disclosure header.",
                "name": "level",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Disclosure.tsx#_DisclosureTitle"] = {
        docgenInfo: _DisclosureTitle.__docgenInfo,
        name: "_DisclosureTitle",
        path: "packages/@react-spectrum/s2/src/Disclosure.tsx#_DisclosureTitle"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _DisclosurePanel.displayName = "_DisclosurePanel";
    // @ts-ignore
    _DisclosurePanel.__docgenInfo = {
        "description": "A disclosure panel is a collapsible section of content that is hidden until the disclosure is expanded.",
        "displayName": "_DisclosurePanel",
        "props": {
            "role": {
                "defaultValue": {
                    value: "'group'"
                },
                "description": "The accessibility role for the disclosure's panel.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"group\""
                        },
                        {
                            "value": "\"region\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Disclosure.tsx#_DisclosurePanel"] = {
        docgenInfo: _DisclosurePanel.__docgenInfo,
        name: "_DisclosurePanel",
        path: "packages/@react-spectrum/s2/src/Disclosure.tsx#_DisclosurePanel"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"giAo4","1":"hu49p","2":"4C72D","3":"buhib","4":"uTBW4","5":"bPhTy","react/jsx-runtime":"2JzhG","./ActionButton":"hbuyN","react-aria-components":"8nuKL","./CenterBaseline":"hXatv","../ui-icons/Chevron":"dnGTM","@react-aria/utils":"e9Yvo","react":"jEiK2","@react-spectrum/utils":"bebxO","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"giAo4":[function() {},{}],"hu49p":[function() {},{}],"4C72D":[function() {},{}],"buhib":[function() {},{}],"uTBW4":[function() {},{}],"bPhTy":[function() {},{}],"dnGTM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Chevron);
var _jsxRuntime = require("react/jsx-runtime");
var _s2ChevronSize200Svg = require("./S2_ChevronSize200.svg");
var _s2ChevronSize200SvgDefault = parcelHelpers.interopDefault(_s2ChevronSize200Svg);
var _s2ChevronSize100Svg = require("./S2_ChevronSize100.svg");
var _s2ChevronSize100SvgDefault = parcelHelpers.interopDefault(_s2ChevronSize100Svg);
var _s2ChevronSize75Svg = require("./S2_ChevronSize75.svg");
var _s2ChevronSize75SvgDefault = parcelHelpers.interopDefault(_s2ChevronSize75Svg);
var _s2ChevronSize300Svg = require("./S2_ChevronSize300.svg");
var _s2ChevronSize300SvgDefault = parcelHelpers.interopDefault(_s2ChevronSize300Svg);
var _s2ChevronSize50Svg = require("./S2_ChevronSize50.svg");
var _s2ChevronSize50SvgDefault = parcelHelpers.interopDefault(_s2ChevronSize50Svg);
var _s2ChevronSize400Svg = require("./S2_ChevronSize400.svg");
var _s2ChevronSize400SvgDefault = parcelHelpers.interopDefault(_s2ChevronSize400Svg);
function Chevron(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2ChevronSize100SvgDefault.default), {
                ...otherProps
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2ChevronSize200SvgDefault.default), {
                ...otherProps
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2ChevronSize300SvgDefault.default), {
                ...otherProps
            });
        case 'XXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2ChevronSize400SvgDefault.default), {
                ...otherProps
            });
        case 'XS':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2ChevronSize50SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2ChevronSize75SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2JzhG","./S2_ChevronSize200.svg":"QtXjj","./S2_ChevronSize100.svg":"1rA73","./S2_ChevronSize75.svg":"knzW7","./S2_ChevronSize300.svg":"kr3cg","./S2_ChevronSize50.svg":"4IgZe","./S2_ChevronSize400.svg":"4YPRU","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"QtXjj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2ChevronSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M9.301 6c0-.049-.02-.095-.028-.143-.01-.068-.013-.136-.039-.2a.9.9 0 0 0-.2-.302L4.343.663a.912.912 0 0 0-1.29 1.29L7.102 6l-4.047 4.048a.912.912 0 0 0 1.289 1.289l4.691-4.692a.9.9 0 0 0 .2-.302c.026-.064.028-.132.04-.2C9.28 6.095 9.3 6.05 9.3 6"
        })
    });
exports.default = SvgS2ChevronSize200;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"1rA73":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2ChevronSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M7.965 5.178C7.978 5.118 8 5.061 8 5s-.021-.118-.034-.178c-.01-.05-.01-.102-.03-.15-.023-.058-.068-.107-.104-.16-.03-.042-.047-.09-.084-.127l-.004-.003-.003-.004L3.615.303a.875.875 0 1 0-1.23 1.244L5.88 5 2.385 8.453a.875.875 0 1 0 1.23 1.244L7.74 5.622l.003-.004.004-.003c.037-.038.055-.085.084-.127.036-.053.08-.102.104-.16.02-.048.02-.1.03-.15"
        })
    });
exports.default = SvgS2ChevronSize100;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"knzW7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2ChevronSize75 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M7.483 4.406 3.86.783a.84.84 0 1 0-1.188 1.188L5.702 5l-3.03 3.03A.84.84 0 1 0 3.86 9.216l3.623-3.623a.84.84 0 0 0 0-1.188"
        })
    });
exports.default = SvgS2ChevronSize75;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kr3cg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2ChevronSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.361 6.328 5.03.996a.954.954 0 0 0-1.343 0 .95.95 0 0 0 0 1.344L8.346 7l-4.66 4.66a.95.95 0 0 0 1.344 1.344l5.331-5.332a.95.95 0 0 0 0-1.344"
        })
    });
exports.default = SvgS2ChevronSize300;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"4IgZe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2ChevronSize50 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 6,
        height: 6,
        viewBox: "0 0 6 6",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M1.985 5.961a.695.695 0 0 1-.7-.704.7.7 0 0 1 .209-.493L3.279 3 1.51 1.251A.7.7 0 0 1 1.3.757.696.696 0 0 1 2.492.255l2.275 2.247a.7.7 0 0 1 0 .996L2.477 5.76a.7.7 0 0 1-.492.201"
        })
    });
exports.default = SvgS2ChevronSize50;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"4YPRU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2ChevronSize400 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M11.726 7.3 5.67 1.247A.988.988 0 1 0 4.27 2.645L9.628 8 4.27 13.355a.988.988 0 1 0 1.399 1.399l6.056-6.055a.99.99 0 0 0 0-1.398"
        })
    });
exports.default = SvgS2ChevronSize400;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hqMHG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMenuContext", ()=>ActionMenuContext);
parcelHelpers.export(exports, "ActionMenu", ()=>_ActionMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _react = require("react");
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _menu = require("./Menu");
var _s2IconMore20NSvg = require("../s2wf-icons/S2_Icon_More_20_N.svg");
var _s2IconMore20NSvgDefault = parcelHelpers.interopDefault(_s2IconMore20NSvg);
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ActionMenuContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ActionMenu(props, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ActionMenuContext);
    let buttonProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    if (buttonProps['aria-label'] === undefined) buttonProps['aria-label'] = stringFormatter.format('menu.moreActions');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
        isOpen: props.isOpen,
        defaultOpen: props.defaultOpen,
        onOpenChange: props.onOpenChange,
        align: props.align,
        direction: props.direction,
        shouldFlip: props.shouldFlip,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                ref: ref,
                size: props.size,
                isDisabled: props.isDisabled,
                autoFocus: props.autoFocus,
                isQuiet: props.isQuiet,
                styles: props.styles,
                ...buttonProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconMore20NSvgDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
                items: props.items,
                disabledKeys: props.disabledKeys,
                onAction: props.onAction,
                size: props.menuSize,
                children: props.children
            })
        ]
    });
}
/**
 * ActionMenu combines an ActionButton with a Menu for simple "more actions" use cases.
 */ let _ActionMenu = /*#__PURE__*/ (0, _react.forwardRef)(ActionMenu);
try {
    // @ts-ignore
    ActionMenuContext.displayName = "ActionMenuContext";
    // @ts-ignore
    ActionMenuContext.__docgenInfo = {
        "description": "",
        "displayName": "ActionMenuContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ActionMenuProps<any>, FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ActionMenu.tsx#ActionMenuContext"] = {
        docgenInfo: ActionMenuContext.__docgenInfo,
        name: "ActionMenuContext",
        path: "packages/@react-spectrum/s2/src/ActionMenu.tsx#ActionMenuContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ActionMenu.displayName = "_ActionMenu";
    // @ts-ignore
    _ActionMenu.__docgenInfo = {
        "description": "ActionMenu combines an ActionButton with a Menu for simple \"more actions\" use cases.",
        "displayName": "_ActionMenu",
        "props": {
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "Alignment of the menu relative to the trigger.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "direction": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "Where the Menu opens relative to its trigger.",
                "name": "direction",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the button is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "menuSize": {
                "defaultValue": null,
                "description": "",
                "name": "menuSize",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the menu should automatically flip direction when space is limited.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ActionButton.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        },
                        {
                            "value": "\"XS\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when an item is selected.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ActionMenu.tsx#_ActionMenu"] = {
        docgenInfo: _ActionMenu.__docgenInfo,
        name: "_ActionMenu",
        path: "packages/@react-spectrum/s2/src/ActionMenu.tsx#_ActionMenu"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"react/jsx-runtime":"2JzhG","./ActionButton":"hbuyN","react":"jEiK2","@react-aria/utils":"e9Yvo","../intl/*.json":"iU6xz","./Menu":"hGkxl","../s2wf-icons/S2_Icon_More_20_N.svg":"8N2I0","@react-aria/i18n":"hFrKJ","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hGkxl":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuContext", ()=>MenuContext);
parcelHelpers.export(exports, "menu", ()=>menu);
parcelHelpers.export(exports, "section", ()=>section);
parcelHelpers.export(exports, "sectionHeader", ()=>sectionHeader);
parcelHelpers.export(exports, "sectionHeading", ()=>sectionHeading);
parcelHelpers.export(exports, "menuitem", ()=>menuitem);
parcelHelpers.export(exports, "checkmark", ()=>checkmark);
parcelHelpers.export(exports, "icon", ()=>icon);
parcelHelpers.export(exports, "iconCenterWrapper", ()=>iconCenterWrapper);
parcelHelpers.export(exports, "label", ()=>label);
parcelHelpers.export(exports, "description", ()=>description);
parcelHelpers.export(exports, "Menu", ()=>_Menu);
parcelHelpers.export(exports, "Divider", ()=>Divider);
parcelHelpers.export(exports, "MenuSection", ()=>MenuSection);
parcelHelpers.export(exports, "MenuItem", ()=>MenuItem);
parcelHelpers.export(exports, "MenuTrigger", ()=>MenuTrigger);
parcelHelpers.export(exports, "SubmenuTrigger", ()=>SubmenuTrigger);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "CombinedMenu", ()=>CombinedMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkbox = require("./Checkbox");
var _centerBaseline = require("./CenterBaseline");
var _checkmark = require("../ui-icons/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _react = require("react");
var _divider = require("./Divider");
var _content = require("./Content");
var _icon = require("./Icon"); // chevron right removed??
var _image = require("./Image");
var _linkOut = require("../ui-icons/LinkOut");
var _linkOutDefault = parcelHelpers.interopDefault(_linkOut);
var _runtime = require("../style/runtime");
var _reactAria = require("react-aria");
var _popover = require("./Popover");
var _interactions = require("@react-aria/interactions");
var _pressScale = require("./pressScale");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const MenuContext = /*#__PURE__*/ (0, _react.createContext)(null);
let menu = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $r = false;
    for (let p of matches)if (/^\s*r/.test(p)) $r = true;
    rules += ' _La';
    rules += ' _Zf';
    if (props.size === "XL") rules += ' __h-358ibk';
    else if (props.size === "L") rules += ' __h-1w0s9l0';
    else if (props.size === "M") rules += ' __h-1kgdida';
    else if (props.size === "S") rules += ' __h-17i5a9u';
    rules += ' __na';
    rules += ' p-17zqamw';
    if (props.isPopover) rules += ' __va';
    if (props.isPopover) rules += ' __wa';
    if (!$r) {
        if (props.isPopover) rules += ' r_____z';
    }
    if (props.isPopover) rules += ' Ed';
    if (props.isPopover) rules += ' Fd';
    if (props.isPopover) rules += ' Cd';
    if (props.isPopover) rules += ' Dd';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    return rules;
};
let section = " . __a-3t1y __b-3hmpv _1c _Zf __j-f9k53a __h-1cwd7ud";
let sectionHeader = function anonymous(props) {
    let rules = " .";
    if (props.isPressed) rules += ' ao';
    else if (props.isFocusVisible) rules += ' ao';
    else if (props.isHovered) rules += ' ao';
    else rules += ' an';
    rules += ' __a-3t1z';
    rules += ' __b-3hmpw';
    rules += ' __na';
    rules += ' o-375tou';
    rules += ' E-1dbqcch';
    rules += ' F-1dbqcch';
    if (props.size === "XL") rules += ' -_375tou_o-j';
    else if (props.size === "L") rules += ' -_375tou_o-i';
    else if (props.size === "S") rules += ' -_375tou_o-h';
    else if (props.size === "XS") rules += ' -_375tou_o-g';
    else rules += ' -_375tou_o-f';
    return rules;
};
let sectionHeading = " . _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _de _dbf _ed _fa _f-1x99dlob an Aa Ba ya za";
let menuitem = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $U = false;
    let $__a = false;
    let $__b = false;
    for (let p of matches){
        if (/^\s*U/.test(p)) $U = true;
        if (/^\s*__a/.test(p)) $__a = true;
        if (/^\s*__b/.test(p)) $__b = true;
    }
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    rules += ' __na';
    rules += ' _vh';
    rules += ' _wh';
    rules += ' _xh';
    rules += ' _yh';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) {
        rules += ' aa_____B';
        rules += ' aj';
    } else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' -_1gogtue_E--1dbqcch';
    rules += ' F-1gogtue';
    if (props.isFocused) rules += ' bh';
    else rules += ' ba';
    if (!$U) rules += ' Uc';
    if (!$__a) rules += ' __a-3t1y';
    if (!$__b) rules += ' __b-3hmpv';
    rules += ' _Zf';
    rules += ' __j-f9k53a';
    rules += ' __h-1cwd7ud';
    rules += ' __i-1mnwavb-1wamrdj';
    rules += ' __i-kmtuht';
    rules += ' i-1mnwavb-cplj4k';
    rules += ' _1d';
    rules += ' o-375tou';
    rules += ' _ld';
    if (props.isLink) rules += ' __Hc';
    else rules += ' __Hb';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    if (props.size === "XL") rules += ' -_375tou_o-j';
    else if (props.size === "L") rules += ' -_375tou_o-i';
    else if (props.size === "S") rules += ' -_375tou_o-h';
    else if (props.size === "XS") rules += ' -_375tou_o-g';
    else rules += ' -_375tou_o-f';
    return rules;
};
let checkmark = function anonymous(props) {
    let rules = " .";
    if (props.isSelected) rules += ' __Ea';
    else rules += ' __Eb';
    rules += ' __a-jjmfgu';
    rules += ' __b-jjmfgu';
    rules += ' __c-jjmfgu';
    rules += ' __d-jjmfgu';
    if (props.isPressed) rules += ' az';
    else if (props.isFocusVisible) rules += ' az';
    else if (props.isHovered) rules += ' az';
    else rules += ' ay';
    rules += ' -rwx0fg_e-a_____X';
    rules += ' -rwx0fg_e-b';
    rules += ' zF';
    rules += ' _bb';
    return rules;
};
let checkbox = " . __a-jjmfgu __b-jjmfgu __c-jjmfgu __d-jjmfgu zF";
let icon = " . _Za l-1sthc3k k-1sthc3k zG zbH -rwx0fg_e-b";
let iconCenterWrapper = " . _Zd __a-ykjmzy __b-ykjmzy __c-ykjmzy __d-ykjmzy";
let image = function anonymous(props) {
    let rules = " .";
    rules += ' __a-ykjmzy';
    rules += ' __b-ykjmzy';
    rules += ' __c-ykjmzy';
    rules += ' __d-7u9dhl';
    rules += ' zbH';
    rules += ' zG';
    rules += ' A-1kmz9hv';
    rules += ' _4d';
    rules += ' _vb';
    rules += ' _wb';
    rules += ' _xb';
    rules += ' _yb';
    if (props.size === "XL") rules += ' l_a';
    else if (props.size === "L") rules += ' l6';
    else if (props.size === "M") rules += ' l2';
    else if (props.size === "S") rules += ' lU';
    else rules += ' l2';
    if (props.size === "XL") rules += ' k_a';
    else if (props.size === "L") rules += ' k6';
    else if (props.size === "M") rules += ' k2';
    else if (props.size === "S") rules += ' kU';
    else rules += ' k2';
    rules += ' _bb';
    rules += ' __Na';
    return rules;
};
let label = function anonymous(props) {
    let rules = " .";
    rules += ' __a-4e9m05';
    rules += ' __b-4e9m05';
    rules += ' __c-4e9m05';
    rules += ' __d-4e9m05';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _ec';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    rules += ' a-17zqamw';
    rules += ' A-1gogtue';
    return rules;
};
let description = function anonymous(props) {
    let rules = " .";
    rules += ' __a-14f9fux';
    rules += ' __b-14f9fux';
    rules += ' __c-14f9fux';
    rules += ' __d-14f9fux';
    if (props.size === "XL") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "L") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "M") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "S") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    }
    if (props.size === "XL") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "L") {
        rules += ' _dbf';
        rules += ' _de';
    } else if (props.size === "M") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "S") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbd';
        rules += ' _dc';
    }
    if (props.size === "XL") rules += ' _eb';
    else if (props.size === "L") rules += ' _eb';
    else if (props.size === "M") rules += ' _eb';
    else if (props.size === "S") rules += ' _eb';
    else rules += ' _eb';
    if (props.size === "XL") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    } else if (props.size === "L") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    } else if (props.size === "M") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    } else if (props.size === "S") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    } else {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    }
    if (props.isDisabled) rules += ' aj';
    else if (props.isFocused) rules += ' an';
    else {
        if (props.isPressed) rules += ' an';
        else if (props.isFocusVisible) rules += ' an';
        else if (props.isHovered) rules += ' an';
        else rules += ' am';
    }
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    return rules;
};
let value = " . __a-4lc1fm __b-4lc1fm __c-4lc1fm __d-4lc1fm yd";
let keyboard = function anonymous(props) {
    let rules = " .";
    rules += ' __a-1fzj7g6';
    rules += ' __b-1fzj7g6';
    rules += ' __c-1fzj7g6';
    rules += ' __d-1fzj7g6';
    rules += ' yd';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    rules += ' _dbf';
    rules += ' _de';
    rules += ' _ea';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) rules += ' aa_____B';
    if (props.isDisabled) rules += ' aj';
    else rules += ' al';
    return rules;
};
let descriptor = " . __a-1eqbudg __b-1eqbudg __c-1eqbudg __d-1eqbudg yd -rwx0fg_e-b";
let InternalMenuContext = /*#__PURE__*/ (0, _react.createContext)({
    size: 'M',
    isSubmenu: false
});
let InternalMenuTriggerContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Menu(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, MenuContext);
    let { isSubmenu, size: ctxSize } = (0, _react.useContext)(InternalMenuContext);
    let { children, size = ctxSize, UNSAFE_style, UNSAFE_className, styles } = props;
    let ctx = (0, _react.useContext)(InternalMenuTriggerContext);
    let { align = 'start', direction = 'bottom', shouldFlip } = ctx ?? {};
    // TODO: change offset/crossoffset based on size? scale?
    // actual values?
    let initialPlacement;
    switch(direction){
        case 'left':
        case 'right':
        case 'start':
        case 'end':
            initialPlacement = `${direction} ${align === 'end' ? 'bottom' : 'top'}`;
            break;
        case 'bottom':
        case 'top':
        default:
            initialPlacement = `${direction} ${align}`;
    }
    if (isSubmenu) initialPlacement = 'end top';
    let content = /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalMenuContext.Provider, {
        value: {
            size,
            isSubmenu: true
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _content.HeaderContext),
                    {
                        styles: sectionHeader({
                            size
                        })
                    }
                ],
                [
                    (0, _content.HeadingContext),
                    {
                        styles: sectionHeading
                    }
                ],
                [
                    (0, _content.TextContext),
                    {
                        slots: {
                            'description': {
                                styles: description({
                                    size
                                })
                            }
                        }
                    }
                ]
            ],
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Menu), {
                ...props,
                className: menu({
                    size,
                    isPopover: !!ctx || isSubmenu
                }, ctx ? null : styles),
                children: children
            })
        })
    });
    if (ctx || isSubmenu) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverBase), {
        ref: ref,
        hideArrow: true,
        placement: initialPlacement,
        shouldFlip: shouldFlip,
        // For submenus, the offset from the edge of the popover should be 10px.
        // Subtract 8px for the padding around the parent menu.
        offset: isSubmenu ? -2 : 8,
        // Offset by padding + border so that the first item in a submenu lines up with the parent menu item.
        crossOffset: isSubmenu ? -9 : 0,
        UNSAFE_style: UNSAFE_style,
        UNSAFE_className: UNSAFE_className,
        styles: styles,
        children: content
    });
    return content;
}
/**
 * Menus display a list of actions or options that a user can choose.
 */ let _Menu = /*#__PURE__*/ (0, _react.forwardRef)(Menu);
function Divider(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Separator), {
        ...props,
        className: (0, _runtime.mergeStyles)((0, _divider.divider)({
            size: 'M',
            orientation: 'horizontal',
            staticColor: undefined
        }), " . _Zf _Z-uamghwj __a-3t1z __b-3hmpw A-1x1h2a6 B-1x1h2a6")
    });
}
function MenuSection(props) {
    // remember, context doesn't work if it's around Section nor inside
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.MenuSection), {
                ...props,
                className: section,
                children: props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Divider, {})
        ]
    });
}
const checkmarkIconSize = {
    S: 'XS',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
const linkIconSize = {
    S: 'M',
    M: 'L',
    L: 'XL',
    XL: 'XL'
};
function MenuItem(props1) {
    let ref = (0, _react.useRef)(null);
    let isLink = props1.href != null;
    let isLinkOut = isLink && props1.target === '_blank';
    let { size } = (0, _react.useContext)(InternalMenuContext);
    let textValue = props1.textValue || (typeof props1.children === 'string' ? props1.children : undefined);
    let { direction } = (0, _reactAria.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.MenuItem), {
        ...props1,
        textValue: textValue,
        ref: ref,
        style: (0, _pressScale.pressScale)(ref, props1.UNSAFE_style),
        className: (renderProps)=>(props1.UNSAFE_className || '') + menuitem({
                ...renderProps,
                isFocused: renderProps.hasSubmenu && renderProps.isOpen || renderProps.isFocused,
                size,
                isLink
            }, props1.styles),
        children: (renderProps)=>{
            let { children } = props1;
            let checkboxRenderProps = {
                ...renderProps,
                size,
                isFocused: false,
                isFocusVisible: false,
                isIndeterminate: false,
                isReadOnly: false,
                isInvalid: false,
                isRequired: false
            };
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Provider), {
                    values: [
                        [
                            (0, _icon.IconContext),
                            {
                                slots: {
                                    icon: {
                                        render: (0, _centerBaseline.centerBaseline)({
                                            slot: 'icon',
                                            styles: iconCenterWrapper
                                        }),
                                        styles: icon
                                    },
                                    descriptor: {
                                        render: (0, _centerBaseline.centerBaseline)({
                                            slot: 'descriptor',
                                            styles: descriptor
                                        })
                                    } // TODO: remove once we have default?
                                }
                            }
                        ],
                        [
                            (0, _content.TextContext),
                            {
                                slots: {
                                    label: {
                                        styles: label({
                                            size
                                        })
                                    },
                                    description: {
                                        styles: description({
                                            ...renderProps,
                                            size
                                        })
                                    },
                                    value: {
                                        styles: value
                                    }
                                }
                            }
                        ],
                        [
                            (0, _content.KeyboardContext),
                            {
                                styles: keyboard({
                                    size,
                                    isDisabled: renderProps.isDisabled
                                })
                            }
                        ],
                        [
                            (0, _image.ImageContext),
                            {
                                styles: image({
                                    size
                                })
                            }
                        ]
                    ],
                    children: [
                        renderProps.selectionMode === 'single' && !isLink && !renderProps.hasSubmenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                            size: checkmarkIconSize[size],
                            className: checkmark({
                                ...renderProps,
                                size
                            })
                        }),
                        renderProps.selectionMode === 'multiple' && !isLink && !renderProps.hasSubmenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _runtime.mergeStyles)(checkbox, (0, _checkbox.box)(checkboxRenderProps)),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                                size: size,
                                className: (0, _checkbox.iconStyles)
                            })
                        }),
                        typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                            slot: "label",
                            children: children
                        }) : children,
                        isLinkOut && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkOutDefault.default), {
                            size: linkIconSize[size],
                            className: descriptor
                        }),
                        renderProps.hasSubmenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            slot: "descriptor",
                            className: descriptor,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                                size: size,
                                className: function anonymous(props) {
                                    let rules = " .";
                                    if (props.direction === "rtl") rules += ' S-3hmpv';
                                    return rules;
                                }({
                                    direction
                                })
                            })
                        })
                    ]
                })
            });
        }
    });
}
/**
 * The MenuTrigger serves as a wrapper around a Menu and its associated trigger,
 * linking the Menu's open state with the trigger's press state.
 */ function MenuTrigger(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalMenuTriggerContext.Provider, {
        value: {
            align: props.align,
            direction: props.direction,
            shouldFlip: props.shouldFlip
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.MenuTrigger), {
            ...props,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _interactions.PressResponder), {
                isPressed: false,
                children: props.children
            })
        })
    });
}
const SubmenuTrigger = (0, _reactAriaComponents.SubmenuTrigger);
function CombinedMenu(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {});
}
try {
    // @ts-ignore
    Divider.displayName = "Divider";
    // @ts-ignore
    Divider.__docgenInfo = {
        "description": "",
        "displayName": "Divider",
        "props": {
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "elementType": {
                "defaultValue": null,
                "description": "The HTML element type that will be used to render the separator.",
                "name": "elementType",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'horizontal'"
                },
                "description": "The orientation of the separator.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#Divider"] = {
        docgenInfo: Divider.__docgenInfo,
        name: "Divider",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#Divider"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    MenuSection.displayName = "MenuSection";
    // @ts-ignore
    MenuSection.__docgenInfo = {
        "description": "",
        "displayName": "MenuSection",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Static child items or a function to render children.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactElement<unknown, string | JSXElementConstructor<any>>)"
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The currently disabled keys in the collection (controlled).",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the section.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "The type of selection that is allowed in the collection.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Selection) => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#MenuSection"] = {
        docgenInfo: MenuSection.__docgenInfo,
        name: "MenuSection",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#MenuSection"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    MenuItem.displayName = "MenuItem";
    // @ts-ignore
    MenuItem.__docgenInfo = {
        "description": "",
        "displayName": "MenuItem",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the item.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when the item is selected.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#MenuItem"] = {
        docgenInfo: MenuItem.__docgenInfo,
        name: "MenuItem",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#MenuItem"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    CombinedMenu.displayName = "CombinedMenu";
    // @ts-ignore
    CombinedMenu.__docgenInfo = {
        "description": "",
        "displayName": "CombinedMenu",
        "props": {
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "Alignment of the menu relative to the trigger.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Where the focus should be set.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean | FocusStrategy"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "direction": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "Where the Menu opens relative to its trigger.",
                "name": "direction",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "The type of selection that is allowed in the collection.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the menu should automatically flip direction when space is limited.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "shouldFocusWrap": {
                "defaultValue": null,
                "description": "Whether keyboard navigation is circular.",
                "name": "shouldFocusWrap",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Menu.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "trigger": {
                "defaultValue": {
                    value: "'press'"
                },
                "description": "How the menu is triggered.",
                "name": "trigger",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"press\""
                        },
                        {
                            "value": "\"longPress\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when an item is selected.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "onClose": {
                "defaultValue": null,
                "description": "Handler that is called when the menu should close after selecting an item.",
                "name": "onClose",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean) => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Selection) => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#CombinedMenu"] = {
        docgenInfo: CombinedMenu.__docgenInfo,
        name: "CombinedMenu",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#CombinedMenu"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    MenuContext.displayName = "MenuContext";
    // @ts-ignore
    MenuContext.__docgenInfo = {
        "description": "",
        "displayName": "MenuContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<MenuProps<any>, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#MenuContext"] = {
        docgenInfo: MenuContext.__docgenInfo,
        name: "MenuContext",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#MenuContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    menu.displayName = "menu";
    // @ts-ignore
    menu.__docgenInfo = {
        "description": "",
        "displayName": "menu",
        "props": {
            "isPopover": {
                "defaultValue": null,
                "description": "",
                "name": "isPopover",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": true,
                "type": {
                    "name": "any"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#menu"] = {
        docgenInfo: menu.__docgenInfo,
        name: "menu",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#menu"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    sectionHeader.displayName = "sectionHeader";
    // @ts-ignore
    sectionHeader.__docgenInfo = {
        "description": "",
        "displayName": "sectionHeader",
        "props": {
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#sectionHeader"] = {
        docgenInfo: sectionHeader.__docgenInfo,
        name: "sectionHeader",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#sectionHeader"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    menuitem.displayName = "menuitem";
    // @ts-ignore
    menuitem.__docgenInfo = {
        "description": "",
        "displayName": "menuitem",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "",
                "name": "isDisabled",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "isFocused": {
                "defaultValue": null,
                "description": "",
                "name": "isFocused",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "isFocusVisible": {
                "defaultValue": null,
                "description": "",
                "name": "isFocusVisible",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "isLink": {
                "defaultValue": null,
                "description": "",
                "name": "isLink",
                "required": true,
                "type": {
                    "name": "any"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#menuitem"] = {
        docgenInfo: menuitem.__docgenInfo,
        name: "menuitem",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#menuitem"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    checkmark.displayName = "checkmark";
    // @ts-ignore
    checkmark.__docgenInfo = {
        "description": "",
        "displayName": "checkmark",
        "props": {
            "isSelected": {
                "defaultValue": null,
                "description": "",
                "name": "isSelected",
                "required": true,
                "type": {
                    "name": "any"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#checkmark"] = {
        docgenInfo: checkmark.__docgenInfo,
        name: "checkmark",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#checkmark"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    label.displayName = "label";
    // @ts-ignore
    label.__docgenInfo = {
        "description": "",
        "displayName": "label",
        "props": {
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": true,
                "type": {
                    "name": "string"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#label"] = {
        docgenInfo: label.__docgenInfo,
        name: "label",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#label"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    description.displayName = "description";
    // @ts-ignore
    description.__docgenInfo = {
        "description": "",
        "displayName": "description",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "",
                "name": "isDisabled",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "isFocused": {
                "defaultValue": null,
                "description": "",
                "name": "isFocused",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": true,
                "type": {
                    "name": "any"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#description"] = {
        docgenInfo: description.__docgenInfo,
        name: "description",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#description"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Menu.displayName = "_Menu";
    // @ts-ignore
    _Menu.__docgenInfo = {
        "description": "Menus display a list of actions or options that a user can choose.",
        "displayName": "_Menu",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Where the focus should be set.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean | FocusStrategy"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "The type of selection that is allowed in the collection.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "shouldFocusWrap": {
                "defaultValue": null,
                "description": "Whether keyboard navigation is circular.",
                "name": "shouldFocusWrap",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Menu.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when an item is selected.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "onClose": {
                "defaultValue": null,
                "description": "Handler that is called when the menu should close after selecting an item.",
                "name": "onClose",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Selection) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#_Menu"] = {
        docgenInfo: _Menu.__docgenInfo,
        name: "_Menu",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#_Menu"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    MenuTrigger.displayName = "MenuTrigger";
    // @ts-ignore
    MenuTrigger.__docgenInfo = {
        "description": "The MenuTrigger serves as a wrapper around a Menu and its associated trigger,\nlinking the Menu's open state with the trigger's press state.",
        "displayName": "MenuTrigger",
        "props": {
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "Alignment of the menu relative to the trigger.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "direction": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "Where the Menu opens relative to its trigger.",
                "name": "direction",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        }
                    ]
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the menu should automatically flip direction when space is limited.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "trigger": {
                "defaultValue": {
                    value: "'press'"
                },
                "description": "How the menu is triggered.",
                "name": "trigger",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"press\""
                        },
                        {
                            "value": "\"longPress\""
                        }
                    ]
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean) => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Menu.tsx#MenuTrigger"] = {
        docgenInfo: MenuTrigger.__docgenInfo,
        name: "MenuTrigger",
        path: "packages/@react-spectrum/s2/src/Menu.tsx#MenuTrigger"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"6dpAl","1":"jyBSB","2":"gapV9","3":"01ata","4":"kemQH","5":"29T9p","6":"k8tCG","7":"jqhqx","8":"laPGA","9":"3pDbQ","10":"lPAee","11":"6pu5R","12":"3CsJn","13":"g5Gzm","14":"fVLVb","15":"bMJgC","16":"38VBk","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./Checkbox":"7w7or","./CenterBaseline":"hXatv","../ui-icons/Checkmark":"255By","../ui-icons/Chevron":"dnGTM","react":"jEiK2","./Divider":"cE2Z4","./Content":"aBWEm","./Icon":"1OC2a","./Image":"l3wRP","../ui-icons/LinkOut":"fVkBV","../style/runtime":"dzhKB","react-aria":"4BEis","./Popover":"3Y0dA","@react-aria/interactions":"dtdXE","./pressScale":"6BiUY","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"6dpAl":[function() {},{}],"jyBSB":[function() {},{}],"gapV9":[function() {},{}],"01ata":[function() {},{}],"kemQH":[function() {},{}],"29T9p":[function() {},{}],"k8tCG":[function() {},{}],"jqhqx":[function() {},{}],"laPGA":[function() {},{}],"3pDbQ":[function() {},{}],"lPAee":[function() {},{}],"6pu5R":[function() {},{}],"3CsJn":[function() {},{}],"g5Gzm":[function() {},{}],"fVLVb":[function() {},{}],"bMJgC":[function() {},{}],"38VBk":[function() {},{}],"7w7or":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxContext", ()=>CheckboxContext);
parcelHelpers.export(exports, "box", ()=>box);
parcelHelpers.export(exports, "iconStyles", ()=>iconStyles);
parcelHelpers.export(exports, "Checkbox", ()=>_Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _checkmark = require("../ui-icons/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _react = require("react");
var _dash = require("../ui-icons/Dash");
var _dashDefault = parcelHelpers.interopDefault(_dash);
var _form = require("./Form");
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const CheckboxContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $l = false;
    let $__a = false;
    for (let p of matches){
        if (/^\s*l/.test(p)) $l = true;
        if (/^\s*__a/.test(p)) $__a = true;
    }
    rules += ' _Zd';
    rules += ' jF';
    rules += ' _1d';
    if (!$l) rules += ' le';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) {
        rules += ' aa_____B';
        rules += ' aj';
    } else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' _Ob';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    if (!$__a) {
        if (props.isInForm) rules += ' __a-4a7c5l';
    }
    rules += ' __R-yksgrp';
    return rules;
};
const box = function anonymous(props) {
    let rules = " .";
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    if (props.size === "XL") rules += ' lg';
    else if (props.size === "L") rules += ' lm';
    else if (props.size === "S") rules += ' ll';
    else rules += ' lk';
    if (props.size === "XL") rules += ' kg';
    else if (props.size === "L") rules += ' km';
    else if (props.size === "S") rules += ' kl';
    else rules += ' kk';
    rules += ' _vi';
    rules += ' _wi';
    rules += ' _xi';
    rules += ' _yi';
    rules += ' _8-3t1x';
    rules += ' _Zd';
    rules += ' _1c';
    rules += ' _2d';
    rules += ' uc';
    rules += ' vc';
    rules += ' sc';
    rules += ' tc';
    rules += ' __na';
    rules += ' wa';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' _zb';
    if (props.isSelected) {
        if (props.isDisabled) {
            rules += ' ba_____B';
            rules += ' bj';
        } else if (props.isInvalid) {
            rules += ' ba_____C';
            if (props.isPressed) rules += ' bP';
            else if (props.isFocusVisible) rules += ' bP';
            else if (props.isHovered) rules += ' bP';
            else rules += ' bO';
        } else {
            rules += ' ba_____z';
            if (props.isEmphasized) {
                if (props.isPressed) rules += ' bz';
                else if (props.isFocusVisible) rules += ' bz';
                else if (props.isHovered) rules += ' bz';
                else rules += ' by';
            } else {
                if (props.isPressed) rules += ' bo';
                else if (props.isFocusVisible) rules += ' bo';
                else if (props.isHovered) rules += ' bo';
                else rules += ' bn';
            }
        }
    } else {
        rules += ' ba_____u';
        rules += ' bd';
    }
    if (props.isSelected) rules += ' ca';
    else if (props.isDisabled) {
        rules += ' ca_____B';
        rules += ' cj';
    } else if (props.isInvalid) {
        rules += ' ca_____C';
        if (props.isPressed) rules += ' cQ';
        else if (props.isFocusVisible) rules += ' cP';
        else if (props.isHovered) rules += ' cP';
        else rules += ' cO';
    } else {
        rules += ' ca_____v';
        if (props.isPressed) rules += ' co';
        else if (props.isFocusVisible) rules += ' co';
        else if (props.isHovered) rules += ' co';
        else rules += ' cn';
    }
    return rules;
};
const iconStyles = " . -rwx0fg_e-B -rwx0fg_e-a_____Y";
const iconSize = {
    S: 'XS',
    M: 'S',
    L: 'M',
    XL: 'L'
};
function Checkbox({ children, ...props }, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CheckboxContext);
    let boxRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let isInForm = !!(0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let isInCheckboxGroup = !!(0, _react.useContext)((0, _reactAriaComponents.CheckboxGroupStateContext));
    let ctx = (0, _reactAriaComponents.useSlottedContext)(CheckboxContext, props.slot);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Checkbox), {
        ...props,
        ref: domRef,
        inputRef: inputRef,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + wrapper({
                ...renderProps,
                isInForm,
                size: props.size || 'M'
            }, props.styles),
        children: (renderProps)=>{
            let checkbox = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: boxRef,
                style: (0, _pressScale.pressScale)(boxRef)(renderProps),
                className: box({
                    ...renderProps,
                    isSelected: renderProps.isSelected || renderProps.isIndeterminate,
                    size: props.size || 'M',
                    isEmphasized: isInCheckboxGroup ? ctx?.isEmphasized : props.isEmphasized
                }),
                children: [
                    renderProps.isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashDefault.default), {
                        size: iconSize[props.size || 'M'],
                        className: iconStyles
                    }),
                    renderProps.isSelected && !renderProps.isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                        size: iconSize[props.size || 'M'],
                        className: iconStyles
                    })
                ]
            });
            // Only render checkbox without center baseline if no label.
            // This avoids expanding the checkbox height to the font's line height.
            if (!children) return checkbox;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                        children: checkbox
                    }),
                    children
                ]
            });
        }
    });
}
/**
 * Checkboxes allow users to select multiple items from a list of individual items,
 * or to mark one individual item as selected.
 */ let _Checkbox = /*#__PURE__*/ (0, _react.forwardRef)(Checkbox);
try {
    // @ts-ignore
    CheckboxContext.displayName = "CheckboxContext";
    // @ts-ignore
    CheckboxContext.__docgenInfo = {
        "description": "",
        "displayName": "CheckboxContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<CheckboxProps, FocusableRefValue<HTMLLabelElement, HTMLLabelElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Checkbox.tsx#CheckboxContext"] = {
        docgenInfo: CheckboxContext.__docgenInfo,
        name: "CheckboxContext",
        path: "packages/@react-spectrum/s2/src/Checkbox.tsx#CheckboxContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    box.displayName = "box";
    // @ts-ignore
    box.__docgenInfo = {
        "description": "",
        "displayName": "box",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the checkbox is disabled.\n@selector [data-disabled]",
                "name": "isDisabled",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isFocused": {
                "defaultValue": null,
                "description": "Whether the checkbox is focused, either via a mouse or keyboard.\n@selector [data-focused]",
                "name": "isFocused",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isFocusVisible": {
                "defaultValue": null,
                "description": "Whether the checkbox is keyboard focused.\n@selector [data-focus-visible]",
                "name": "isFocusVisible",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isHovered": {
                "defaultValue": null,
                "description": "Whether the checkbox is currently hovered with a mouse.\n@selector [data-hovered]",
                "name": "isHovered",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isIndeterminate": {
                "defaultValue": null,
                "description": "Whether the checkbox is indeterminate.\n@selector [data-indeterminate]",
                "name": "isIndeterminate",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the checkbox invalid.\n@selector [data-invalid]",
                "name": "isInvalid",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isPressed": {
                "defaultValue": null,
                "description": "Whether the checkbox is currently in a pressed state.\n@selector [data-pressed]",
                "name": "isPressed",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the checkbox is read only.\n@selector [data-readonly]",
                "name": "isReadOnly",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether the checkbox is required.\n@selector [data-required]",
                "name": "isRequired",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isSelected": {
                "defaultValue": null,
                "description": "Whether the checkbox is selected.\n@selector [data-selected]",
                "name": "isSelected",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Checkbox should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Checkbox.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Checkbox.tsx#box"] = {
        docgenInfo: box.__docgenInfo,
        name: "box",
        path: "packages/@react-spectrum/s2/src/Checkbox.tsx#box"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Checkbox.displayName = "_Checkbox";
    // @ts-ignore
    _Checkbox.__docgenInfo = {
        "description": "Checkboxes allow users to select multiple items from a list of individual items,\nor to mark one individual item as selected.",
        "displayName": "_Checkbox",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The label for the element.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelected": {
                "defaultValue": null,
                "description": "Whether the element should be selected (uncontrolled).",
                "name": "defaultSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inputRef": {
                "defaultValue": null,
                "description": "A ref for the HTML input element.",
                "name": "inputRef",
                "required": false,
                "type": {
                    "name": "RefObject<HTMLInputElement | null>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Checkbox should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isIndeterminate": {
                "defaultValue": null,
                "description": "Indeterminism is presentational only.\nThe indeterminate visual representation remains regardless of user interaction.",
                "name": "isIndeterminate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isSelected": {
                "defaultValue": null,
                "description": "Whether the element should be selected (controlled).",
                "name": "isSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Checkbox.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: boolean) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the element's selection state changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((isSelected: boolean) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLLabelElement, HTMLLabelElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Checkbox.tsx#_Checkbox"] = {
        docgenInfo: _Checkbox.__docgenInfo,
        name: "_Checkbox",
        path: "packages/@react-spectrum/s2/src/Checkbox.tsx#_Checkbox"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"iknok","1":"gZvyk","2":"iDvLA","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./CenterBaseline":"hXatv","../ui-icons/Checkmark":"255By","react":"jEiK2","../ui-icons/Dash":"95EE2","./Form":"gJckc","./pressScale":"6BiUY","@react-spectrum/utils":"bebxO","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"iknok":[function() {},{}],"gZvyk":[function() {},{}],"iDvLA":[function() {},{}],"255By":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Checkmark);
var _jsxRuntime = require("react/jsx-runtime");
var _s2CheckmarkSize200Svg = require("./S2_CheckmarkSize200.svg");
var _s2CheckmarkSize200SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize200Svg);
var _s2CheckmarkSize100Svg = require("./S2_CheckmarkSize100.svg");
var _s2CheckmarkSize100SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize100Svg);
var _s2CheckmarkSize75Svg = require("./S2_CheckmarkSize75.svg");
var _s2CheckmarkSize75SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize75Svg);
var _s2CheckmarkSize300Svg = require("./S2_CheckmarkSize300.svg");
var _s2CheckmarkSize300SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize300Svg);
var _s2CheckmarkSize50Svg = require("./S2_CheckmarkSize50.svg");
var _s2CheckmarkSize50SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize50Svg);
var _s2CheckmarkSize400Svg = require("./S2_CheckmarkSize400.svg");
var _s2CheckmarkSize400SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize400Svg);
function Checkmark(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize100SvgDefault.default), {
                ...otherProps
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize200SvgDefault.default), {
                ...otherProps
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize300SvgDefault.default), {
                ...otherProps
            });
        case 'XXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize400SvgDefault.default), {
                ...otherProps
            });
        case 'XS':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize50SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize75SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2JzhG","./S2_CheckmarkSize200.svg":"iO5io","./S2_CheckmarkSize100.svg":"kR0XN","./S2_CheckmarkSize75.svg":"7u0t7","./S2_CheckmarkSize300.svg":"hVRt7","./S2_CheckmarkSize50.svg":"jKv8G","./S2_CheckmarkSize400.svg":"kcGk5","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"iO5io":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M4.313 10.98c-.308 0-.602-.137-.8-.375L.648 7.165a1.042 1.042 0 0 1 1.6-1.334L4.29 8.283l5.442-6.93a1.043 1.043 0 0 1 1.64 1.288l-6.24 7.941a1.04 1.04 0 0 1-.804.397z"
        })
    });
exports.default = SvgS2CheckmarkSize200;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kR0XN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M3.5 9.503c-.3 0-.584-.135-.774-.367l-2.45-3A1 1 0 1 1 1.823 4.87L3.481 6.9 8.161.888A1 1 0 0 1 9.74 2.118l-5.45 7a1 1 0 0 1-.777.385z"
        })
    });
exports.default = SvgS2CheckmarkSize100;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"7u0t7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize75 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M3.667 9.074a.96.96 0 0 1-.737-.345L.753 6.116a.96.96 0 1 1 1.474-1.228l1.418 1.7 4.112-5.233a.96.96 0 1 1 1.51 1.186L4.422 8.707a.96.96 0 0 1-.741.367z"
        })
    });
exports.default = SvgS2CheckmarkSize75;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hVRt7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M5.102 12.517c-.322 0-.627-.143-.833-.391L.989 8.191a1.083 1.083 0 0 1 .139-1.527 1.08 1.08 0 0 1 1.527.139l2.422 2.904 6.243-7.946a1.086 1.086 0 0 1 1.707 1.34l-7.072 9c-.203.258-.51.41-.838.416z"
        })
    });
exports.default = SvgS2CheckmarkSize300;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"jKv8G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize50 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M3.815 8.69a.92.92 0 0 1-.708-.333L1.216 6.09a.922.922 0 0 1 1.416-1.18l1.162 1.394 3.56-4.532a.92.92 0 1 1 1.45 1.14L4.54 8.336a.92.92 0 0 1-.712.352z"
        })
    });
exports.default = SvgS2CheckmarkSize50;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kcGk5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize400 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M5.864 14.115c-.335 0-.653-.15-.868-.407L1.25 9.21a1.13 1.13 0 1 1 1.736-1.447l2.854 3.424 7.148-9.1a1.13 1.13 0 1 1 1.777 1.396l-8.011 10.2a1.13 1.13 0 0 1-.872.432z"
        })
    });
exports.default = SvgS2CheckmarkSize400;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"95EE2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Dash);
var _jsxRuntime = require("react/jsx-runtime");
var _s2DashSize200Svg = require("./S2_DashSize200.svg");
var _s2DashSize200SvgDefault = parcelHelpers.interopDefault(_s2DashSize200Svg);
var _s2DashSize100Svg = require("./S2_DashSize100.svg");
var _s2DashSize100SvgDefault = parcelHelpers.interopDefault(_s2DashSize100Svg);
var _s2DashSize75Svg = require("./S2_DashSize75.svg");
var _s2DashSize75SvgDefault = parcelHelpers.interopDefault(_s2DashSize75Svg);
var _s2DashSize300Svg = require("./S2_DashSize300.svg");
var _s2DashSize300SvgDefault = parcelHelpers.interopDefault(_s2DashSize300Svg);
var _s2DashSize50Svg = require("./S2_DashSize50.svg");
var _s2DashSize50SvgDefault = parcelHelpers.interopDefault(_s2DashSize50Svg);
function Dash(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize100SvgDefault.default), {
                ...otherProps
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize200SvgDefault.default), {
                ...otherProps
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize300SvgDefault.default), {
                ...otherProps
            });
        case 'XS':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize50SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize75SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2JzhG","./S2_DashSize200.svg":"fGrZX","./S2_DashSize100.svg":"3Gvtj","./S2_DashSize75.svg":"gy364","./S2_DashSize300.svg":"kLhbp","./S2_DashSize50.svg":"i7jX7","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"fGrZX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.021 7.041H1.98a1.04 1.04 0 1 1 0-2.082h8.042a1.04 1.04 0 1 1 0 2.082"
        })
    });
exports.default = SvgS2DashSize200;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"3Gvtj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M8.5 6h-7a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2"
        })
    });
exports.default = SvgS2DashSize100;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"gy364":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize75 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M6.99 4.96H1.01a.96.96 0 1 1 0-1.92h5.98a.96.96 0 1 1 0 1.92"
        })
    });
exports.default = SvgS2DashSize75;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kLhbp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.61 7.085H1.39a1.084 1.084 0 1 1 0-2.17h9.22a1.084 1.084 0 1 1 0 2.17"
        })
    });
exports.default = SvgS2DashSize300;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"i7jX7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize50 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M6.634 4.922H1.366a.922.922 0 0 1 0-1.844h5.268a.922.922 0 0 1 0 1.844"
        })
    });
exports.default = SvgS2DashSize50;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"cE2Z4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DividerContext", ()=>DividerContext);
parcelHelpers.export(exports, "divider", ()=>divider);
parcelHelpers.export(exports, "Divider", ()=>_Divider);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DividerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const divider = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $_4 = false;
    let $A = false;
    let $B = false;
    let $y = false;
    let $z = false;
    let $l = false;
    for (let p of matches){
        if (/^\s*_4/.test(p)) $_4 = true;
        if (/^\s*A/.test(p)) $A = true;
        if (/^\s*B/.test(p)) $B = true;
        if (/^\s*y/.test(p)) $y = true;
        if (/^\s*z/.test(p)) $z = true;
        if (/^\s*l/.test(p)) $l = true;
    }
    if (!$_4) rules += ' _4e';
    rules += ' ba_____v';
    if (props.staticColor === "black") {
        if (props.size === "L") rules += ' b_____r';
        else rules += ' b_____l';
    } else if (props.staticColor === "white") {
        if (props.size === "L") rules += ' b_____e';
        else rules += ' b____8';
    } else if (props.size === "L") rules += ' bn';
    else rules += ' bh';
    rules += ' wf';
    rules += ' _vf';
    rules += ' _wf';
    rules += ' _xf';
    rules += ' _yf';
    if (!$A) rules += ' Aa';
    if (!$B) rules += ' Ba';
    if (!$y) rules += ' ya';
    if (!$z) rules += ' za';
    if (props.orientation === "horizontal") {
        if (props.size === "L") rules += ' k-3761a9';
        else if (props.size === "S") rules += ' k-375yri';
        else rules += ' k-375zlr';
    }
    if (!$l) {
        if (props.orientation === "vertical") {
            if (props.size === "L") rules += ' l-3761a9';
            else if (props.size === "S") rules += ' l-375yri';
            else rules += ' l-375zlr';
        }
    }
    return rules;
};
function Divider(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, DividerContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Separator), {
        ...props,
        ref: domRef,
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + divider({
            size: props.size || 'M',
            orientation: props.orientation || 'horizontal',
            staticColor: props.staticColor
        }, props.styles)
    });
}
/**
 * Dividers bring clarity to a layout by grouping and dividing content in close proximity.
 * They can also be used to establish rhythm and hierarchy.
 */ let _Divider = /*#__PURE__*/ (0, _react.forwardRef)(Divider);
try {
    // @ts-ignore
    DividerContext.displayName = "DividerContext";
    // @ts-ignore
    DividerContext.__docgenInfo = {
        "description": "",
        "displayName": "DividerContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<DividerProps, DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Divider.tsx#DividerContext"] = {
        docgenInfo: DividerContext.__docgenInfo,
        name: "DividerContext",
        path: "packages/@react-spectrum/s2/src/Divider.tsx#DividerContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    divider.displayName = "divider";
    // @ts-ignore
    divider.__docgenInfo = {
        "description": "",
        "displayName": "divider",
        "props": {
            "orientation": {
                "defaultValue": {
                    value: "'horizontal'"
                },
                "description": "How thick the Divider should be.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "How thick the Divider should be.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the Divider appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Divider.tsx#divider"] = {
        docgenInfo: divider.__docgenInfo,
        name: "divider",
        path: "packages/@react-spectrum/s2/src/Divider.tsx#divider"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Divider.displayName = "_Divider";
    // @ts-ignore
    _Divider.__docgenInfo = {
        "description": "Dividers bring clarity to a layout by grouping and dividing content in close proximity.\nThey can also be used to establish rhythm and hierarchy.",
        "displayName": "_Divider",
        "props": {
            "orientation": {
                "defaultValue": {
                    value: "'horizontal'"
                },
                "description": "How thick the Divider should be.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "How thick the Divider should be.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the Divider appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Divider.tsx#_Divider"] = {
        docgenInfo: _Divider.__docgenInfo,
        name: "_Divider",
        path: "packages/@react-spectrum/s2/src/Divider.tsx#_Divider"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"hEa3h","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","react":"jEiK2","@react-spectrum/utils":"bebxO","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hEa3h":[function() {},{}],"fVkBV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LinkOut);
var _jsxRuntime = require("react/jsx-runtime");
var _s2LinkOutSize200Svg = require("./S2_LinkOutSize200.svg");
var _s2LinkOutSize200SvgDefault = parcelHelpers.interopDefault(_s2LinkOutSize200Svg);
var _s2LinkOutSize100Svg = require("./S2_LinkOutSize100.svg");
var _s2LinkOutSize100SvgDefault = parcelHelpers.interopDefault(_s2LinkOutSize100Svg);
var _s2LinkOutSize300Svg = require("./S2_LinkOutSize300.svg");
var _s2LinkOutSize300SvgDefault = parcelHelpers.interopDefault(_s2LinkOutSize300Svg);
var _s2LinkOutSize400Svg = require("./S2_LinkOutSize400.svg");
var _s2LinkOutSize400SvgDefault = parcelHelpers.interopDefault(_s2LinkOutSize400Svg);
function LinkOut(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinkOutSize100SvgDefault.default), {
                ...otherProps
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinkOutSize200SvgDefault.default), {
                ...otherProps
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinkOutSize300SvgDefault.default), {
                ...otherProps
            });
        case 'XXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinkOutSize400SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2JzhG","./S2_LinkOutSize200.svg":"9Fxaq","./S2_LinkOutSize100.svg":"hvIvD","./S2_LinkOutSize300.svg":"dWHFO","./S2_LinkOutSize400.svg":"9MhyO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"9Fxaq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2LinkOutSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.089 1h-5.51a.911.911 0 0 0 0 1.822h3.31L1.355 9.355a.91.91 0 1 0 1.29 1.29L9.178 4.11v3.31a.911.911 0 0 0 1.822 0v-5.51A.91.91 0 0 0 10.089 1"
        })
    });
exports.default = SvgS2LinkOutSize200;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hvIvD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2LinkOutSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M8.125 1H3.741a.875.875 0 1 0 0 1.75h2.27l-4.88 4.88a.88.88 0 0 0 0 1.24.873.873 0 0 0 1.238 0L7.25 3.987v2.27a.875.875 0 1 0 1.75 0V1.876A.875.875 0 0 0 8.125 1"
        })
    });
exports.default = SvgS2LinkOutSize100;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"dWHFO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2LinkOutSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M12.05 1H5.164a.949.949 0 1 0 0 1.898h4.595l-8.18 8.18a.95.95 0 0 0 1.344 1.344l8.18-8.18v4.595a.949.949 0 1 0 1.898 0V1.949A.95.95 0 0 0 12.05 1"
        })
    });
exports.default = SvgS2LinkOutSize300;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"9MhyO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2LinkOutSize400 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M14.01 1h-8a.99.99 0 0 0 0 1.979h5.613L1.551 13.05a.988.988 0 1 0 1.398 1.398L13.021 4.377v5.612a.99.99 0 0 0 1.979 0v-8A.99.99 0 0 0 14.01 1"
        })
    });
exports.default = SvgS2LinkOutSize400;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"8N2I0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 10.021,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 8.5c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4,
                cy: 10.021,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4,
                cy: 10,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 16,
                cy: 10.021,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 16,
                cy: 10,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef, (0, _icon.IconContext));

},{"react/jsx-runtime":"2JzhG","~/src/Icon":"1OC2a","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"aUSdB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlertDialog", ()=>_AlertDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _s2IconAlertTriangle20NSvg = require("../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg");
var _s2IconAlertTriangle20NSvgDefault = parcelHelpers.interopDefault(_s2IconAlertTriangle20NSvg);
var _button = require("./Button");
var _buttonGroup = require("./ButtonGroup");
var _centerBaseline = require("./CenterBaseline");
var _utils = require("@react-aria/utils");
var _content = require("./Content");
var _dialog = require("./Dialog");
var _react = require("react");
var _icon = require("./Icon");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _s2IconAlertDiamond20NSvg = require("../s2wf-icons/S2_Icon_AlertDiamond_20_N.svg");
var _s2IconAlertDiamond20NSvgDefault = parcelHelpers.interopDefault(_s2IconAlertDiamond20NSvg);
var _reactAriaComponents = require("react-aria-components");
var _i18N = require("@react-aria/i18n");
const icon = function anonymous(props) {
    let rules = " .";
    rules += ' zd';
    if (props.variant === "warning") rules += ' -rwx0fg_e-g';
    else if (props.variant === "error") rules += ' -rwx0fg_e-e';
    return rules;
};
function AlertDialog(props, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let { autoFocusButton, cancelLabel, secondaryActionLabel, primaryActionLabel, isSecondaryActionDisabled, isPrimaryActionDisabled, onCancel = ()=>{}, onPrimaryAction = ()=>{}, onSecondaryAction = ()=>{}, title, children, variant = 'confirmation' } = props;
    let buttonVariant = 'primary';
    if (variant === 'confirmation') buttonVariant = 'accent';
    else if (variant === 'destructive') buttonVariant = 'negative';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
        role: "alertdialog",
        ref: ref,
        size: props.size,
        UNSAFE_style: props.UNSAFE_style,
        UNSAFE_className: props.UNSAFE_className || '',
        children: ({ close })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _icon.IconContext),
                                {
                                    styles: icon({
                                        variant
                                    })
                                }
                            ]
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Heading), {
                            slot: "title",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _centerBaseline.CenterBaseline), {
                                children: [
                                    variant === 'error' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconAlertTriangle20NSvgDefault.default), {
                                        "aria-label": stringFormatter.format('dialog.alert')
                                    }),
                                    variant === 'warning' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconAlertDiamond20NSvgDefault.default), {
                                        "aria-label": stringFormatter.format('dialog.alert')
                                    }),
                                    title
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Content), {
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonGroup.ButtonGroup), {
                        children: [
                            cancelLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                onPress: ()=>(0, _utils.chain)(close(), onCancel()),
                                variant: "secondary",
                                fillStyle: "outline",
                                autoFocus: autoFocusButton === 'cancel',
                                children: cancelLabel
                            }),
                            secondaryActionLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                onPress: ()=>(0, _utils.chain)(close(), onSecondaryAction()),
                                variant: "secondary",
                                isDisabled: isSecondaryActionDisabled,
                                fillStyle: "outline",
                                autoFocus: autoFocusButton === 'secondary',
                                children: secondaryActionLabel
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: buttonVariant,
                                isDisabled: isPrimaryActionDisabled,
                                autoFocus: autoFocusButton === 'primary',
                                onPress: ()=>(0, _utils.chain)(close(), onPrimaryAction()),
                                children: primaryActionLabel
                            })
                        ]
                    })
                ]
            })
    });
}
/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */ let _AlertDialog = /*#__PURE__*/ (0, _react.forwardRef)(AlertDialog);
try {
    // @ts-ignore
    _AlertDialog.displayName = "_AlertDialog";
    // @ts-ignore
    _AlertDialog.__docgenInfo = {
        "description": "AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.",
        "displayName": "_AlertDialog",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the AlertDialog.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "primaryActionLabel": {
                "defaultValue": null,
                "description": "The label to display within the confirm button.",
                "name": "primaryActionLabel",
                "required": true,
                "type": {
                    "name": "string"
                }
            },
            "title": {
                "defaultValue": null,
                "description": "The title of the AlertDialog.",
                "name": "title",
                "required": true,
                "type": {
                    "name": "string"
                }
            },
            "autoFocusButton": {
                "defaultValue": null,
                "description": "Button to focus by default when the dialog opens.",
                "name": "autoFocusButton",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"cancel\""
                        },
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        }
                    ]
                }
            },
            "cancelLabel": {
                "defaultValue": null,
                "description": "The label to display within the cancel button.",
                "name": "cancelLabel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isPrimaryActionDisabled": {
                "defaultValue": null,
                "description": "Whether the primary button is disabled.",
                "name": "isPrimaryActionDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isSecondaryActionDisabled": {
                "defaultValue": null,
                "description": "Whether the secondary button is disabled.",
                "name": "isSecondaryActionDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "secondaryActionLabel": {
                "defaultValue": null,
                "description": "The label to display within the secondary button.",
                "name": "secondaryActionLabel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Dialog.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": null,
                "description": "The [visual style](https://spectrum.adobe.com/page/alert-dialog/#Options) of the AlertDialog.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"confirmation\""
                        },
                        {
                            "value": "\"information\""
                        },
                        {
                            "value": "\"destructive\""
                        },
                        {
                            "value": "\"error\""
                        },
                        {
                            "value": "\"warning\""
                        }
                    ]
                }
            },
            "onCancel": {
                "defaultValue": null,
                "description": "Handler that is called when the cancel button is pressed.",
                "name": "onCancel",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onPrimaryAction": {
                "defaultValue": null,
                "description": "Handler that is called when the primary button is pressed.",
                "name": "onPrimaryAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onSecondaryAction": {
                "defaultValue": null,
                "description": "Handler that is called when the secondary button is pressed.",
                "name": "onSecondaryAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/AlertDialog.tsx#_AlertDialog"] = {
        docgenInfo: _AlertDialog.__docgenInfo,
        name: "_AlertDialog",
        path: "packages/@react-spectrum/s2/src/AlertDialog.tsx#_AlertDialog"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"dbFAX","react/jsx-runtime":"2JzhG","../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg":"gH5vG","./Button":"lgKOs","./ButtonGroup":"bQ9CV","./CenterBaseline":"hXatv","@react-aria/utils":"e9Yvo","./Content":"aBWEm","./Dialog":"1TY9V","react":"jEiK2","./Icon":"1OC2a","../intl/*.json":"iU6xz","../s2wf-icons/S2_Icon_AlertDiamond_20_N.svg":"dewOV","react-aria-components":"8nuKL","@react-aria/i18n":"hFrKJ","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"dbFAX":[function() {},{}],"dewOV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.795c-.601 0-1.166-.234-1.591-.66l-6.545-6.544c-.876-.877-.876-2.305 0-3.182l6.545-6.545c.849-.85 2.333-.85 3.182 0l6.545 6.545c.876.877.876 2.305 0 3.182l-6.545 6.545c-.425.425-.99.659-1.591.659m0-16.09c-.2 0-.389.078-.53.22L2.925 9.47c-.292.292-.292.768 0 1.06l6.545 6.545c.283.283.778.283 1.06 0l6.545-6.545c.292-.292.292-.768 0-1.06L10.53 2.925c-.141-.142-.33-.22-.53-.22"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 14.998c-.231.008-.456-.073-.627-.228-.33-.365-.33-.92 0-1.285.17-.158.395-.242.626-.234.237-.01.466.08.633.247.162.168.25.394.242.627.012.235-.07.465-.228.639-.174.164-.408.25-.647.234M10 11.625c-.414 0-.75-.336-.75-.75v-5c0-.414.336-.75.75-.75s.75.336.75.75v5c0 .414-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef, (0, _icon.IconContext));

},{"react/jsx-runtime":"2JzhG","~/src/Icon":"1OC2a","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"5QOSi":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AvatarGroupContext", ()=>AvatarGroupContext);
parcelHelpers.export(exports, "AvatarGroup", ()=>_AvatarGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _avatar = require("./Avatar");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _utils1 = require("@react-spectrum/utils");
var _reactAria = require("react-aria");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const AvatarGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const avatar = " . y-1oavdfs y-13alit4a";
const text = function anonymous(props) {
    let rules = " .";
    rules += ' yd';
    rules += ' __vb';
    rules += ' __wb';
    rules += ' _ma';
    rules += ' _pb';
    if (props.size === "40") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "36") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "32") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "28") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "24") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "20") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "16") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    }
    if (props.size === "40") {
        rules += ' _dbm';
        rules += ' _dj';
    } else if (props.size === "36") {
        rules += ' _dbl';
        rules += ' _dk';
    } else if (props.size === "32") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "28") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "24") {
        rules += ' _dbf';
        rules += ' _de';
    } else if (props.size === "20") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "16") {
        rules += ' _dbb';
        rules += ' _da';
    }
    if (props.size === "40") rules += ' _eb';
    else if (props.size === "36") rules += ' _eb';
    else if (props.size === "32") rules += ' _eb';
    else if (props.size === "28") rules += ' _eb';
    else if (props.size === "24") rules += ' _eb';
    else if (props.size === "20") rules += ' _eb';
    else if (props.size === "16") rules += ' _eb';
    if (props.size === "40") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    } else if (props.size === "36") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    } else if (props.size === "32") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    } else if (props.size === "28") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    } else if (props.size === "24") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    } else if (props.size === "20") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    } else if (props.size === "16") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    }
    if (props.size === "40") rules += ' an';
    else if (props.size === "36") rules += ' an';
    else if (props.size === "32") rules += ' an';
    else if (props.size === "28") rules += ' an';
    else if (props.size === "24") rules += ' an';
    else if (props.size === "20") rules += ' an';
    else if (props.size === "16") rules += ' an';
    return rules;
};
const container = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W)[^\s]+/g) || [];
    rules += matches.join('');
    rules += ' _Zd';
    rules += ' _1c';
    return rules;
};
function AvatarGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, AvatarGroupContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { children, label, size = 24, styles, UNSAFE_style, UNSAFE_className, ...otherProps } = props;
    let { labelProps, fieldProps } = (0, _reactAria.useLabel)({
        ...props,
        labelElementType: 'span'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatar.AvatarContext).Provider, {
        value: {
            styles: avatar,
            size,
            isOverBackground: true
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            ref: domRef,
            ...(0, _utils.filterDOMProps)(otherProps),
            ...fieldProps,
            role: "group",
            className: (UNSAFE_className ?? '') + container(null, styles),
            style: {
                ...UNSAFE_style,
                '--size': size / 16 + 'rem'
            },
            children: [
                children,
                label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    ...labelProps,
                    className: text({
                        size: String(size)
                    }),
                    children: label
                })
            ]
        })
    });
}
/**
 * An avatar group is a grouping of avatars that are related to each other.
 */ let _AvatarGroup = /*#__PURE__*/ (0, _react.forwardRef)(AvatarGroup);
try {
    // @ts-ignore
    AvatarGroupContext.displayName = "AvatarGroupContext";
    // @ts-ignore
    AvatarGroupContext.__docgenInfo = {
        "description": "",
        "displayName": "AvatarGroupContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<AvatarGroupProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/AvatarGroup.tsx#AvatarGroupContext"] = {
        docgenInfo: AvatarGroupContext.__docgenInfo,
        name: "AvatarGroupContext",
        path: "packages/@react-spectrum/s2/src/AvatarGroup.tsx#AvatarGroupContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _AvatarGroup.displayName = "_AvatarGroup";
    // @ts-ignore
    _AvatarGroup.__docgenInfo = {
        "description": "An avatar group is a grouping of avatars that are related to each other.",
        "displayName": "_AvatarGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Avatar children of the avatar group.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The label for the avatar group.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "24"
                },
                "description": "The size of the avatar group.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "16"
                        },
                        {
                            "value": "20"
                        },
                        {
                            "value": "24"
                        },
                        {
                            "value": "28"
                        },
                        {
                            "value": "32"
                        },
                        {
                            "value": "36"
                        },
                        {
                            "value": "40"
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithoutWidth"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/AvatarGroup.tsx#_AvatarGroup"] = {
        docgenInfo: _AvatarGroup.__docgenInfo,
        name: "_AvatarGroup",
        path: "packages/@react-spectrum/s2/src/AvatarGroup.tsx#_AvatarGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"g5CYt","1":"7jqVL","2":"72NGv","react/jsx-runtime":"2JzhG","./Avatar":"3UH45","react":"jEiK2","@react-aria/utils":"e9Yvo","@react-spectrum/utils":"bebxO","react-aria":"4BEis","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"g5CYt":[function() {},{}],"7jqVL":[function() {},{}],"72NGv":[function() {},{}],"bGDQa":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>_Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    rules += ' _Zd';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.fillStyle === "outline") rules += ' ap';
    else if (props.fillStyle === "subtle") rules += ' ap';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' ab';
        else if (props.variant === "charteuse") rules += ' ab';
        else if (props.variant === "yellow") rules += ' ab';
        else if (props.variant === "orange") rules += ' ab';
        else if (props.variant === "notice") rules += ' ab';
        else rules += ' ac';
    }
    rules += ' _2d';
    rules += ' _1c';
    rules += ' _vh';
    rules += ' _wh';
    rules += ' _xh';
    rules += ' _yh';
    rules += ' o-375tou';
    rules += ' C-1dz4pg9a';
    rules += ' CI';
    rules += ' D-1dz4pg9a';
    rules += ' DI';
    rules += ' -_1gogtue_E--1dbqcch';
    rules += ' _b-1dz4pg9b';
    rules += ' -oelgqu_A--1dz4pg9a';
    rules += ' -oelgqu_A--177861o';
    rules += ' jbH';
    rules += ' jG';
    if (props.fillStyle === "outline") rules += ' b______k';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' b______j';
        else if (props.variant === "cinnamon") rules += ' b______f';
        else if (props.variant === "brown") rules += ' b______h';
        else if (props.variant === "turquoise") rules += ' b______d';
        else if (props.variant === "pink") rules += ' b______b';
        else if (props.variant === "magenta") rules += ' b_____9';
        else if (props.variant === "fuchsia") rules += ' b_____7';
        else if (props.variant === "purple") rules += ' b_____5';
        else if (props.variant === "indigo") rules += ' b_____3';
        else if (props.variant === "blue") rules += ' b_____G';
        else if (props.variant === "cyan") rules += ' b_____1';
        else if (props.variant === "seafoam") rules += ' b_____Z';
        else if (props.variant === "green") rules += ' b_____P';
        else if (props.variant === "celery") rules += ' b_____X';
        else if (props.variant === "charteuse") rules += ' b_____V';
        else if (props.variant === "yellow") rules += ' b_____T';
        else if (props.variant === "orange") rules += ' b_____R';
        else if (props.variant === "red") rules += ' b_____M';
        else if (props.variant === "gray") rules += ' b_____J';
        else if (props.variant === "negative") rules += ' b_____M';
        else if (props.variant === "notice") rules += ' b_____R';
        else if (props.variant === "positive") rules += ' b_____P';
        else if (props.variant === "neutral") rules += ' b_____J';
        else if (props.variant === "informative") rules += ' b_____G';
        else if (props.variant === "accent") rules += ' b_____G';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' b______i';
        else if (props.variant === "cinnamon") rules += ' b______e';
        else if (props.variant === "brown") rules += ' b______g';
        else if (props.variant === "turquoise") rules += ' b______c';
        else if (props.variant === "pink") rules += ' b______a';
        else if (props.variant === "magenta") rules += ' b_____8';
        else if (props.variant === "fuchsia") rules += ' b_____6';
        else if (props.variant === "purple") rules += ' b_____4';
        else if (props.variant === "indigo") rules += ' b_____2';
        else if (props.variant === "blue") rules += ' b_____E';
        else if (props.variant === "cyan") rules += ' b_____0';
        else if (props.variant === "seafoam") rules += ' b_____Y';
        else if (props.variant === "green") rules += ' b_____N';
        else if (props.variant === "celery") rules += ' b_____W';
        else if (props.variant === "charteuse") rules += ' b_____U';
        else if (props.variant === "yellow") rules += ' b_____S';
        else if (props.variant === "orange") rules += ' b_____Q';
        else if (props.variant === "red") rules += ' b_____K';
        else if (props.variant === "gray") rules += ' b_____H';
        else if (props.variant === "negative") {
            if (props.isPressed) rules += ' b_____L';
            else if (props.isFocusVisible) rules += ' b_____L';
            else if (props.isHovered) rules += ' b_____L';
            else rules += ' b_____K';
        } else if (props.variant === "notice") rules += ' b_____Q';
        else if (props.variant === "positive") {
            if (props.isPressed) rules += ' b_____O';
            else if (props.isFocusVisible) rules += ' b_____O';
            else if (props.isHovered) rules += ' b_____O';
            else rules += ' b_____N';
        } else if (props.variant === "neutral") {
            if (props.isPressed) rules += ' b_____I';
            else if (props.isFocusVisible) rules += ' b_____I';
            else if (props.isHovered) rules += ' b_____I';
            else rules += ' b_____H';
        } else if (props.variant === "informative") {
            if (props.isPressed) rules += ' b_____F';
            else if (props.isFocusVisible) rules += ' b_____F';
            else if (props.isHovered) rules += ' b_____F';
            else rules += ' b_____E';
        } else if (props.variant === "accent") {
            if (props.isPressed) rules += ' b_____F';
            else if (props.isFocusVisible) rules += ' b_____F';
            else if (props.isHovered) rules += ' b_____F';
            else rules += ' b_____E';
        }
    }
    rules += ' wa';
    rules += ' __na';
    rules += ' u-375tp0';
    rules += ' v-375tp1';
    rules += ' sc';
    rules += ' tc';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' c-awl6xt';
        else if (props.variant === "notice") rules += ' c-1c1g5qb';
        else if (props.variant === "positive") rules += ' c-32o7sp';
        else if (props.variant === "neutral") rules += ' c-lj7qwa';
        else if (props.variant === "informative") rules += ' c-1n5lxsq';
        else if (props.variant === "accent") rules += ' c-1n5lxsq';
    } else rules += ' ca';
    rules += ' -rwx0fg_e-b';
    if (props.size === "XL") rules += ' -_375tou_o-j';
    else if (props.size === "L") rules += ' -_375tou_o-i';
    else if (props.size === "S") rules += ' -_375tou_o-h';
    else if (props.size === "XS") rules += ' -_375tou_o-g';
    else rules += ' -_375tou_o-f';
    rules += ' -_375tp0_u-c';
    rules += ' -_375tp1_v-c';
    return rules;
};
function Badge(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', ...otherProps } = props; // useProviderProps(props) in v3
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: " . E-1gogtue F-1gogtue __A-3t1y"
                }
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " . __A-3t1x"
                    }),
                    styles: " . l-1sthc3k k-1sthc3k y-oelgqu _8-3t1x"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _utils.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props.styles),
                style: props.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
}
/**
 * Badges are used for showing a small amount of color-categorized metadata, ideal for getting a user's attention.
 */ let _Badge = /*#__PURE__*/ (0, _react.forwardRef)(Badge);
try {
    // @ts-ignore
    BadgeContext.displayName = "BadgeContext";
    // @ts-ignore
    BadgeContext.__docgenInfo = {
        "description": "",
        "displayName": "BadgeContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<Partial<BadgeProps>, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Badge.tsx#BadgeContext"] = {
        docgenInfo: BadgeContext.__docgenInfo,
        name: "BadgeContext",
        path: "packages/@react-spectrum/s2/src/Badge.tsx#BadgeContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Badge.displayName = "_Badge";
    // @ts-ignore
    _Badge.__docgenInfo = {
        "description": "Badges are used for showing a small amount of color-categorized metadata, ideal for getting a user's attention.",
        "displayName": "_Badge",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the badge.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "fillStyle": {
                "defaultValue": {
                    value: "'bold'"
                },
                "description": "The fill of the badge.",
                "name": "fillStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"bold\""
                        },
                        {
                            "value": "\"subtle\""
                        },
                        {
                            "value": "\"outline\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'S'"
                },
                "description": "The size of the badge.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'neutral'"
                },
                "description": "The variant changes the background color of the badge. When badge has a semantic meaning, they should use the variant for semantic colors.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"red\""
                        },
                        {
                            "value": "\"green\""
                        },
                        {
                            "value": "\"blue\""
                        },
                        {
                            "value": "\"informative\""
                        },
                        {
                            "value": "\"positive\""
                        },
                        {
                            "value": "\"notice\""
                        },
                        {
                            "value": "\"negative\""
                        },
                        {
                            "value": "\"neutral\""
                        },
                        {
                            "value": "\"gray\""
                        },
                        {
                            "value": "\"orange\""
                        },
                        {
                            "value": "\"yellow\""
                        },
                        {
                            "value": "\"celery\""
                        },
                        {
                            "value": "\"seafoam\""
                        },
                        {
                            "value": "\"cyan\""
                        },
                        {
                            "value": "\"indigo\""
                        },
                        {
                            "value": "\"purple\""
                        },
                        {
                            "value": "\"fuchsia\""
                        },
                        {
                            "value": "\"magenta\""
                        },
                        {
                            "value": "\"pink\""
                        },
                        {
                            "value": "\"turquoise\""
                        },
                        {
                            "value": "\"brown\""
                        },
                        {
                            "value": "\"silver\""
                        },
                        {
                            "value": "\"cinnamon\""
                        },
                        {
                            "value": "\"accent\""
                        },
                        {
                            "value": "\"charteuse\""
                        }
                    ]
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Badge.tsx#_Badge"] = {
        docgenInfo: _Badge.__docgenInfo,
        name: "_Badge",
        path: "packages/@react-spectrum/s2/src/Badge.tsx#_Badge"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"9xzbt","1":"gZSr5","2":"2S31J","3":"jK44t","react/jsx-runtime":"2JzhG","./CenterBaseline":"hXatv","react-aria-components":"8nuKL","@react-aria/utils":"e9Yvo","./Icon":"1OC2a","react":"jEiK2","./Skeleton":"2hWWB","./Content":"aBWEm","@react-spectrum/utils":"bebxO","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"9xzbt":[function() {},{}],"gZSr5":[function() {},{}],"2S31J":[function() {},{}],"jK44t":[function() {},{}],"eRg7d":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BreadcrumbsContext", ()=>BreadcrumbsContext);
parcelHelpers.export(exports, "Breadcrumbs", ()=>_Breadcrumbs);
parcelHelpers.export(exports, "Breadcrumb", ()=>_Breadcrumb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _actionButton = require("./ActionButton");
var _reactAriaComponents = require("react-aria-components");
var _reactAria = require("react-aria");
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _s2IconFolderBreadcrumb20NSvg = require("../s2wf-icons/S2_Icon_FolderBreadcrumb_20_N.svg");
var _s2IconFolderBreadcrumb20NSvgDefault = parcelHelpers.interopDefault(_s2IconFolderBreadcrumb20NSvg);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _menu = require("./Menu");
var _content = require("./Content");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const MIN_VISIBLE_ITEMS = 1;
const MAX_VISIBLE_ITEMS = 4;
const BreadcrumbsContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $U = false;
    let $_9 = false;
    let $_8 = false;
    let $h = false;
    let $A = false;
    let $B = false;
    let $y = false;
    for (let p of matches){
        if (/^\s*U/.test(p)) $U = true;
        if (/^\s*_9/.test(p)) $_9 = true;
        if (/^\s*_8/.test(p)) $_8 = true;
        if (/^\s*h/.test(p)) $h = true;
        if (/^\s*A/.test(p)) $A = true;
        if (/^\s*B/.test(p)) $B = true;
        if (/^\s*y/.test(p)) $y = true;
    }
    if (!$U) rules += ' Uc';
    rules += ' _Zd';
    rules += ' _2b';
    rules += ' _ga';
    rules += ' _7c';
    if (!$_9) rules += ' _9-3t1y';
    if (!$_8) rules += ' _8-3t1x';
    if (!$h) rules += ' ha';
    if (props.size === "L") rules += ' i-1dtpt05';
    else if (props.size === "M") rules += ' i-ve8p9e';
    if (props.size === "L") rules += ' j-1dtpt05';
    else if (props.size === "M") rules += ' j-ve8p9e';
    rules += ' Ea';
    rules += ' Fa';
    rules += ' Ca';
    rules += ' Da';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    if (!$A) rules += ' Aa';
    if (!$B) rules += ' Ba';
    if (!$y) {
        if (props.size === "L") rules += ' y-1dtpt05';
        else if (props.size === "M") rules += ' y-ve8p9e';
    }
    return rules;
};
const InternalBreadcrumbsContext = /*#__PURE__*/ (0, _react.createContext)({});
function Breadcrumbs(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, BreadcrumbsContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { UNSAFE_className = '', UNSAFE_style, styles, size = 'M', children, isDisabled, ...otherProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                InternalBreadcrumbsContext,
                {
                    size,
                    isDisabled
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapsingCollection, {
            containerRef: domRef,
            onAction: props.onAction,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Breadcrumbs), {
                ...otherProps,
                isDisabled: isDisabled,
                ref: domRef,
                style: UNSAFE_style,
                className: UNSAFE_className + wrapper({
                    size
                }, styles),
                children: children
            })
        })
    });
}
let BreadcrumbMenu = (props)=>{
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let { items, onAction } = props;
    let { direction } = (0, _reactAria.useLocale)();
    let { size, isDisabled } = (0, _react.useContext)(InternalBreadcrumbsContext);
    let label = stringFormatter.format('breadcrumbs.more');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.UNSTABLE_CollectionRendererContext).Provider, {
        value: (0, _reactAriaComponents.UNSTABLE_DefaultCollectionRenderer),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
            className: breadcrumbStyles({
                size,
                isDisabled,
                isMenu: true
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                            isDisabled: isDisabled,
                            isQuiet: true,
                            "aria-label": label,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconFolderBreadcrumb20NSvgDefault.default), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
                            items: items,
                            onAction: onAction,
                            children: (item)=>/*#__PURE__*/ (0, _react.createElement)((0, _menu.MenuItem), {
                                    ...item.props.originalProps,
                                    key: item.key
                                }, /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                                    slot: "label",
                                    children: item.props.children({
                                        size,
                                        isCurrent: false,
                                        isMenu: true
                                    })
                                }))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                    size: size,
                    className: chevronStyles({
                        direction,
                        isMenu: true
                    })
                })
            ]
        })
    });
};
/** Breadcrumbs show hierarchy and navigational context for a user’s location within an application. */ let _Breadcrumbs = /*#__PURE__*/ (0, _react.forwardRef)(Breadcrumbs);
let HiddenBreadcrumbs = function(props) {
    let { listRef, items, size } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        // @ts-ignore
        inert: "true",
        ref: listRef,
        className: " . _Z-17zqamw i-17zqamw j-17zqamw _7-17zqamw Ua Xa Za __Eb __vb __wb _K-3t1x",
        children: [
            items.map((item, idx)=>{
                // pull off individual props as an allow list, don't want refs or other props getting through
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    "data-hidden-breadcrumb": true,
                    style: item.props.UNSAFE_style,
                    className: item.props.className({
                        size,
                        isCurrent: idx === items.length - 1
                    }),
                    children: item.props.children({
                        size,
                        isCurrent: idx === items.length - 1
                    })
                }, item.key);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                "data-hidden-button": true,
                isQuiet: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconFolderBreadcrumb20NSvgDefault.default), {})
            })
        ]
    });
};
const breadcrumbStyles = function anonymous(props) {
    let rules = " .";
    rules += ' _Zd';
    rules += ' _1c';
    rules += ' _2b';
    if (props.size === "XL") rules += ' kj';
    else if (props.size === "L") rules += ' ki';
    else if (props.size === "S") rules += ' kh';
    else if (props.size === "XS") rules += ' kg';
    else rules += ' kf';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' Uc';
    rules += ' _8-3t1x';
    if (props.isDisabled) rules += ' aa_____B';
    else rules += ' aa_____x';
    if (props.isDisabled) rules += ' aj';
    else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' wf';
    if (props.isMenu) rules += ' y-460fe7';
    return rules;
};
const chevronStyles = function anonymous(props) {
    let rules = " .";
    if (props.direction === "rtl") rules += ' S-3hmpv';
    if (props.isMenu) rules += ' ya';
    else {
        rules += ' ybH';
        rules += ' yG';
    }
    rules += ' aa_____D';
    if (props.isPressed) rules += ' ao';
    else if (props.isFocusVisible) rules += ' ao';
    else if (props.isHovered) rules += ' ao';
    else rules += ' an';
    rules += ' -rwx0fg_e-b';
    return rules;
};
const linkStyles = function anonymous(props) {
    let rules = " .";
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    rules += ' _vb';
    rules += ' _wb';
    rules += ' _xb';
    rules += ' _yb';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) rules += ' aa_____B';
    else rules += ' aa_____D';
    if (props.isCurrent) {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    } else if (props.isDisabled) rules += ' aj';
    else {
        if (props.isPressed) rules += ' an';
        else if (props.isFocusVisible) rules += ' an';
        else if (props.isHovered) rules += ' an';
        else rules += ' am';
    }
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    if (props.isDisabled) rules += ' _ld';
    else if (props.isFocusVisible) rules += ' _la';
    else if (props.isHovered) rules += ' _la';
    else rules += ' _ld';
    if (props.isDisabled) rules += ' __Hb';
    else rules += ' __Hc';
    rules += ' __R-yksgrp';
    return rules;
};
const currentStyles = function anonymous(props) {
    let rules = " .";
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _ed';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    rules += ' an';
    return rules;
};
// TODO: support user heading size customization, for now just set it to large
const heading = " . Aa Ba ya za _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _dn _dbo _ee _fa _f-1x99dlob ao";
function Breadcrumb({ children, ...props }, ref) {
    let { href, target, rel, download, ping, referrerPolicy } = props;
    let { size = 'M' } = (0, _react.useContext)(InternalBreadcrumbsContext) ?? {};
    let domRef = (0, _utils.useDOMRef)(ref);
    let { direction } = (0, _reactAria.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Breadcrumb), {
        ...props,
        ref: domRef,
        // @ts-ignore
        originalProps: props,
        className: ({ isCurrent, isDisabled })=>breadcrumbStyles({
                size,
                isCurrent,
                isDisabled
            }),
        children: ({ isCurrent, isDisabled, // @ts-ignore
        isMenu })=>{
            if (isMenu) return children;
            return isCurrent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: currentStyles({
                    size
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                    values: [
                        [
                            (0, _reactAriaComponents.HeadingContext),
                            {
                                className: heading
                            }
                        ]
                    ],
                    children: children
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
                        style: ({ isFocusVisible })=>({
                                clipPath: isFocusVisible ? 'none' : 'margin-box'
                            }),
                        href: href,
                        target: target,
                        rel: rel,
                        download: download,
                        ping: ping,
                        referrerPolicy: referrerPolicy,
                        isDisabled: isDisabled || isCurrent,
                        className: ({ isFocused, isFocusVisible, isHovered, isDisabled, isPressed })=>linkStyles({
                                isFocused,
                                isFocusVisible,
                                isHovered,
                                isDisabled,
                                size,
                                isPressed
                            }),
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                        size: "M",
                        className: chevronStyles({
                            direction
                        })
                    })
                ]
            });
        }
    });
}
/** An individual Breadcrumb for Breadcrumbs. */ let _Breadcrumb = /*#__PURE__*/ (0, _react.forwardRef)(Breadcrumb);
// Context for passing the count for the custom renderer
let CollapseContext = /*#__PURE__*/ (0, _react.createContext)(null);
function CollapsingCollection({ children, containerRef, onAction }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseContext.Provider, {
        value: {
            containerRef,
            onAction
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.UNSTABLE_CollectionRendererContext).Provider, {
            value: CollapsingCollectionRenderer,
            children: children
        })
    });
}
let CollapsingCollectionRenderer = {
    CollectionRoot ({ collection }) {
        return useCollectionRender(collection);
    },
    CollectionBranch ({ collection }) {
        return useCollectionRender(collection);
    }
};
let useCollectionRender = (collection)=>{
    let { containerRef, onAction } = (0, _react.useContext)(CollapseContext) ?? {};
    let [visibleItems, setVisibleItems] = (0, _react.useState)(collection.size);
    let { size = 'M' } = (0, _react.useContext)(InternalBreadcrumbsContext);
    let children = (0, _react.useMemo)(()=>{
        let result = [];
        for (let key of collection.getKeys())result.push(collection.getItem(key));
        return result;
    }, [
        collection
    ]);
    let listRef = (0, _react.useRef)(null);
    let updateOverflow = (0, _react.useCallback)(()=>{
        let currListRef = listRef.current;
        if (!currListRef) {
            setVisibleItems(collection.size);
            return;
        }
        let container = currListRef.parentElement;
        if (!container) {
            setVisibleItems(collection.size);
            return;
        }
        let listItems = Array.from(currListRef.querySelectorAll('[data-hidden-breadcrumb]'));
        let folder = currListRef.querySelector('button');
        if (listItems.length <= 0) {
            setVisibleItems(collection.size);
            return;
        }
        let containerWidth = container.offsetWidth;
        let containerGap = parseInt(getComputedStyle(container).gap, 10);
        let folderGap = parseInt(getComputedStyle(folder).marginInlineStart, 10);
        let newVisibleItems = 0;
        let maxVisibleItems = MAX_VISIBLE_ITEMS;
        let widths = [];
        let totalWidth = 0;
        for (let breadcrumb of listItems){
            let width = breadcrumb.offsetWidth + 1; // offsetWidth is rounded down
            widths.push(width);
            totalWidth += width;
        }
        // can we fit all the items without collapsing
        if (totalWidth <= containerWidth - collection.size * containerGap && collection.size <= MAX_VISIBLE_ITEMS) {
            setVisibleItems(collection.size);
            return;
        }
        // we know there is always at least one item because of the listItems.length check up above
        let widthOfFirst = widths.shift();
        let availableWidth = containerWidth - widthOfFirst - folderGap - folder.offsetWidth - containerGap;
        maxVisibleItems -= 2; // account for the first item and folder
        for (let width of widths.reverse()){
            availableWidth -= width;
            if (availableWidth <= 0) break;
            availableWidth -= containerGap;
            newVisibleItems++;
        }
        setVisibleItems(Math.max(MIN_VISIBLE_ITEMS, Math.min(maxVisibleItems, newVisibleItems)));
    }, [
        collection.size,
        setVisibleItems
    ]);
    // making bad assumption that i can listen to containerRef when it's declared in the parent?
    (0, _utils.useResizeObserver)({
        ref: containerRef,
        onResize: updateOverflow
    });
    (0, _utils1.useLayoutEffect)(()=>{
        if (collection.size > 0) queueMicrotask(updateOverflow);
    }, [
        collection.size,
        updateOverflow
    ]);
    (0, _react.useEffect)(()=>{
        // Recalculate visible tags when fonts are loaded.
        document.fonts?.ready.then(()=>updateOverflow());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let sliceIndex = collection.size - visibleItems;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(HiddenBreadcrumbs, {
                items: children,
                size: size,
                listRef: listRef
            }),
            visibleItems < collection.size && collection.size > 2 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children[0].render?.(children[0]),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbMenu, {
                        items: children.slice(1, sliceIndex),
                        onAction: onAction
                    }),
                    children.slice(sliceIndex).map((node)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                            children: node.render?.(node)
                        }, node.key))
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: children.map((node)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                        children: node.render?.(node)
                    }, node.key))
            })
        ]
    });
};
try {
    // @ts-ignore
    BreadcrumbsContext.displayName = "BreadcrumbsContext";
    // @ts-ignore
    BreadcrumbsContext.__docgenInfo = {
        "description": "",
        "displayName": "BreadcrumbsContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<BreadcrumbsProps<any>, DOMRefValue<HTMLOListElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Breadcrumbs.tsx#BreadcrumbsContext"] = {
        docgenInfo: BreadcrumbsContext.__docgenInfo,
        name: "BreadcrumbsContext",
        path: "packages/@react-spectrum/s2/src/Breadcrumbs.tsx#BreadcrumbsContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Breadcrumbs.displayName = "_Breadcrumbs";
    // @ts-ignore
    _Breadcrumbs.__docgenInfo = {
        "description": "Breadcrumbs show hierarchy and navigational context for a user\u2019s location within an application.",
        "displayName": "_Breadcrumbs",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the Breadcrumbs.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the breadcrumbs are disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "Size of the Breadcrumbs including spacing and layout.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a breadcrumb is clicked.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLOListElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Breadcrumbs.tsx#_Breadcrumbs"] = {
        docgenInfo: _Breadcrumbs.__docgenInfo,
        name: "_Breadcrumbs",
        path: "packages/@react-spectrum/s2/src/Breadcrumbs.tsx#_Breadcrumbs"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"fifuw","1":"5PAeh","2":"afvAm","3":"iuCs8","4":"3BmGi","5":"9VKft","6":"5qDKp","react/jsx-runtime":"2JzhG","react":"jEiK2","./ActionButton":"hbuyN","react-aria-components":"8nuKL","react-aria":"4BEis","../ui-icons/Chevron":"dnGTM","../s2wf-icons/S2_Icon_FolderBreadcrumb_20_N.svg":"c7zrS","../intl/*.json":"iU6xz","./Menu":"hGkxl","./Content":"aBWEm","@react-spectrum/utils":"bebxO","@react-aria/utils":"e9Yvo","@react-aria/i18n":"hFrKJ","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"fifuw":[function() {},{}],"5PAeh":[function() {},{}],"afvAm":[function() {},{}],"iuCs8":[function() {},{}],"3BmGi":[function() {},{}],"9VKft":[function() {},{}],"5qDKp":[function() {},{}],"c7zrS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 5h-5.964c-.218 0-.424-.094-.566-.259L8.516 2.777C8.089 2.283 7.47 2 6.816 2H3.25C2.01 2 1 3.01 1 4.25v10.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-7.5C19 6.01 17.99 5 16.75 5M3.25 3.5h3.565c.218 0 .424.094.567.259L8.459 5H2.5v-.75c0-.413.337-.75.75-.75M17.5 14.75c0 .413-.337.75-.75.75H3.25c-.413 0-.75-.337-.75-.75V6.5h14.25c.413 0 .75.337.75.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 13.65c-.192 0-.384-.073-.53-.22l-3-3c-.293-.292-.293-.767 0-1.06s.767-.293 1.06 0L10 11.84l2.47-2.47c.293-.293.767-.293 1.06 0s.293.768 0 1.06l-3 3c-.146.147-.338.22-.53.22"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef, (0, _icon.IconContext));

},{"react/jsx-runtime":"2JzhG","~/src/Icon":"1OC2a","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"l7EYo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalCardViewContext", ()=>InternalCardViewContext);
parcelHelpers.export(exports, "CardContext", ()=>CardContext);
parcelHelpers.export(exports, "Card", ()=>Card);
parcelHelpers.export(exports, "CardPreview", ()=>CardPreview);
parcelHelpers.export(exports, "CollectionCardPreview", ()=>CollectionCardPreview);
parcelHelpers.export(exports, "AssetCard", ()=>AssetCard);
parcelHelpers.export(exports, "UserCard", ()=>UserCard);
parcelHelpers.export(exports, "ProductCard", ()=>ProductCard);
var _jsxRuntime = require("react/jsx-runtime");
var _actionMenu = require("./ActionMenu");
var _avatar = require("./Avatar");
var _button = require("./Button");
var _checkbox = require("./Checkbox");
var _reactAriaComponents = require("react-aria-components");
var _content = require("./Content");
var _react = require("react");
var _divider = require("./Divider");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _image = require("./Image");
var _imageCoordinator = require("./ImageCoordinator");
var _runtime = require("../style/runtime");
var _pressScale = require("./pressScale");
var _skeleton = require("./Skeleton");
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const borderRadius = {
    default: 'lg',
    size: {
        XS: 'default',
        S: 'default'
    }
};
let card = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $U = false;
    let $l = false;
    for (let p of matches){
        if (/^\s*U/.test(p)) $U = true;
        if (/^\s*l/.test(p)) $l = true;
    }
    rules += ' _Zd';
    rules += ' _6b';
    if (!$U) rules += ' Uc';
    if (props.size === "S") rules += ' _vc';
    else if (props.size === "XS") rules += ' _vc';
    else rules += ' _vd';
    if (props.size === "S") rules += ' _wc';
    else if (props.size === "XS") rules += ' _wc';
    else rules += ' _wd';
    if (props.size === "S") rules += ' _xc';
    else if (props.size === "XS") rules += ' _xc';
    else rules += ' _xd';
    if (props.size === "S") rules += ' _yc';
    else if (props.size === "XS") rules += ' _yc';
    else rules += ' _yd';
    rules += ' -_1de2x0q_b-a_____w';
    if (props.variant === "secondary") rules += ' -_1de2x0q_b-e';
    else if (props.variant === "primary") rules += ' -_1de2x0q_b-______k';
    if (props.variant === "quiet") rules += ' ba';
    else if (props.variant === "tertiary") rules += ' ba';
    else rules += ' b-1de2x0q';
    if (props.variant === "quiet") rules += ' _td';
    else if (props.variant === "tertiary") {
        rules += ' _ta-8u3g88';
        if (props.isSelected) rules += ' _td';
        else if (props.isFocusVisible) rules += ' _t-1l158k4';
        else if (props.isHovered) rules += ' _t-1l158k4';
        else rules += ' _t-9p5yze';
    } else {
        rules += ' _ta-8u3g88';
        if (props.isSelected) rules += ' _tb';
        else if (props.isFocusVisible) rules += ' _tb';
        else if (props.isHovered) rules += ' _tb';
        else rules += ' _ta';
    }
    rules += ' _zb';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.variant === "quiet") rules += ' __vd';
    else rules += ' __vc';
    if (props.variant === "quiet") rules += ' __wd';
    else rules += ' __wc';
    rules += ' __mf';
    rules += ' __R-yksgrp';
    if (props.isCardView) rules += ' __Da';
    if (props.isLink) rules += ' __Hc';
    if (!$l) {
        if (props.isCardView) rules += ' lb';
        else if (props.size === "XL") rules += ' l______Q';
        else if (props.size === "L") rules += ' l_____y';
        else if (props.size === "M") rules += ' l____g';
        else if (props.size === "S") rules += ' l___u';
        else if (props.size === "XS") rules += ' l__c';
    }
    rules += ' kb';
    if (props.density === "spacious") {
        if (props.size === "XL") rules += ' -nxovgr_E-i';
        else if (props.size === "L") rules += ' -nxovgr_E-h';
        else if (props.size === "M") rules += ' -nxovgr_E-g';
        else if (props.size === "S") rules += ' -nxovgr_E-f';
        else if (props.size === "XS") rules += ' -nxovgr_E-e';
    } else if (props.density === "regular") {
        if (props.size === "XL") rules += ' -nxovgr_E-h';
        else if (props.size === "L") rules += ' -nxovgr_E-g';
        else if (props.size === "M") rules += ' -nxovgr_E-f';
        else if (props.size === "S") rules += ' -nxovgr_E-e';
        else if (props.size === "XS") rules += ' -nxovgr_E-d';
    } else if (props.density === "compact") {
        if (props.size === "XL") rules += ' -nxovgr_E-g';
        else if (props.size === "L") rules += ' -nxovgr_E-f';
        else if (props.size === "M") rules += ' -nxovgr_E-e';
        else if (props.size === "S") rules += ' -nxovgr_E-d';
        else if (props.size === "XS") rules += ' -nxovgr_E-undefined';
    }
    if (props.variant === "quiet") rules += ' -_1bqkh6r_E-a';
    else rules += ' -_1bqkh6r_E--nxovgr';
    if (props.variant === "quiet") rules += ' -_1bqkh6q_C-a';
    else rules += ' -_1bqkh6q_C--nxovgr';
    rules += ' E-1bqkh6r';
    rules += ' F-1bqkh6r';
    rules += ' C-1bqkh6q';
    rules += ' D-1bqkh6q';
    rules += ' __na';
    if (props.variant === "quiet") rules += ' _La';
    else if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    return rules;
};
let selectionIndicator = function anonymous(props) {
    let rules = " .";
    rules += ' Ua';
    rules += ' Xa';
    rules += ' Za';
    rules += ' Va';
    rules += ' Wa';
    rules += ' __Q-3t1z';
    if (props.size === "S") rules += ' _vc';
    else if (props.size === "XS") rules += ' _vc';
    else rules += ' _vd';
    if (props.size === "S") rules += ' _wc';
    else if (props.size === "XS") rules += ' _wc';
    else rules += ' _wd';
    if (props.size === "S") rules += ' _xc';
    else if (props.size === "XS") rules += ' _xc';
    else rules += ' _xd';
    if (props.size === "S") rules += ' _yc';
    else if (props.size === "XS") rules += ' _yc';
    else rules += ' _yd';
    rules += ' __Ba';
    rules += ' uc';
    rules += ' vc';
    rules += ' sc';
    rules += ' tc';
    rules += ' wa';
    rules += ' cp';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    if (props.isSelected) rules += ' _K-3t1y';
    else rules += ' _K-3t1x';
    rules += ' d-834pbw';
    rules += ' _M-3hmpy';
    if (props.isStrokeInner) rules += ' _Lb';
    else rules += ' _La';
    rules += ' _Nc';
    return rules;
};
let preview = function anonymous(props) {
    let rules = " .";
    rules += ' Uc';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' __vc';
    rules += ' __wc';
    rules += ' y-orfo3s';
    rules += ' z-orfo3s';
    rules += ' A-ja89ex';
    rules += ' B-uamghw-ja89ex';
    if (props.isQuiet) {
        if (props.size === "S") rules += ' _vc';
        else if (props.size === "XS") rules += ' _vc';
        else rules += ' _vd';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' _wc';
        else if (props.size === "XS") rules += ' _wc';
        else rules += ' _wd';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' _xc';
        else if (props.size === "XS") rules += ' _xc';
        else rules += ' _xd';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' _yc';
        else if (props.size === "XS") rules += ' _yc';
        else rules += ' _yd';
    }
    if (props.isQuiet) {
        if (props.isSelected) rules += ' _tb';
        else if (props.isFocusVisible) rules += ' _tb';
        else if (props.isHovered) rules += ' _tb';
    }
    if (props.isQuiet) {
        if (props.isFocusVisible) rules += ' _Lb';
    } else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    return rules;
};
const image = " . lb _b-375yqh __Nb __Da __Ba";
let title = function anonymous(props) {
    let rules = " .";
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "M") {
        rules += ' _dbf';
        rules += ' _de';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbd';
        rules += ' _dc';
    }
    rules += ' _e-1x99dlod';
    rules += ' _ed';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    rules += ' ao';
    rules += ' _n-3t20';
    rules += ' __a-4k3jmv';
    rules += ' __b-4k3jmv';
    rules += ' __c-4k3jmv';
    rules += ' __d-4k3jmv';
    return rules;
};
let description = function anonymous(props) {
    let rules = " .";
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "L") {
        rules += ' _dbf';
        rules += ' _de';
    } else if (props.size === "M") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "S") {
        rules += ' _dbb';
        rules += ' _da';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    }
    rules += ' _eb';
    rules += ' _f-1x99dloc';
    rules += ' _fb';
    rules += ' an';
    rules += ' _n-3t20';
    rules += ' __a-14f9fux';
    rules += ' __b-14f9fux';
    rules += ' __c-14f9fux';
    rules += ' __d-14f9fux';
    return rules;
};
let content = function anonymous(props) {
    let rules = " .";
    rules += ' _Zf';
    rules += ' __h-8mtrwf-ho9dum';
    rules += ' __h-375yi6';
    rules += ' __j-8mtrwf-1h7qlgk';
    rules += ' __j-1272nor';
    rules += ' jc';
    rules += ' _9-3t1y';
    rules += ' _1d';
    rules += ' _0e';
    if (props.size === "XL") rules += ' id';
    else if (props.size === "L") rules += ' i-6njx2e';
    else if (props.size === "M") rules += ' i-6njx2e';
    else if (props.size === "S") rules += ' ic';
    else if (props.size === "XS") rules += ' ic';
    rules += ' E-13alit4a';
    rules += ' E-nxovgr';
    rules += ' F-uamghwa';
    rules += ' F-sh5t6w';
    return rules;
};
let actionMenu = " . __a-ykmrkq __b-ykmrkq __c-ykmrkq __d-ykmrkq A-1rxwibp B-1rxwibp";
let footer = " . _Zd _6a _1b _2e id jd E-sh5t6w";
const InternalCardViewContext = /*#__PURE__*/ (0, _react.createContext)('div');
const CardContext = /*#__PURE__*/ (0, _react.createContext)(null);
const InternalCardContext = /*#__PURE__*/ (0, _react.createContext)({
    isQuiet: false,
    size: 'M',
    isSelected: false,
    isHovered: false,
    isFocusVisible: false,
    isPressed: false,
    isCheckboxSelection: true
});
const actionButtonSize = {
    XS: 'XS',
    S: 'XS',
    M: 'S',
    L: 'M',
    XL: 'L'
};
const Card = /*#__PURE__*/ (0, _react.forwardRef)(function Card(props, ref) {
    [props] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CardContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { density = 'regular', size = 'M', variant = 'primary', UNSAFE_className = '', UNSAFE_style, styles, id, ...otherProps } = props;
    let isQuiet = variant === 'quiet';
    let isSkeleton = (0, _skeleton.useIsSkeleton)();
    let children = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _image.ImageContext),
                {
                    alt: '',
                    styles: image
                }
            ],
            [
                (0, _content.TextContext),
                {
                    slots: {
                        [(0, _reactAriaComponents.DEFAULT_SLOT)]: {},
                        title: {
                            styles: title({
                                size
                            })
                        },
                        description: {
                            styles: description({
                                size
                            })
                        }
                    }
                }
            ],
            [
                (0, _content.ContentContext),
                {
                    styles: content({
                        size
                    })
                }
            ],
            [
                (0, _divider.DividerContext),
                {
                    size: 'S'
                }
            ],
            [
                (0, _content.FooterContext),
                {
                    styles: footer
                }
            ],
            [
                (0, _actionMenu.ActionMenuContext),
                {
                    isQuiet: true,
                    size: actionButtonSize[size],
                    isDisabled: isSkeleton,
                    // @ts-ignore
                    'data-slot': 'menu',
                    styles: actionMenu
                }
            ],
            [
                (0, _skeleton.SkeletonContext),
                isSkeleton
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageCoordinator.ImageCoordinator), {
            children: typeof props.children === 'function' ? props.children({
                size
            }) : props.children
        })
    });
    let ElementType = (0, _react.useContext)(InternalCardViewContext);
    if (ElementType === 'div' || isSkeleton) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _utils.filterDOMProps)(otherProps),
        id: id != null ? String(id) : undefined,
        // @ts-ignore - React < 19 compat
        inert: isSkeleton ? 'true' : undefined,
        ref: domRef,
        className: UNSAFE_className + card({
            size,
            density,
            variant,
            isCardView: ElementType !== 'div'
        }, styles),
        style: UNSAFE_style,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalCardContext.Provider, {
            value: {
                size,
                isQuiet,
                isCheckboxSelection: false,
                isHovered: false,
                isFocusVisible: false,
                isSelected: false,
                isPressed: false
            },
            children: children
        })
    });
    let press = (0, _pressScale.pressScale)(domRef, UNSAFE_style);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ElementType, {
        ...props,
        ref: domRef,
        className: (renderProps)=>UNSAFE_className + card({
                ...renderProps,
                isCardView: true,
                isLink: !!props.href,
                size,
                density,
                variant
            }, styles),
        style: (renderProps)=>// Only the preview in quiet cards scales down on press
            variant === 'quiet' ? UNSAFE_style : press(renderProps),
        children: ({ selectionMode, selectionBehavior, isHovered, isFocusVisible, isSelected, isPressed })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(InternalCardContext.Provider, {
                value: {
                    size,
                    isQuiet,
                    isCheckboxSelection: selectionMode !== 'none' && selectionBehavior === 'toggle',
                    isHovered,
                    isFocusVisible,
                    isSelected,
                    isPressed
                },
                children: [
                    !isQuiet && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectionIndicator, {}),
                    !isQuiet && selectionMode !== 'none' && selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardCheckbox, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " . _Zh",
                        children: children
                    })
                ]
            })
    });
});
function SelectionIndicator() {
    let { size, isSelected, isQuiet, isCheckboxSelection } = (0, _react.useContext)(InternalCardContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: selectionIndicator({
            size,
            isSelected,
            // Add an inner stroke only for quiet cards with no checkbox to
            // help distinguish the selected state from the preview.
            isStrokeInner: isQuiet && !isCheckboxSelection
        })
    });
}
function CardCheckbox() {
    let { size } = (0, _react.useContext)(InternalCardContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: " . Ua X-nxovgr V-nxovgr __Q-3t1z Ec Fc Cc Dc b-834pbw _vc _wc _xc _yc _ta",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
            slot: "selection",
            excludeFromTabOrder: true,
            size: size === 'XS' ? 'S' : size
        })
    });
}
const CardPreview = /*#__PURE__*/ (0, _react.forwardRef)(function CardPreview(props, ref) {
    let { size, isQuiet, isHovered, isFocusVisible, isSelected, isPressed, isCheckboxSelection } = (0, _react.useContext)(InternalCardContext);
    let { UNSAFE_className, UNSAFE_style } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...(0, _utils.filterDOMProps)(props),
        slot: "preview",
        ref: domRef,
        className: UNSAFE_className + preview({
            size,
            isQuiet,
            isHovered,
            isFocusVisible,
            isSelected
        }),
        style: isQuiet ? (0, _pressScale.pressScale)(domRef)({
            isPressed
        }) : UNSAFE_style,
        children: [
            isQuiet && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectionIndicator, {}),
            isQuiet && isCheckboxSelection && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardCheckbox, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " . _v-17zqamw _w-17zqamw _x-17zqamw _y-17zqamw __vc __wc",
                children: props.children
            })
        ]
    });
});
const collection = function anonymous(props) {
    let rules = " .";
    rules += ' _Zf';
    rules += ' __h-1hkn3tr';
    if (props.size === "S") rules += ' ib';
    else if (props.size === "XS") rules += ' ib';
    else rules += ' ic';
    if (props.size === "S") rules += ' jb';
    else if (props.size === "XS") rules += ' jb';
    else rules += ' jc';
    return rules;
};
const collectionImage = " . lb _bb _b-7ptyxf-375yqh __b-7ptyxf-7u9dhm __Nb __Ba __Da";
const CollectionCardPreview = /*#__PURE__*/ (0, _react.forwardRef)(function CollectionCardPreview(props, ref) {
    let { size } = (0, _react.useContext)(InternalCardContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardPreview, {
        ...props,
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: collection({
                size
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _image.ImageContext).Provider, {
                value: {
                    styles: collectionImage
                },
                children: props.children
            })
        })
    });
});
const AssetCard = /*#__PURE__*/ (0, _react.forwardRef)(function AssetCard(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
        ...props,
        ref: ref,
        density: "regular",
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _image.ImageContext),
                        {
                            alt: '',
                            styles: " . lb _bb __Na __Ba __Da"
                        }
                    ],
                    [
                        (0, _icon.IllustrationContext),
                        {
                            render (icon) {
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: " . _Zd _1c _2d bg _bb",
                                        children: icon
                                    })
                                });
                            },
                            styles: " . ka r__Z p__Z l-3760fj"
                        }
                    ]
                ],
                children: children
            }))
    });
});
const avatarSize = {
    XS: 24,
    S: 48,
    M: 64,
    L: 64,
    XL: 80
};
const UserCard = /*#__PURE__*/ (0, _react.forwardRef)(function UserCard(props, ref) {
    let { size = 'M' } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
        ...props,
        ref: ref,
        density: "spacious",
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _image.ImageContext),
                        {
                            alt: '',
                            styles: " . lb _b-375yqg __Nb __Ba __Da"
                        }
                    ],
                    [
                        (0, _avatar.AvatarContext),
                        {
                            size: avatarSize[size],
                            UNSAFE_style: {
                                '--size': avatarSize[size] + 'px'
                            },
                            styles: " . Uc Aa A-1d75it2-1oavddy",
                            isOverBackground: true
                        }
                    ]
                ],
                children: children
            }))
    });
});
const buttonSize = {
    XS: 'S',
    S: 'S',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
const ProductCard = /*#__PURE__*/ (0, _react.forwardRef)(function ProductCard(props1, ref) {
    let { size = 'M' } = props1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
        ...props1,
        ref: ref,
        density: "spacious",
        children: (0, _reactAriaComponents.composeRenderProps)(props1.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _image.ImageContext),
                        {
                            slots: {
                                preview: {
                                    alt: '',
                                    styles: " . lb _b-3760ey __Nb __Ba __Da"
                                },
                                thumbnail: {
                                    alt: '',
                                    styles: function anonymous(props) {
                                        let rules = " .";
                                        rules += ' Uc';
                                        rules += ' __Ba';
                                        rules += ' __Da';
                                        if (props.size === "XL") rules += ' l_i';
                                        else if (props.size === "L") rules += ' l6';
                                        else if (props.size === "M") rules += ' l2';
                                        else if (props.size === "S") rules += ' lY';
                                        else if (props.size === "XS") rules += ' lM';
                                        rules += ' k-375toq';
                                        if (props.size === "S") rules += ' _vb';
                                        else if (props.size === "XS") rules += ' _vb';
                                        else rules += ' _vc';
                                        if (props.size === "S") rules += ' _wb';
                                        else if (props.size === "XS") rules += ' _wb';
                                        else rules += ' _wc';
                                        if (props.size === "S") rules += ' _xb';
                                        else if (props.size === "XS") rules += ' _xb';
                                        else rules += ' _xc';
                                        if (props.size === "S") rules += ' _yb';
                                        else if (props.size === "XS") rules += ' _yb';
                                        else rules += ' _yc';
                                        rules += ' __Nb';
                                        rules += ' A-1d75it2-6grsbv';
                                        rules += ' Aa';
                                        rules += ' _Lb';
                                        if (props.size === "XS") rules += ' _Nb';
                                        else rules += ' _Nc';
                                        rules += ' d-1de2x0q';
                                        if (props.size === "XL") rules += ' -_375toq_k-_i';
                                        else if (props.size === "L") rules += ' -_375toq_k-6';
                                        else if (props.size === "M") rules += ' -_375toq_k-2';
                                        else if (props.size === "S") rules += ' -_375toq_k-Y';
                                        else if (props.size === "XS") rules += ' -_375toq_k-M';
                                        return rules;
                                    }({
                                        size
                                    })
                                }
                            }
                        }
                    ],
                    [
                        (0, _content.FooterContext),
                        {
                            styles: (0, _runtime.mergeStyles)(footer, " . _2c")
                        }
                    ],
                    [
                        (0, _button.ButtonContext),
                        {
                            size: buttonSize[size]
                        }
                    ],
                    [
                        (0, _button.LinkButtonContext),
                        {
                            size: buttonSize[size]
                        }
                    ]
                ],
                children: children
            }))
    });
});
try {
    // @ts-ignore
    InternalCardViewContext.displayName = "InternalCardViewContext";
    // @ts-ignore
    InternalCardViewContext.__docgenInfo = {
        "description": "",
        "displayName": "InternalCardViewContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "\"div\" | (<T extends object>(props: GridListItemProps<T> & RefAttributes<T>) => ReactElement<unknown, string | JSXElementConstructor<any>> | null)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Card.tsx#InternalCardViewContext"] = {
        docgenInfo: InternalCardViewContext.__docgenInfo,
        name: "InternalCardViewContext",
        path: "packages/@react-spectrum/s2/src/Card.tsx#InternalCardViewContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    CardContext.displayName = "CardContext";
    // @ts-ignore
    CardContext.__docgenInfo = {
        "description": "",
        "displayName": "CardContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<Partial<CardProps>, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Card.tsx#CardContext"] = {
        docgenInfo: CardContext.__docgenInfo,
        name: "CardContext",
        path: "packages/@react-spectrum/s2/src/Card.tsx#CardContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    Card.displayName = "Card";
    // @ts-ignore
    Card.__docgenInfo = {
        "description": "",
        "displayName": "Card",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the Card.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode | ((renderProps: CardRenderProps) => ReactNode)"
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of internal padding within the Card.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Card.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        },
                        {
                            "value": "\"XS\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The visual style of the Card.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"tertiary\""
                        },
                        {
                            "value": "\"quiet\""
                        }
                    ]
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Card.tsx#Card"] = {
        docgenInfo: Card.__docgenInfo,
        name: "Card",
        path: "packages/@react-spectrum/s2/src/Card.tsx#Card"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    CardPreview.displayName = "CardPreview";
    // @ts-ignore
    CardPreview.__docgenInfo = {
        "description": "",
        "displayName": "CardPreview",
        "props": {
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Card.tsx#CardPreview"] = {
        docgenInfo: CardPreview.__docgenInfo,
        name: "CardPreview",
        path: "packages/@react-spectrum/s2/src/Card.tsx#CardPreview"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    CollectionCardPreview.displayName = "CollectionCardPreview";
    // @ts-ignore
    CollectionCardPreview.__docgenInfo = {
        "description": "",
        "displayName": "CollectionCardPreview",
        "props": {
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Card.tsx#CollectionCardPreview"] = {
        docgenInfo: CollectionCardPreview.__docgenInfo,
        name: "CollectionCardPreview",
        path: "packages/@react-spectrum/s2/src/Card.tsx#CollectionCardPreview"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    AssetCard.displayName = "AssetCard";
    // @ts-ignore
    AssetCard.__docgenInfo = {
        "description": "",
        "displayName": "AssetCard",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the Card.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode | ((renderProps: CardRenderProps) => ReactNode)"
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Card.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        },
                        {
                            "value": "\"XS\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The visual style of the Card.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"tertiary\""
                        },
                        {
                            "value": "\"quiet\""
                        }
                    ]
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Card.tsx#AssetCard"] = {
        docgenInfo: AssetCard.__docgenInfo,
        name: "AssetCard",
        path: "packages/@react-spectrum/s2/src/Card.tsx#AssetCard"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    UserCard.displayName = "UserCard";
    // @ts-ignore
    UserCard.__docgenInfo = {
        "description": "",
        "displayName": "UserCard",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the Card.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode | ((renderProps: CardRenderProps) => ReactNode)"
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of internal padding within the Card.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Card.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        },
                        {
                            "value": "\"XS\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The visual style of the Card.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"tertiary\""
                        },
                        {
                            "value": "\"quiet\""
                        }
                    ]
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Card.tsx#UserCard"] = {
        docgenInfo: UserCard.__docgenInfo,
        name: "UserCard",
        path: "packages/@react-spectrum/s2/src/Card.tsx#UserCard"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    ProductCard.displayName = "ProductCard";
    // @ts-ignore
    ProductCard.__docgenInfo = {
        "description": "",
        "displayName": "ProductCard",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the Card.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode | ((renderProps: CardRenderProps) => ReactNode)"
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Card.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        },
                        {
                            "value": "\"XS\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "variant": {
                "defaultValue": null,
                "description": "",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"tertiary\""
                        }
                    ]
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Card.tsx#ProductCard"] = {
        docgenInfo: ProductCard.__docgenInfo,
        name: "ProductCard",
        path: "packages/@react-spectrum/s2/src/Card.tsx#ProductCard"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"fexQH","1":"iFIKP","2":"8iPLz","3":"8ZA9o","4":"b3RbA","5":"fBjM9","6":"gVNRj","7":"cUSBp","8":"i8ODn","9":"deN70","10":"in5k4","11":"ifJhL","12":"2eYCx","13":"er34z","14":"4LPWu","15":"lscn5","16":"lu23d","17":"cmLEz","18":"9PjH7","19":"cYac0","20":"gFqcE","21":"91tet","react/jsx-runtime":"2JzhG","./ActionMenu":"hqMHG","./Avatar":"3UH45","./Button":"lgKOs","./Checkbox":"7w7or","react-aria-components":"8nuKL","./Content":"aBWEm","react":"jEiK2","./Divider":"cE2Z4","@react-aria/utils":"e9Yvo","./Icon":"1OC2a","./Image":"l3wRP","./ImageCoordinator":"2Xi55","../style/runtime":"dzhKB","./pressScale":"6BiUY","./Skeleton":"2hWWB","@react-spectrum/utils":"bebxO","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"fexQH":[function() {},{}],"iFIKP":[function() {},{}],"8iPLz":[function() {},{}],"8ZA9o":[function() {},{}],"b3RbA":[function() {},{}],"fBjM9":[function() {},{}],"gVNRj":[function() {},{}],"cUSBp":[function() {},{}],"i8ODn":[function() {},{}],"deN70":[function() {},{}],"in5k4":[function() {},{}],"ifJhL":[function() {},{}],"2eYCx":[function() {},{}],"er34z":[function() {},{}],"4LPWu":[function() {},{}],"lscn5":[function() {},{}],"lu23d":[function() {},{}],"cmLEz":[function() {},{}],"9PjH7":[function() {},{}],"cYac0":[function() {},{}],"gFqcE":[function() {},{}],"91tet":[function() {},{}],"2W2In":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardViewContext", ()=>CardViewContext);
parcelHelpers.export(exports, "CardView", ()=>_CardView);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _card = require("./Card");
var _react = require("react");
var _imageCoordinator = require("./ImageCoordinator");
var _virtualizer = require("@react-stately/virtualizer");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
class FlexibleGridLayout extends (0, _virtualizer.Layout) {
    update(invalidationContext) {
        let { minItemSize = new (0, _virtualizer.Size)(200, 200), maxItemSize = new (0, _virtualizer.Size)(Infinity, Infinity), minSpace = new (0, _virtualizer.Size)(18, 18), maxColumns = Infinity } = invalidationContext.layoutOptions || {};
        let visibleWidth = this.virtualizer.visibleRect.width;
        // The max item width is always the entire viewport.
        // If the max item height is infinity, scale in proportion to the max width.
        let maxItemWidth = Math.min(maxItemSize.width, visibleWidth);
        let maxItemHeight = Number.isFinite(maxItemSize.height) ? maxItemSize.height : Math.floor(minItemSize.height / minItemSize.width * maxItemWidth);
        // Compute the number of rows and columns needed to display the content
        let columns = Math.floor(visibleWidth / (minItemSize.width + minSpace.width));
        let numColumns = Math.max(1, Math.min(maxColumns, columns));
        // Compute the available width (minus the space between items)
        let width = visibleWidth - minSpace.width * Math.max(0, numColumns);
        // Compute the item width based on the space available
        let itemWidth = Math.floor(width / numColumns);
        itemWidth = Math.max(minItemSize.width, Math.min(maxItemWidth, itemWidth));
        // Compute the item height, which is proportional to the item width
        let t = (itemWidth - minItemSize.width) / Math.max(1, maxItemWidth - minItemSize.width);
        let itemHeight = minItemSize.height + Math.floor((maxItemHeight - minItemSize.height) * t);
        itemHeight = Math.max(minItemSize.height, Math.min(maxItemHeight, itemHeight));
        // Compute the horizontal spacing and content height
        let horizontalSpacing = Math.floor((visibleWidth - numColumns * itemWidth) / (numColumns + 1));
        let rows = Math.ceil(this.virtualizer.collection.size / numColumns);
        let iterator = this.virtualizer.collection[Symbol.iterator]();
        let y = rows > 0 ? minSpace.height : 0;
        let newLayoutInfos = new Map();
        let skeleton = null;
        let skeletonCount = 0;
        for(let row = 0; row < rows; row++){
            let maxHeight = 0;
            let rowLayoutInfos = [];
            for(let col = 0; col < numColumns; col++){
                // Repeat skeleton until the end of the current row.
                let node = skeleton || iterator.next().value;
                if (!node) break;
                if (node.type === 'skeleton') skeleton = node;
                let key = skeleton ? `${skeleton.key}-${skeletonCount++}` : node.key;
                let content = skeleton ? {
                    ...skeleton
                } : node;
                let x = horizontalSpacing + col * (itemWidth + horizontalSpacing);
                let oldLayoutInfo = this.layoutInfos.get(key);
                let height = itemHeight;
                let estimatedSize = true;
                if (oldLayoutInfo) {
                    height = oldLayoutInfo.rect.height;
                    estimatedSize = invalidationContext.sizeChanged || oldLayoutInfo.estimatedSize || oldLayoutInfo.content !== content;
                }
                let rect = new (0, _virtualizer.Rect)(x, y, itemWidth, height);
                let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, key, rect);
                layoutInfo.estimatedSize = estimatedSize;
                layoutInfo.allowOverflow = true;
                layoutInfo.content = content;
                newLayoutInfos.set(key, layoutInfo);
                rowLayoutInfos.push(layoutInfo);
                maxHeight = Math.max(maxHeight, rect.height);
            }
            for (let layoutInfo of rowLayoutInfos)layoutInfo.rect.height = maxHeight;
            y += maxHeight + minSpace.height;
            // Keep adding skeleton rows until we fill the viewport
            if (skeleton && row === rows - 1 && y < this.virtualizer.visibleRect.height) rows++;
        }
        this.layoutInfos = newLayoutInfos;
        this.contentSize = new (0, _virtualizer.Size)(this.virtualizer.visibleRect.width, y);
    }
    getLayoutInfo(key) {
        return this.layoutInfos.get(key);
    }
    getContentSize() {
        return this.contentSize;
    }
    getVisibleLayoutInfos(rect) {
        let layoutInfos = [];
        for (let layoutInfo of this.layoutInfos.values())if (layoutInfo.rect.intersects(rect) || this.virtualizer.isPersistedKey(layoutInfo.key)) layoutInfos.push(layoutInfo);
        return layoutInfos;
    }
    updateItemSize(key, size) {
        let layoutInfo = this.layoutInfos.get(key);
        if (!size || !layoutInfo) return false;
        if (size.height !== layoutInfo.rect.height) {
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect.height = size.height;
            newLayoutInfo.estimatedSize = false;
            this.layoutInfos.set(key, newLayoutInfo);
            return true;
        }
        return false;
    }
    constructor(...args){
        super(...args), this.contentSize = new (0, _virtualizer.Size)(), this.layoutInfos = new Map();
    }
}
class WaterfallLayoutInfo extends (0, _virtualizer.LayoutInfo) {
    copy() {
        let res = super.copy();
        res.column = this.column;
        return res;
    }
    constructor(...args){
        super(...args), this.column = 0;
    }
}
class WaterfallLayout extends (0, _virtualizer.Layout) {
    update(invalidationContext) {
        let { minItemSize = new (0, _virtualizer.Size)(200, 200), maxItemSize = new (0, _virtualizer.Size)(Infinity, Infinity), minSpace = new (0, _virtualizer.Size)(18, 18), maxColumns = Infinity } = invalidationContext.layoutOptions || {};
        let visibleWidth = this.virtualizer.visibleRect.width;
        // The max item width is always the entire viewport.
        // If the max item height is infinity, scale in proportion to the max width.
        let maxItemWidth = Math.min(maxItemSize.width, visibleWidth);
        let maxItemHeight = Number.isFinite(maxItemSize.height) ? maxItemSize.height : Math.floor(minItemSize.height / minItemSize.width * maxItemWidth);
        // Compute the number of rows and columns needed to display the content
        let columns = Math.floor(visibleWidth / (minItemSize.width + minSpace.width));
        let numColumns = Math.max(1, Math.min(maxColumns, columns));
        // Compute the available width (minus the space between items)
        let width = visibleWidth - minSpace.width * Math.max(0, numColumns);
        // Compute the item width based on the space available
        let itemWidth = Math.floor(width / numColumns);
        itemWidth = Math.max(minItemSize.width, Math.min(maxItemWidth, itemWidth));
        // Compute the item height, which is proportional to the item width
        let t = (itemWidth - minItemSize.width) / Math.max(1, maxItemWidth - minItemSize.width);
        let itemHeight = minItemSize.height + Math.floor((maxItemHeight - minItemSize.height) * t);
        itemHeight = Math.max(minItemSize.height, Math.min(maxItemHeight, itemHeight));
        // Compute the horizontal spacing and content height
        let horizontalSpacing = Math.floor((visibleWidth - numColumns * itemWidth) / (numColumns + 1));
        // Setup an array of column heights
        let columnHeights = Array(numColumns).fill(minSpace.height);
        let newLayoutInfos = new Map();
        let addNode = (key, node)=>{
            let oldLayoutInfo = this.layoutInfos.get(key);
            let height = itemHeight;
            let estimatedSize = true;
            if (oldLayoutInfo) {
                height = oldLayoutInfo.rect.height;
                estimatedSize = invalidationContext.sizeChanged || oldLayoutInfo.estimatedSize || oldLayoutInfo.content !== node;
            }
            // Figure out which column to place the item in, and compute its position.
            // Preserve the previous column index so items don't jump around during resizing unless the number of columns changed.
            let prevColumn = numColumns === this.numColumns ? oldLayoutInfo?.column : undefined;
            let column = prevColumn ?? columnHeights.reduce((minIndex, h, i)=>h < columnHeights[minIndex] ? i : minIndex, 0);
            let x = horizontalSpacing + column * (itemWidth + horizontalSpacing);
            let y = columnHeights[column];
            let rect = new (0, _virtualizer.Rect)(x, y, itemWidth, height);
            let layoutInfo = new WaterfallLayoutInfo(node.type, key, rect);
            layoutInfo.estimatedSize = estimatedSize;
            layoutInfo.allowOverflow = true;
            layoutInfo.content = node;
            layoutInfo.column = column;
            newLayoutInfos.set(key, layoutInfo);
            columnHeights[column] += layoutInfo.rect.height + minSpace.height;
        };
        let skeletonCount = 0;
        for (let node of this.virtualizer.collection)if (node.type === 'skeleton') {
            // Add skeleton cards until every column has at least one, and we fill the viewport.
            let startingHeights = [
                ...columnHeights
            ];
            while(!columnHeights.every((h, i)=>h !== startingHeights[i]) || Math.min(...columnHeights) < this.virtualizer.visibleRect.height){
                let key = `${node.key}-${skeletonCount++}`;
                let content = this.layoutInfos.get(key)?.content || {
                    ...node
                };
                addNode(key, content);
            }
            break;
        } else addNode(node.key, node);
        // Reset all columns to the maximum for the next section
        let maxHeight = Math.max(...columnHeights);
        this.contentSize = new (0, _virtualizer.Size)(this.virtualizer.visibleRect.width, maxHeight);
        this.layoutInfos = newLayoutInfos;
        this.numColumns = numColumns;
    }
    getLayoutInfo(key) {
        return this.layoutInfos.get(key);
    }
    getContentSize() {
        return this.contentSize;
    }
    getVisibleLayoutInfos(rect) {
        let layoutInfos = [];
        for (let layoutInfo of this.layoutInfos.values())if (layoutInfo.rect.intersects(rect) || this.virtualizer.isPersistedKey(layoutInfo.key)) layoutInfos.push(layoutInfo);
        return layoutInfos;
    }
    updateItemSize(key, size) {
        let layoutInfo = this.layoutInfos.get(key);
        if (!size || !layoutInfo) return false;
        if (size.height !== layoutInfo.rect.height) {
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect.height = size.height;
            newLayoutInfo.estimatedSize = false;
            this.layoutInfos.set(key, newLayoutInfo);
            return true;
        }
        return false;
    }
    // Override keyboard navigation to work spacially.
    getKeyRightOf(key) {
        let layoutInfo = this.getLayoutInfo(key);
        if (!layoutInfo) return null;
        let rect = new (0, _virtualizer.Rect)(layoutInfo.rect.maxX, layoutInfo.rect.y, this.virtualizer.visibleRect.maxX - layoutInfo.rect.maxX, layoutInfo.rect.height);
        let layoutInfos = this.getVisibleLayoutInfos(rect);
        let bestKey = null;
        let bestDistance = Infinity;
        for (let candidate of layoutInfos){
            if (candidate.key === key) continue;
            // Find the closest item in the x direction with the most overlap in the y direction.
            let deltaX = candidate.rect.x - rect.x;
            let overlapY = Math.min(candidate.rect.maxY, rect.maxY) - Math.max(candidate.rect.y, rect.y);
            let distance = deltaX - overlapY;
            if (distance < bestDistance) {
                bestDistance = distance;
                bestKey = candidate.key;
            }
        }
        return bestKey;
    }
    getKeyLeftOf(key) {
        let layoutInfo = this.getLayoutInfo(key);
        if (!layoutInfo) return null;
        let rect = new (0, _virtualizer.Rect)(0, layoutInfo.rect.y, layoutInfo.rect.x, layoutInfo.rect.height);
        let layoutInfos = this.getVisibleLayoutInfos(rect);
        let bestKey = null;
        let bestDistance = Infinity;
        for (let candidate of layoutInfos){
            if (candidate.key === key) continue;
            // Find the closest item in the x direction with the most overlap in the y direction.
            let deltaX = rect.maxX - candidate.rect.maxX;
            let overlapY = Math.min(candidate.rect.maxY, rect.maxY) - Math.max(candidate.rect.y, rect.y);
            let distance = deltaX - overlapY;
            if (distance < bestDistance) {
                bestDistance = distance;
                bestKey = candidate.key;
            }
        }
        return bestKey;
    }
    // This overrides the default behavior of shift selection to work spacially
    // rather than following the order of the items in the collection (which may appear unpredictable).
    getKeyRange(from, to) {
        let fromLayoutInfo = this.getLayoutInfo(from);
        let toLayoutInfo = this.getLayoutInfo(to);
        if (!fromLayoutInfo || !toLayoutInfo) return [];
        // Find items where half of the area intersects the rectangle
        // formed from the first item to the last item in the range.
        let rect = fromLayoutInfo.rect.union(toLayoutInfo.rect);
        let keys = [];
        for (let layoutInfo of this.layoutInfos.values())if (rect.intersection(layoutInfo.rect).area > layoutInfo.rect.area / 2) keys.push(layoutInfo.key);
        return keys;
    }
    constructor(...args){
        super(...args), this.contentSize = new (0, _virtualizer.Size)(), this.layoutInfos = new Map(), this.numColumns = 0;
    }
}
const layoutOptions = {
    XS: {
        compact: {
            minSpace: new (0, _virtualizer.Size)(6, 6),
            minItemSize: new (0, _virtualizer.Size)(100, 100),
            maxItemSize: new (0, _virtualizer.Size)(140, 140)
        },
        regular: {
            minSpace: new (0, _virtualizer.Size)(8, 8),
            minItemSize: new (0, _virtualizer.Size)(100, 100),
            maxItemSize: new (0, _virtualizer.Size)(140, 140)
        },
        spacious: {
            minSpace: new (0, _virtualizer.Size)(12, 12),
            minItemSize: new (0, _virtualizer.Size)(100, 100),
            maxItemSize: new (0, _virtualizer.Size)(140, 140)
        }
    },
    S: {
        compact: {
            minSpace: new (0, _virtualizer.Size)(8, 8),
            minItemSize: new (0, _virtualizer.Size)(150, 150),
            maxItemSize: new (0, _virtualizer.Size)(210, 210)
        },
        regular: {
            minSpace: new (0, _virtualizer.Size)(12, 12),
            minItemSize: new (0, _virtualizer.Size)(150, 150),
            maxItemSize: new (0, _virtualizer.Size)(210, 210)
        },
        spacious: {
            minSpace: new (0, _virtualizer.Size)(16, 16),
            minItemSize: new (0, _virtualizer.Size)(150, 150),
            maxItemSize: new (0, _virtualizer.Size)(210, 210)
        }
    },
    M: {
        compact: {
            minSpace: new (0, _virtualizer.Size)(12, 12),
            minItemSize: new (0, _virtualizer.Size)(200, 200),
            maxItemSize: new (0, _virtualizer.Size)(280, 280)
        },
        regular: {
            minSpace: new (0, _virtualizer.Size)(16, 16),
            minItemSize: new (0, _virtualizer.Size)(200, 200),
            maxItemSize: new (0, _virtualizer.Size)(280, 280)
        },
        spacious: {
            minSpace: new (0, _virtualizer.Size)(20, 20),
            minItemSize: new (0, _virtualizer.Size)(200, 200),
            maxItemSize: new (0, _virtualizer.Size)(280, 280)
        }
    },
    L: {
        compact: {
            minSpace: new (0, _virtualizer.Size)(16, 16),
            minItemSize: new (0, _virtualizer.Size)(270, 270),
            maxItemSize: new (0, _virtualizer.Size)(370, 370)
        },
        regular: {
            minSpace: new (0, _virtualizer.Size)(20, 20),
            minItemSize: new (0, _virtualizer.Size)(270, 270),
            maxItemSize: new (0, _virtualizer.Size)(370, 370)
        },
        spacious: {
            minSpace: new (0, _virtualizer.Size)(24, 24),
            minItemSize: new (0, _virtualizer.Size)(270, 270),
            maxItemSize: new (0, _virtualizer.Size)(370, 370)
        }
    },
    XL: {
        compact: {
            minSpace: new (0, _virtualizer.Size)(20, 20),
            minItemSize: new (0, _virtualizer.Size)(340, 340),
            maxItemSize: new (0, _virtualizer.Size)(460, 460)
        },
        regular: {
            minSpace: new (0, _virtualizer.Size)(24, 24),
            minItemSize: new (0, _virtualizer.Size)(340, 340),
            maxItemSize: new (0, _virtualizer.Size)(460, 460)
        },
        spacious: {
            minSpace: new (0, _virtualizer.Size)(28, 28),
            minItemSize: new (0, _virtualizer.Size)(340, 340),
            maxItemSize: new (0, _virtualizer.Size)(460, 460)
        }
    }
};
const SIZES = [
    'XS',
    'S',
    'M',
    'L',
    'XL'
];
const cardViewStyles = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r|k|o|p)[^\s]+/g) || [];
    rules += matches.join('');
    if (props.isLoading) rules += ' __wb';
    else rules += ' __wa';
    if (props.isEmpty) rules += ' _Zd';
    rules += ' _6b';
    rules += ' _1c';
    rules += ' _2d';
    if (props.isEmpty) {
        if (props.isFocusVisible) rules += ' _Lb';
    } else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3hmpw';
    return rules;
};
const CardViewContext = /*#__PURE__*/ (0, _react.createContext)(null);
function CardView(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CardViewContext);
    let { children, layout: layoutName = 'grid', size: sizeProp = 'M', density = 'regular', variant = 'primary', selectionStyle = 'checkbox', UNSAFE_className = '', UNSAFE_style, styles, ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let layout = (0, _react.useMemo)(()=>{
        return layoutName === 'waterfall' ? new WaterfallLayout() : new FlexibleGridLayout();
    }, [
        layoutName
    ]);
    // This calculates the maximum t-shirt size where at least two columns fit in the available width.
    let [maxSizeIndex, setMaxSizeIndex] = (0, _react.useState)(SIZES.length - 1);
    let updateSize = (0, _utils1.useEffectEvent)(()=>{
        let w = domRef.current?.clientWidth ?? 0;
        let i = SIZES.length - 1;
        while(i > 0){
            let opts = layoutOptions[SIZES[i]][density];
            if (w >= opts.minItemSize.width * 2 + opts.minSpace.width * 3) break;
            i--;
        }
        setMaxSizeIndex(i);
    });
    (0, _utils1.useResizeObserver)({
        ref: domRef,
        box: 'border-box',
        onResize: updateSize
    });
    (0, _utils1.useLayoutEffect)(()=>{
        updateSize();
    }, [
        updateSize
    ]);
    // The actual rendered t-shirt size is the minimum between the size prop and the maximum possible size.
    let size = SIZES[Math.min(maxSizeIndex, SIZES.indexOf(sizeProp))];
    let options = layoutOptions[size][density];
    (0, _utils1.useLoadMore)({
        isLoading: props.loadingState !== 'idle' && props.loadingState !== 'error',
        items: props.items,
        onLoadMore: props.onLoadMore
    }, domRef);
    let ctx = (0, _react.useMemo)(()=>({
            size,
            variant
        }), [
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.UNSTABLE_Virtualizer), {
        layout: layout,
        layoutOptions: options,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.InternalCardViewContext).Provider, {
            value: (0, _reactAriaComponents.GridListItem),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContext).Provider, {
                value: ctx,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageCoordinator.ImageCoordinator), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridList), {
                        ref: domRef,
                        ...otherProps,
                        layout: "grid",
                        selectionBehavior: selectionStyle === 'highlight' ? 'replace' : 'toggle',
                        style: {
                            ...UNSAFE_style,
                            scrollPadding: options.minSpace.height
                        },
                        className: (renderProps)=>UNSAFE_className + cardViewStyles({
                                ...renderProps,
                                isLoading: props.loadingState === 'loading'
                            }, styles),
                        children: children
                    })
                })
            })
        })
    });
}
const _CardView = /*#__PURE__*/ (0, _react.forwardRef)(CardView);
try {
    // @ts-ignore
    CardViewContext.displayName = "CardViewContext";
    // @ts-ignore
    CardViewContext.__docgenInfo = {
        "description": "",
        "displayName": "CardViewContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<CardViewProps<any>, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/CardView.tsx#CardViewContext"] = {
        docgenInfo: CardViewContext.__docgenInfo,
        name: "CardViewContext",
        path: "packages/@react-spectrum/s2/src/CardView.tsx#CardViewContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _CardView.displayName = "_CardView";
    // @ts-ignore
    _CardView.__docgenInfo = {
        "description": "",
        "displayName": "_CardView",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of space between the cards.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "disabledBehavior": {
                "defaultValue": null,
                "description": "Whether `disabledKeys` applies to all interactions, or only selection.",
                "name": "disabledBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"all\""
                        },
                        {
                            "value": "\"selection\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "dragAndDropHooks": {
                "defaultValue": null,
                "description": "The drag and drop hooks returned by `useDragAndDrop` used to enable drag and drop behavior for the GridList.",
                "name": "dragAndDropHooks",
                "required": false,
                "type": {
                    "name": "DragAndDropHooks"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "layout": {
                "defaultValue": {
                    value: "'grid'"
                },
                "description": "The layout of the cards.",
                "name": "layout",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"grid\""
                        },
                        {
                            "value": "\"waterfall\""
                        }
                    ]
                }
            },
            "loadingState": {
                "defaultValue": null,
                "description": "The loading state of the CardView.",
                "name": "loadingState",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"error\""
                        },
                        {
                            "value": "\"loading\""
                        },
                        {
                            "value": "\"sorting\""
                        },
                        {
                            "value": "\"loadingMore\""
                        },
                        {
                            "value": "\"idle\""
                        },
                        {
                            "value": "\"filtering\""
                        }
                    ]
                }
            },
            "renderEmptyState": {
                "defaultValue": null,
                "description": "Provides content to display when there are no items in the list.",
                "name": "renderEmptyState",
                "required": false,
                "type": {
                    "name": "((props: GridListRenderProps) => ReactNode)"
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "The type of selection that is allowed in the collection.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "selectionStyle": {
                "defaultValue": {
                    value: "'checkbox'"
                },
                "description": "How selection should be displayed.",
                "name": "selectionStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"checkbox\""
                        },
                        {
                            "value": "\"highlight\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the cards.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        },
                        {
                            "value": "\"XS\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The visual style of the cards.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"tertiary\""
                        },
                        {
                            "value": "\"quiet\""
                        }
                    ]
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on an item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "onLoadMore": {
                "defaultValue": null,
                "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
                "name": "onLoadMore",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Selection) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/CardView.tsx#_CardView"] = {
        docgenInfo: _CardView.__docgenInfo,
        name: "_CardView",
        path: "packages/@react-spectrum/s2/src/CardView.tsx#_CardView"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"bRkKQ","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./Card":"l7EYo","react":"jEiK2","./ImageCoordinator":"2Xi55","@react-stately/virtualizer":"emKZ4","@react-spectrum/utils":"bebxO","@react-aria/utils":"e9Yvo","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"bRkKQ":[function() {},{}],"lihSA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxGroupContext", ()=>CheckboxGroupContext);
parcelHelpers.export(exports, "CheckboxGroup", ()=>_CheckboxGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkbox = require("./Checkbox");
var _react = require("react");
var _field = require("./Field");
var _form = require("./Form");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const CheckboxGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
function CheckboxGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CheckboxGroupContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { label, description, errorMessage, children, labelPosition = 'top', labelAlign = 'start', necessityIndicator = 'icon', size = 'M', orientation = 'vertical', UNSAFE_className = '', UNSAFE_style, isEmphasized, ...groupProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CheckboxGroup), {
        ...groupProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " .";
            let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
            rules += matches.join('');
            let $__a = false;
            let $__b = false;
            for (let p of matches){
                if (/^\s*__a/.test(p)) $__a = true;
                if (/^\s*__b/.test(p)) $__b = true;
            }
            rules += ' _Zf';
            if (!$__a) {
                if (props.isInForm) rules += ' __a-3t1y';
            }
            if (!$__b) {
                if (props.isInForm) {
                    if (props.labelPosition === "side") rules += ' __b-7u9dhl';
                }
            }
            if (props.isInForm) rules += ' __h-1cwd7ud';
            else {
                if (props.labelPosition === "side") rules += ' __h-jyg4vb';
                else if (props.labelPosition === "top") rules += ' __h-375yi6';
            }
            if (props.labelPosition === "side") rules += ' __i-jyg4vb';
            else if (props.labelPosition === "top") rules += ' __i-fdenls';
            if (props.labelPosition === "side") rules += ' __j-5eez8j';
            else if (props.labelPosition === "top") rules += ' __j-xlaqir';
            if (props.size === "XL") {
                rules += ' _dbj';
                rules += ' _di';
            } else if (props.size === "L") {
                rules += ' _dbh';
                rules += ' _dg';
            } else if (props.size === "S") {
                rules += ' _dbd';
                rules += ' _dc';
            } else if (props.size === "XS") {
                rules += ' _dbb';
                rules += ' _da';
            } else {
                rules += ' _dbf';
                rules += ' _de';
            }
            rules += ' _1d';
            rules += ' _f-1x99dlob';
            rules += ' _fa';
            if (props.size === "XL") rules += ' -aqrvqh_k-j';
            else if (props.size === "L") rules += ' -aqrvqh_k-i';
            else if (props.size === "S") rules += ' -aqrvqh_k-h';
            else if (props.size === "XS") rules += ' -aqrvqh_k-g';
            else rules += ' -aqrvqh_k-f';
            rules += ' -_1inj1bc_i--vfy389';
            rules += ' je';
            rules += ' __R-yksgrp';
            return rules;
        }({
            size: props.size,
            labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: ({ isDisabled, isInvalid })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: function anonymous(props) {
                            let rules = " .";
                            rules += ' __a-4cfph1';
                            rules += ' __b-4cfph1';
                            rules += ' __c-4cfph1';
                            rules += ' __d-4cfph1';
                            rules += ' _Zd';
                            if (props.orientation === "horizontal") rules += ' _6a';
                            else if (props.orientation === "vertical") rules += ' _6b';
                            rules += ' _f-1x99dlob';
                            rules += ' _fa';
                            rules += ' i-1inj1bc';
                            rules += ' jf';
                            rules += ' _7a';
                            return rules;
                        }({
                            orientation
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FormContext).Provider, {
                            value: {
                                ...formContext,
                                size
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.CheckboxContext).Provider, {
                                value: {
                                    isEmphasized
                                },
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        showErrorIcon: true,
                        children: errorMessage
                    })
                ]
            })
    });
}
/**
 * A CheckboxGroup allows users to select one or more items from a list of choices.
 */ let _CheckboxGroup = /*#__PURE__*/ (0, _react.forwardRef)(CheckboxGroup);
try {
    // @ts-ignore
    CheckboxGroupContext.displayName = "CheckboxGroupContext";
    // @ts-ignore
    CheckboxGroupContext.__docgenInfo = {
        "description": "",
        "displayName": "CheckboxGroupContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<CheckboxGroupProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/CheckboxGroup.tsx#CheckboxGroupContext"] = {
        docgenInfo: CheckboxGroupContext.__docgenInfo,
        name: "CheckboxGroupContext",
        path: "packages/@react-spectrum/s2/src/CheckboxGroup.tsx#CheckboxGroupContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _CheckboxGroup.displayName = "_CheckboxGroup";
    // @ts-ignore
    _CheckboxGroup.__docgenInfo = {
        "description": "A CheckboxGroup allows users to select one or more items from a list of choices.",
        "displayName": "_CheckboxGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The Checkboxes contained within the CheckboxGroup.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string[]"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "By default, checkboxes are not emphasized (gray).\nThe emphasized (blue) version provides visual prominence.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'vertical'"
                },
                "description": "The axis the checkboxes should align with.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Checkboxes in the CheckboxGroup.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: string[]) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string[]"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: string[]) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/CheckboxGroup.tsx#_CheckboxGroup"] = {
        docgenInfo: _CheckboxGroup.__docgenInfo,
        name: "_CheckboxGroup",
        path: "packages/@react-spectrum/s2/src/CheckboxGroup.tsx#_CheckboxGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"eSWN6","1":"hkLAN","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./Checkbox":"7w7or","react":"jEiK2","./Field":"9c1qW","./Form":"gJckc","@react-spectrum/utils":"bebxO","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"eSWN6":[function() {},{}],"hkLAN":[function() {},{}],"aQBoD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorFieldContext", ()=>ColorFieldContext);
parcelHelpers.export(exports, "ColorField", ()=>_ColorField);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _field = require("./Field");
var _form = require("./Form");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ColorFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ColorField(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ColorFieldContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { label, description, errorMessage, necessityIndicator, labelPosition = 'top', labelAlign = 'start', UNSAFE_style, UNSAFE_className = '', styles, ...fieldProps } = props;
    // Expose imperative interface for ref
    let domRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorField), {
        ...fieldProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " .";
            let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
            rules += matches.join('');
            let $__a = false;
            let $__b = false;
            for (let p of matches){
                if (/^\s*__a/.test(p)) $__a = true;
                if (/^\s*__b/.test(p)) $__b = true;
            }
            rules += ' _Zf';
            if (!$__a) {
                if (props.isInForm) rules += ' __a-3t1y';
            }
            if (!$__b) {
                if (props.isInForm) {
                    if (props.labelPosition === "side") rules += ' __b-7u9dhl';
                }
            }
            if (props.isInForm) rules += ' __h-1cwd7ud';
            else {
                if (props.labelPosition === "side") rules += ' __h-jyg4vb';
                else if (props.labelPosition === "top") rules += ' __h-375yi6';
            }
            if (props.labelPosition === "side") rules += ' __i-jyg4vb';
            else if (props.labelPosition === "top") rules += ' __i-fdenls';
            if (props.labelPosition === "side") rules += ' __j-5eez8j';
            else if (props.labelPosition === "top") rules += ' __j-xlaqir';
            if (props.size === "XL") {
                rules += ' _dbj';
                rules += ' _di';
            } else if (props.size === "L") {
                rules += ' _dbh';
                rules += ' _dg';
            } else if (props.size === "S") {
                rules += ' _dbd';
                rules += ' _dc';
            } else if (props.size === "XS") {
                rules += ' _dbb';
                rules += ' _da';
            } else {
                rules += ' _dbf';
                rules += ' _de';
            }
            rules += ' _1d';
            rules += ' _f-1x99dlob';
            rules += ' _fa';
            if (props.size === "XL") rules += ' -aqrvqh_k-j';
            else if (props.size === "L") rules += ' -aqrvqh_k-i';
            else if (props.size === "S") rules += ' -aqrvqh_k-h';
            else if (props.size === "XS") rules += ' -aqrvqh_k-g';
            else rules += ' -aqrvqh_k-f';
            rules += ' -_1inj1bc_i--prjw07';
            rules += ' je';
            rules += ' __R-yksgrp';
            return rules;
        }({
            size: props.size,
            labelPosition,
            isInForm: !!formContext
        }, styles),
        children: ({ isDisabled, isInvalid })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: props.size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        role: "presentation",
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: props.size,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {
                                ref: inputRef
                            }),
                            isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: props.size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        children: errorMessage
                    })
                ]
            })
    });
}
/**
 * A color field allows users to edit a hex color or individual color channel value.
 */ const _ColorField = /*#__PURE__*/ (0, _react.forwardRef)(ColorField);
try {
    // @ts-ignore
    ColorFieldContext.displayName = "ColorFieldContext";
    // @ts-ignore
    ColorFieldContext.__docgenInfo = {
        "description": "",
        "displayName": "ColorFieldContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ColorFieldProps, TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ColorField.tsx#ColorFieldContext"] = {
        docgenInfo: ColorFieldContext.__docgenInfo,
        name: "ColorFieldContext",
        path: "packages/@react-spectrum/s2/src/ColorField.tsx#ColorFieldContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ColorField.displayName = "_ColorField";
    // @ts-ignore
    _ColorField.__docgenInfo = {
        "description": "A color field allows users to edit a hex color or individual color channel value.",
        "displayName": "_ColorField",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "channel": {
                "defaultValue": null,
                "description": "The color channel that this field edits. If not provided, \nthe color is edited as a hex value.",
                "name": "channel",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"hue\""
                        },
                        {
                            "value": "\"saturation\""
                        },
                        {
                            "value": "\"brightness\""
                        },
                        {
                            "value": "\"lightness\""
                        },
                        {
                            "value": "\"red\""
                        },
                        {
                            "value": "\"green\""
                        },
                        {
                            "value": "\"blue\""
                        },
                        {
                            "value": "\"alpha\""
                        }
                    ]
                }
            },
            "colorSpace": {
                "defaultValue": null,
                "description": "The color space that the color field operates in if a `channel` prop is provided.\nIf no `channel` is provided, the color field always displays the color as an RGB hex value.",
                "name": "colorSpace",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"rgb\""
                        },
                        {
                            "value": "\"hsl\""
                        },
                        {
                            "value": "\"hsb\""
                        }
                    ]
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string | Color | null"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isWheelDisabled": {
                "defaultValue": null,
                "description": "Enables or disables changing the value with scroll.",
                "name": "isWheelDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the color field.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: Color | null) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string | Color | null"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((color: Color | null) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ColorField.tsx#_ColorField"] = {
        docgenInfo: _ColorField.__docgenInfo,
        name: "_ColorField",
        path: "packages/@react-spectrum/s2/src/ColorField.tsx#_ColorField"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"7BkWX","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","react":"jEiK2","@react-spectrum/utils":"bebxO","./Field":"9c1qW","./Form":"gJckc","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"7BkWX":[function() {},{}],"9w8CV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboBoxContext", ()=>ComboBoxContext);
parcelHelpers.export(exports, "ComboBox", ()=>_ComboBox);
parcelHelpers.export(exports, "ComboBoxItem", ()=>ComboBoxItem);
parcelHelpers.export(exports, "ComboBoxSection", ()=>ComboBoxSection);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _menu = require("./Menu");
var _checkmark = require("../ui-icons/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _field = require("./Field");
var _form = require("./Form");
var _content = require("./Content");
var _icon = require("./Icon");
var _picker = require("./Picker");
var _utils1 = require("@react-aria/utils");
var _popover = require("./Popover");
var _pressScale = require("./pressScale");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ComboBoxContext = /*#__PURE__*/ (0, _react.createContext)(null);
const inputButton = function anonymous(props) {
    let rules = " .";
    rules += ' _Zd';
    rules += ' _La';
    rules += ' _jb';
    rules += ' wf';
    rules += ' _vi';
    rules += ' _wi';
    rules += ' _xi';
    rules += ' _yi';
    rules += ' _1c';
    rules += ' _2d';
    if (props.size === "XL") rules += ' lU';
    else if (props.size === "L") rules += ' lM';
    else if (props.size === "M") rules += ' lI';
    else if (props.size === "S") rules += ' lE';
    if (props.size === "XL") rules += ' kU';
    else if (props.size === "L") rules += ' kM';
    else if (props.size === "M") rules += ' kI';
    else if (props.size === "S") rules += ' kE';
    rules += ' yF';
    rules += ' _bb';
    rules += ' _8-3t1x';
    rules += ' _Oag';
    rules += ' _Oa';
    rules += ' _Qa-375x7f';
    rules += ' _Q-375x7f';
    rules += ' _Raa';
    rules += ' _Ra';
    if (props.isDisabled) rules += ' ba_____B';
    else if (props.isOpen) rules += ' ba_____z';
    else if (props.isHovered) rules += ' ba_____z';
    else rules += ' ba_____x';
    if (props.isDisabled) rules += ' bg';
    else if (props.isOpen) rules += ' bh';
    else {
        if (props.isPressed) rules += ' bh';
        else if (props.isFocusVisible) rules += ' bh';
        else if (props.isHovered) rules += ' bh';
        else rules += ' bg';
    }
    rules += ' aa_____w';
    if (props.isDisabled) rules += ' aj';
    else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    return rules;
};
const iconStyles = " . _8-3t1x R-3hn0u -rwx0fg_e-b";
let InternalComboboxContext = /*#__PURE__*/ (0, _react.createContext)({
    size: 'M'
});
function ComboBox(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, ComboBoxContext);
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _react.useRef)(null);
    let buttonRef = (0, _react.useRef)(null);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props1 = (0, _form.useFormProps)(props1);
    let { direction = 'bottom', align = 'start', shouldFlip = true, menuWidth, label, description: descriptionMessage, errorMessage, children, items, size = 'M', labelPosition = 'top', labelAlign = 'start', necessityIndicator, UNSAFE_className = '', UNSAFE_style, ...pickerProps } = props1;
    // Expose imperative interface for ref
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    // Better way to encode this into a style? need to account for flipping
    let menuOffset;
    if (size === 'S') menuOffset = 6;
    else if (size === 'M') menuOffset = 6;
    else if (size === 'L') menuOffset = 7;
    else menuOffset = 8;
    let triggerRef = (0, _react.useRef)(null);
    // Make menu width match input + button
    let [triggerWidth, setTriggerWidth] = (0, _react.useState)(null);
    let onResize = (0, _react.useCallback)(()=>{
        if (triggerRef.current) {
            let inputRect = triggerRef.current.getBoundingClientRect();
            let minX = inputRect.left;
            let maxX = inputRect.right;
            setTriggerWidth(maxX - minX + 'px');
        }
    }, [
        triggerRef,
        setTriggerWidth
    ]);
    (0, _utils1.useResizeObserver)({
        ref: triggerRef,
        onResize: onResize
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ComboBox), {
        ...pickerProps,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " .";
            let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
            rules += matches.join('');
            let $__a = false;
            let $__b = false;
            for (let p of matches){
                if (/^\s*__a/.test(p)) $__a = true;
                if (/^\s*__b/.test(p)) $__b = true;
            }
            rules += ' _Zf';
            if (!$__a) {
                if (props.isInForm) rules += ' __a-3t1y';
            }
            if (!$__b) {
                if (props.isInForm) {
                    if (props.labelPosition === "side") rules += ' __b-7u9dhl';
                }
            }
            if (props.isInForm) rules += ' __h-1cwd7ud';
            else {
                if (props.labelPosition === "side") rules += ' __h-jyg4vb';
                else if (props.labelPosition === "top") rules += ' __h-375yi6';
            }
            if (props.labelPosition === "side") rules += ' __i-jyg4vb';
            else if (props.labelPosition === "top") rules += ' __i-fdenls';
            if (props.labelPosition === "side") rules += ' __j-5eez8j';
            else if (props.labelPosition === "top") rules += ' __j-xlaqir';
            if (props.size === "XL") {
                rules += ' _dbj';
                rules += ' _di';
            } else if (props.size === "L") {
                rules += ' _dbh';
                rules += ' _dg';
            } else if (props.size === "S") {
                rules += ' _dbd';
                rules += ' _dc';
            } else if (props.size === "XS") {
                rules += ' _dbb';
                rules += ' _da';
            } else {
                rules += ' _dbf';
                rules += ' _de';
            }
            rules += ' _1d';
            rules += ' _f-1x99dlob';
            rules += ' _fa';
            if (props.size === "XL") rules += ' -aqrvqh_k-j';
            else if (props.size === "L") rules += ' -aqrvqh_k-i';
            else if (props.size === "S") rules += ' -aqrvqh_k-h';
            else if (props.size === "XS") rules += ' -aqrvqh_k-g';
            else rules += ' -aqrvqh_k-f';
            rules += ' -_1inj1bc_i--prjw07';
            rules += ' je';
            rules += ' __R-yksgrp';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, props1.styles),
        children: ({ isDisabled, isOpen, isRequired, isInvalid })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InternalComboboxContext.Provider, {
                    value: {
                        size
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                            isDisabled: isDisabled,
                            isRequired: isRequired,
                            size: size,
                            labelPosition: labelPosition,
                            labelAlign: labelAlign,
                            necessityIndicator: necessityIndicator,
                            contextualHelp: props1.contextualHelp,
                            children: label
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                            ref: triggerRef,
                            role: "presentation",
                            isDisabled: isDisabled,
                            isInvalid: isInvalid,
                            size: size,
                            styles: function anonymous(props) {
                                let rules = " .";
                                rules += ' __a-4cfph1';
                                rules += ' __b-4cfph1';
                                rules += ' __c-4cfph1';
                                rules += ' __d-4cfph1';
                                if (props.size === "XL") rules += ' qj';
                                else if (props.size === "L") rules += ' qi';
                                else if (props.size === "S") rules += ' qh';
                                else if (props.size === "XS") rules += ' qg';
                                else rules += ' qf';
                                if (props.isQuiet) rules += ' __ma';
                                else rules += ' __m-1s8glxue';
                                if (props.size === "XL") rules += ' -usygro_l-____g';
                                else if (props.size === "L") rules += ' -usygro_l-___0';
                                else if (props.size === "S") rules += ' -usygro_l-___u';
                                else rules += ' -usygro_l-___K';
                                rules += ' m-rwozxi';
                                rules += ' C-375tnm';
                                rules += ' D-375tnn';
                                rules += ' -_375tnm_C-I';
                                rules += ' -_375tnn_D--45az6c';
                                return rules;
                            }({
                                size
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.InputContext).Consumer, {
                                    children: (ctx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.InputContext).Provider, {
                                            value: {
                                                ...ctx,
                                                ref: (0, _utils1.mergeRefs)(ctx?.ref, inputRef)
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {})
                                        })
                                }),
                                isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
                                    isDisabled: isDisabled
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                                    ref: buttonRef,
                                    // Prevent press scale from sticking while ComboBox is open.
                                    // @ts-ignore
                                    isPressed: false,
                                    style: (renderProps)=>(0, _pressScale.pressScale)(buttonRef)(renderProps),
                                    className: (renderProps)=>inputButton({
                                            ...renderProps,
                                            size,
                                            isOpen
                                        }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                                        size: size,
                                        className: iconStyles
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                            size: size,
                            isDisabled: isDisabled,
                            isInvalid: isInvalid,
                            description: descriptionMessage,
                            children: errorMessage
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverBase), {
                            hideArrow: true,
                            triggerRef: triggerRef,
                            offset: menuOffset,
                            placement: `${direction} ${align}`,
                            shouldFlip: shouldFlip,
                            UNSAFE_style: {
                                width: menuWidth ? `${menuWidth}px` : undefined,
                                // manually subtract border as we can't set Popover to border-box, it causes the contents to spill out
                                '--trigger-width': `calc(${triggerWidth} - 2px)`
                            },
                            styles: " . q-1utmx2y l-1utmx2y",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                values: [
                                    [
                                        (0, _content.HeaderContext),
                                        {
                                            styles: (0, _menu.sectionHeader)({
                                                size
                                            })
                                        }
                                    ],
                                    [
                                        (0, _content.HeadingContext),
                                        {
                                            styles: (0, _menu.sectionHeading)
                                        }
                                    ],
                                    [
                                        (0, _content.TextContext),
                                        {
                                            slots: {
                                                'description': {
                                                    styles: (0, _menu.description)({
                                                        size
                                                    })
                                                }
                                            }
                                        }
                                    ]
                                ],
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
                                    items: items,
                                    className: (0, _picker.menu)({
                                        size
                                    }),
                                    children: children
                                })
                            })
                        })
                    ]
                })
            })
    });
}
/**
 * ComboBox allow users to choose a single option from a collapsible list of options when space is limited.
 */ let _ComboBox = /*#__PURE__*/ (0, _react.forwardRef)(ComboBox);
const checkmarkIconSize = {
    S: 'XS',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
function ComboBoxItem(props) {
    let ref = (0, _react.useRef)(null);
    let isLink = props.href != null;
    let { size } = (0, _react.useContext)(InternalComboboxContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        ref: ref,
        textValue: props.textValue || (typeof props.children === 'string' ? props.children : undefined),
        style: (0, _pressScale.pressScale)(ref, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + (0, _menu.menuitem)({
                ...renderProps,
                size,
                isLink
            }, props.styles),
        children: (renderProps)=>{
            let { children } = props;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Provider), {
                    values: [
                        [
                            (0, _icon.IconContext),
                            {
                                slots: {
                                    icon: {
                                        render: (0, _centerBaseline.centerBaseline)({
                                            slot: 'icon',
                                            styles: (0, _menu.iconCenterWrapper)
                                        }),
                                        styles: (0, _menu.icon)
                                    }
                                }
                            }
                        ],
                        [
                            (0, _content.TextContext),
                            {
                                slots: {
                                    label: {
                                        styles: (0, _menu.label)({
                                            size
                                        })
                                    },
                                    description: {
                                        styles: (0, _menu.description)({
                                            ...renderProps,
                                            size
                                        })
                                    }
                                }
                            }
                        ]
                    ],
                    children: [
                        !isLink && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                            size: checkmarkIconSize[size],
                            className: (0, _menu.checkmark)({
                                ...renderProps,
                                size
                            })
                        }),
                        typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                            slot: "label",
                            children: children
                        }) : children
                    ]
                })
            });
        }
    });
}
function ComboBoxSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxSection), {
                ...props,
                className: (0, _menu.section),
                children: props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Divider), {})
        ]
    });
}
try {
    // @ts-ignore
    ComboBoxItem.displayName = "ComboBoxItem";
    // @ts-ignore
    ComboBoxItem.__docgenInfo = {
        "description": "",
        "displayName": "ComboBoxItem",
        "props": {
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ComboBox.tsx#ComboBoxItem"] = {
        docgenInfo: ComboBoxItem.__docgenInfo,
        name: "ComboBoxItem",
        path: "packages/@react-spectrum/s2/src/ComboBox.tsx#ComboBoxItem"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    ComboBoxSection.displayName = "ComboBoxSection";
    // @ts-ignore
    ComboBoxSection.__docgenInfo = {
        "description": "",
        "displayName": "ComboBoxSection",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Static child items or a function to render children.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactElement<unknown, string | JSXElementConstructor<any>>)"
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the section.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ComboBox.tsx#ComboBoxSection"] = {
        docgenInfo: ComboBoxSection.__docgenInfo,
        name: "ComboBoxSection",
        path: "packages/@react-spectrum/s2/src/ComboBox.tsx#ComboBoxSection"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    ComboBoxContext.displayName = "ComboBoxContext";
    // @ts-ignore
    ComboBoxContext.__docgenInfo = {
        "description": "",
        "displayName": "ComboBoxContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<Partial<ComboBoxProps<any>>, TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ComboBox.tsx#ComboBoxContext"] = {
        docgenInfo: ComboBoxContext.__docgenInfo,
        name: "ComboBoxContext",
        path: "packages/@react-spectrum/s2/src/ComboBox.tsx#ComboBoxContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ComboBox.displayName = "_ComboBox";
    // @ts-ignore
    _ComboBox.__docgenInfo = {
        "description": "ComboBox allow users to choose a single option from a collapsible list of options when space is limited.",
        "displayName": "_ComboBox",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "Alignment of the menu relative to the input target.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "allowsCustomValue": {
                "defaultValue": null,
                "description": "Whether the ComboBox allows a non-item matching input value to be set.",
                "name": "allowsCustomValue",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultInputValue": {
                "defaultValue": null,
                "description": "The default value of the ComboBox input (uncontrolled).",
                "name": "defaultInputValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "defaultItems": {
                "defaultValue": null,
                "description": "The list of ComboBox items (uncontrolled).",
                "name": "defaultItems",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "defaultSelectedKey": {
                "defaultValue": null,
                "description": "The initial selected key in the collection (uncontrolled).",
                "name": "defaultSelectedKey",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "direction": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "Direction the menu will render relative to the Picker.",
                "name": "direction",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "formValue": {
                "defaultValue": {
                    value: "'key'"
                },
                "description": "Whether the text or key of the selected item is submitted as part of an HTML form.\nWhen `allowsCustomValue` is `true`, this option does not apply and the text is always submitted.",
                "name": "formValue",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"key\""
                        },
                        {
                            "value": "\"text\""
                        }
                    ]
                }
            },
            "inputValue": {
                "defaultValue": null,
                "description": "The value of the ComboBox input (controlled).",
                "name": "inputValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "The list of ComboBox items (controlled).",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "menuTrigger": {
                "defaultValue": {
                    value: "'input'"
                },
                "description": "The interaction required to display the ComboBox menu.",
                "name": "menuTrigger",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"focus\""
                        },
                        {
                            "value": "\"input\""
                        },
                        {
                            "value": "\"manual\""
                        }
                    ]
                }
            },
            "menuWidth": {
                "defaultValue": null,
                "description": "Width of the menu. By default, matches width of the trigger. Note that the minimum width of the dropdown is always equal to the trigger's width.",
                "name": "menuWidth",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "selectedKey": {
                "defaultValue": null,
                "description": "The currently selected key in the collection (controlled).",
                "name": "selectedKey",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "shouldFocusWrap": {
                "defaultValue": null,
                "description": "Whether keyboard navigation is circular.",
                "name": "shouldFocusWrap",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Combobox.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: ComboBoxValidationValue) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "onInputChange": {
                "defaultValue": null,
                "description": "Handler that is called when the ComboBox input value changes.",
                "name": "onInputChange",
                "required": false,
                "type": {
                    "name": "((value: string) => void)"
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Method that is called when the open state of the menu changes. Returns the new open state and the action that caused the opening of the menu.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean, menuTrigger?: MenuTriggerAction) => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((key: Key | null) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ComboBox.tsx#_ComboBox"] = {
        docgenInfo: _ComboBox.__docgenInfo,
        name: "_ComboBox",
        path: "packages/@react-spectrum/s2/src/ComboBox.tsx#_ComboBox"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"jlSki","1":"doRMr","2":"fqezl","3":"ailqT","4":"6BPvt","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./CenterBaseline":"hXatv","./Menu":"hGkxl","../ui-icons/Checkmark":"255By","../ui-icons/Chevron":"dnGTM","react":"jEiK2","@react-spectrum/utils":"bebxO","./Field":"9c1qW","./Form":"gJckc","./Content":"aBWEm","./Icon":"1OC2a","./Picker":"2JyaH","@react-aria/utils":"e9Yvo","./Popover":"3Y0dA","./pressScale":"6BiUY","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"jlSki":[function() {},{}],"doRMr":[function() {},{}],"fqezl":[function() {},{}],"ailqT":[function() {},{}],"6BPvt":[function() {},{}],"2JyaH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerContext", ()=>PickerContext);
parcelHelpers.export(exports, "menu", ()=>menu);
parcelHelpers.export(exports, "Picker", ()=>_Picker);
parcelHelpers.export(exports, "PickerItem", ()=>PickerItem);
parcelHelpers.export(exports, "PickerSection", ()=>PickerSection);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _menu = require("./Menu");
var _checkmark = require("../ui-icons/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _field = require("./Field");
var _form = require("./Form");
var _content = require("./Content");
var _icon = require("./Icon");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _popover = require("./Popover");
var _pressScale = require("./pressScale");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-spectrum/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const PickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const inputButton = function anonymous(props) {
    let rules = " .";
    if (props.isQuiet) rules += ' _La';
    else if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    rules += ' __a-4cfph1';
    rules += ' __b-4cfph1';
    rules += ' __c-4cfph1';
    rules += ' __d-4cfph1';
    if (props.size === "XL") rules += ' qj';
    else if (props.size === "L") rules += ' qi';
    else if (props.size === "S") rules += ' qh';
    else if (props.size === "XS") rules += ' qg';
    else rules += ' qf';
    if (props.isQuiet) rules += ' __ma';
    else rules += ' __m-1s8glxue';
    if (props.size === "XL") rules += ' -usygro_l-____g';
    else if (props.size === "L") rules += ' -usygro_l-___0';
    else if (props.size === "S") rules += ' -usygro_l-___u';
    else rules += ' -usygro_l-___K';
    rules += ' m-rwozxi';
    rules += ' Uc';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) rules += ' aj';
    else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' _Zd';
    rules += ' _ja';
    rules += ' waa';
    rules += ' wf';
    if (props.isDisabled) rules += ' ca_____B';
    else rules += ' ca_____x';
    rules += ' _vh';
    rules += ' _wh';
    rules += ' _xh';
    rules += ' _yh';
    rules += ' _1c';
    rules += ' k-375toq';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    if (props.isQuiet) {
        rules += ' jbH';
        rules += ' jG';
    } else rules += ' jF';
    rules += ' C-375tnm';
    rules += ' D-375tnn';
    if (props.isQuiet) rules += ' ba';
    else if (props.isDisabled) rules += ' bg';
    else if (props.isOpen) rules += ' bh';
    else {
        if (props.isPressed) rules += ' bh';
        else if (props.isFocusVisible) rules += ' bh';
        else if (props.isHovered) rules += ' bh';
        else rules += ' bg';
    }
    if (props.isQuiet) rules += ' rd';
    rules += ' __R-yksgrp';
    if (props.isQuiet) rules += ' -_375tnm_C-a';
    else rules += ' -_375tnm_C-I';
    if (props.isQuiet) rules += ' -_375tnn_D-a';
    else rules += ' -_375tnn_D-I';
    if (props.size === "XL") rules += ' -_375toq_k-j';
    else if (props.size === "L") rules += ' -_375toq_k-i';
    else if (props.size === "S") rules += ' -_375toq_k-h';
    else if (props.size === "XS") rules += ' -_375toq_k-g';
    else rules += ' -_375toq_k-f';
    return rules;
};
const quietFocusLine = " . lb k-375zlr Ua Za _vf _wf _xf _yf bx ba_____z";
let menu = function anonymous(props) {
    let rules = " .";
    rules += ' _La';
    rules += ' _Zf';
    if (props.size === "XL") rules += ' __h-358ibk';
    else if (props.size === "L") rules += ' __h-1w0s9l0';
    else if (props.size === "M") rules += ' __h-1kgdida';
    else if (props.size === "S") rules += ' __h-17i5a9u';
    rules += ' __na';
    rules += ' p-17zqamw';
    rules += ' __va';
    rules += ' __wa';
    rules += ' Ed';
    rules += ' Fd';
    rules += ' Cd';
    rules += ' Dd';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    return rules;
};
const invalidBorder = function anonymous(props) {
    let rules = " .";
    rules += ' Ua';
    rules += ' Xa';
    rules += ' Ya';
    rules += ' Za';
    rules += ' _aa';
    rules += ' __Ba';
    rules += ' _vh';
    rules += ' _wh';
    rules += ' _xh';
    rules += ' _yh';
    rules += ' wa';
    rules += ' uc';
    rules += ' vc';
    rules += ' sc';
    rules += ' tc';
    if (props.isPressed) rules += ' cQ';
    else if (props.isFocusVisible) rules += ' cP';
    else if (props.isHovered) rules += ' cP';
    else rules += ' cO';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    return rules;
};
const valueStyles = function anonymous(props) {
    let rules = " .";
    if (props.isQuiet) rules += ' _9-3t1x';
    else rules += ' _9-3t1y';
    rules += ' __vb';
    rules += ' __wb';
    rules += ' _ma';
    rules += ' _pb';
    rules += ' _Zd';
    rules += ' _1c';
    return rules;
};
const iconStyles = " . _8-3t1x R-3hn0u -rwx0fg_e-b";
let InternalPickerContext = /*#__PURE__*/ (0, _react.createContext)({
    size: 'M'
});
let InsideSelectValueContext = /*#__PURE__*/ (0, _react.createContext)(false);
function Picker(props1, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, PickerContext);
    let domRef = (0, _utils.useFocusableRef)(ref);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props1 = (0, _form.useFormProps)(props1);
    let { direction = 'bottom', align = 'start', shouldFlip = true, menuWidth, label, description: descriptionMessage, errorMessage, children, items, size = 'M', labelPosition = 'top', labelAlign = 'start', necessityIndicator, UNSAFE_className = '', UNSAFE_style, placeholder = stringFormatter.format('picker.placeholder'), isQuiet, ...pickerProps } = props1;
    // Better way to encode this into a style? need to account for flipping
    let menuOffset;
    if (size === 'S') menuOffset = 6;
    else if (size === 'M') menuOffset = 6;
    else if (size === 'L') menuOffset = 7;
    else menuOffset = 8;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Select), {
        ...pickerProps,
        placeholder: placeholder,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " .";
            let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
            rules += matches.join('');
            let $__a = false;
            let $__b = false;
            for (let p of matches){
                if (/^\s*__a/.test(p)) $__a = true;
                if (/^\s*__b/.test(p)) $__b = true;
            }
            rules += ' _Zf';
            if (!$__a) {
                if (props.isInForm) rules += ' __a-3t1y';
            }
            if (!$__b) {
                if (props.isInForm) {
                    if (props.labelPosition === "side") rules += ' __b-7u9dhl';
                }
            }
            if (props.isInForm) rules += ' __h-1cwd7ud';
            else {
                if (props.labelPosition === "side") rules += ' __h-jyg4vb';
                else if (props.labelPosition === "top") rules += ' __h-375yi6';
            }
            if (props.labelPosition === "side") rules += ' __i-jyg4vb';
            else if (props.labelPosition === "top") rules += ' __i-fdenls';
            if (props.labelPosition === "side") rules += ' __j-5eez8j';
            else if (props.labelPosition === "top") rules += ' __j-xlaqir';
            if (props.size === "XL") {
                rules += ' _dbj';
                rules += ' _di';
            } else if (props.size === "L") {
                rules += ' _dbh';
                rules += ' _dg';
            } else if (props.size === "S") {
                rules += ' _dbd';
                rules += ' _dc';
            } else if (props.size === "XS") {
                rules += ' _dbb';
                rules += ' _da';
            } else {
                rules += ' _dbf';
                rules += ' _de';
            }
            rules += ' _1d';
            rules += ' _f-1x99dlob';
            rules += ' _fa';
            if (props.size === "XL") rules += ' -aqrvqh_k-j';
            else if (props.size === "L") rules += ' -aqrvqh_k-i';
            else if (props.size === "S") rules += ' -aqrvqh_k-h';
            else if (props.size === "XS") rules += ' -aqrvqh_k-g';
            else rules += ' -aqrvqh_k-f';
            rules += ' -_1inj1bc_i--prjw07';
            rules += ' je';
            rules += ' __R-yksgrp';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, props1.styles),
        children: ({ isDisabled, isOpen, isFocusVisible, isInvalid, isRequired })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InternalPickerContext.Provider, {
                    value: {
                        size
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                            isDisabled: isDisabled,
                            isRequired: isRequired,
                            size: size,
                            labelPosition: labelPosition,
                            labelAlign: labelAlign,
                            isQuiet: isQuiet,
                            necessityIndicator: necessityIndicator,
                            contextualHelp: props1.contextualHelp,
                            children: label
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                            ref: domRef,
                            style: (renderProps)=>(0, _pressScale.pressScale)(domRef)(renderProps),
                            // Prevent press scale from sticking while Picker is open.
                            // @ts-ignore
                            isPressed: false,
                            className: (renderProps)=>inputButton({
                                    ...renderProps,
                                    size: size,
                                    isOpen,
                                    isQuiet
                                }),
                            children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SelectValue), {
                                            className: valueStyles({
                                                isQuiet
                                            }) + ' ' + "-u6zm92",
                                            children: ({ defaultChildren })=>{
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                                    values: [
                                                        [
                                                            (0, _icon.IconContext),
                                                            {
                                                                slots: {
                                                                    icon: {
                                                                        render: (0, _centerBaseline.centerBaseline)({
                                                                            slot: 'icon',
                                                                            styles: (0, _menu.iconCenterWrapper)
                                                                        }),
                                                                        styles: (0, _menu.icon)
                                                                    }
                                                                }
                                                            }
                                                        ],
                                                        [
                                                            (0, _content.TextContext),
                                                            {
                                                                slots: {
                                                                    description: {},
                                                                    label: {
                                                                        styles: " . _Za _9-3t1y __vb __wb _ma _pb"
                                                                    }
                                                                }
                                                            }
                                                        ],
                                                        [
                                                            InsideSelectValueContext,
                                                            true
                                                        ]
                                                    ],
                                                    children: defaultChildren
                                                });
                                            }
                                        }),
                                        isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
                                            isDisabled: isDisabled
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                                            size: size,
                                            className: iconStyles
                                        }),
                                        isFocusVisible && isQuiet && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: quietFocusLine
                                        }),
                                        isInvalid && !isDisabled && !isQuiet && // @ts-ignore known limitation detecting functions from the theme
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: invalidBorder({
                                                ...renderProps,
                                                size
                                            })
                                        })
                                    ]
                                })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                            size: size,
                            isDisabled: isDisabled,
                            isInvalid: isInvalid,
                            description: descriptionMessage,
                            children: errorMessage
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverBase), {
                            hideArrow: true,
                            offset: menuOffset,
                            placement: `${direction} ${align}`,
                            shouldFlip: shouldFlip,
                            UNSAFE_style: {
                                width: menuWidth && !isQuiet ? `${menuWidth}px` : undefined
                            },
                            styles: function anonymous(props) {
                                let rules = " .";
                                rules += ' y-375tp4';
                                if (props.isQuiet) rules += ' q___u';
                                else rules += ' q-1utmx2y';
                                if (props.isQuiet) rules += ' l-13f72lm';
                                else rules += ' l-1utmx2y';
                                if (props.isQuiet) rules += ' -_375tp4_y-M';
                                return rules;
                            }(props1),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                values: [
                                    [
                                        (0, _content.HeaderContext),
                                        {
                                            styles: (0, _menu.sectionHeader)({
                                                size
                                            })
                                        }
                                    ],
                                    [
                                        (0, _content.HeadingContext),
                                        {
                                            styles: (0, _menu.sectionHeading)
                                        }
                                    ],
                                    [
                                        (0, _content.TextContext),
                                        {
                                            slots: {
                                                description: {
                                                    styles: (0, _menu.description)({
                                                        size
                                                    })
                                                }
                                            }
                                        }
                                    ]
                                ],
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
                                    items: items,
                                    className: menu({
                                        size
                                    }),
                                    children: children
                                })
                            })
                        })
                    ]
                })
            })
    });
}
/**
 * Pickers allow users to choose a single option from a collapsible list of options when space is limited.
 */ let _Picker = /*#__PURE__*/ (0, _react.forwardRef)(Picker);
const checkmarkIconSize = {
    S: 'XS',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
function PickerItem(props) {
    let ref = (0, _react.useRef)(null);
    let isLink = props.href != null;
    let { size } = (0, _react.useContext)(InternalPickerContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        ref: ref,
        textValue: props.textValue || (typeof props.children === 'string' ? props.children : undefined),
        style: (0, _pressScale.pressScale)(ref, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + (0, _menu.menuitem)({
                ...renderProps,
                size,
                isLink
            }, props.styles),
        children: (renderProps)=>{
            let { children } = props;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DefaultProvider, {
                context: (0, _icon.IconContext),
                value: {
                    slots: {
                        icon: {
                            render: (0, _centerBaseline.centerBaseline)({
                                slot: 'icon',
                                styles: (0, _menu.iconCenterWrapper)
                            }),
                            styles: (0, _menu.icon)
                        }
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DefaultProvider, {
                    context: (0, _content.TextContext),
                    value: {
                        slots: {
                            label: {
                                styles: (0, _menu.label)({
                                    size
                                })
                            },
                            description: {
                                styles: (0, _menu.description)({
                                    ...renderProps,
                                    size
                                })
                            }
                        }
                    },
                    children: [
                        !isLink && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                            size: checkmarkIconSize[size],
                            className: (0, _menu.checkmark)({
                                ...renderProps,
                                size
                            })
                        }),
                        typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                            slot: "label",
                            children: children
                        }) : children
                    ]
                })
            });
        }
    });
}
// A Context.Provider that only sets a value if not inside SelectValue.
function DefaultProvider({ context, value, children }) {
    let inSelectValue = (0, _react.useContext)(InsideSelectValueContext);
    if (inSelectValue) return children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(context.Provider, {
        value: value,
        children: children
    });
}
function PickerSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxSection), {
                ...props,
                className: (0, _menu.section),
                children: props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Divider), {})
        ]
    });
}
try {
    // @ts-ignore
    PickerItem.displayName = "PickerItem";
    // @ts-ignore
    PickerItem.__docgenInfo = {
        "description": "",
        "displayName": "PickerItem",
        "props": {
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the item's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Picker.tsx#PickerItem"] = {
        docgenInfo: PickerItem.__docgenInfo,
        name: "PickerItem",
        path: "packages/@react-spectrum/s2/src/Picker.tsx#PickerItem"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    PickerSection.displayName = "PickerSection";
    // @ts-ignore
    PickerSection.__docgenInfo = {
        "description": "",
        "displayName": "PickerSection",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Static child items or a function to render children.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactElement<unknown, string | JSXElementConstructor<any>>)"
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the section.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "object"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Picker.tsx#PickerSection"] = {
        docgenInfo: PickerSection.__docgenInfo,
        name: "PickerSection",
        path: "packages/@react-spectrum/s2/src/Picker.tsx#PickerSection"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    PickerContext.displayName = "PickerContext";
    // @ts-ignore
    PickerContext.__docgenInfo = {
        "description": "",
        "displayName": "PickerContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<Partial<PickerProps<any>>, FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Picker.tsx#PickerContext"] = {
        docgenInfo: PickerContext.__docgenInfo,
        name: "PickerContext",
        path: "packages/@react-spectrum/s2/src/Picker.tsx#PickerContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    menu.displayName = "menu";
    // @ts-ignore
    menu.__docgenInfo = {
        "description": "",
        "displayName": "menu",
        "props": {
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": true,
                "type": {
                    "name": "any"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Picker.tsx#menu"] = {
        docgenInfo: menu.__docgenInfo,
        name: "menu",
        path: "packages/@react-spectrum/s2/src/Picker.tsx#menu"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Picker.displayName = "_Picker";
    // @ts-ignore
    _Picker.__docgenInfo = {
        "description": "Pickers allow users to choose a single option from a collapsible list of options when space is limited.",
        "displayName": "_Picker",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "Alignment of the menu relative to the input target.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "autoComplete": {
                "defaultValue": null,
                "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
                "name": "autoComplete",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Sets the default open state of the menu.",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "defaultSelectedKey": {
                "defaultValue": null,
                "description": "The initial selected key in the collection (uncontrolled).",
                "name": "defaultSelectedKey",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "direction": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "Direction the menu will render relative to the Picker.",
                "name": "direction",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Sets the open state of the menu.",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the picker should be displayed with a quiet style.\n@private",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "menuWidth": {
                "defaultValue": null,
                "description": "Width of the menu. By default, matches width of the trigger. Note that the minimum width of the dropdown is always equal to the trigger's width.",
                "name": "menuWidth",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input, used when submitting an HTML form.",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "placeholder": {
                "defaultValue": null,
                "description": "Temporary text that occupies the text input when it is empty.",
                "name": "placeholder",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "selectedKey": {
                "defaultValue": null,
                "description": "The currently selected key in the collection (controlled).",
                "name": "selectedKey",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Picker.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: Key) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Method that is called when the open state of the menu changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean) => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Picker.tsx#_Picker"] = {
        docgenInfo: _Picker.__docgenInfo,
        name: "_Picker",
        path: "packages/@react-spectrum/s2/src/Picker.tsx#_Picker"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"cgzbX","1":"dKldM","2":"k7uHT","3":"3jUPL","4":"eLu9o","5":"bfF35","6":"6czW3","7":"iGg7z","8":"dWckN","9":"6j0hw","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./CenterBaseline":"hXatv","./Menu":"hGkxl","../ui-icons/Checkmark":"255By","../ui-icons/Chevron":"dnGTM","./Field":"9c1qW","./Form":"gJckc","./Content":"aBWEm","./Icon":"1OC2a","../intl/*.json":"iU6xz","./Popover":"3Y0dA","./pressScale":"6BiUY","react":"jEiK2","@react-spectrum/utils":"bebxO","@react-aria/i18n":"hFrKJ","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"cgzbX":[function() {},{}],"dKldM":[function() {},{}],"k7uHT":[function() {},{}],"3jUPL":[function() {},{}],"eLu9o":[function() {},{}],"bfF35":[function() {},{}],"6czW3":[function() {},{}],"iGg7z":[function() {},{}],"dWckN":[function() {},{}],"6j0hw":[function() {},{}],"cpdjl":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CustomDialog", ()=>_CustomDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _modal = require("./Modal");
var _utils = require("@react-spectrum/utils");
const dialogStyle = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r|k|o|p)[^\s]+/g) || [];
    rules += matches.join('');
    let $U = false;
    let $l = false;
    let $k = false;
    let $r = false;
    let $p = false;
    for (let p of matches){
        if (/^\s*U/.test(p)) $U = true;
        if (/^\s*l/.test(p)) $l = true;
        if (/^\s*k/.test(p)) $k = true;
        if (/^\s*r/.test(p)) $r = true;
        if (/^\s*p/.test(p)) $p = true;
    }
    if (props.padding === "none") rules += ' Ea';
    else if (props.padding === "default") {
        rules += ' Ecj';
        rules += ' Eh';
    }
    if (props.padding === "none") rules += ' Fa';
    else if (props.padding === "default") {
        rules += ' Fcj';
        rules += ' Fh';
    }
    if (props.padding === "none") rules += ' Ca';
    else if (props.padding === "default") {
        rules += ' Ccj';
        rules += ' Ch';
    }
    if (props.padding === "none") rules += ' Da';
    else if (props.padding === "default") {
        rules += ' Dcj';
        rules += ' Dh';
    }
    rules += ' __na';
    rules += ' _La';
    rules += ' _v-17zqamw';
    rules += ' _w-17zqamw';
    rules += ' _x-17zqamw';
    rules += ' _y-17zqamw';
    rules += ' __va';
    rules += ' __wa';
    if (!$U) rules += ' Uc';
    if (!$l) rules += ' lb';
    if (!$k) rules += ' kb';
    if (!$r) rules += ' r-17zqamw';
    if (!$p) rules += ' p-17zqamw';
    return rules;
};
function CustomDialog(props, ref) {
    let { size, isDismissible, isKeyboardDismissDisabled, padding = 'default' } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
        size: size,
        isDismissable: isDismissible,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Dialog), {
            ...props,
            ref: domRef,
            style: props.UNSAFE_style,
            className: (props.UNSAFE_className || '') + dialogStyle({
                padding
            }, props.styles),
            children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children)=>// Reset OverlayTriggerStateContext so the buttons inside the dialog don't retain their hover state.
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayTriggerStateContext).Provider, {
                    value: null,
                    children: children
                }))
        })
    });
}
/**
 * A CustomDialog is a floating window with a custom layout.
 */ let _CustomDialog = /*#__PURE__*/ (0, _react.forwardRef)(CustomDialog);
try {
    // @ts-ignore
    _CustomDialog.displayName = "_CustomDialog";
    // @ts-ignore
    _CustomDialog.__docgenInfo = {
        "description": "A CustomDialog is a floating window with a custom layout.",
        "displayName": "_CustomDialog",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((opts: DialogRenderProps) => ReactNode)"
                }
            },
            "isDismissible": {
                "defaultValue": null,
                "description": "Whether the Dialog is dismissible.",
                "name": "isDismissible",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isKeyboardDismissDisabled": {
                "defaultValue": null,
                "description": "Whether pressing the escape key to close the dialog should be disabled.",
                "name": "isKeyboardDismissDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "padding": {
                "defaultValue": {
                    value: "'default'"
                },
                "description": "The amount of padding around the contents of the dialog.",
                "name": "padding",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"default\""
                        }
                    ]
                }
            },
            "role": {
                "defaultValue": {
                    value: "'dialog'"
                },
                "description": "The accessibility role for the dialog.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"dialog\""
                        },
                        {
                            "value": "\"alertdialog\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": null,
                "description": "The size of the Dialog.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"fullscreen\""
                        },
                        {
                            "value": "\"fullscreenTakeover\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/CustomDialog.tsx#_CustomDialog"] = {
        docgenInfo: _CustomDialog.__docgenInfo,
        name: "_CustomDialog",
        path: "packages/@react-spectrum/s2/src/CustomDialog.tsx#_CustomDialog"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"km8LR","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","react":"jEiK2","./Modal":"3rhAy","@react-spectrum/utils":"bebxO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"km8LR":[function() {},{}],"2ybS9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dialogInner", ()=>dialogInner);
parcelHelpers.export(exports, "FullscreenDialog", ()=>_FullscreenDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _buttonGroup = require("./ButtonGroup");
var _reactAriaComponents = require("react-aria-components");
var _content = require("./Content");
var _react = require("react");
var _modal = require("./Modal");
var _utils = require("@react-spectrum/utils");
const heading = " . __a-go5hed __b-go5hed __c-go5hed __d-go5hed _9-3t1y Aa Ba _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _dj _dbm _ee _e-1x99dloe _fa _f-1x99dlob ao";
const header = " . __a-i6pim __b-i6pim __c-i6pim __d-i6pim yc_d zc_d _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _di _dbj _eb _fb _f-1x99dloc an";
const content = " . __a-1mod4sg __b-1mod4sg __c-1mod4sg __d-1mod4sg _9-3t1y __wa __w-l92dlrd _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _dg _dbh _eb _fb _f-1x99dloc an";
const buttonGroup = " . __a-15bi2vo __b-15bi2vo __c-15bi2vo __d-15bi2vo y_d rb";
const dialogInner = " . _Zf __j-1fflgh0 __jc-1viqiso __h-375yi6 __hc-fdenls __i-36luh1 __ic-1wmzwss Eh Ecj Fh Fcj Ch Ccj Dh Dcj jf jch p-17zqamw kb __na _La _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _v-17zqamw _w-17zqamw _x-17zqamw _y-17zqamw __va __wa";
function FullscreenDialog(props, ref) {
    let { variant = 'fullscreen', isKeyboardDismissDisabled } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
        size: variant,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Dialog), {
            ...props,
            ref: domRef,
            style: props.UNSAFE_style,
            className: (props.UNSAFE_className || '') + dialogInner,
            children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children)=>// Reset OverlayTriggerStateContext so the buttons inside the dialog don't retain their hover state.
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayTriggerStateContext).Provider, {
                    value: null,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _content.HeadingContext),
                                {
                                    styles: heading
                                }
                            ],
                            [
                                (0, _content.HeaderContext),
                                {
                                    styles: header
                                }
                            ],
                            [
                                (0, _content.ContentContext),
                                {
                                    styles: content
                                }
                            ],
                            [
                                (0, _buttonGroup.ButtonGroupContext),
                                {
                                    styles: buttonGroup
                                }
                            ]
                        ],
                        children: children
                    })
                }))
        })
    });
}
/**
 * Takeover dialogs are large types of dialogs. They use the totality of the screen and should be used for modal experiences with complex workflows.
 */ let _FullscreenDialog = /*#__PURE__*/ (0, _react.forwardRef)(FullscreenDialog);
try {
    // @ts-ignore
    _FullscreenDialog.displayName = "_FullscreenDialog";
    // @ts-ignore
    _FullscreenDialog.__docgenInfo = {
        "description": "Takeover dialogs are large types of dialogs. They use the totality of the screen and should be used for modal experiences with complex workflows.",
        "displayName": "_FullscreenDialog",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((opts: DialogRenderProps) => ReactNode)"
                }
            },
            "isKeyboardDismissDisabled": {
                "defaultValue": null,
                "description": "Whether pressing the escape key to close the dialog should be disabled.",
                "name": "isKeyboardDismissDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "role": {
                "defaultValue": {
                    value: "'dialog'"
                },
                "description": "The accessibility role for the dialog.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"dialog\""
                        },
                        {
                            "value": "\"alertdialog\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "\"fullscreen\""
                },
                "description": "The variant of fullscreen dialog to display.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"fullscreen\""
                        },
                        {
                            "value": "\"fullscreenTakeover\""
                        }
                    ]
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/FullscreenDialog.tsx#_FullscreenDialog"] = {
        docgenInfo: _FullscreenDialog.__docgenInfo,
        name: "_FullscreenDialog",
        path: "packages/@react-spectrum/s2/src/FullscreenDialog.tsx#_FullscreenDialog"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"3HIh8","1":"9VRvW","2":"jbRKM","3":"gaTnB","4":"aPFQc","react/jsx-runtime":"2JzhG","./ButtonGroup":"bQ9CV","react-aria-components":"8nuKL","./Content":"aBWEm","react":"jEiK2","./Modal":"3rhAy","@react-spectrum/utils":"bebxO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"3HIh8":[function() {},{}],"9VRvW":[function() {},{}],"jbRKM":[function() {},{}],"gaTnB":[function() {},{}],"aPFQc":[function() {},{}],"4CN6y":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A DialogContainer accepts a single Dialog as a child, and manages showing and hiding
 * it in a modal. Useful in cases where there is no trigger element
 * or when the trigger unmounts while the dialog is open.
 */ parcelHelpers.export(exports, "DialogContainer", ()=>DialogContainer);
parcelHelpers.export(exports, "useDialogContainer", ()=>useDialogContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function DialogContainer(props) {
    let { children, onDismiss } = props;
    let childArray = (0, _reactDefault.default).Children.toArray(children);
    if (childArray.length > 1) throw new Error('Only a single child can be passed to DialogContainer.');
    let [lastChild, setLastChild] = (0, _react.useState)(null);
    // React.Children.toArray mutates the children, and we need them to be stable
    // between renders so that the lastChild comparison works.
    let child = undefined;
    if (Array.isArray(children)) child = children.find((0, _reactDefault.default).isValidElement);
    else if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(children)) child = children;
    if (child && child !== lastChild) setLastChild(child);
    let onOpenChange = (isOpen)=>{
        if (!isOpen) onDismiss();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ModalContext).Provider, {
        value: {
            isOpen: !!child,
            onOpenChange
        },
        children: lastChild
    });
}
function useDialogContainer() {
    let context = (0, _reactAriaComponents.useSlottedContext)((0, _reactAriaComponents.ModalContext));
    if (!context) throw new Error('Cannot call useDialogContext outside a <DialogTrigger> or <DialogContainer>.');
    return {
        dismiss () {
            context?.onOpenChange?.(false);
        }
    };
}
try {
    // @ts-ignore
    DialogContainer.displayName = "DialogContainer";
    // @ts-ignore
    DialogContainer.__docgenInfo = {
        "description": "A DialogContainer accepts a single Dialog as a child, and manages showing and hiding\nit in a modal. Useful in cases where there is no trigger element\nor when the trigger unmounts while the dialog is open.",
        "displayName": "DialogContainer",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The Dialog to display, if any.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "onDismiss": {
                "defaultValue": null,
                "description": "Handler that is called when the 'x' button of a dismissable Dialog is clicked.",
                "name": "onDismiss",
                "required": true,
                "type": {
                    "name": "() => void"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/DialogContainer.tsx#DialogContainer"] = {
        docgenInfo: DialogContainer.__docgenInfo,
        name: "DialogContainer",
        path: "packages/@react-spectrum/s2/src/DialogContainer.tsx#DialogContainer"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"jlcpx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropZoneContext", ()=>DropZoneContext);
parcelHelpers.export(exports, "DropZone", ()=>_DropZone);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _illustratedMessage = require("./IllustratedMessage");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-spectrum/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DropZoneContext = /*#__PURE__*/ (0, _react.createContext)(null);
const dropzone = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r|k|o|p)[^\s]+/g) || [];
    rules += matches.join('');
    let $U = false;
    for (let p of matches)if (/^\s*U/.test(p)) $U = true;
    rules += ' _Zd';
    rules += ' _2d';
    rules += ' _1c';
    if (!$U) rules += ' Uc';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    rules += ' ao';
    if (props.isDropTarget) rules += ' wa';
    else rules += ' wb';
    if (props.isDropTarget) rules += ' br';
    rules += ' uc';
    rules += ' vc';
    rules += ' sc';
    rules += ' tc';
    if (props.isFocusVisible) rules += ' cx';
    else if (props.isDropTarget) rules += ' cx';
    else rules += ' ci';
    rules += ' _vd';
    rules += ' _wd';
    rules += ' _xd';
    rules += ' _yd';
    rules += ' Eh';
    rules += ' Fh';
    rules += ' Ch';
    rules += ' Dh';
    return rules;
};
const banner = function anonymous(props) {
    let rules = " .";
    rules += ' Ua';
    rules += ' Ya';
    rules += ' _aa';
    rules += ' y_d';
    rules += ' z_d';
    rules += ' _Zd';
    rules += ' _1c';
    rules += ' _2d';
    rules += ' o-375tou';
    rules += ' le';
    if (props.size === "L") rules += ' r___L';
    else if (props.size === "S") rules += ' r__Z';
    else rules += ' r___v';
    if (props.isPressed) rules += ' b_____F';
    else if (props.isFocusVisible) rules += ' b_____F';
    else if (props.isHovered) rules += ' b_____F';
    else rules += ' b_____E';
    rules += ' _vc';
    rules += ' _wc';
    rules += ' _xc';
    rules += ' _yc';
    rules += ' ac';
    rules += ' _ed';
    rules += ' E-17c1d5h';
    rules += ' F-17c1d5h';
    rules += ' C-17c1d5h';
    rules += ' D-17c1d5h';
    rules += ' -_375tou_o-I';
    return rules;
};
function DropZone(props, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, DropZoneContext);
    let { size = 'M' } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DropZone), {
        ...props,
        ref: domRef,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + dropzone(renderProps, props.styles),
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _illustratedMessage.IllustratedMessageContext).Provider, {
                        value: {
                            isInDropZone: true,
                            isDropTarget: renderProps.isDropTarget,
                            size
                        },
                        children: props.children
                    }),
                    renderProps.isDropTarget && props.isFilled && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: banner({
                            size
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: props.replaceMessage ? props.replaceMessage : stringFormatter.format('dropzone.replaceMessage')
                        })
                    })
                ]
            })
    });
}
/**
 * A drop zone is an area into which one or multiple objects can be dragged and dropped.
 */ let _DropZone = /*#__PURE__*/ (0, _react.forwardRef)(DropZone);
try {
    // @ts-ignore
    DropZoneContext.displayName = "DropZoneContext";
    // @ts-ignore
    DropZoneContext.__docgenInfo = {
        "description": "",
        "displayName": "DropZoneContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<DropZoneProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/DropZone.tsx#DropZoneContext"] = {
        docgenInfo: DropZoneContext.__docgenInfo,
        name: "DropZoneContext",
        path: "packages/@react-spectrum/s2/src/DropZone.tsx#DropZoneContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _DropZone.displayName = "_DropZone";
    // @ts-ignore
    _DropZone.__docgenInfo = {
        "description": "A drop zone is an area into which one or multiple objects can be dragged and dropped.",
        "displayName": "_DropZone",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the drop zone.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "getDropOperation": {
                "defaultValue": null,
                "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
                "name": "getDropOperation",
                "required": false,
                "type": {
                    "name": "((types: DragTypes, allowedOperations: DropOperation[]) => DropOperation)"
                }
            },
            "isFilled": {
                "defaultValue": null,
                "description": "Whether the drop zone has been filled.",
                "name": "isFilled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "replaceMessage": {
                "defaultValue": null,
                "description": "The message to replace the default banner message that is shown when the drop zone is filled.",
                "name": "replaceMessage",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the DropZone.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onDrop": {
                "defaultValue": null,
                "description": "Handler that is called when a valid drag is dropped on the drop target.",
                "name": "onDrop",
                "required": false,
                "type": {
                    "name": "((e: DropEvent) => void)"
                }
            },
            "onDropActivate": {
                "defaultValue": null,
                "description": "Handler that is called after a valid drag is held over the drop target for a period of time.\nThis typically opens the item so that the user can drop within it.\n@private",
                "name": "onDropActivate",
                "required": false,
                "type": {
                    "name": "((e: DropActivateEvent) => void)"
                }
            },
            "onDropEnter": {
                "defaultValue": null,
                "description": "Handler that is called when a valid drag enters the drop target.",
                "name": "onDropEnter",
                "required": false,
                "type": {
                    "name": "((e: DropEnterEvent) => void)"
                }
            },
            "onDropExit": {
                "defaultValue": null,
                "description": "Handler that is called when a valid drag exits the drop target.",
                "name": "onDropExit",
                "required": false,
                "type": {
                    "name": "((e: DropExitEvent) => void)"
                }
            },
            "onDropMove": {
                "defaultValue": null,
                "description": "Handler that is called when a valid drag is moved within the drop target.",
                "name": "onDropMove",
                "required": false,
                "type": {
                    "name": "((e: DropMoveEvent) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/DropZone.tsx#_DropZone"] = {
        docgenInfo: _DropZone.__docgenInfo,
        name: "_DropZone",
        path: "packages/@react-spectrum/s2/src/DropZone.tsx#_DropZone"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"63Ey8","1":"iSg88","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","react":"jEiK2","./IllustratedMessage":"67Z4d","../intl/*.json":"iU6xz","@react-spectrum/utils":"bebxO","@react-aria/i18n":"hFrKJ","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"63Ey8":[function() {},{}],"iSg88":[function() {},{}],"67Z4d":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IllustratedMessageContext", ()=>IllustratedMessageContext);
parcelHelpers.export(exports, "IllustratedMessage", ()=>_IllustratedMessage);
var _jsxRuntime = require("react/jsx-runtime");
var _buttonGroup = require("./ButtonGroup");
var _content = require("./Content");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const illustratedMessage = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r|k|o|p)[^\s]+/g) || [];
    rules += matches.join('');
    let $r = false;
    for (let p of matches)if (/^\s*r/.test(p)) $r = true;
    rules += ' _Zf';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    if (!$r) {
        if (props.orientation === "horizontal") rules += ' r________V';
        else if (props.orientation === "vertical") rules += ' r______x';
    }
    if (props.orientation === "horizontal") rules += ' __j-1t3dvev';
    else if (props.orientation === "vertical") rules += ' __j-tu9mw5';
    if (props.orientation === "horizontal") rules += ' __i-1efftez';
    else if (props.orientation === "vertical") {
        if (props.size === "L") rules += ' __i-xadfxd';
        else rules += ' __i-fd9mh8';
    }
    if (props.orientation === "horizontal") rules += ' __h-883psa';
    if (props.orientation === "horizontal") rules += ' _3a';
    else if (props.orientation === "vertical") rules += ' _3c';
    if (props.orientation === "vertical") rules += ' _jb';
    return rules;
};
const illustration = function anonymous(props) {
    let rules = " .";
    rules += ' __a-1e6vo9b';
    rules += ' __b-1e6vo9b';
    rules += ' __c-1e6vo9b';
    rules += ' __d-1e6vo9b';
    if (props.size === "L") rules += ' l__Y';
    else if (props.size === "M") rules += ' l_W';
    else if (props.size === "S") rules += ' l_W';
    if (props.size === "L") rules += ' k__Y';
    else if (props.size === "M") rules += ' k_W';
    else if (props.size === "S") rules += ' k_W';
    rules += ' _4d';
    if (props.isDropTarget) {
        if (props.isPressed) rules += ' -rwx0fg_a-z';
        else if (props.isFocusVisible) rules += ' -rwx0fg_a-z';
        else if (props.isHovered) rules += ' -rwx0fg_a-z';
        else rules += ' -rwx0fg_a-y';
    } else {
        if (props.isPressed) rules += ' -rwx0fg_a-o';
        else if (props.isFocusVisible) rules += ' -rwx0fg_a-o';
        else if (props.isHovered) rules += ' -rwx0fg_a-o';
        else rules += ' -rwx0fg_a-n';
    }
    return rules;
};
const heading = function anonymous(props) {
    let rules = " .";
    rules += ' __a-go5hed';
    rules += ' __b-go5hed';
    rules += ' __c-go5hed';
    rules += ' __d-go5hed';
    if (props.size === "L") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "M") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "S") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    }
    if (props.size === "L") {
        rules += ' _dbm';
        rules += ' _dj';
    } else if (props.size === "M") {
        rules += ' _dbl';
        rules += ' _dk';
    } else if (props.size === "S") {
        rules += ' _dbh';
        rules += ' _dg';
    }
    if (props.size === "L") {
        rules += ' _e-1x99dlod';
        rules += ' _ed';
    } else if (props.size === "M") {
        rules += ' _e-1x99dlod';
        rules += ' _ed';
    } else if (props.size === "S") {
        rules += ' _e-1x99dlod';
        rules += ' _ed';
    }
    if (props.size === "L") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    } else if (props.size === "M") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    } else if (props.size === "S") {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    }
    if (props.size === "L") rules += ' ao';
    else if (props.size === "M") rules += ' ao';
    else if (props.size === "S") rules += ' ao';
    rules += ' _4c';
    rules += ' Aa';
    rules += ' Ba';
    rules += ' ya';
    rules += ' za';
    return rules;
};
const content = function anonymous(props) {
    let rules = " .";
    if (props.size === "L") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "M") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    } else if (props.size === "S") {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    }
    if (props.size === "L") {
        rules += ' _dbf';
        rules += ' _de';
    } else if (props.size === "M") {
        rules += ' _dbf';
        rules += ' _de';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    }
    if (props.size === "L") rules += ' _eb';
    else if (props.size === "M") rules += ' _eb';
    else if (props.size === "S") rules += ' _eb';
    if (props.size === "L") {
        rules += ' _f-1x99dloc';
        rules += ' _fb';
    } else if (props.size === "M") {
        rules += ' _f-1x99dloc';
        rules += ' _fb';
    } else if (props.size === "S") {
        rules += ' _f-1x99dloc';
        rules += ' _fb';
    }
    if (props.size === "L") rules += ' an';
    else if (props.size === "M") rules += ' an';
    else if (props.size === "S") rules += ' an';
    rules += ' __a-1mod4sg';
    rules += ' __b-1mod4sg';
    rules += ' __c-1mod4sg';
    rules += ' __d-1mod4sg';
    rules += ' _4b';
    return rules;
};
const buttonGroup = " . __a-3yyxn2 __b-3yyxn2 __c-3yyxn2 __d-3yyxn2 Af";
const IllustratedMessageContext = /*#__PURE__*/ (0, _react.createContext)(null);
function IllustratedMessage(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, IllustratedMessageContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { children, orientation = 'horizontal', size = 'M', UNSAFE_className = '', UNSAFE_style, isInDropZone = false, isDropTarget = false, ...otherProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _utils.filterDOMProps)(otherProps),
        style: UNSAFE_style,
        className: UNSAFE_className + illustratedMessage({
            size: props.size || 'M',
            orientation: props.orientation || 'vertical'
        }, props.styles),
        ref: domRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _content.HeadingContext),
                    {
                        styles: heading({
                            orientation,
                            size
                        })
                    }
                ],
                [
                    (0, _content.ContentContext),
                    {
                        styles: content({
                            size
                        })
                    }
                ],
                [
                    (0, _icon.IllustrationContext),
                    {
                        size: size === 'L' ? 'L' : 'M',
                        styles: illustration({
                            orientation,
                            size,
                            isInDropZone,
                            isDropTarget
                        })
                    }
                ],
                [
                    (0, _buttonGroup.ButtonGroupContext),
                    {
                        styles: buttonGroup
                    }
                ]
            ],
            children: children
        })
    });
}
/**
 * An IllustratedMessage displays an illustration and a message, usually
 * for an empty state or an error page.
 */ let _IllustratedMessage = /*#__PURE__*/ (0, _react.forwardRef)(IllustratedMessage);
try {
    // @ts-ignore
    IllustratedMessageContext.displayName = "IllustratedMessageContext";
    // @ts-ignore
    IllustratedMessageContext.__docgenInfo = {
        "description": "",
        "displayName": "IllustratedMessageContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<IllustratedMessageContextProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/IllustratedMessage.tsx#IllustratedMessageContext"] = {
        docgenInfo: IllustratedMessageContext.__docgenInfo,
        name: "IllustratedMessageContext",
        path: "packages/@react-spectrum/s2/src/IllustratedMessage.tsx#IllustratedMessageContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _IllustratedMessage.displayName = "_IllustratedMessage";
    // @ts-ignore
    _IllustratedMessage.__docgenInfo = {
        "description": "An IllustratedMessage displays an illustration and a message, usually\nfor an empty state or an error page.",
        "displayName": "_IllustratedMessage",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the IllustratedMessage.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'vertical'"
                },
                "description": "The direction that the IllustratedMessage should be laid out in.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the IllustratedMessage.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/IllustratedMessage.tsx#_IllustratedMessage"] = {
        docgenInfo: _IllustratedMessage.__docgenInfo,
        name: "_IllustratedMessage",
        path: "packages/@react-spectrum/s2/src/IllustratedMessage.tsx#_IllustratedMessage"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"aox3A","1":"1GG0X","2":"6lfWx","3":"dFh1o","4":"d1T2Z","react/jsx-runtime":"2JzhG","./ButtonGroup":"bQ9CV","./Content":"aBWEm","react-aria-components":"8nuKL","react":"jEiK2","@react-aria/utils":"e9Yvo","./Icon":"1OC2a","@react-spectrum/utils":"bebxO","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"aox3A":[function() {},{}],"1GG0X":[function() {},{}],"6lfWx":[function() {},{}],"dFh1o":[function() {},{}],"d1T2Z":[function() {},{}],"cfqoF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineAlertContext", ()=>InlineAlertContext);
parcelHelpers.export(exports, "InlineAlert", ()=>_InlineAlert);
var _jsxRuntime = require("react/jsx-runtime");
var _s2IconAlertTriangle20NSvg = require("../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg");
var _s2IconAlertTriangle20NSvgDefault = parcelHelpers.interopDefault(_s2IconAlertTriangle20NSvg);
var _s2IconCheckmarkCircle20NSvg = require("../s2wf-icons/S2_Icon_CheckmarkCircle_20_N.svg");
var _s2IconCheckmarkCircle20NSvgDefault = parcelHelpers.interopDefault(_s2IconCheckmarkCircle20NSvg);
var _react = require("react");
var _content = require("./Content");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _s2IconInfoCircle20NSvg = require("../s2wf-icons/S2_Icon_InfoCircle_20_N.svg");
var _s2IconInfoCircle20NSvgDefault = parcelHelpers.interopDefault(_s2IconInfoCircle20NSvg);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _s2IconAlertDiamond20NSvg = require("../s2wf-icons/S2_Icon_AlertDiamond_20_N.svg");
var _s2IconAlertDiamond20NSvgDefault = parcelHelpers.interopDefault(_s2IconAlertDiamond20NSvg);
var _utils1 = require("@react-spectrum/utils");
var _reactAria = require("react-aria");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const InlineAlertContext = /*#__PURE__*/ (0, _react.createContext)(null);
const inlineAlert = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $U = false;
    let $r = false;
    for (let p of matches){
        if (/^\s*U/.test(p)) $U = true;
        if (/^\s*r/.test(p)) $r = true;
    }
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    rules += ' _Zb';
    if (!$U) rules += ' Uc';
    rules += ' __na';
    if (!$r) rules += ' r_____z';
    rules += ' Eh';
    rules += ' Fh';
    rules += ' Ch';
    rules += ' Dh';
    rules += ' _vd';
    rules += ' _wd';
    rules += ' _xd';
    rules += ' _yd';
    rules += ' wa';
    rules += ' uc';
    rules += ' vc';
    rules += ' sc';
    rules += ' tc';
    if (props.fillStyle === "boldFill") rules += ' ca';
    else if (props.fillStyle === "subtleFill") rules += ' ca';
    else if (props.fillStyle === "border") {
        if (props.variant === "neutral") rules += ' cm';
        else if (props.variant === "negative") rules += ' cN';
        else if (props.variant === "notice") rules += ' c2';
        else if (props.variant === "positive") rules += ' c_4';
        else if (props.variant === "informative") rules += ' cx';
    }
    if (props.variant === "neutral") {
        if (props.fillStyle === "boldFill") {
            if (props.isPressed) rules += ' b_____I';
            else if (props.isFocusVisible) rules += ' b_____I';
            else if (props.isHovered) rules += ' b_____I';
            else rules += ' b_____H';
        } else if (props.fillStyle === "subtleFill") rules += ' b_____J';
        else if (props.fillStyle === "border") rules += ' bd';
    } else if (props.variant === "negative") {
        if (props.fillStyle === "boldFill") {
            if (props.isPressed) rules += ' b_____L';
            else if (props.isFocusVisible) rules += ' b_____L';
            else if (props.isHovered) rules += ' b_____L';
            else rules += ' b_____K';
        } else if (props.fillStyle === "subtleFill") rules += ' b_____M';
        else if (props.fillStyle === "border") rules += ' bd';
    } else if (props.variant === "notice") {
        if (props.fillStyle === "boldFill") rules += ' b_____Q';
        else if (props.fillStyle === "subtleFill") rules += ' b_____R';
        else if (props.fillStyle === "border") rules += ' bd';
    } else if (props.variant === "positive") {
        if (props.fillStyle === "boldFill") {
            if (props.isPressed) rules += ' b_____O';
            else if (props.isFocusVisible) rules += ' b_____O';
            else if (props.isHovered) rules += ' b_____O';
            else rules += ' b_____N';
        } else if (props.fillStyle === "subtleFill") rules += ' b_____P';
        else if (props.fillStyle === "border") rules += ' bd';
    } else if (props.variant === "informative") {
        if (props.fillStyle === "boldFill") {
            if (props.isPressed) rules += ' b_____F';
            else if (props.isFocusVisible) rules += ' b_____F';
            else if (props.isHovered) rules += ' b_____F';
            else rules += ' b_____E';
        } else if (props.fillStyle === "subtleFill") rules += ' b_____G';
        else if (props.fillStyle === "border") rules += ' bd';
    }
    return rules;
};
const icon = function anonymous(props) {
    let rules = " .";
    rules += ' __a-ykjmzy';
    rules += ' __b-ykjmzy';
    rules += ' __c-ykjmzy';
    rules += ' __d-ykjmzy';
    if (props.fillStyle === "boldFill") {
        if (props.variant === "notice") rules += ' -rwx0fg_e-z';
        else rules += ' -rwx0fg_e-A';
    } else if (props.fillStyle === "subtleFill") {
        if (props.variant === "neutral") rules += ' -rwx0fg_e-d';
        else if (props.variant === "negative") rules += ' -rwx0fg_e-e';
        else if (props.variant === "notice") rules += ' -rwx0fg_e-e';
        else if (props.variant === "positive") rules += ' -rwx0fg_e-f';
        else if (props.variant === "informative") rules += ' -rwx0fg_e-c';
    } else if (props.fillStyle === "border") {
        if (props.variant === "neutral") rules += ' -rwx0fg_e-d';
        else if (props.variant === "negative") rules += ' -rwx0fg_e-e';
        else if (props.variant === "notice") rules += ' -rwx0fg_e-g';
        else if (props.variant === "positive") rules += ' -rwx0fg_e-f';
        else if (props.variant === "informative") rules += ' -rwx0fg_e-c';
    }
    return rules;
};
const grid = " . _Zf jh __h-u2tns7 __i-ld1isw lb __j-11zp5n8";
let ICONS = {
    informative: (0, _s2IconInfoCircle20NSvgDefault.default),
    positive: (0, _s2IconCheckmarkCircle20NSvgDefault.default),
    notice: (0, _s2IconAlertDiamond20NSvgDefault.default),
    negative: (0, _s2IconAlertTriangle20NSvgDefault.default),
    neutral: undefined
};
const heading = function anonymous(props) {
    let rules = " .";
    rules += ' Aa';
    rules += ' __a-go5hed';
    rules += ' __b-go5hed';
    rules += ' __c-go5hed';
    rules += ' __d-go5hed';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    rules += ' _dbf';
    rules += ' _de';
    rules += ' _e-1x99dlod';
    rules += ' _ed';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.fillStyle === "boldFill") {
        if (props.variant === "notice") rules += ' ab';
        else rules += ' ac';
    } else rules += ' ao';
    return rules;
};
const content = function anonymous(props) {
    let rules = " .";
    rules += ' __a-1mod4sg';
    rules += ' __b-1mod4sg';
    rules += ' __c-1mod4sg';
    rules += ' __d-1mod4sg';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    rules += ' _dbf';
    rules += ' _de';
    rules += ' _eb';
    rules += ' _f-1x99dloc';
    rules += ' _fb';
    if (props.fillStyle === "boldFill") {
        if (props.variant === "notice") rules += ' ab';
        else rules += ' ac';
    } else rules += ' an';
    return rules;
};
function InlineAlert(props, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, InlineAlertContext);
    let { children, variant = 'neutral', fillStyle = 'border', autoFocus } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let Icon = null;
    let iconAlt = '';
    if (variant in ICONS) {
        Icon = ICONS[variant];
        if (Icon) iconAlt = stringFormatter.format(`inlinealert.${variant}`);
    }
    let { isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)({
        autoFocus: props.autoFocus
    });
    let autoFocusRef = (0, _react.useRef)(props.autoFocus);
    (0, _react.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) domRef.current.focus();
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _utils.filterDOMProps)(props),
        ...focusProps,
        ref: domRef,
        tabIndex: autoFocus ? -1 : undefined,
        autoFocus: autoFocus,
        role: "alert",
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + inlineAlert({
            variant,
            fillStyle,
            isFocusVisible
        }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: grid,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _content.HeadingContext),
                        {
                            styles: heading({
                                fillStyle
                            })
                        }
                    ],
                    [
                        (0, _content.ContentContext),
                        {
                            styles: content({
                                fillStyle
                            })
                        }
                    ],
                    [
                        (0, _icon.IconContext),
                        {
                            styles: icon({
                                variant,
                                fillStyle
                            })
                        }
                    ]
                ],
                children: [
                    Icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                        "aria-label": iconAlt
                    }),
                    children
                ]
            })
        })
    });
}
/**
 * Inline alerts display a non-modal message associated with objects in a view.
 * These are often used in form validation, providing a place to aggregate feedback related to multiple fields.
 */ const _InlineAlert = /*#__PURE__*/ (0, _react.forwardRef)(InlineAlert);
try {
    // @ts-ignore
    InlineAlertContext.displayName = "InlineAlertContext";
    // @ts-ignore
    InlineAlertContext.__docgenInfo = {
        "description": "",
        "displayName": "InlineAlertContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<Partial<InlineAlertProps>, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/InlineAlert.tsx#InlineAlertContext"] = {
        docgenInfo: InlineAlertContext.__docgenInfo,
        name: "InlineAlertContext",
        path: "packages/@react-spectrum/s2/src/InlineAlert.tsx#InlineAlertContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _InlineAlert.displayName = "_InlineAlert";
    // @ts-ignore
    _InlineAlert.__docgenInfo = {
        "description": "Inline alerts display a non-modal message associated with objects in a view.\nThese are often used in form validation, providing a place to aggregate feedback related to multiple fields.",
        "displayName": "_InlineAlert",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the Inline Alert.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether to automatically focus the Inline Alert when it first renders.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "fillStyle": {
                "defaultValue": {
                    value: "border"
                },
                "description": "The visual style of the Inline Alert.",
                "name": "fillStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"border\""
                        },
                        {
                            "value": "\"subtleFill\""
                        },
                        {
                            "value": "\"boldFill\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "neutral"
                },
                "description": "The semantic tone of a Inline Alert.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"negative\""
                        },
                        {
                            "value": "\"informative\""
                        },
                        {
                            "value": "\"neutral\""
                        },
                        {
                            "value": "\"positive\""
                        },
                        {
                            "value": "\"notice\""
                        }
                    ]
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/InlineAlert.tsx#_InlineAlert"] = {
        docgenInfo: _InlineAlert.__docgenInfo,
        name: "_InlineAlert",
        path: "packages/@react-spectrum/s2/src/InlineAlert.tsx#_InlineAlert"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"8nFUK","1":"7XDLB","2":"bB2Sm","3":"3qHeg","4":"faCgM","react/jsx-runtime":"2JzhG","../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg":"gH5vG","../s2wf-icons/S2_Icon_CheckmarkCircle_20_N.svg":"2lFZV","react":"jEiK2","./Content":"aBWEm","react-aria-components":"8nuKL","@react-aria/utils":"e9Yvo","./Icon":"1OC2a","../s2wf-icons/S2_Icon_InfoCircle_20_N.svg":"1inb5","../intl/*.json":"iU6xz","../s2wf-icons/S2_Icon_AlertDiamond_20_N.svg":"dewOV","@react-spectrum/utils":"bebxO","react-aria":"4BEis","@react-aria/i18n":"hFrKJ","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"8nFUK":[function() {},{}],"7XDLB":[function() {},{}],"bB2Sm":[function() {},{}],"3qHeg":[function() {},{}],"faCgM":[function() {},{}],"2lFZV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.223 13.5c-.212 0-.415-.09-.558-.248l-2.51-2.792c-.278-.309-.253-.782.055-1.06s.781-.252 1.06.056l1.893 2.107 3.487-4.756c.244-.334.711-.41 1.048-.161.334.244.406.713.161 1.047l-4.032 5.5c-.133.183-.342.295-.567.306z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef, (0, _icon.IconContext));

},{"react/jsx-runtime":"2JzhG","~/src/Icon":"1OC2a","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"atz6N":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberFieldContext", ()=>NumberFieldContext);
parcelHelpers.export(exports, "NumberField", ()=>_NumberField);
var _jsxRuntime = require("react/jsx-runtime");
var _add = require("../ui-icons/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _dash = require("../ui-icons/Dash");
var _dashDefault = parcelHelpers.interopDefault(_dash);
var _field = require("./Field");
var _utils1 = require("@react-aria/utils");
var _form = require("./Form");
var _pressScale = require("./pressScale");
var _reactAria = require("react-aria");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const NumberFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const inputButton = function anonymous(props) {
    let rules = " .";
    rules += ' _Zd';
    rules += ' _La';
    rules += ' _jb';
    rules += ' wf';
    if (props.type === "decrementStep") rules += ' _va';
    else {
        if (props.size === "XL") rules += ' _v-3762yr';
        else if (props.size === "L") rules += ' _v-37624i';
        else if (props.size === "M") rules += ' _v-3761a9';
        else if (props.size === "S") rules += ' _v-3760g0';
    }
    if (props.type === "decrementStep") rules += ' _wa';
    else {
        if (props.size === "XL") rules += ' _w-3762yr';
        else if (props.size === "L") rules += ' _w-37624i';
        else if (props.size === "M") rules += ' _w-3761a9';
        else if (props.size === "S") rules += ' _w-3760g0';
    }
    if (props.type === "incrementStep") rules += ' _xa';
    else {
        if (props.size === "XL") rules += ' _x-3762yr';
        else if (props.size === "L") rules += ' _x-37624i';
        else if (props.size === "M") rules += ' _x-3761a9';
        else if (props.size === "S") rules += ' _x-3760g0';
    }
    if (props.type === "incrementStep") rules += ' _ya';
    else {
        if (props.size === "XL") rules += ' _y-3762yr';
        else if (props.size === "L") rules += ' _y-37624i';
        else if (props.size === "M") rules += ' _y-3761a9';
        else if (props.size === "S") rules += ' _y-3760g0';
    }
    rules += ' _1c';
    rules += ' _2d';
    if (props.size === "XL") rules += ' lU';
    else if (props.size === "L") rules += ' lM';
    else if (props.size === "M") rules += ' lI';
    else if (props.size === "S") rules += ' lE';
    rules += ' ka';
    if (props.type === "increment") rules += ' ya';
    else rules += ' yF';
    rules += ' _bb';
    rules += ' _8-3t1x';
    rules += ' oo';
    rules += ' _Oag';
    rules += ' _Oa';
    rules += ' _Qa-375x7f';
    rules += ' _Q-375x7f';
    rules += ' _Raa';
    rules += ' _Ra';
    if (props.isDisabled) rules += ' ba_____B';
    else if (props.isHovered) rules += ' ba_____z';
    else rules += ' ba_____x';
    if (props.isDisabled) rules += ' bg';
    else {
        if (props.isPressed) rules += ' bh';
        else if (props.isFocusVisible) rules += ' bh';
        else if (props.isHovered) rules += ' bh';
        else rules += ' bg';
    }
    rules += ' aa_____w';
    if (props.isDisabled) rules += ' aj';
    else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' __Hb';
    return rules;
};
const iconStyles = function anonymous(props) {
    let rules = " .";
    rules += ' _8-3t1x';
    if (props.type === "decrementStep") rules += ' R-3hn0u';
    else if (props.type === "incrementStep") rules += ' R-375y3i';
    else rules += ' R-3t1x';
    rules += ' -rwx0fg_e-b';
    return rules;
};
const stepperContainerStyles = function anonymous(props) {
    let rules = " .";
    rules += ' _Zd';
    rules += ' _6a';
    if (props.size === "XL") rules += ' id';
    else if (props.size === "L") rules += ' id';
    else if (props.size === "M") rules += ' ic';
    else if (props.size === "S") rules += ' id';
    if (props.size === "XL") rules += ' jd';
    else if (props.size === "L") rules += ' jd';
    else if (props.size === "M") rules += ' jc';
    else if (props.size === "S") rules += ' jd';
    if (props.size === "XL") rules += ' D-6njx2e';
    else if (props.size === "L") rules += ' D-6njx2e';
    else if (props.size === "M") rules += ' Dc';
    else if (props.size === "S") rules += ' Db';
    return rules;
};
function NumberField(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, NumberFieldContext);
    let { label, contextualHelp, description: descriptionMessage, errorMessage, hideStepper, isRequired, size = 'M', labelPosition = 'top', necessityIndicator, labelAlign = 'start', UNSAFE_className = '', UNSAFE_style, ...numberFieldProps } = props1;
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    let domRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    let decrementButtonRef = (0, _react.useRef)(null);
    let incrementButtonRef = (0, _react.useRef)(null);
    // Expose imperative interface for ref
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.NumberField), {
        isRequired: isRequired,
        ...numberFieldProps,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " .";
            let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
            rules += matches.join('');
            let $__a = false;
            let $__b = false;
            for (let p of matches){
                if (/^\s*__a/.test(p)) $__a = true;
                if (/^\s*__b/.test(p)) $__b = true;
            }
            rules += ' _Zf';
            if (!$__a) {
                if (props.isInForm) rules += ' __a-3t1y';
            }
            if (!$__b) {
                if (props.isInForm) {
                    if (props.labelPosition === "side") rules += ' __b-7u9dhl';
                }
            }
            if (props.isInForm) rules += ' __h-1cwd7ud';
            else {
                if (props.labelPosition === "side") rules += ' __h-jyg4vb';
                else if (props.labelPosition === "top") rules += ' __h-375yi6';
            }
            if (props.labelPosition === "side") rules += ' __i-jyg4vb';
            else if (props.labelPosition === "top") rules += ' __i-fdenls';
            if (props.labelPosition === "side") rules += ' __j-5eez8j';
            else if (props.labelPosition === "top") rules += ' __j-xlaqir';
            if (props.size === "XL") {
                rules += ' _dbj';
                rules += ' _di';
            } else if (props.size === "L") {
                rules += ' _dbh';
                rules += ' _dg';
            } else if (props.size === "S") {
                rules += ' _dbd';
                rules += ' _dc';
            } else if (props.size === "XS") {
                rules += ' _dbb';
                rules += ' _da';
            } else {
                rules += ' _dbf';
                rules += ' _de';
            }
            rules += ' _1d';
            rules += ' _f-1x99dlob';
            rules += ' _fa';
            if (props.size === "XL") rules += ' -aqrvqh_k-j';
            else if (props.size === "L") rules += ' -aqrvqh_k-i';
            else if (props.size === "S") rules += ' -aqrvqh_k-h';
            else if (props.size === "XS") rules += ' -aqrvqh_k-g';
            else rules += ' -aqrvqh_k-f';
            rules += ' -_1inj1bc_i--prjw07';
            rules += ' je';
            rules += ' __R-yksgrp';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, props1.styles),
        children: ({ isDisabled, isInvalid })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        role: "presentation",
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " .";
                            rules += ' __a-4cfph1';
                            rules += ' __b-4cfph1';
                            rules += ' __c-4cfph1';
                            rules += ' __d-4cfph1';
                            if (props.size === "XL") rules += ' qj';
                            else if (props.size === "L") rules += ' qi';
                            else if (props.size === "S") rules += ' qh';
                            else if (props.size === "XS") rules += ' qg';
                            else rules += ' qf';
                            if (props.isQuiet) rules += ' __ma';
                            else rules += ' __m-1s8glxue';
                            if (props.size === "XL") rules += ' -usygro_l-____g';
                            else if (props.size === "L") rules += ' -usygro_l-___0';
                            else if (props.size === "S") rules += ' -usygro_l-___u';
                            else rules += ' -usygro_l-___K';
                            rules += ' m-rwozxi';
                            rules += ' C-375tnm';
                            rules += ' D-375tnn';
                            rules += ' -_375tnm_C-I';
                            if (props.isStepperHidden) rules += ' -_375tnn_D-I';
                            else rules += ' -_375tnn_D-a';
                            return rules;
                        }({
                            size,
                            isStepperHidden: hideStepper
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.InputContext).Consumer, {
                                children: (ctx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.InputContext).Provider, {
                                        value: {
                                            ...ctx,
                                            ref: (0, _utils1.mergeRefs)(ctx?.ref, inputRef)
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {})
                                    })
                            }),
                            isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
                                isDisabled: isDisabled
                            }),
                            !hideStepper && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: stepperContainerStyles({
                                    size
                                }),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepButton, {
                                        ref: decrementButtonRef,
                                        slot: "decrement",
                                        style: (renderProps)=>(0, _pressScale.pressScale)(decrementButtonRef)(renderProps),
                                        className: (renderProps)=>inputButton({
                                                ...renderProps,
                                                type: 'decrement',
                                                size
                                            }),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashDefault.default), {
                                            size: size,
                                            className: iconStyles({})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepButton, {
                                        ref: incrementButtonRef,
                                        slot: "increment",
                                        style: (renderProps)=>(0, _pressScale.pressScale)(incrementButtonRef)(renderProps),
                                        className: (renderProps)=>inputButton({
                                                ...renderProps,
                                                type: 'increment',
                                                size
                                            }),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {
                                            size: size,
                                            className: iconStyles({})
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    descriptionMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        slot: "description",
                        children: descriptionMessage
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: errorMessage
                    })
                ]
            });
        }
    });
}
const additionalButtonHTMLAttributes = new Set([
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'name',
    'value'
]);
let StepButton = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    [props, ref] = (0, _reactAriaComponents.useContextProps)(props, ref, (0, _reactAriaComponents.ButtonContext));
    let ctx = props;
    /**
   * Must use div for now because Safari pointer event bugs on disabled form elements.
   * Link https://bugs.webkit.org/show_bug.cgi?id=219188.
   */ let { buttonProps, isPressed } = (0, _reactAria.useButton)({
        ...props,
        elementType: 'div'
    }, ref);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)(props);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let renderProps = useRenderProps({
        ...props,
        values: {
            isHovered,
            isPressed,
            isFocused,
            isFocusVisible,
            isDisabled: props.isDisabled || false
        },
        defaultClassName: 'react-aria-Button'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _utils1.filterDOMProps)(props, {
            propNames: additionalButtonHTMLAttributes
        }),
        ...(0, _utils1.mergeProps)(buttonProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-pressed": ctx.isPressed || isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    });
});
/**
 * NumberFields allow users to input number values with a keyboard or increment/decrement with step buttons.
 */ let _NumberField = /*#__PURE__*/ (0, _react.forwardRef)(NumberField);
// replace from RAC
function useRenderProps(props) {
    let { className, style, children, defaultClassName, defaultChildren, defaultStyle, values } = props;
    return (0, _react.useMemo)(()=>{
        let computedClassName;
        let computedStyle;
        let computedChildren;
        if (typeof className === 'function') computedClassName = className({
            ...values,
            defaultClassName
        });
        else computedClassName = className;
        if (typeof style === 'function') computedStyle = style({
            ...values,
            defaultStyle: defaultStyle || {}
        });
        else computedStyle = style;
        if (typeof children === 'function') computedChildren = children({
            ...values,
            defaultChildren
        });
        else if (children == null) computedChildren = defaultChildren;
        else computedChildren = children;
        return {
            className: computedClassName ?? defaultClassName,
            style: computedStyle || defaultStyle ? {
                ...defaultStyle,
                ...computedStyle
            } : undefined,
            children: computedChildren ?? defaultChildren,
            'data-rac': ''
        };
    }, [
        className,
        style,
        children,
        defaultClassName,
        defaultChildren,
        defaultStyle,
        values
    ]);
}
try {
    // @ts-ignore
    NumberFieldContext.displayName = "NumberFieldContext";
    // @ts-ignore
    NumberFieldContext.__docgenInfo = {
        "description": "",
        "displayName": "NumberFieldContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<NumberFieldProps, TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/NumberField.tsx#NumberFieldContext"] = {
        docgenInfo: NumberFieldContext.__docgenInfo,
        name: "NumberFieldContext",
        path: "packages/@react-spectrum/s2/src/NumberField.tsx#NumberFieldContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _NumberField.displayName = "_NumberField";
    // @ts-ignore
    _NumberField.__docgenInfo = {
        "description": "NumberFields allow users to input number values with a keyboard or increment/decrement with step buttons.",
        "displayName": "_NumberField",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "decrementAriaLabel": {
                "defaultValue": null,
                "description": "A custom aria-label for the decrement button. If not provided, the localized string \"Decrement\" is used.",
                "name": "decrementAriaLabel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "formatOptions": {
                "defaultValue": null,
                "description": "Formatting options for the value displayed in the number field.\nThis also affects what characters are allowed to be typed by the user.",
                "name": "formatOptions",
                "required": false,
                "type": {
                    "name": "NumberFormatOptions"
                }
            },
            "hideStepper": {
                "defaultValue": {
                    value: "false"
                },
                "description": "Whether to hide the increment and decrement buttons.",
                "name": "hideStepper",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "incrementAriaLabel": {
                "defaultValue": null,
                "description": "A custom aria-label for the increment button. If not provided, the localized string \"Increment\" is used.",
                "name": "incrementAriaLabel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isWheelDisabled": {
                "defaultValue": null,
                "description": "Enables or disables changing the value with scroll.",
                "name": "isWheelDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxValue": {
                "defaultValue": null,
                "description": "The largest value allowed for the input.",
                "name": "maxValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minValue": {
                "defaultValue": null,
                "description": "The smallest value allowed for the input.",
                "name": "minValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the NumberField.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "step": {
                "defaultValue": null,
                "description": "The amount that the input value changes with each increment or decrement \"tick\".",
                "name": "step",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: number) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: number) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/NumberField.tsx#_NumberField"] = {
        docgenInfo: _NumberField.__docgenInfo,
        name: "_NumberField",
        path: "packages/@react-spectrum/s2/src/NumberField.tsx#_NumberField"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"7MjUi","1":"3ZM9k","2":"DkI9H","3":"kdhhl","4":"6pecq","react/jsx-runtime":"2JzhG","../ui-icons/Add":"1Uyx9","react-aria-components":"8nuKL","react":"jEiK2","@react-spectrum/utils":"bebxO","../ui-icons/Dash":"95EE2","./Field":"9c1qW","@react-aria/utils":"e9Yvo","./Form":"gJckc","./pressScale":"6BiUY","react-aria":"4BEis","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"7MjUi":[function() {},{}],"3ZM9k":[function() {},{}],"DkI9H":[function() {},{}],"kdhhl":[function() {},{}],"6pecq":[function() {},{}],"1Uyx9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Add);
var _jsxRuntime = require("react/jsx-runtime");
var _s2AddSize200Svg = require("./S2_AddSize200.svg");
var _s2AddSize200SvgDefault = parcelHelpers.interopDefault(_s2AddSize200Svg);
var _s2AddSize100Svg = require("./S2_AddSize100.svg");
var _s2AddSize100SvgDefault = parcelHelpers.interopDefault(_s2AddSize100Svg);
var _s2AddSize75Svg = require("./S2_AddSize75.svg");
var _s2AddSize75SvgDefault = parcelHelpers.interopDefault(_s2AddSize75Svg);
var _s2AddSize300Svg = require("./S2_AddSize300.svg");
var _s2AddSize300SvgDefault = parcelHelpers.interopDefault(_s2AddSize300Svg);
var _s2AddSize50Svg = require("./S2_AddSize50.svg");
var _s2AddSize50SvgDefault = parcelHelpers.interopDefault(_s2AddSize50Svg);
function Add(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AddSize100SvgDefault.default), {
                ...otherProps
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AddSize200SvgDefault.default), {
                ...otherProps
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AddSize300SvgDefault.default), {
                ...otherProps
            });
        case 'XS':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AddSize50SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AddSize75SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2JzhG","./S2_AddSize200.svg":"jI592","./S2_AddSize100.svg":"6AXgQ","./S2_AddSize75.svg":"8NQXY","./S2_AddSize300.svg":"bAnQf","./S2_AddSize50.svg":"i6bBh","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"jI592":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AddSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.021 4.959h-2.98v-2.98a1.04 1.04 0 1 0-2.082 0v2.98h-2.98a1.04 1.04 0 1 0 0 2.082h2.98v2.98a1.04 1.04 0 1 0 2.082 0v-2.98h2.98a1.04 1.04 0 1 0 0-2.082"
        })
    });
exports.default = SvgS2AddSize200;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"6AXgQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AddSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M8.5 4H6V1.5a1 1 0 1 0-2 0V4H1.5a1 1 0 1 0 0 2H4v2.5a1 1 0 1 0 2 0V6h2.5a1 1 0 1 0 0-2"
        })
    });
exports.default = SvgS2AddSize100;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"8NQXY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AddSize75 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M7 3.04H4.96V1a.96.96 0 1 0-1.92 0v2.04H1a.96.96 0 1 0 0 1.92h2.04V7a.96.96 0 1 0 1.92 0V4.96H7a.96.96 0 1 0 0-1.92"
        })
    });
exports.default = SvgS2AddSize75;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"bAnQf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AddSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.61 4.915H7.085V1.39a1.084 1.084 0 1 0-2.17 0v3.525H1.39a1.084 1.084 0 1 0 0 2.17h3.525v3.525a1.084 1.084 0 1 0 2.17 0V7.085h3.525a1.084 1.084 0 1 0 0-2.17"
        })
    });
exports.default = SvgS2AddSize300;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"i6bBh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AddSize50 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M6.625 3.078H4.922V1.375a.922.922 0 0 0-1.844 0v1.703H1.375a.922.922 0 0 0 0 1.844h1.703v1.703a.922.922 0 0 0 1.844 0V4.922h1.703a.922.922 0 0 0 0-1.844"
        })
    });
exports.default = SvgS2AddSize50;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kqg2U":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBarContext", ()=>ProgressBarContext);
parcelHelpers.export(exports, "ProgressBar", ()=>_ProgressBar);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _field = require("./Field");
var _runtime = require("../style/runtime");
var _utils = require("@react-spectrum/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ProgressBarContext = /*#__PURE__*/ (0, _react.createContext)(null);
const indeterminateLTR = "-vliq1d";
const indeterminateRTL = "-_167g35";
const wrapper = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $U = false;
    let $q = false;
    let $r = false;
    for (let p of matches){
        if (/^\s*U/.test(p)) $U = true;
        if (/^\s*q/.test(p)) $q = true;
        if (/^\s*r/.test(p)) $r = true;
    }
    if (!$U) rules += ' Uc';
    rules += ' _Zf';
    if (props.isIndeterminate) {
        if (props.labelPosition === "side") rules += ' __h-jyg4vb';
        else if (props.labelPosition === "top") rules += ' __h-375yi6';
    } else {
        if (props.labelPosition === "side") rules += ' __h-jyg4vb';
        else if (props.labelPosition === "top") rules += ' __h-1egg2pz';
    }
    if (props.isIndeterminate) {
        if (props.labelPosition === "side") rules += ' __j-1uh5wa';
        else if (props.labelPosition === "top") rules += ' __j-h9yogq';
    } else {
        if (props.labelPosition === "side") rules += ' __j-7y9rdj';
        else if (props.labelPosition === "top") rules += ' __j-6w8ip8';
    }
    rules += ' _1d';
    rules += ' __Fa';
    if (!$q) rules += ' q_a';
    if (!$r) rules += ' r____________N';
    if (props.size === "XL") rules += ' -aqrvqh_k-j';
    else if (props.size === "L") rules += ' -aqrvqh_k-i';
    else if (props.size === "S") rules += ' -aqrvqh_k-h';
    else if (props.size === "XS") rules += ' -aqrvqh_k-g';
    else rules += ' -aqrvqh_k-f';
    rules += ' -_1urhtf5_k-s';
    rules += ' -_1inj1bc_i--q18lfg';
    rules += ' je';
    return rules;
};
const valueStyles = function anonymous(props) {
    let rules = " .";
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    rules += ' aa_____x';
    if (props.staticColor === "black") rules += ' a_____s';
    else if (props.staticColor === "white") rules += ' a_____d';
    else if (props.isDisabled) rules += ' aj';
    else {
        if (props.isPressed) rules += ' an';
        else if (props.isFocusVisible) rules += ' an';
        else if (props.isHovered) rules += ' an';
        else rules += ' am';
    }
    rules += ' __Hb';
    rules += ' __a-4lc1fm';
    rules += ' __b-4lc1fm';
    rules += ' __c-4lc1fm';
    rules += ' __d-4lc1fm';
    return rules;
};
const trackStyles = function anonymous(props) {
    let rules = " .";
    rules += ' __a-3773ju';
    rules += ' __b-3773ju';
    rules += ' __c-3773ju';
    rules += ' __d-3773ju';
    if (props.size === "XL") rules += ' qj';
    else if (props.size === "L") rules += ' qi';
    else if (props.size === "S") rules += ' qh';
    else if (props.size === "XS") rules += ' qg';
    else rules += ' qf';
    if (props.isQuiet) rules += ' __ma';
    else rules += ' __m-1s8glxue';
    if (props.size === "XL") rules += ' -usygro_l-____g';
    else if (props.size === "L") rules += ' -usygro_l-___0';
    else if (props.size === "S") rules += ' -usygro_l-___u';
    else rules += ' -usygro_l-___K';
    rules += ' m-rwozxi';
    rules += ' __vb';
    rules += ' __wb';
    rules += ' _vf';
    rules += ' _wf';
    rules += ' _xf';
    rules += ' _yf';
    rules += ' ba_____w';
    if (props.staticColor === "black") rules += ' b_____n';
    else if (props.staticColor === "white") rules += ' b____7';
    else rules += ' bi';
    rules += ' _Nab';
    rules += ' _Na';
    rules += ' _Lab';
    rules += ' _La';
    rules += ' da_____x';
    rules += ' da';
    rules += ' __Q-3t1y';
    if (props.size === "XL") rules += ' ky';
    else if (props.size === "L") rules += ' kw';
    else if (props.size === "M") rules += ' ku';
    else if (props.size === "S") rules += ' ks';
    else rules += ' ku';
    return rules;
};
const fill = function anonymous(props) {
    let rules = " .";
    rules += ' kb';
    rules += ' wf';
    rules += ' _vf';
    rules += ' _wf';
    rules += ' _xf';
    rules += ' _yf';
    rules += ' ba_____x';
    if (props.staticColor === "black") rules += ' b_____s';
    else if (props.staticColor === "white") rules += ' b_____f';
    else {
        if (props.isPressed) rules += ' b_____F';
        else if (props.isFocusVisible) rules += ' b_____F';
        else if (props.isHovered) rules += ' b_____F';
        else rules += ' b_____E';
    }
    if (props.isIndeterminate) rules += ' lb';
    if (props.isIndeterminate) rules += ' __Gh';
    return rules;
};
const indeterminateAnimation = function anonymous(props) {
    let rules = " .";
    if (props.direction === "rtl") rules += ' _S-2vmxa6';
    else if (props.direction === "ltr") rules += ' _S-1aanztv';
    rules += ' _T-yjb9nq';
    rules += ' _Ya';
    rules += ' _X-twzmrf';
    rules += ' __Pd';
    rules += ' Uc';
    return rules;
};
function ProgressBar(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ProgressBarContext);
    let { label, size = 'M', staticColor, isIndeterminate, labelPosition = 'top', UNSAFE_style, UNSAFE_className = '' } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let { direction } = (0, _i18N.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ProgressBar), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + wrapper({
            ...props,
            size,
            labelPosition
        }, props.styles),
        children: ({ percentage, valueText })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        size: size,
                        labelAlign: "start",
                        labelPosition: labelPosition,
                        staticColor: staticColor,
                        children: label
                    }),
                    label && !isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: valueStyles({
                            size,
                            labelAlign: 'end',
                            staticColor
                        }),
                        children: valueText
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: trackStyles({
                            ...props
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _runtime.mergeStyles)(fill({
                                ...props,
                                staticColor
                            }), isIndeterminate ? indeterminateAnimation({
                                direction
                            }) : null),
                            style: {
                                width: isIndeterminate ? undefined : percentage + '%'
                            }
                        })
                    })
                ]
            })
    });
}
/**
 * ProgressBars show the progression of a system operation: downloading, uploading, processing, etc., in a visual way.
 * They can represent either determinate or indeterminate progress.
 */ const _ProgressBar = /*#__PURE__*/ (0, _react.forwardRef)(ProgressBar);
try {
    // @ts-ignore
    ProgressBarContext.displayName = "ProgressBarContext";
    // @ts-ignore
    ProgressBarContext.__docgenInfo = {
        "description": "",
        "displayName": "ProgressBarContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ProgressBarProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ProgressBar.tsx#ProgressBarContext"] = {
        docgenInfo: ProgressBarContext.__docgenInfo,
        name: "ProgressBarContext",
        path: "packages/@react-spectrum/s2/src/ProgressBar.tsx#ProgressBarContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ProgressBar.displayName = "_ProgressBar";
    // @ts-ignore
    _ProgressBar.__docgenInfo = {
        "description": "ProgressBars show the progression of a system operation: downloading, uploading, processing, etc., in a visual way.\nThey can represent either determinate or indeterminate progress.",
        "displayName": "_ProgressBar",
        "props": {
            "formatOptions": {
                "defaultValue": {
                    value: "{style: 'percent'}"
                },
                "description": "The display format of the value label.",
                "name": "formatOptions",
                "required": false,
                "type": {
                    "name": "NumberFormatOptions"
                }
            },
            "isIndeterminate": {
                "defaultValue": null,
                "description": "Whether presentation is indeterminate when progress isn't known.",
                "name": "isIndeterminate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxValue": {
                "defaultValue": {
                    value: "100"
                },
                "description": "The largest value allowed for the input.",
                "name": "maxValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minValue": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The smallest value allowed for the input.",
                "name": "minValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ProgressBar.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the button appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "valueLabel": {
                "defaultValue": null,
                "description": "The content to display as the value's label (e.g. 1 of 4).",
                "name": "valueLabel",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ProgressBar.tsx#_ProgressBar"] = {
        docgenInfo: _ProgressBar.__docgenInfo,
        name: "_ProgressBar",
        path: "packages/@react-spectrum/s2/src/ProgressBar.tsx#_ProgressBar"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"kDnLX","1":"gO2Jk","2":"9qav4","3":"fPwEz","4":"c1mky","5":"hZxHV","6":"hL7CV","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","react":"jEiK2","./Field":"9c1qW","../style/runtime":"dzhKB","@react-spectrum/utils":"bebxO","@react-aria/i18n":"hFrKJ","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kDnLX":[function() {},{}],"gO2Jk":[function() {},{}],"9qav4":[function() {},{}],"fPwEz":[function() {},{}],"c1mky":[function() {},{}],"hZxHV":[function() {},{}],"hL7CV":[function() {},{}],"bI0vl":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Radio", ()=>_Radio);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _form = require("./Form");
var _react = require("react");
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
const wrapper = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $__a = false;
    for (let p of matches)if (/^\s*__a/.test(p)) $__a = true;
    rules += ' _Zd';
    rules += ' jF';
    rules += ' _1d';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) {
        rules += ' aa_____B';
        rules += ' aj';
    } else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' _Ob';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    if (!$__a) {
        if (props.isInForm) rules += ' __a-4a7c5l';
    }
    rules += ' __R-yksgrp';
    return rules;
};
const circle = function anonymous(props) {
    let rules = " .";
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    if (props.size === "XL") rules += ' lg';
    else if (props.size === "L") rules += ' lm';
    else if (props.size === "S") rules += ' ll';
    else rules += ' lk';
    rules += ' k-375toq';
    rules += ' _8-3t1x';
    rules += ' _Zd';
    rules += ' _1c';
    rules += ' _2d';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' _vf';
    rules += ' _wf';
    rules += ' _xf';
    rules += ' _yf';
    rules += ' wa';
    rules += ' __na';
    if (props.isSelected) rules += ' u-uyu8pk';
    else rules += ' uc';
    if (props.isSelected) rules += ' v-uyu8pk';
    else rules += ' vc';
    if (props.isSelected) rules += ' s-uyu8pk';
    else rules += ' sc';
    if (props.isSelected) rules += ' t-uyu8pk';
    else rules += ' tc';
    rules += ' _zb';
    rules += ' bd';
    if (props.isDisabled) {
        rules += ' ca_____B';
        rules += ' cj';
    } else if (props.isInvalid) {
        rules += ' ca_____C';
        if (props.isPressed) rules += ' cQ';
        else if (props.isFocusVisible) rules += ' cP';
        else if (props.isHovered) rules += ' cP';
        else rules += ' cO';
    } else if (props.isSelected) {
        rules += ' ca_____z';
        if (props.isEmphasized) {
            if (props.isPressed) rules += ' cz';
            else if (props.isFocusVisible) rules += ' cz';
            else if (props.isHovered) rules += ' cz';
            else rules += ' cy';
        }
    } else {
        rules += ' ca_____v';
        if (props.isPressed) rules += ' co';
        else if (props.isFocusVisible) rules += ' co';
        else if (props.isHovered) rules += ' co';
        else rules += ' cn';
    }
    if (props.size === "XL") rules += ' -_375toq_k-g';
    else if (props.size === "L") rules += ' -_375toq_k-m';
    else if (props.size === "S") rules += ' -_375toq_k-l';
    else rules += ' -_375toq_k-k';
    return rules;
};
function Radio(props, ref) {
    let { children, UNSAFE_className = '', UNSAFE_style } = props;
    let circleRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let isInForm = !!(0, _react.useContext)((0, _form.FormContext));
    let { size = 'M', ...allProps } = (0, _form.useFormProps)(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Radio), {
        ...allProps,
        ref: domRef,
        inputRef: inputRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + wrapper({
                ...renderProps,
                isInForm,
                size
            }, allProps.styles),
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            ref: circleRef,
                            style: (0, _pressScale.pressScale)(circleRef)(renderProps),
                            className: circle({
                                ...renderProps,
                                isEmphasized: allProps.isEmphasized,
                                isSelected: renderProps.isSelected,
                                size
                            })
                        })
                    }),
                    children
                ]
            })
    });
}
/**
 * Radio buttons allow users to select a single option from a list of mutually exclusive options.
 * All possible options are exposed up front for users to compare.
 */ let _Radio = /*#__PURE__*/ (0, _react.forwardRef)(Radio);
try {
    // @ts-ignore
    _Radio.displayName = "_Radio";
    // @ts-ignore
    _Radio.__docgenInfo = {
        "description": "Radio buttons allow users to select a single option from a list of mutually exclusive options.\nAll possible options are exposed up front for users to compare.",
        "displayName": "_Radio",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "The value of the radio button, used when submitting an HTML form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio#Value).",
                "name": "value",
                "required": true,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The label for the element.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "inputRef": {
                "defaultValue": null,
                "description": "A ref for the HTML input element.",
                "name": "inputRef",
                "required": false,
                "type": {
                    "name": "RefObject<HTMLInputElement | null>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the radio button is disabled or not.\nShows that a selection exists, but is not available in that circumstance.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLLabelElement, HTMLLabelElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Radio.tsx#_Radio"] = {
        docgenInfo: _Radio.__docgenInfo,
        name: "_Radio",
        path: "packages/@react-spectrum/s2/src/Radio.tsx#_Radio"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"cFOUT","1":"altAe","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./CenterBaseline":"hXatv","./Form":"gJckc","react":"jEiK2","./pressScale":"6BiUY","@react-spectrum/utils":"bebxO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"cFOUT":[function() {},{}],"altAe":[function() {},{}],"8siyv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioGroupContext", ()=>RadioGroupContext);
parcelHelpers.export(exports, "RadioGroup", ()=>_RadioGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _field = require("./Field");
var _form = require("./Form");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const RadioGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
function RadioGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, RadioGroupContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { label, description, errorMessage, children, isEmphasized, labelPosition = 'top', labelAlign = 'start', necessityIndicator = 'icon', size = 'M', orientation = 'vertical', UNSAFE_className = '', UNSAFE_style, ...groupProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.RadioGroup), {
        ...groupProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " .";
            let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
            rules += matches.join('');
            let $__a = false;
            let $__b = false;
            for (let p of matches){
                if (/^\s*__a/.test(p)) $__a = true;
                if (/^\s*__b/.test(p)) $__b = true;
            }
            rules += ' _Zf';
            if (!$__a) {
                if (props.isInForm) rules += ' __a-3t1y';
            }
            if (!$__b) {
                if (props.isInForm) {
                    if (props.labelPosition === "side") rules += ' __b-7u9dhl';
                }
            }
            if (props.isInForm) rules += ' __h-1cwd7ud';
            else {
                if (props.labelPosition === "side") rules += ' __h-jyg4vb';
                else if (props.labelPosition === "top") rules += ' __h-375yi6';
            }
            if (props.labelPosition === "side") rules += ' __i-jyg4vb';
            else if (props.labelPosition === "top") rules += ' __i-fdenls';
            if (props.labelPosition === "side") rules += ' __j-5eez8j';
            else if (props.labelPosition === "top") rules += ' __j-xlaqir';
            if (props.size === "XL") {
                rules += ' _dbj';
                rules += ' _di';
            } else if (props.size === "L") {
                rules += ' _dbh';
                rules += ' _dg';
            } else if (props.size === "S") {
                rules += ' _dbd';
                rules += ' _dc';
            } else if (props.size === "XS") {
                rules += ' _dbb';
                rules += ' _da';
            } else {
                rules += ' _dbf';
                rules += ' _de';
            }
            rules += ' _1d';
            rules += ' _f-1x99dlob';
            rules += ' _fa';
            if (props.size === "XL") rules += ' -aqrvqh_k-j';
            else if (props.size === "L") rules += ' -aqrvqh_k-i';
            else if (props.size === "S") rules += ' -aqrvqh_k-h';
            else if (props.size === "XS") rules += ' -aqrvqh_k-g';
            else rules += ' -aqrvqh_k-f';
            rules += ' -_1inj1bc_i--vfy389';
            rules += ' je';
            rules += ' __R-yksgrp';
            return rules;
        }({
            size,
            labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: ({ isDisabled, isInvalid })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: function anonymous(props) {
                            let rules = " .";
                            rules += ' __a-4cfph1';
                            rules += ' __b-4cfph1';
                            rules += ' __c-4cfph1';
                            rules += ' __d-4cfph1';
                            rules += ' _Zd';
                            if (props.orientation === "horizontal") rules += ' _6a';
                            else if (props.orientation === "vertical") rules += ' _6b';
                            rules += ' _7a';
                            rules += ' jf';
                            rules += ' i-1inj1bc';
                            return rules;
                        }({
                            orientation
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FormContext).Provider, {
                            value: {
                                ...formContext,
                                size,
                                isEmphasized
                            },
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        showErrorIcon: true,
                        children: errorMessage
                    })
                ]
            })
    });
}
/**
 * Radio groups allow users to select a single option from a list of mutually exclusive options.
 * All possible options are exposed up front for users to compare.
 */ let _RadioGroup = /*#__PURE__*/ (0, _react.forwardRef)(RadioGroup);
try {
    // @ts-ignore
    RadioGroupContext.displayName = "RadioGroupContext";
    // @ts-ignore
    RadioGroupContext.__docgenInfo = {
        "description": "",
        "displayName": "RadioGroupContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<RadioGroupProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/RadioGroup.tsx#RadioGroupContext"] = {
        docgenInfo: RadioGroupContext.__docgenInfo,
        name: "RadioGroupContext",
        path: "packages/@react-spectrum/s2/src/RadioGroup.tsx#RadioGroupContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _RadioGroup.displayName = "_RadioGroup";
    // @ts-ignore
    _RadioGroup.__docgenInfo = {
        "description": "Radio groups allow users to select a single option from a list of mutually exclusive options.\nAll possible options are exposed up front for users to compare.",
        "displayName": "_RadioGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The Radios contained within the RadioGroup.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string | null"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the RadioGroup should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'vertical'"
                },
                "description": "The axis the radio elements should align with.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"vertical\""
                        },
                        {
                            "value": "\"horizontal\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the RadioGroup.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: string | null) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string | null"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: string) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/RadioGroup.tsx#_RadioGroup"] = {
        docgenInfo: _RadioGroup.__docgenInfo,
        name: "_RadioGroup",
        path: "packages/@react-spectrum/s2/src/RadioGroup.tsx#_RadioGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"eq1EX","1":"dgdEC","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./Field":"9c1qW","./Form":"gJckc","react":"jEiK2","@react-spectrum/utils":"bebxO","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"eq1EX":[function() {},{}],"dgdEC":[function() {},{}],"axfe0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeSliderContext", ()=>RangeSliderContext);
parcelHelpers.export(exports, "RangeSlider", ()=>_RangeSlider);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _slider = require("./Slider");
var _form = require("./Form");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const RangeSliderContext = /*#__PURE__*/ (0, _react.createContext)(null);
function RangeSlider(props, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, RangeSliderContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { labelPosition = 'top', size = 'M', isEmphasized, trackStyle = 'thin', thumbStyle = 'default' } = props;
    let lowerThumbRef = (0, _react.useRef)(null);
    let upperThumbRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null); // TODO: need to pass inputRef to SliderThumb when we release the next version of RAC 1.3.0
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let { direction } = (0, _i18N.useLocale)();
    let cssDirection = direction === 'rtl' ? 'right' : 'left';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slider.SliderBase), {
        ...props,
        value: props.value ? [
            props.value.start,
            props.value.end
        ] : undefined,
        defaultValue: props.defaultValue ? [
            props.defaultValue.start,
            props.defaultValue.end
        ] : [
            props.minValue ?? 0,
            props.maxValue ?? 100
        ],
        onChange: (v)=>props.onChange?.({
                start: v[0],
                end: v[1]
            }),
        onChangeEnd: (v)=>props.onChangeEnd?.({
                start: v[0],
                end: v[1]
            }),
        sliderRef: domRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderTrack), {
            className: (0, _slider.track)({
                size,
                labelPosition,
                isInForm: !!formContext
            }),
            children: ({ state, isDisabled })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _slider.upperTrack)({
                                isDisabled,
                                trackStyle
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                width: `${Math.abs(state.getThumbPercent(0) - state.getThumbPercent(1)) * 100}%`,
                                [cssDirection]: `${state.getThumbPercent(0) * 100}%`
                            },
                            className: (0, _slider.filledTrack)({
                                isDisabled,
                                isEmphasized,
                                trackStyle
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderThumb), {
                            className: (0, _slider.thumbContainer),
                            index: 0,
                            name: props.startName,
                            "aria-label": stringFormatter.format('slider.minimum'),
                            ref: lowerThumbRef,
                            style: (renderProps)=>(0, _pressScale.pressScale)(lowerThumbRef, {
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: state.getThumbPercent(0) === 1 ? 1 : undefined
                                })({
                                    ...renderProps,
                                    isPressed: renderProps.isDragging
                                }),
                            children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _slider.thumbHitArea)({
                                        size
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _slider.thumb)({
                                            ...renderProps,
                                            size,
                                            thumbStyle
                                        })
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderThumb), {
                            className: (0, _slider.thumbContainer),
                            index: 1,
                            name: props.endName,
                            "aria-label": stringFormatter.format('slider.maximum'),
                            ref: upperThumbRef,
                            style: (renderProps)=>(0, _pressScale.pressScale)(upperThumbRef, {
                                    transform: 'translate(-50%, -50%)'
                                })({
                                    ...renderProps,
                                    isPressed: renderProps.isDragging
                                }),
                            children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _slider.thumbHitArea)({
                                        size
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _slider.thumb)({
                                            ...renderProps,
                                            size,
                                            thumbStyle
                                        })
                                    })
                                })
                        })
                    ]
                })
        })
    });
}
let _RangeSlider = /*#__PURE__*/ (0, _react.forwardRef)(RangeSlider);
try {
    // @ts-ignore
    RangeSliderContext.displayName = "RangeSliderContext";
    // @ts-ignore
    RangeSliderContext.__docgenInfo = {
        "description": "",
        "displayName": "RangeSliderContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<RangeSliderProps, FocusableRefValue<HTMLDivElement, HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/RangeSlider.tsx#RangeSliderContext"] = {
        docgenInfo: RangeSliderContext.__docgenInfo,
        name: "RangeSliderContext",
        path: "packages/@react-spectrum/s2/src/RangeSlider.tsx#RangeSliderContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _RangeSlider.displayName = "_RangeSlider";
    // @ts-ignore
    _RangeSlider.__docgenInfo = {
        "description": "",
        "displayName": "_RangeSlider",
        "props": {
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "RangeValue<number>"
                }
            },
            "endName": {
                "defaultValue": null,
                "description": "The name of the end input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "endName",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formatOptions": {
                "defaultValue": null,
                "description": "The display format of the value label.",
                "name": "formatOptions",
                "required": false,
                "type": {
                    "name": "NumberFormatOptions"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the whole Slider is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Slider should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxValue": {
                "defaultValue": {
                    value: "100"
                },
                "description": "The slider's maximum value.",
                "name": "maxValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minValue": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The slider's minimum value.",
                "name": "minValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Slider.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "startName": {
                "defaultValue": null,
                "description": "The name of the start input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "startName",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "step": {
                "defaultValue": {
                    value: "1"
                },
                "description": "The slider's step value.",
                "name": "step",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "thumbStyle": {
                "defaultValue": {
                    value: "'default'"
                },
                "description": "The style of the Slider's thumb.",
                "name": "thumbStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"default\""
                        },
                        {
                            "value": "\"precise\""
                        }
                    ]
                }
            },
            "trackStyle": {
                "defaultValue": {
                    value: "'thin'"
                },
                "description": "The style of the Slider's track.",
                "name": "trackStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"thin\""
                        },
                        {
                            "value": "\"thick\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "RangeValue<number>"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: RangeValue<number>) => void)"
                }
            },
            "onChangeEnd": {
                "defaultValue": null,
                "description": "Fired when the slider stops moving, due to being let go.",
                "name": "onChangeEnd",
                "required": false,
                "type": {
                    "name": "((value: RangeValue<number>) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLDivElement, HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/RangeSlider.tsx#_RangeSlider"] = {
        docgenInfo: _RangeSlider.__docgenInfo,
        name: "_RangeSlider",
        path: "packages/@react-spectrum/s2/src/RangeSlider.tsx#_RangeSlider"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","react":"jEiK2","./Slider":"i5lSP","./Form":"gJckc","../intl/*.json":"iU6xz","./pressScale":"6BiUY","@react-spectrum/utils":"bebxO","@react-aria/i18n":"hFrKJ","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kpN9o":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchFieldContext", ()=>SearchFieldContext);
parcelHelpers.export(exports, "SearchField", ()=>_SearchField);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _clearButton = require("./ClearButton");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _field = require("./Field");
var _form = require("./Form");
var _icon = require("./Icon");
var _s2IconSearch20NSvg = require("../s2wf-icons/S2_Icon_Search_20_N.svg");
var _s2IconSearch20NSvgDefault = parcelHelpers.interopDefault(_s2IconSearch20NSvg);
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const SearchFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
function SearchField(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, SearchFieldContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { label, description, errorMessage, necessityIndicator, labelPosition = 'top', labelAlign = 'start', UNSAFE_className = '', UNSAFE_style, ...searchFieldProps } = props;
    let domRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    // Expose imperative interface for ref
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SearchField), {
        ...searchFieldProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " .";
            let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
            rules += matches.join('');
            let $__a = false;
            let $__b = false;
            for (let p of matches){
                if (/^\s*__a/.test(p)) $__a = true;
                if (/^\s*__b/.test(p)) $__b = true;
            }
            rules += ' _Zf';
            if (!$__a) {
                if (props.isInForm) rules += ' __a-3t1y';
            }
            if (!$__b) {
                if (props.isInForm) {
                    if (props.labelPosition === "side") rules += ' __b-7u9dhl';
                }
            }
            if (props.isInForm) rules += ' __h-1cwd7ud';
            else {
                if (props.labelPosition === "side") rules += ' __h-jyg4vb';
                else if (props.labelPosition === "top") rules += ' __h-375yi6';
            }
            if (props.labelPosition === "side") rules += ' __i-jyg4vb';
            else if (props.labelPosition === "top") rules += ' __i-fdenls';
            if (props.labelPosition === "side") rules += ' __j-5eez8j';
            else if (props.labelPosition === "top") rules += ' __j-xlaqir';
            if (props.size === "XL") {
                rules += ' _dbj';
                rules += ' _di';
            } else if (props.size === "L") {
                rules += ' _dbh';
                rules += ' _dg';
            } else if (props.size === "S") {
                rules += ' _dbd';
                rules += ' _dc';
            } else if (props.size === "XS") {
                rules += ' _dbb';
                rules += ' _da';
            } else {
                rules += ' _dbf';
                rules += ' _de';
            }
            rules += ' _1d';
            rules += ' _f-1x99dlob';
            rules += ' _fa';
            if (props.size === "XL") rules += ' -aqrvqh_k-j';
            else if (props.size === "L") rules += ' -aqrvqh_k-i';
            else if (props.size === "S") rules += ' -aqrvqh_k-h';
            else if (props.size === "XS") rules += ' -aqrvqh_k-g';
            else rules += ' -aqrvqh_k-f';
            rules += ' -_1inj1bc_i--prjw07';
            rules += ' je';
            rules += ' __R-yksgrp';
            rules += ' -oelgqu_A--177861o';
            if (props.isDisabled) {
                rules += ' aa_____B';
                rules += ' aj';
            } else {
                if (props.isPressed) rules += ' ao';
                else if (props.isFocusVisible) rules += ' ao';
                else if (props.isHovered) rules += ' ao';
                else rules += ' an';
            }
            return rules;
        }({
            size: props.size,
            labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: ({ isDisabled, isInvalid, isEmpty })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: props.size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        isDisabled: isDisabled,
                        size: props.size,
                        styles: " . _vf _wf _xf _yf CJ Da",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                values: [
                                    [
                                        (0, _icon.IconContext),
                                        {
                                            render: (0, _centerBaseline.centerBaseline)({
                                                slot: 'icon',
                                                styles: " . _8-3t1x zG zbH -rwx0fg_e-b"
                                            }),
                                            styles: " . l-1sthc3k k-1sthc3k y-oelgqu"
                                        }
                                    ]
                                ],
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconSearch20NSvgDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {
                                ref: inputRef,
                                UNSAFE_className: "-_1wbkwcp"
                            }),
                            !isEmpty && !searchFieldProps.isReadOnly && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearButton.ClearButton), {
                                size: props.size
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: props.size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        children: errorMessage
                    })
                ]
            })
    });
}
/**
 * A SearchField is a text field designed for searches.
 */ let _SearchField = /*#__PURE__*/ (0, _react.forwardRef)(SearchField);
try {
    // @ts-ignore
    SearchFieldContext.displayName = "SearchFieldContext";
    // @ts-ignore
    SearchFieldContext.__docgenInfo = {
        "description": "",
        "displayName": "SearchFieldContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<SearchFieldProps, TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/SearchField.tsx#SearchFieldContext"] = {
        docgenInfo: SearchFieldContext.__docgenInfo,
        name: "SearchFieldContext",
        path: "packages/@react-spectrum/s2/src/SearchField.tsx#SearchFieldContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _SearchField.displayName = "_SearchField";
    // @ts-ignore
    _SearchField.__docgenInfo = {
        "description": "A SearchField is a text field designed for searches.",
        "displayName": "_SearchField",
        "props": {
            "autoComplete": {
                "defaultValue": null,
                "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
                "name": "autoComplete",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inputMode": {
                "defaultValue": null,
                "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
                "name": "inputMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"decimal\""
                        },
                        {
                            "value": "\"text\""
                        },
                        {
                            "value": "\"url\""
                        },
                        {
                            "value": "\"tel\""
                        },
                        {
                            "value": "\"email\""
                        },
                        {
                            "value": "\"numeric\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxLength": {
                "defaultValue": null,
                "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
                "name": "maxLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minLength": {
                "defaultValue": null,
                "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
                "name": "minLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "pattern": {
                "defaultValue": null,
                "description": "Regex pattern that the value of the input must match to be valid. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefpattern).",
                "name": "pattern",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the SearchField.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "type": {
                "defaultValue": null,
                "description": "The type of input to render. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdeftype).",
                "name": "type",
                "required": false,
                "type": {
                    "name": "\"search\" | \"text\" | (string & {}) | \"url\" | \"tel\" | \"email\" | \"password\""
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: string) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: string) => void)"
                }
            },
            "onClear": {
                "defaultValue": null,
                "description": "Handler that is called when the clear button is pressed.",
                "name": "onClear",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onSubmit": {
                "defaultValue": null,
                "description": "Handler that is called when the SearchField is submitted.",
                "name": "onSubmit",
                "required": false,
                "type": {
                    "name": "((value: string) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/SearchField.tsx#_SearchField"] = {
        docgenInfo: _SearchField.__docgenInfo,
        name: "_SearchField",
        path: "packages/@react-spectrum/s2/src/SearchField.tsx#_SearchField"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"4UfPn","1":"fP0Ro","2":"bp298","3":"gZZu7","4":"1WqTf","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./CenterBaseline":"hXatv","./ClearButton":"ebNWz","react":"jEiK2","@react-spectrum/utils":"bebxO","./Field":"9c1qW","./Form":"gJckc","./Icon":"1OC2a","../s2wf-icons/S2_Icon_Search_20_N.svg":"jIF01","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"4UfPn":[function() {},{}],"fP0Ro":[function() {},{}],"bp298":[function() {},{}],"gZZu7":[function() {},{}],"1WqTf":[function() {},{}],"ebNWz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClearButton", ()=>_ClearButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _cross = require("../ui-icons/Cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _react = require("react");
var _utils = require("@react-spectrum/utils");
function ClearButton(props, ref) {
    let domRef = (0, _utils.useFocusableRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        ref: domRef,
        className: (renderProps)=>(function anonymous(props) {
                let rules = " .";
                rules += ' _Zd';
                rules += ' _1c';
                rules += ' _2d';
                rules += ' kb';
                if (props.size === "XL") rules += ' lj';
                else if (props.size === "L") rules += ' li';
                else if (props.size === "S") rules += ' lh';
                else if (props.size === "XS") rules += ' lg';
                else rules += ' lf';
                rules += ' _8-3t1x';
                rules += ' wf';
                rules += ' _La';
                rules += ' ba';
                rules += ' Ea';
                rules += ' Fa';
                rules += ' Ca';
                rules += ' Da';
                rules += ' a-17zqamw';
                rules += ' -rwx0fg_e-b';
                return rules;
            })({
                ...renderProps,
                size: props.size || 'M'
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossDefault.default), {
            size: props.size || 'M'
        })
    });
}
let _ClearButton = /*#__PURE__*/ (0, _react.forwardRef)(ClearButton);
try {
    // @ts-ignore
    _ClearButton.displayName = "_ClearButton";
    // @ts-ignore
    _ClearButton.__docgenInfo = {
        "description": "",
        "displayName": "_ClearButton",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The children of the component. A function may be provided to alter the children based on component state.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((values: ButtonRenderProps & { defaultChildren: ReactNode; }) => ReactNode)"
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string | ((values: ButtonRenderProps & { defaultClassName: string; }) => string)"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "form": {
                "defaultValue": null,
                "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.",
                "name": "form",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formAction": {
                "defaultValue": null,
                "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
                "name": "formAction",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formEncType": {
                "defaultValue": null,
                "description": "Indicates how to encode the form data that is submitted.",
                "name": "formEncType",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formMethod": {
                "defaultValue": null,
                "description": "Indicates the HTTP method used to submit the form.",
                "name": "formMethod",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formNoValidate": {
                "defaultValue": null,
                "description": "Indicates that the form is not to be validated when it is submitted.",
                "name": "formNoValidate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "formTarget": {
                "defaultValue": null,
                "description": "Overrides the target attribute of the button's form owner.",
                "name": "formTarget",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the button is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isPending": {
                "defaultValue": null,
                "description": "Whether the button is in a pending state. This disables press and hover events\nwhile retaining focusability, and announces the pending state to screen readers.",
                "name": "isPending",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "Submitted as a pair with the button's value as part of the form data.",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "preventFocusOnPress": {
                "defaultValue": null,
                "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
                "name": "preventFocusOnPress",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ClearButton.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties | ((values: ButtonRenderProps & { defaultStyle: CSSProperties; }) => CSSProperties)"
                }
            },
            "type": {
                "defaultValue": {
                    value: "'button'"
                },
                "description": "The behavior of the button when used in an HTML form.",
                "name": "type",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"button\""
                        },
                        {
                            "value": "\"submit\""
                        },
                        {
                            "value": "\"reset\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The value associated with the button's name when it's submitted with the form data.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onPress": {
                "defaultValue": null,
                "description": "Handler that is called when the press is released over the target.",
                "name": "onPress",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressChange": {
                "defaultValue": null,
                "description": "Handler that is called when the press state changes.",
                "name": "onPressChange",
                "required": false,
                "type": {
                    "name": "((isPressed: boolean) => void)"
                }
            },
            "onPressEnd": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
                "name": "onPressEnd",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressStart": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction starts.",
                "name": "onPressStart",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressUp": {
                "defaultValue": null,
                "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
                "name": "onPressUp",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ClearButton.tsx#_ClearButton"] = {
        docgenInfo: _ClearButton.__docgenInfo,
        name: "_ClearButton",
        path: "packages/@react-spectrum/s2/src/ClearButton.tsx#_ClearButton"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"3sDDl","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","../ui-icons/Cross":"dcfAa","react":"jEiK2","@react-spectrum/utils":"bebxO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"3sDDl":[function() {},{}],"jIF01":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.53 17.47-5.083-5.084C14.417 11.186 15 9.66 15 8c0-3.86-3.14-7-7-7S1 4.14 1 8s3.14 7 7 7c1.66 0 3.185-.584 4.386-1.553l5.084 5.083c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M8 13.5c-3.032 0-5.5-2.468-5.5-5.5S4.968 2.5 8 2.5s5.5 2.468 5.5 5.5-2.468 5.5-5.5 5.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef, (0, _icon.IconContext));

},{"react/jsx-runtime":"2JzhG","~/src/Icon":"1OC2a","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"5WxQe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SegmentedControlContext", ()=>SegmentedControlContext);
parcelHelpers.export(exports, "SegmentedControlItem", ()=>_SegmentedControlItem);
parcelHelpers.export(exports, "SegmentedControl", ()=>_SegmentedControl);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _icon = require("./Icon");
var _pressScale = require("./pressScale");
var _content = require("./Content");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const SegmentedControlContext = /*#__PURE__*/ (0, _react.createContext)(null);
const segmentedControl = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $l = false;
    for (let p of matches)if (/^\s*l/.test(p)) $l = true;
    rules += ' _Zd';
    rules += ' ic';
    rules += ' jc';
    rules += ' bg';
    rules += ' _vc';
    rules += ' _wc';
    rules += ' _xc';
    rules += ' _yc';
    if (!$l) rules += ' le';
    return rules;
};
const controlItem = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $U = false;
    let $_9 = false;
    let $h = false;
    let $_8 = false;
    let $q = false;
    for (let p of matches){
        if (/^\s*U/.test(p)) $U = true;
        if (/^\s*_9/.test(p)) $_9 = true;
        if (/^\s*h/.test(p)) $h = true;
        if (/^\s*_8/.test(p)) $_8 = true;
        if (/^\s*q/.test(p)) $q = true;
    }
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    if (!$U) rules += ' Uc';
    rules += ' _Zd';
    rules += ' _zb';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isSelected) rules += ' aa_____A';
    else if (props.isDisabled) rules += ' aa_____B';
    else rules += ' aa_____x';
    if (props.isDisabled) rules += ' aj';
    else if (props.isSelected) {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    } else if (props.isHovered) {
        if (props.isPressed) rules += ' an';
        else if (props.isFocusVisible) rules += ' an';
        else if (props.isHovered) rules += ' an';
        else rules += ' am';
    } else rules += ' am';
    rules += ' C-soocic-6njx2e';
    rules += ' CI';
    rules += ' D-soocic-6njx2e';
    rules += ' DI';
    rules += ' k-375toq';
    rules += ' _1c';
    if (!$_9) {
        if (props.isJustified) rules += ' _9-3t1y';
    }
    if (!$h) {
        if (props.isJustified) rules += ' ha';
    }
    if (!$_8) rules += ' _8-3t1x';
    if (!$q) rules += ' qo';
    rules += ' _2d';
    rules += ' _pb';
    rules += ' __R-yksgrp';
    rules += ' __Da';
    rules += ' ba';
    rules += ' wf';
    rules += ' _vc';
    rules += ' _wc';
    rules += ' _xc';
    rules += ' _yc';
    rules += ' -rwx0fg_e-b';
    rules += ' -_375toq_k-U';
    return rules;
};
const slider = function anonymous(props) {
    let rules = " .";
    if (props.isDisabled) rules += ' ba_____B';
    else rules += ' ba_____z';
    rules += ' bd';
    rules += ' Ya';
    rules += ' lb';
    rules += ' kb';
    rules += ' Ua';
    rules += ' __na';
    rules += ' wa';
    rules += ' uc';
    rules += ' vc';
    rules += ' sc';
    rules += ' tc';
    if (props.isDisabled) rules += ' ca_____B';
    else rules += ' ca_____z';
    if (props.isDisabled) rules += ' ci';
    else rules += ' co';
    rules += ' _vd';
    rules += ' _wd';
    rules += ' _xd';
    rules += ' _yd';
    return rules;
};
const InternalSegmentedControlContext = /*#__PURE__*/ (0, _react.createContext)({});
function SegmentedControl(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, SegmentedControlContext);
    let { defaultSelectedKey, selectedKey, onSelectionChange } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let prevRef = (0, _react.useRef)(null);
    let currentSelectedRef = (0, _react.useRef)(null);
    let onChange = (values)=>{
        if (currentSelectedRef.current) prevRef.current = currentSelectedRef?.current.getBoundingClientRect();
        if (onSelectionChange) onSelectionChange(values.values().next().value);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ToggleButtonGroup), {
        ...props,
        selectedKeys: selectedKey != null ? [
            selectedKey
        ] : undefined,
        defaultSelectedKeys: defaultSelectedKey != null ? [
            defaultSelectedKey
        ] : undefined,
        disallowEmptySelection: true,
        ref: domRef,
        orientation: "horizontal",
        style: props.UNSAFE_style,
        onSelectionChange: onChange,
        className: (props.UNSAFE_className || '') + segmentedControl(null, props.styles),
        "aria-label": props['aria-label'],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DefaultSelectionTracker, {
            defaultValue: defaultSelectedKey,
            value: selectedKey,
            prevRef: prevRef,
            currentSelectedRef: currentSelectedRef,
            isJustified: props.isJustified,
            children: props.children
        })
    });
}
function DefaultSelectionTracker(props) {
    let state = (0, _react.useContext)((0, _reactAriaComponents.ToggleGroupStateContext));
    let isRegistered = (0, _react.useRef)(!(props.defaultValue == null && props.value == null));
    // default select the first available item
    let register = (0, _react.useCallback)((value)=>{
        if (state && !isRegistered.current) {
            isRegistered.current = true;
            state.toggleKey(value);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                InternalSegmentedControlContext,
                {
                    register: register,
                    prevRef: props.prevRef,
                    currentSelectedRef: props.currentSelectedRef,
                    isJustified: props.isJustified
                }
            ]
        ],
        children: props.children
    });
}
function SegmentedControlItem(props, ref) {
    let domRef = (0, _utils.useFocusableRef)(ref);
    let divRef = (0, _react.useRef)(null);
    let { register, prevRef, currentSelectedRef, isJustified } = (0, _react.useContext)(InternalSegmentedControlContext);
    let state = (0, _react.useContext)((0, _reactAriaComponents.ToggleGroupStateContext));
    let isSelected = state?.selectedKeys.has(props.id);
    // do not apply animation if a user has the prefers-reduced-motion setting
    let isReduced = false;
    if (window?.matchMedia) isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    (0, _utils1.useLayoutEffect)(()=>{
        register?.(props.id);
    }, []);
    (0, _utils1.useLayoutEffect)(()=>{
        if (isSelected && prevRef?.current && currentSelectedRef?.current && !isReduced) {
            let currentItem = currentSelectedRef?.current.getBoundingClientRect();
            let deltaX = prevRef?.current.left - currentItem?.left;
            currentSelectedRef.current.animate([
                {
                    transform: `translateX(${deltaX}px)`,
                    width: `${prevRef?.current.width}px`
                },
                {
                    transform: 'translateX(0px)',
                    width: `${currentItem.width}px`
                }
            ], {
                duration: 200,
                easing: 'ease-out'
            });
            prevRef.current = null;
        }
    }, [
        isSelected
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ToggleButton), {
        ...props,
        ref: domRef,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + controlItem({
                ...renderProps,
                isJustified
            }, props.styles),
        children: ({ isSelected, isPressed, isDisabled })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: slider({
                            isDisabled
                        }),
                        ref: currentSelectedRef
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _icon.IconContext),
                                {
                                    render: (0, _centerBaseline.centerBaseline)({
                                        slot: 'icon',
                                        styles: " . __A-3t1x _8-3t1x"
                                    })
                                }
                            ],
                            [
                                (0, _reactAriaComponents.TextContext),
                                {
                                    slots: {
                                        [(0, _reactAriaComponents.DEFAULT_SLOT)]: {}
                                    }
                                }
                            ],
                            [
                                (0, _content.TextContext),
                                {
                                    styles: " . __A-3t1y __vb __wb _ma _pb"
                                }
                            ]
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            ref: divRef,
                            style: (0, _pressScale.pressScale)(divRef)({
                                isPressed
                            }),
                            className: " . _Zd iG ibH jG jbH _Oa _Q-375x7f _Ra _1c qo",
                            children: typeof props.children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                                children: props.children
                            }) : props.children
                        })
                    })
                ]
            })
    });
}
/**
 * A SegmentedControlItem represents an option within a SegmentedControl.
 */ const _SegmentedControlItem = /*#__PURE__*/ (0, _react.forwardRef)(SegmentedControlItem);
/**
 * A SegmentedControl is a mutually exclusive group of buttons used for view switching.
 */ const _SegmentedControl = /*#__PURE__*/ (0, _react.forwardRef)(SegmentedControl);
try {
    // @ts-ignore
    SegmentedControlContext.displayName = "SegmentedControlContext";
    // @ts-ignore
    SegmentedControlContext.__docgenInfo = {
        "description": "",
        "displayName": "SegmentedControlContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<SegmentedControlProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/SegmentedControl.tsx#SegmentedControlContext"] = {
        docgenInfo: SegmentedControlContext.__docgenInfo,
        name: "SegmentedControlContext",
        path: "packages/@react-spectrum/s2/src/SegmentedControl.tsx#SegmentedControlContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _SegmentedControlItem.displayName = "_SegmentedControlItem";
    // @ts-ignore
    _SegmentedControlItem.__docgenInfo = {
        "description": "A SegmentedControlItem represents an option within a SegmentedControl.",
        "displayName": "_SegmentedControlItem",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the segmented control item.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the item is disabled or not.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/SegmentedControl.tsx#_SegmentedControlItem"] = {
        docgenInfo: _SegmentedControlItem.__docgenInfo,
        name: "_SegmentedControlItem",
        path: "packages/@react-spectrum/s2/src/SegmentedControl.tsx#_SegmentedControlItem"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _SegmentedControl.displayName = "_SegmentedControl";
    // @ts-ignore
    _SegmentedControl.__docgenInfo = {
        "description": "A SegmentedControl is a mutually exclusive group of buttons used for view switching.",
        "displayName": "_SegmentedControl",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the segmented control.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelectedKey": {
                "defaultValue": null,
                "description": "The id of the initial selected item (uncontrolled).",
                "name": "defaultSelectedKey",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the segmented control is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isJustified": {
                "defaultValue": null,
                "description": "Whether the items should divide the container width equally.",
                "name": "isJustified",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "selectedKey": {
                "defaultValue": null,
                "description": "The id of the currently selected item (controlled).",
                "name": "selectedKey",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((id: Key) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/SegmentedControl.tsx#_SegmentedControl"] = {
        docgenInfo: _SegmentedControl.__docgenInfo,
        name: "_SegmentedControl",
        path: "packages/@react-spectrum/s2/src/SegmentedControl.tsx#_SegmentedControl"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"bCnhU","1":"1rjd3","2":"9vZhv","3":"747eo","4":"e8rXV","5":"bvzqU","react/jsx-runtime":"2JzhG","./CenterBaseline":"hXatv","react-aria-components":"8nuKL","react":"jEiK2","./Icon":"1OC2a","./pressScale":"6BiUY","./Content":"aBWEm","@react-spectrum/utils":"bebxO","@react-aria/utils":"e9Yvo","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"bCnhU":[function() {},{}],"1rjd3":[function() {},{}],"9vZhv":[function() {},{}],"747eo":[function() {},{}],"e8rXV":[function() {},{}],"bvzqU":[function() {},{}],"lVjiz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkeletonCollection", ()=>SkeletonCollection);
var _jsxRuntime = require("react/jsx-runtime");
var _collections = require("@react-aria/collections");
var _skeleton = require("./Skeleton");
let cache = new WeakMap();
const SkeletonCollection = (0, _collections.createLeafComponent)('skeleton', (props, ref, node)=>{
    // Cache rendering based on node object identity. This allows the children function to randomize
    // its content (e.g. heights) and preserve on re-renders.
    // TODO: do we need a `dependencies` prop here?
    let cached = cache.get(node);
    if (!cached) {
        cached = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.Skeleton), {
            isLoading: true,
            children: props.children()
        });
        cache.set(node, cached);
    }
    return cached;
});
try {
    // @ts-ignore
    SkeletonCollection.displayName = "SkeletonCollection";
    // @ts-ignore
    SkeletonCollection.__docgenInfo = {
        "description": "A SkeletonCollection generates placeholder content within a collection component such as CardView.",
        "displayName": "SkeletonCollection",
        "props": {
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<object>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/SkeletonCollection.tsx#SkeletonCollection"] = {
        docgenInfo: SkeletonCollection.__docgenInfo,
        name: "SkeletonCollection",
        path: "packages/@react-spectrum/s2/src/SkeletonCollection.tsx#SkeletonCollection"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"react/jsx-runtime":"2JzhG","@react-aria/collections":"1Wqew","./Skeleton":"2hWWB","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"3dgNy":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusLightContext", ()=>StatusLightContext);
parcelHelpers.export(exports, "StatusLight", ()=>_StatusLight);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _content = require("./Content");
var _utils1 = require("@react-spectrum/utils");
var _skeleton = require("./Skeleton");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const StatusLightContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $l = false;
    for (let p of matches)if (/^\s*l/.test(p)) $l = true;
    rules += ' _Zd';
    rules += ' ibH';
    rules += ' iG';
    rules += ' jbH';
    rules += ' jG';
    rules += ' _1d';
    if (!$l) rules += ' le';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.variant === "neutral") rules += ' al';
    else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' __R-yksgrp';
    return rules;
};
const light = function anonymous(props) {
    let rules = " .";
    if (props.size === "XL") rules += ' lC';
    else if (props.size === "L") rules += ' lA';
    else if (props.size === "M") rules += ' ly';
    else if (props.size === "S") rules += ' lw';
    if (props.size === "XL") rules += ' kC';
    else if (props.size === "L") rules += ' kA';
    else if (props.size === "M") rules += ' ky';
    else if (props.size === "S") rules += ' kw';
    if (props.isSkeleton) rules += ' eF';
    else if (props.variant === "silver") rules += ' ex';
    else if (props.variant === "brown") rules += ' ew';
    else if (props.variant === "cinnamon") rules += ' ev';
    else if (props.variant === "turquoise") rules += ' eu';
    else if (props.variant === "pink") rules += ' et';
    else if (props.variant === "yellow") rules += ' ej';
    else if (props.variant === "seafoam") rules += ' en';
    else if (props.variant === "indigo") rules += ' ep';
    else if (props.variant === "magenta") rules += ' es';
    else if (props.variant === "purple") rules += ' eq';
    else if (props.variant === "fuchsia") rules += ' er';
    else if (props.variant === "cyan") rules += ' eo';
    else if (props.variant === "chartreuse") rules += ' ek';
    else if (props.variant === "celery") rules += ' el';
    else if (props.variant === "negative") rules += ' ee';
    else if (props.variant === "notice") rules += ' eg';
    else if (props.variant === "positive") rules += ' ef';
    else if (props.variant === "neutral") rules += ' ed';
    else if (props.variant === "informative") rules += ' ec';
    rules += ' __vd';
    rules += ' __wd';
    return rules;
};
function StatusLight(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, StatusLightContext);
    let { children, size = 'M', variant, role, UNSAFE_className = '', UNSAFE_style, styles } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isSkeleton = (0, _skeleton.useIsSkeleton)();
    if (!children && !props['aria-label']) console.warn('If no children are provided, an aria-label must be specified');
    if (!role && (props['aria-label'] || props['aria-labelledby'])) console.warn('A labelled StatusLight must have a role.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...(0, _utils.filterDOMProps)(props, {
            labelable: !!role
        }),
        ref: domRef,
        role: role,
        style: UNSAFE_style,
        className: UNSAFE_className + wrapper({
            size,
            variant
        }, styles),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    className: light({
                        size,
                        variant,
                        isSkeleton
                    }),
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        r: "50%",
                        cx: "50%",
                        cy: "50%"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                children: children
            })
        ]
    });
}
/**
 * Status lights are used to color code categories and labels commonly found in data visualization.
 * When status lights have a semantic meaning, they should use semantic variant colors.
 */ let _StatusLight = /*#__PURE__*/ (0, _react.forwardRef)(StatusLight);
try {
    // @ts-ignore
    StatusLightContext.displayName = "StatusLightContext";
    // @ts-ignore
    StatusLightContext.__docgenInfo = {
        "description": "",
        "displayName": "StatusLightContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<StatusLightProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/StatusLight.tsx#StatusLightContext"] = {
        docgenInfo: StatusLightContext.__docgenInfo,
        name: "StatusLightContext",
        path: "packages/@react-spectrum/s2/src/StatusLight.tsx#StatusLightContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _StatusLight.displayName = "_StatusLight";
    // @ts-ignore
    _StatusLight.__docgenInfo = {
        "description": "Status lights are used to color code categories and labels commonly found in data visualization.\nWhen status lights have a semantic meaning, they should use semantic variant colors.",
        "displayName": "_StatusLight",
        "props": {
            "variant": {
                "defaultValue": null,
                "description": "The variant changes the color of the status light.\nWhen status lights have a semantic meaning, they should use the variant for semantic colors.",
                "name": "variant",
                "required": true,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"informative\""
                        },
                        {
                            "value": "\"positive\""
                        },
                        {
                            "value": "\"notice\""
                        },
                        {
                            "value": "\"negative\""
                        },
                        {
                            "value": "\"neutral\""
                        },
                        {
                            "value": "\"yellow\""
                        },
                        {
                            "value": "\"chartreuse\""
                        },
                        {
                            "value": "\"celery\""
                        },
                        {
                            "value": "\"seafoam\""
                        },
                        {
                            "value": "\"cyan\""
                        },
                        {
                            "value": "\"indigo\""
                        },
                        {
                            "value": "\"purple\""
                        },
                        {
                            "value": "\"fuchsia\""
                        },
                        {
                            "value": "\"magenta\""
                        },
                        {
                            "value": "\"pink\""
                        },
                        {
                            "value": "\"turquoise\""
                        },
                        {
                            "value": "\"brown\""
                        },
                        {
                            "value": "\"silver\""
                        },
                        {
                            "value": "\"cinnamon\""
                        }
                    ]
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "role": {
                "defaultValue": null,
                "description": "An accessibility role for the status light. Should be set when the status\ncan change at runtime, and no more than one status light will update simultaneously.\nFor cases where multiple statuses can change at the same time, use a Toast instead.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"status\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the StatusLight.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/StatusLight.tsx#_StatusLight"] = {
        docgenInfo: _StatusLight.__docgenInfo,
        name: "_StatusLight",
        path: "packages/@react-spectrum/s2/src/StatusLight.tsx#_StatusLight"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"8bHzQ","1":"eXB1e","react/jsx-runtime":"2JzhG","./CenterBaseline":"hXatv","react":"jEiK2","@react-aria/utils":"e9Yvo","./Content":"aBWEm","@react-spectrum/utils":"bebxO","./Skeleton":"2hWWB","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"8bHzQ":[function() {},{}],"eXB1e":[function() {},{}],"8IIR1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwitchContext", ()=>SwitchContext);
parcelHelpers.export(exports, "Switch", ()=>_Switch);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _react = require("react");
var _form = require("./Form");
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const SwitchContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $l = false;
    let $__a = false;
    for (let p of matches){
        if (/^\s*l/.test(p)) $l = true;
        if (/^\s*__a/.test(p)) $__a = true;
    }
    rules += ' _Zd';
    rules += ' jF';
    rules += ' _1d';
    if (!$l) rules += ' le';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) {
        rules += ' aa_____B';
        rules += ' aj';
    } else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' _Ob';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    if (!$__a) {
        if (props.isInForm) rules += ' __a-4a7c5l';
    }
    rules += ' __R-yksgrp';
    return rules;
};
const track = function anonymous(props) {
    let rules = " .";
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    rules += ' _vf';
    rules += ' _wf';
    rules += ' _xf';
    rules += ' _yf';
    rules += ' -rcxrzo_l--unb2ci';
    if (props.size === "XL") rules += ' -_14pdrm5_k-g';
    else if (props.size === "L") rules += ' -_14pdrm5_k-m';
    else if (props.size === "S") rules += ' -_14pdrm5_k-l';
    else rules += ' -_14pdrm5_k-k';
    rules += ' l-rcxrzo';
    rules += ' k-14pdrm5';
    rules += ' __na';
    rules += ' uc';
    rules += ' vc';
    rules += ' sc';
    rules += ' tc';
    rules += ' wa';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' _zb';
    if (props.isSelected) rules += ' ca';
    else if (props.isDisabled) {
        rules += ' ca_____B';
        rules += ' cj';
    } else {
        rules += ' ca_____v';
        if (props.isPressed) rules += ' co';
        else if (props.isFocusVisible) rules += ' co';
        else if (props.isHovered) rules += ' co';
        else rules += ' cn';
    }
    if (props.isSelected) {
        if (props.isDisabled) {
            rules += ' ba_____B';
            rules += ' bj';
        } else {
            rules += ' ba_____z';
            if (props.isEmphasized) {
                if (props.isPressed) rules += ' bz';
                else if (props.isFocusVisible) rules += ' bz';
                else if (props.isHovered) rules += ' bz';
                else rules += ' by';
            } else {
                if (props.isPressed) rules += ' bo';
                else if (props.isFocusVisible) rules += ' bo';
                else if (props.isHovered) rules += ' bo';
                else rules += ' bn';
            }
        }
    } else rules += ' bd';
    return rules;
};
const handle = function anonymous(props) {
    let rules = " .";
    rules += ' kb';
    rules += ' _bb';
    rules += ' _vf';
    rules += ' _wf';
    rules += ' _xf';
    rules += ' _yf';
    if (props.isSelected) rules += ' bd';
    else if (props.isDisabled) {
        rules += ' ba_____B';
        rules += ' bj';
    } else {
        if (props.isPressed) rules += ' bo';
        else if (props.isFocusVisible) rules += ' bo';
        else if (props.isHovered) rules += ' bo';
        else rules += ' bn';
    }
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    return rules;
};
// Use an inline style to calculate the transform so we can combine it with the press scale.
const transformStyle = ({ isSelected })=>({
        // In the default state, the handle is 8px smaller than the track. When selected it grows to 6px smaller than the track.
        // Normally this could be calculated as a scale transform with (trackHeight - 8px) / trackHeight, however,
        // CSS does not allow division with units. To solve this we use a 3d perspective transform. Perspective is the
        // distance from the Z=0 plane to the viewer. Since we want to scale the handle by a fixed amount and we cannot divide
        // by a value with units, we can set the Z translation to a fixed amount and change the perspective in order to achieve
        // the desired effect. Given the following formula:
        //
        //   scale = perspective / (perspective - translateZ)
        //
        // and desired scale factors (accounting for the 2px border on each side of the track):
        //
        //   defaultScale = (trackHeight - 8px) / (trackHeight - 4px)
        //   selectedScale = (trackHeight - 6px) / (trackHeight - 4px)
        //
        // we can solve for the perspective needed in each case where translateZ is hard coded to -4px:
        //
        //    defaultPerspective = trackHeight - 8px
        //    selectedPerspective = 2 * (trackHeight - 6px)
        transform: isSelected ? 'translateX(calc(var(--trackWidth) - 100% - 4px)) perspective(calc(2 * (var(--trackHeight) - 6px))) translateZ(-4px)' : 'perspective(calc(var(--trackHeight) - 8px)) translateZ(-4px)'
    });
function Switch(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, SwitchContext);
    let { children, UNSAFE_className = '', UNSAFE_style } = props;
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let handleRef = (0, _react.useRef)(null);
    let isInForm = !!(0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Switch), {
        ...props,
        ref: domRef,
        inputRef: inputRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + wrapper({
                ...renderProps,
                isInForm,
                size: props.size || 'M'
            }, props.styles),
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: track({
                                ...renderProps,
                                size: props.size || 'M',
                                isEmphasized: props.isEmphasized
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                ref: handleRef,
                                style: (0, _pressScale.pressScale)(handleRef, transformStyle)(renderProps),
                                className: handle(renderProps)
                            })
                        })
                    }),
                    children
                ]
            })
    });
}
/**
 * Switches allow users to turn an individual option on or off.
 * They are usually used to activate or deactivate a specific setting.
 */ let _Switch = /*#__PURE__*/ (0, _react.forwardRef)(Switch);
try {
    // @ts-ignore
    SwitchContext.displayName = "SwitchContext";
    // @ts-ignore
    SwitchContext.__docgenInfo = {
        "description": "",
        "displayName": "SwitchContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<SwitchProps, FocusableRefValue<HTMLLabelElement, HTMLLabelElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Switch.tsx#SwitchContext"] = {
        docgenInfo: SwitchContext.__docgenInfo,
        name: "SwitchContext",
        path: "packages/@react-spectrum/s2/src/Switch.tsx#SwitchContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Switch.displayName = "_Switch";
    // @ts-ignore
    _Switch.__docgenInfo = {
        "description": "Switches allow users to turn an individual option on or off.\nThey are usually used to activate or deactivate a specific setting.",
        "displayName": "_Switch",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "defaultSelected": {
                "defaultValue": null,
                "description": "Whether the Switch should be selected (uncontrolled).",
                "name": "defaultSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inputRef": {
                "defaultValue": null,
                "description": "A ref for the HTML input element.",
                "name": "inputRef",
                "required": false,
                "type": {
                    "name": "RefObject<HTMLInputElement | null>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Switch should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isSelected": {
                "defaultValue": null,
                "description": "Whether the Switch should be selected (controlled).",
                "name": "isSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Switch.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the Switch's selection state changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((isSelected: boolean) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLLabelElement, HTMLLabelElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Switch.tsx#_Switch"] = {
        docgenInfo: _Switch.__docgenInfo,
        name: "_Switch",
        path: "packages/@react-spectrum/s2/src/Switch.tsx#_Switch"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"1P4Ox","1":"gwXcc","2":"gOOqd","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./CenterBaseline":"hXatv","react":"jEiK2","./Form":"gJckc","./pressScale":"6BiUY","@react-spectrum/utils":"bebxO","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"1P4Ox":[function() {},{}],"gwXcc":[function() {},{}],"gOOqd":[function() {},{}],"8ATnp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S2TableLayout", ()=>S2TableLayout);
parcelHelpers.export(exports, "TableContext", ()=>TableContext);
parcelHelpers.export(exports, "TableBody", ()=>_TableBody);
parcelHelpers.export(exports, "Column", ()=>Column);
parcelHelpers.export(exports, "TableHeader", ()=>_TableHeader);
parcelHelpers.export(exports, "Cell", ()=>Cell);
parcelHelpers.export(exports, "Row", ()=>_Row);
parcelHelpers.export(exports, "TableView", ()=>_TableView);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkbox = require("./Checkbox");
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _icon = require("./Icon");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _menu = require("./Menu");
var _runtime = require("../style/runtime");
var _s2MoveHorizontalTableWidgetSvg = require("../ui-icons/S2_MoveHorizontalTableWidget.svg");
var _s2MoveHorizontalTableWidgetSvgDefault = parcelHelpers.interopDefault(_s2MoveHorizontalTableWidgetSvg);
var _progressCircle = require("./ProgressCircle");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _virtualizer = require("@react-stately/virtualizer");
var _s2IconSortDown20NSvg = require("../s2wf-icons/S2_Icon_SortDown_20_N.svg");
var _s2IconSortDown20NSvgDefault = parcelHelpers.interopDefault(_s2IconSortDown20NSvg);
var _s2IconSortUp20NSvg = require("../s2wf-icons/S2_Icon_SortUp_20_N.svg");
var _s2IconSortUp20NSvgDefault = parcelHelpers.interopDefault(_s2IconSortUp20NSvg);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _utils2 = require("./utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
var _reactAria = require("react-aria");
let InternalTableContext = /*#__PURE__*/ (0, _react.createContext)({});
const tableWrapper = " . oo qo _Zd __Fa __R-yksgrp";
const table = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r|k|o|p)[^\s]+/g) || [];
    rules += matches.join('');
    let $l = false;
    let $o = false;
    let $q = false;
    for (let p of matches){
        if (/^\s*l/.test(p)) $l = true;
        if (/^\s*o/.test(p)) $o = true;
        if (/^\s*q/.test(p)) $q = true;
    }
    if (!$l) rules += ' lb';
    rules += ' __Da';
    if (!$o) rules += ' oo';
    if (!$q) rules += ' qo';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    rules += ' _eb';
    rules += ' __va';
    rules += ' __wa';
    rules += ' ba_____u';
    if (props.isQuiet) rules += ' ba';
    else rules += ' bd';
    rules += ' da_____v';
    if (props.isFocusVisible) rules += ' dx';
    else rules += ' di';
    if (props.isFocusVisible) rules += ' _Nc';
    else if (props.isQuiet) rules += ' _Na';
    else rules += ' _Nb';
    rules += ' _Lb';
    if (props.isQuiet) rules += ' _va';
    else rules += ' _v-3762yr';
    if (props.isQuiet) rules += ' _wa';
    else rules += ' _w-3762yr';
    if (props.isQuiet) rules += ' _xa';
    else rules += ' _x-3762yr';
    if (props.isQuiet) rules += ' _ya';
    else rules += ' _y-3762yr';
    rules += ' Mj';
    if (props.isCheckboxSelection) rules += ' Kl';
    return rules;
};
// component-height-100
const DEFAULT_HEADER_HEIGHT = {
    medium: 32,
    large: 40
};
const ROW_HEIGHTS = {
    compact: {
        medium: 32,
        large: 40
    },
    regular: {
        medium: 40,
        large: 50
    },
    spacious: {
        medium: 48,
        large: 60
    }
};
class S2TableLayout extends (0, _reactAriaComponents.UNSTABLE_TableLayout) {
    constructor(options){
        super({
            ...options,
            loaderHeight: 60
        });
    }
    isStickyColumn(node) {
        return node.props.isSticky;
    }
    buildCollection() {
        let [header, body] = super.buildCollection();
        let { children, layoutInfo } = body;
        // TableLayout's buildCollection always sets the body width to the max width between the header width, but
        // we want the body to be sticky and only as wide as the table so it is always in view if loading/empty
        if (children?.length === 0) layoutInfo.rect.width = this.virtualizer.visibleRect.width - 80;
        return [
            header,
            body
        ];
    }
    buildLoader(node, x, y) {
        let layoutNode = super.buildLoader(node, x, y);
        let { layoutInfo } = layoutNode;
        layoutInfo.allowOverflow = true;
        layoutInfo.rect.width = this.virtualizer.visibleRect.width;
        layoutInfo.isSticky = true;
        return layoutNode;
    }
    buildBody(y) {
        let layoutNode = super.buildBody(y);
        let { children, layoutInfo } = layoutNode;
        // Needs overflow for sticky loader
        layoutInfo.allowOverflow = true;
        // If loading or empty, we'll want the body to be sticky and centered
        if (children?.length === 0) {
            layoutInfo.rect = new (0, _virtualizer.Rect)(40, 40, this.virtualizer.visibleRect.width - 80, this.virtualizer.visibleRect.height - 80);
            layoutInfo.isSticky = true;
        }
        return {
            ...layoutNode,
            layoutInfo
        };
    }
    buildRow(node, x, y) {
        let layoutNode = super.buildRow(node, x, y);
        layoutNode.layoutInfo.allowOverflow = true;
        // Needs overflow for sticky selection/drag cells
        return layoutNode;
    }
    buildTableHeader() {
        let layoutNode = super.buildTableHeader();
        // Needs overflow for sticky selection/drag column
        layoutNode.layoutInfo.allowOverflow = true;
        return layoutNode;
    }
    buildColumn(node, x, y) {
        let layoutNode = super.buildColumn(node, x, y);
        // Needs overflow for the resize handle
        layoutNode.layoutInfo.allowOverflow = true;
        return layoutNode;
    }
}
const TableContext = /*#__PURE__*/ (0, _react.createContext)(null);
function TableView(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TableContext);
    let { UNSAFE_style, UNSAFE_className, isQuiet = false, density = 'regular', overflowMode = 'truncate', styles, loadingState, onLoadMore, onResize: propsOnResize, onResizeStart: propsOnResizeStart, onResizeEnd: propsOnResizeEnd, onAction, ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let scale = (0, _utils2.useScale)();
    let layout = (0, _react.useMemo)(()=>{
        return new S2TableLayout({
            rowHeight: overflowMode === 'wrap' ? undefined : ROW_HEIGHTS[density][scale],
            estimatedRowHeight: overflowMode === 'wrap' ? ROW_HEIGHTS[density][scale] : undefined,
            // No need for estimated headingHeight since the headers aren't affected by overflow mode: wrap
            headingHeight: DEFAULT_HEADER_HEIGHT[scale]
        });
    }, [
        overflowMode,
        density,
        scale
    ]);
    // Starts when the user selects resize from the menu, ends when resizing ends
    // used to control the visibility of the resizer Nubbin
    let [isInResizeMode, setIsInResizeMode] = (0, _react.useState)(false);
    let onResizeStart = (0, _react.useCallback)((widths)=>{
        propsOnResizeStart?.(widths);
    }, [
        propsOnResizeStart
    ]);
    let onResizeEnd = (0, _react.useCallback)((widths)=>{
        setIsInResizeMode(false);
        propsOnResizeEnd?.(widths);
    }, [
        propsOnResizeEnd,
        setIsInResizeMode
    ]);
    let context = (0, _react.useMemo)(()=>({
            isQuiet,
            density,
            overflowMode,
            loadingState,
            isInResizeMode,
            setIsInResizeMode
        }), [
        isQuiet,
        density,
        overflowMode,
        loadingState,
        isInResizeMode,
        setIsInResizeMode
    ]);
    let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
    let scrollRef = (0, _react.useRef)(null);
    let memoedLoadMoreProps = (0, _react.useMemo)(()=>({
            isLoading: isLoading,
            onLoadMore
        }), [
        isLoading,
        onLoadMore
    ]);
    (0, _utils1.useLoadMore)(memoedLoadMoreProps, scrollRef);
    let isCheckboxSelection = props.selectionMode === 'multiple' || props.selectionMode === 'single';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ResizableTableContainer), {
        // TODO: perhaps this ref should be attached to the RACTable but it expects a table type ref which isn't true in the virtualized case
        ref: domRef,
        onResize: propsOnResize,
        onResizeEnd: onResizeEnd,
        onResizeStart: onResizeStart,
        className: (UNSAFE_className || '') + (0, _runtime.mergeStyles)(tableWrapper, styles),
        style: UNSAFE_style,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.UNSTABLE_Virtualizer), {
            layout: layout,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalTableContext.Provider, {
                value: context,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Table), {
                    ref: scrollRef,
                    // Fix webkit bug where scrollbars appear above the checkboxes/other table elements
                    style: {
                        WebkitTransform: 'translateZ(0)'
                    },
                    className: (renderProps)=>table({
                            ...renderProps,
                            isCheckboxSelection,
                            isQuiet
                        }),
                    selectionBehavior: "toggle",
                    onRowAction: onAction,
                    ...otherProps
                })
            })
        })
    });
}
const centeredWrapper = " . _Zd _1c _2d lb kb";
function TableBody(props, ref) {
    let { items, renderEmptyState, children } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let { loadingState } = (0, _react.useContext)(InternalTableContext);
    let emptyRender;
    let renderer = children;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let loadMoreSpinner = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.UNSTABLE_TableLoadingIndicator), {
        className: " . kb lb",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: centeredWrapper,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                isIndeterminate: true,
                "aria-label": stringFormatter.format('table.loadingMore')
            })
        })
    });
    // If the user is rendering their rows in dynamic fashion, wrap their render function in Collection so we can inject
    // the loader. Otherwise it is a static renderer and thus we can simply add the table loader after
    // TODO: this assumes that the user isn't providing their children in some wrapper though and/or isn't doing a map of children
    // (though I guess they wouldn't provide items then so the check for this is still valid in the latter case)...
    if (typeof children === 'function' && items) renderer = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: items,
                children: children
            }),
            loadingState === 'loadingMore' && loadMoreSpinner
        ]
    });
    else renderer = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            children,
            loadingState === 'loadingMore' && loadMoreSpinner
        ]
    });
    if (renderEmptyState != null && loadingState !== 'loading') emptyRender = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: centeredWrapper,
            children: renderEmptyState(props)
        });
    else if (loadingState === 'loading') emptyRender = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: centeredWrapper,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                isIndeterminate: true,
                "aria-label": stringFormatter.format('table.loading')
            })
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TableBody), {
        // @ts-ignore
        ref: domRef,
        className: " . kb",
        ...props,
        renderEmptyState: emptyRender,
        dependencies: [
            loadingState
        ],
        children: renderer
    });
}
/**
 * The body of a `<Table>`, containing the table rows.
 */ let _TableBody = /*#__PURE__*/ (0, _react.forwardRef)(TableBody);
const cellFocus = {
    outlineStyle: {
        default: 'none',
        isFocusVisible: 'solid'
    },
    outlineOffset: -2,
    outlineWidth: 2,
    outlineColor: 'focus-ring',
    borderRadius: '[6px]'
};
function CellFocusRing() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        role: "presentation",
        className: function anonymous(props) {
            let rules = " .";
            if (props.isFocusVisible) rules += ' _Lb';
            else rules += ' _La';
            rules += ' _M-3hmpw';
            rules += ' _Nc';
            rules += ' da_____z';
            rules += ' dx';
            rules += ' _v-3762yr';
            rules += ' _w-3762yr';
            rules += ' _x-3762yr';
            rules += ' _y-3762yr';
            rules += ' Ua';
            rules += ' Xa';
            rules += ' Za';
            rules += ' Va';
            rules += ' Wa';
            return rules;
        }({
            isFocusVisible: true
        })
    });
}
const columnStyles = function anonymous(props) {
    let rules = " .";
    rules += ' k-17zqamw';
    rules += ' __na';
    rules += ' aa_____x';
    if (props.isPressed) rules += ' ao';
    else if (props.isFocusVisible) rules += ' ao';
    else if (props.isHovered) rules += ' ao';
    else rules += ' an';
    if (props.isColumnResizable) rules += ' Ca';
    else rules += ' Cf';
    if (props.isColumnResizable) rules += ' Da';
    else rules += ' Df';
    if (props.align === "end") rules += ' _jc';
    else if (props.align === "center") rules += ' _jb';
    else if (props.align === "start") rules += ' _ja';
    rules += ' _La';
    rules += ' Uc';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    rules += ' _ed';
    rules += ' _Zd';
    rules += ' ca_____v';
    rules += ' ci';
    if (props.isQuiet) rules += ' ub';
    else rules += ' ua';
    rules += ' vb';
    rules += ' sa';
    if (props.isColumnResizable) rules += ' tb';
    else rules += ' ta';
    rules += ' wa';
    rules += ' _zb';
    return rules;
};
const Column = /*#__PURE__*/ (0, _react.forwardRef)(function Column(props, ref) {
    let { isHeaderRowHovered } = (0, _react.useContext)(InternalTableHeaderContext);
    let { isQuiet } = (0, _react.useContext)(InternalTableContext);
    let { allowsResizing, children, align = 'start' } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let isColumnResizable = allowsResizing;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
        ...props,
        ref: domRef,
        style: {
            borderInlineEndColor: 'transparent'
        },
        className: (renderProps)=>columnStyles({
                ...renderProps,
                isColumnResizable,
                align,
                isQuiet
            }),
        children: ({ allowsSorting, sortDirection, isFocusVisible, sort, startResize, isHovered })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    isFocusVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CellFocusRing, {}),
                    isColumnResizable ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResizableColumnContents, {
                        allowsSorting: allowsSorting,
                        sortDirection: sortDirection,
                        sort: sort,
                        startResize: startResize,
                        isHovered: isHeaderRowHovered || isHovered,
                        align: align,
                        children: children
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColumnContents, {
                        allowsSorting: allowsSorting,
                        sortDirection: sortDirection,
                        children: children
                    })
                ]
            })
    });
});
const columnContentWrapper = " . qo _Zd _1c lb";
const sortIcon = function anonymous(props) {
    let rules = " .";
    rules += ' l-1wikn8b';
    rules += ' k-1wikn8b';
    rules += ' _8-3t1x';
    if (props.isButton) {
        rules += ' zbH';
        rules += ' zG';
    } else rules += ' zd';
    if (props.isButton) rules += ' _kundefined';
    else rules += ' _kd';
    rules += ' -rwx0fg_e-b';
    return rules;
};
function ColumnContents(props) {
    let { allowsSorting, sortDirection, children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: columnContentWrapper,
        children: [
            allowsSorting && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _icon.IconContext),
                        {
                            styles: sortIcon({})
                        }
                    ]
                ],
                children: sortDirection != null && (sortDirection === 'ascending' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconSortUp20NSvgDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconSortDown20NSvgDefault.default), {}))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " . __vb __wb _ma _pb lb",
                children: children
            })
        ]
    });
}
const resizableMenuButtonWrapper = function anonymous(props) {
    let rules = " .";
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' _M-3hmpw';
    rules += ' _Nc';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _v-3762yr';
    rules += ' _w-3762yr';
    rules += ' _x-3762yr';
    rules += ' _y-3762yr';
    rules += ' an';
    rules += ' lb';
    rules += ' Uc';
    rules += ' _Zd';
    rules += ' _1c';
    if (props.align === "end") rules += ' _2c';
    else if (props.align === "center") rules += ' _2d';
    else if (props.align === "default") rules += ' _2b';
    rules += ' Cf';
    rules += ' Df';
    rules += ' ba';
    rules += ' wf';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    rules += ' _ed';
    return rules;
};
const resizerHandleContainer = function anonymous(props) {
    let rules = " .";
    if (props.isHovered) rules += ' _Za';
    else if (props.isResizing) rules += ' _Za';
    else rules += ' _Zj';
    rules += ' lA';
    rules += ' kb';
    rules += ' Ua';
    rules += ' Xa';
    rules += ' W-2al4ab';
    if (props.resizableDirection === "both") rules += ' __HD';
    else if (props.resizableDirection === "right") rules += ' __Hz';
    else if (props.resizableDirection === "left") rules += ' __Hx';
    else rules += ' __Hi';
    return rules;
};
const resizerHandle = function anonymous(props) {
    let rules = " .";
    if (props.isResizing) rules += ' ba_____z';
    else if (props.isFocusVisible) rules += ' ba_____z';
    else if (props.isHovered) rules += ' ba_____v';
    else rules += ' ba_____u';
    if (props.isResizing) rules += ' b-14crvkh';
    else if (props.isFocusVisible) rules += ' b-14crvkh';
    else if (props.isHovered) rules += ' bi';
    else rules += ' ba';
    if (props.isResizing) rules += ' kn';
    else rules += ' kb';
    if (props.isResizing) rules += ' lq';
    else rules += ' lp';
    rules += ' Ua';
    rules += ' V-6njx2e';
    return rules;
};
const columnHeaderText = " . __vb __wb _ma _pb q-1wikn8b _9-3t1x _8-3t1y hF";
const chevronIcon = " . R-3hn0u yG ybH q-1wikn8b _8-3t1x -rwx0fg_e-b";
const nubbin = " . Ua Xa V-avx9c1 l-1wikn8b k-1wikn8b e-14crvkh ea_____X -rwx0fg_e-A -rwx0fg_e-a_____Y";
function ResizableColumnContents(props) {
    let { allowsSorting, sortDirection, sort, startResize, children, isHovered, align } = props;
    let { setIsInResizeMode, isInResizeMode } = (0, _react.useContext)(InternalTableContext);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    const onMenuSelect = (key)=>{
        switch(key){
            case 'sort-asc':
                sort('ascending');
                break;
            case 'sort-desc':
                sort('descending');
                break;
            case 'resize':
                setIsInResizeMode?.(true);
                startResize();
                break;
        }
    };
    let items = (0, _react.useMemo)(()=>{
        let options = [
            {
                label: stringFormatter.format('table.resizeColumn'),
                id: 'resize'
            }
        ];
        if (allowsSorting) options = [
            {
                label: stringFormatter.format('table.sortAscending'),
                id: 'sort-asc'
            },
            {
                label: stringFormatter.format('table.sortDescending'),
                id: 'sort-desc'
            },
            ...options
        ];
        return options;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allowsSorting
    ]);
    let buttonAlignment = 'start';
    let menuAlign = 'start';
    if (align === 'center') buttonAlignment = 'center';
    else if (align === 'end') {
        buttonAlignment = 'end';
        menuAlign = 'end';
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
                align: menuAlign,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Button), {
                        className: (renderProps)=>resizableMenuButtonWrapper({
                                ...renderProps,
                                align: buttonAlignment
                            }),
                        children: [
                            allowsSorting && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                values: [
                                    [
                                        (0, _icon.IconContext),
                                        {
                                            styles: sortIcon({
                                                isButton: true
                                            })
                                        }
                                    ]
                                ],
                                children: sortDirection != null && (sortDirection === 'ascending' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconSortUp20NSvgDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconSortDown20NSvgDefault.default), {}))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: columnHeaderText,
                                children: children
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                                size: "M",
                                className: chevronIcon
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
                        onAction: onMenuSelect,
                        items: items,
                        styles: " . q__s",
                        children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                                children: item?.label
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                "data-react-aria-prevent-focus": "true",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColumnResizer), {
                    "data-react-aria-prevent-focus": "true",
                    className: ({ resizableDirection, isResizing })=>resizerHandleContainer({
                            resizableDirection,
                            isResizing,
                            isHovered: isInResizeMode || isHovered
                        }),
                    children: ({ isFocusVisible, isResizing })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResizerIndicator, {
                                    isInResizeMode: isInResizeMode,
                                    isFocusVisible: isFocusVisible,
                                    isHovered: isHovered,
                                    isResizing: isResizing
                                }),
                                (isFocusVisible || isInResizeMode) && isResizing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: nubbin,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2MoveHorizontalTableWidgetSvgDefault.default), {})
                                })
                            ]
                        })
                })
            })
        ]
    });
}
function ResizerIndicator({ isFocusVisible, isHovered, isResizing, isInResizeMode }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: resizerHandle({
            isFocusVisible,
            isHovered: isHovered || isInResizeMode,
            isResizing
        })
    });
}
const tableHeader = " . kb lb bf A-yj899n";
const selectAllCheckbox = " . yf";
const selectAllCheckboxColumn = function anonymous(props) {
    let rules = " .";
    rules += ' Ea';
    rules += ' Fa';
    rules += ' Ca';
    rules += ' Da';
    rules += ' kb';
    rules += ' __na';
    rules += ' _La';
    rules += ' Uc';
    rules += ' _0b';
    rules += ' ca_____v';
    rules += ' ci';
    rules += ' sa';
    rules += ' ta';
    if (props.isQuiet) rules += ' ub';
    else rules += ' ua';
    rules += ' vb';
    rules += ' wa';
    rules += ' bf';
    return rules;
};
let InternalTableHeaderContext = /*#__PURE__*/ (0, _react.createContext)({
    isHeaderRowHovered: false
});
function TableHeader({ columns, children }, ref) {
    let scale = (0, _utils2.useScale)();
    let { selectionBehavior, selectionMode } = (0, _reactAriaComponents.useTableOptions)();
    let { isQuiet } = (0, _react.useContext)(InternalTableContext);
    let [isHeaderRowHovered, setHeaderRowHovered] = (0, _react.useState)(false);
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalTableHeaderContext.Provider, {
        value: {
            isHeaderRowHovered
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TableHeader), {
            // @ts-ignore
            ref: domRef,
            onHoverChange: setHeaderRowHovered,
            className: tableHeader,
            children: [
                selectionBehavior === 'toggle' && // Also isSticky prop is applied just for the layout, will decide what the RAC api should be later
                // @ts-ignore
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
                    isSticky: true,
                    width: scale === 'medium' ? 40 : 52,
                    minWidth: scale === 'medium' ? 40 : 52,
                    className: selectAllCheckboxColumn({
                        isQuiet
                    }),
                    children: ({ isFocusVisible })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                selectionMode === 'single' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        isFocusVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CellFocusRing, {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(VisuallyHiddenSelectAllLabel, {})
                                    ]
                                }),
                                selectionMode === 'multiple' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                    isEmphasized: true,
                                    styles: selectAllCheckbox,
                                    slot: "selection"
                                })
                            ]
                        })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                    items: columns,
                    children: children
                })
            ]
        })
    });
}
/**
 * A header within a `<Table>`, containing the table columns.
 */ let _TableHeader = /*#__PURE__*/ (0, _react.forwardRef)(TableHeader);
function VisuallyHiddenSelectAllLabel() {
    let checkboxProps = (0, _reactAriaComponents.useSlottedContext)((0, _reactAriaComponents.CheckboxContext), 'selection');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAria.VisuallyHidden), {
        children: checkboxProps?.['aria-label']
    });
}
const commonCellStyles = {
    borderColor: 'transparent',
    borderBottomWidth: 1,
    borderTopWidth: 0,
    borderXWidth: 0,
    borderStyle: 'solid',
    position: 'relative',
    color: {
        default: 'gray-800',
        forcedColors: 'ButtonText'
    },
    outlineStyle: 'none',
    paddingX: 16 // table-edge-to-content
};
const cell = function anonymous(props) {
    let rules = " .";
    rules += ' ca_____v';
    rules += ' ci';
    rules += ' v-375tp1';
    rules += ' u-375tp0';
    rules += ' sa';
    if (props.isDivider) rules += ' tb';
    else rules += ' ta';
    if (props.isDivider) rules += ' wa';
    else rules += ' wf';
    rules += ' Uc';
    if (props.isPressed) rules += ' ao';
    else if (props.isFocusVisible) rules += ' ao';
    else if (props.isHovered) rules += ' ao';
    else rules += ' an';
    rules += ' _La';
    rules += ' Cf';
    rules += ' Df';
    rules += ' E-1dbqcch';
    rules += ' F-1dbqcch';
    rules += ' o-375tou';
    rules += ' __na';
    rules += ' kb';
    rules += ' lb';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _1c';
    rules += ' _Zd';
    if (props.density === "spacious") rules += ' -_375tou_o-_a';
    else if (props.density === "compact") rules += ' -_375tou_o-U';
    else rules += ' -_375tou_o-2';
    rules += ' -_375tp0_u-a';
    rules += ' -_375tp1_v-b';
    return rules;
};
const stickyCell = {
    backgroundColor: 'gray-25'
};
const checkboxCellStyle = " . ca va ua sa ta wa Uc an aa_____x _La Cf Df b-19jpv4m _0b k-1xrzxd1";
const cellContent = function anonymous(props) {
    let rules = " .";
    rules += ' __vb';
    rules += ' __wb';
    rules += ' _ma';
    if (props.overflowMode === "wrap") rules += ' _pa';
    else rules += ' _pb';
    if (props.align === "end") rules += ' _jc';
    else if (props.align === "center") rules += ' _jb';
    else if (props.align === "start") rules += ' _ja';
    rules += ' lb';
    rules += ' __Fa';
    if (props.isSticky) rules += ' Ea';
    else rules += ' Ec';
    if (props.isSticky) rules += ' Fa';
    else rules += ' Fc';
    if (props.isSticky) rules += ' Ca';
    else rules += ' Cc';
    if (props.isSticky) rules += ' Da';
    else rules += ' Dc';
    if (props.isSticky) rules += ' Aa';
    else rules += ' AK';
    if (props.isSticky) rules += ' Ba';
    else rules += ' BK';
    if (props.isSticky) rules += ' ya';
    else rules += ' yK';
    if (props.isSticky) rules += ' za';
    else rules += ' zK';
    if (props.isSticky) rules += ' b-19jpv4m';
    else rules += ' ba';
    return rules;
};
const Cell = /*#__PURE__*/ (0, _react.forwardRef)(function Cell(props, ref) {
    let { children, isSticky, showDivider = false, align, textValue, ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let tableVisualOptions = (0, _react.useContext)(InternalTableContext);
    textValue ||= typeof children === 'string' ? children : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
        ref: domRef,
        // Also isSticky prop is applied just for the layout, will decide what the RAC api should be later
        // @ts-ignore
        isSticky: isSticky,
        className: (renderProps)=>cell({
                ...renderProps,
                ...tableVisualOptions,
                isDivider: showDivider
            }),
        textValue: textValue,
        ...otherProps,
        children: ({ isFocusVisible })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    isFocusVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CellFocusRing, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: cellContent({
                            ...tableVisualOptions,
                            isSticky,
                            align: align || 'start'
                        }),
                        children: children
                    })
                ]
            })
    });
});
// Use color-mix instead of transparency so sticky cells work correctly.
const selectedBackground = "[light-dark(color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%), color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(93, 137, 255), rgb(52, 91, 248)) 10%))]";
const selectedActiveBackground = "[light-dark(color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 15%), color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(93, 137, 255), rgb(52, 91, 248)) 15%))]";
const rowBackgroundColor = {
    default: {
        default: 'gray-25',
        isQuiet: '--s2-container-bg'
    },
    isFocusVisibleWithin: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
    isHovered: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
    isPressed: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]",
    isSelected: {
        default: selectedBackground,
        isFocusVisibleWithin: selectedActiveBackground,
        isHovered: selectedActiveBackground,
        isPressed: selectedActiveBackground // table-selected-row-background-color, opacity /15
    },
    forcedColors: {
        default: 'Background'
    }
};
const row = function anonymous(props) {
    let rules = " .";
    rules += ' kb';
    rules += ' Uc';
    rules += ' __na';
    rules += ' b-19jpv4m';
    rules += ' -_19jpv4m_b-a_____u';
    if (props.isSelected) {
        if (props.isPressed) rules += ' -_19jpv4m_b--1hocwbr';
        else if (props.isHovered) rules += ' -_19jpv4m_b--1hocwbr';
        else if (props.isFocusVisibleWithin) rules += ' -_19jpv4m_b--1hocwbr';
        else rules += ' -_19jpv4m_b--sogeql';
    } else if (props.isPressed) rules += ' -_19jpv4m_b--17nxj1';
    else if (props.isHovered) rules += ' -_19jpv4m_b--26tcdv';
    else if (props.isFocusVisibleWithin) rules += ' -_19jpv4m_b--26tcdv';
    else if (props.isQuiet) rules += ' -_19jpv4m_b--1de2x0q';
    else rules += ' -_19jpv4m_b-d';
    rules += ' -oorfdf_d-a_____z';
    rules += ' -oorfdf_d-x';
    rules += ' _La';
    rules += ' ua';
    rules += ' vb';
    rules += ' sa';
    rules += ' ta';
    rules += ' wa';
    rules += ' ca_____v';
    rules += ' ci';
    rules += ' _zb';
    return rules;
};
function Row({ id, columns, children, ...otherProps }, ref) {
    let { selectionBehavior, selectionMode } = (0, _reactAriaComponents.useTableOptions)();
    let tableVisualOptions = (0, _react.useContext)(InternalTableContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Row), {
        // @ts-ignore
        ref: domRef,
        id: id,
        className: (renderProps)=>row({
                ...renderProps,
                ...tableVisualOptions
            }) + (renderProps.isFocusVisible && " -zwoa9h"),
        ...otherProps,
        children: [
            selectionMode !== 'none' && selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Cell, {
                isSticky: true,
                className: checkboxCellStyle,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                    isEmphasized: true,
                    slot: "selection"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: columns,
                children: children
            })
        ]
    });
}
/**
 * A row within a `<Table>`.
 */ let _Row = /*#__PURE__*/ (0, _react.forwardRef)(Row);
/**
 * Tables are containers for displaying information. They allow users to quickly scan, sort, compare, and take action on large amounts of data.
 */ const _TableView = /*#__PURE__*/ (0, _react.forwardRef)(TableView);
try {
    // @ts-ignore
    TableContext.displayName = "TableContext";
    // @ts-ignore
    TableContext.__docgenInfo = {
        "description": "",
        "displayName": "TableContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<TableViewProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TableView.tsx#TableContext"] = {
        docgenInfo: TableContext.__docgenInfo,
        name: "TableContext",
        path: "packages/@react-spectrum/s2/src/TableView.tsx#TableContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _TableBody.displayName = "_TableBody";
    // @ts-ignore
    _TableBody.__docgenInfo = {
        "description": "The body of a `<Table>`, containing the table rows.",
        "displayName": "_TableBody",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "renderEmptyState": {
                "defaultValue": null,
                "description": "Provides content to display when there are no rows in the table.",
                "name": "renderEmptyState",
                "required": false,
                "type": {
                    "name": "((props: TableBodyRenderProps) => ReactNode)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TableView.tsx#_TableBody"] = {
        docgenInfo: _TableBody.__docgenInfo,
        name: "_TableBody",
        path: "packages/@react-spectrum/s2/src/TableView.tsx#_TableBody"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    Column.displayName = "Column";
    // @ts-ignore
    Column.__docgenInfo = {
        "description": "A column within a `<Table>`.",
        "displayName": "Column",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to render as the column header.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The alignment of the column's contents relative to its allotted width.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"center\""
                        }
                    ]
                }
            },
            "allowsResizing": {
                "defaultValue": null,
                "description": "Whether the column allows resizing.",
                "name": "allowsResizing",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "allowsSorting": {
                "defaultValue": null,
                "description": "Whether the column allows sorting.",
                "name": "allowsSorting",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string | ((values: ColumnRenderProps & { defaultClassName: string; }) => string)"
                }
            },
            "defaultWidth": {
                "defaultValue": null,
                "description": "The default width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
                "name": "defaultWidth",
                "required": false,
                "type": {
                    "name": "ColumnSize | null"
                }
            },
            "isRowHeader": {
                "defaultValue": null,
                "description": "Whether a column is a [row header](https://www.w3.org/TR/wai-aria-1.1/#rowheader) and should be announced by assistive technology during row navigation.",
                "name": "isRowHeader",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "maxWidth": {
                "defaultValue": null,
                "description": "The maximum width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
                "name": "maxWidth",
                "required": false,
                "type": {
                    "name": "ColumnStaticSize | null"
                }
            },
            "minWidth": {
                "defaultValue": null,
                "description": "The minimum width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
                "name": "minWidth",
                "required": false,
                "type": {
                    "name": "ColumnStaticSize | null"
                }
            },
            "showDivider": {
                "defaultValue": null,
                "description": "Whether the column should render a divider between it and the next column.",
                "name": "showDivider",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties | ((values: ColumnRenderProps & { defaultStyle: CSSProperties; }) => CSSProperties)"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the column's contents, used for accessibility announcements.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "width": {
                "defaultValue": null,
                "description": "The width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
                "name": "width",
                "required": false,
                "type": {
                    "name": "ColumnSize | null"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TableView.tsx#Column"] = {
        docgenInfo: Column.__docgenInfo,
        name: "Column",
        path: "packages/@react-spectrum/s2/src/TableView.tsx#Column"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _TableHeader.displayName = "_TableHeader";
    // @ts-ignore
    _TableHeader.__docgenInfo = {
        "description": "A header within a `<Table>`, containing the table columns.",
        "displayName": "_TableHeader",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "A list of `Column(s)` or a function. If the latter, a list of columns must be provided using the `columns` prop.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactElement<unknown, string | JSXElementConstructor<any>>)"
                }
            },
            "columns": {
                "defaultValue": null,
                "description": "A list of table columns.",
                "name": "columns",
                "required": false,
                "type": {
                    "name": "T[]"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TableView.tsx#_TableHeader"] = {
        docgenInfo: _TableHeader.__docgenInfo,
        name: "_TableHeader",
        path: "packages/@react-spectrum/s2/src/TableView.tsx#_TableHeader"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    Cell.displayName = "Cell";
    // @ts-ignore
    Cell.__docgenInfo = {
        "description": "A cell within a table row.",
        "displayName": "Cell",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to render as the cell children.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The alignment of the column's contents relative to its allotted width.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"center\""
                        }
                    ]
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string | ((values: CellRenderProps & { defaultClassName: string; }) => string)"
                }
            },
            "isSticky": {
                "defaultValue": null,
                "description": "@private",
                "name": "isSticky",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "showDivider": {
                "defaultValue": null,
                "description": "Whether the column should render a divider between it and the next column.",
                "name": "showDivider",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties | ((values: CellRenderProps & { defaultStyle: CSSProperties; }) => CSSProperties)"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the cell's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TableView.tsx#Cell"] = {
        docgenInfo: Cell.__docgenInfo,
        name: "Cell",
        path: "packages/@react-spectrum/s2/src/TableView.tsx#Cell"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Row.displayName = "_Row";
    // @ts-ignore
    _Row.__docgenInfo = {
        "description": "A row within a `<Table>`.",
        "displayName": "_Row",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The cells within the row. Supports static items or a function for dynamic rendering.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactElement<unknown, string | JSXElementConstructor<any>>)"
                }
            },
            "columns": {
                "defaultValue": null,
                "description": "A list of columns used when dynamically rendering cells.",
                "name": "columns",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "textValue": {
                "defaultValue": null,
                "description": "A string representation of the row's contents, used for features like typeahead.",
                "name": "textValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TableView.tsx#_Row"] = {
        docgenInfo: _Row.__docgenInfo,
        name: "_Row",
        path: "packages/@react-spectrum/s2/src/TableView.tsx#_Row"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _TableView.displayName = "_TableView";
    // @ts-ignore
    _TableView.__docgenInfo = {
        "description": "Tables are containers for displaying information. They allow users to quickly scan, sort, compare, and take action on large amounts of data.",
        "displayName": "_TableView",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The elements that make up the table. Includes the TableHeader, TableBody, Columns, and Rows.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "Sets the amount of vertical padding within each cell.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        },
                        {
                            "value": "\"spacious\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "A list of row keys to disable.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the Table should be displayed with a quiet style.",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "loadingState": {
                "defaultValue": null,
                "description": "The current loading state of the table.",
                "name": "loadingState",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"error\""
                        },
                        {
                            "value": "\"loading\""
                        },
                        {
                            "value": "\"sorting\""
                        },
                        {
                            "value": "\"loadingMore\""
                        },
                        {
                            "value": "\"idle\""
                        },
                        {
                            "value": "\"filtering\""
                        }
                    ]
                }
            },
            "overflowMode": {
                "defaultValue": {
                    value: "'truncate'"
                },
                "description": "Sets the overflow behavior for the cell contents.",
                "name": "overflowMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"wrap\""
                        },
                        {
                            "value": "\"truncate\""
                        }
                    ]
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "The type of selection that is allowed in the collection.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "sortDescriptor": {
                "defaultValue": null,
                "description": "The current sorted column and direction.",
                "name": "sortDescriptor",
                "required": false,
                "type": {
                    "name": "SortDescriptor"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onAction": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs an action on a row.",
                "name": "onAction",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "onLoadMore": {
                "defaultValue": null,
                "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
                "name": "onLoadMore",
                "required": false,
                "type": {
                    "name": "(() => any)"
                }
            },
            "onResize": {
                "defaultValue": null,
                "description": "Handler that is called when a user performs a column resize.\nCan be used with the width property on columns to put the column widths into\na controlled state.",
                "name": "onResize",
                "required": false,
                "type": {
                    "name": "((widths: Map<Key, ColumnSize>) => void)"
                }
            },
            "onResizeEnd": {
                "defaultValue": null,
                "description": "Handler that is called after a user performs a column resize.\nCan be used to store the widths of columns for another future session.",
                "name": "onResizeEnd",
                "required": false,
                "type": {
                    "name": "((widths: Map<Key, ColumnSize>) => void)"
                }
            },
            "onResizeStart": {
                "defaultValue": null,
                "description": "Handler that is called when a user starts a column resize.",
                "name": "onResizeStart",
                "required": false,
                "type": {
                    "name": "((widths: Map<Key, ColumnSize>) => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Selection) => void)"
                }
            },
            "onSortChange": {
                "defaultValue": null,
                "description": "Handler that is called when the sorted column or direction changes.",
                "name": "onSortChange",
                "required": false,
                "type": {
                    "name": "((descriptor: SortDescriptor) => any)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TableView.tsx#_TableView"] = {
        docgenInfo: _TableView.__docgenInfo,
        name: "_TableView",
        path: "packages/@react-spectrum/s2/src/TableView.tsx#_TableView"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"ej7Hm","1":"cEHWK","2":"cNbS7","3":"my5oZ","4":"6nyIg","5":"ekijg","6":"inVVW","7":"giz8i","8":"gwUVD","9":"7Psn5","10":"jUeW6","11":"7CLpA","12":"de60f","13":"1VFM0","14":"bSlUF","15":"7hkCQ","16":"e6wp1","17":"9qlFv","18":"fKdKM","19":"lNvTI","20":"c8b6x","21":"bl06r","22":"hNw2C","23":"2BrW1","24":"3P04N","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./Checkbox":"7w7or","../ui-icons/Chevron":"dnGTM","./Icon":"1OC2a","../intl/*.json":"iU6xz","./Menu":"hGkxl","../style/runtime":"dzhKB","../ui-icons/S2_MoveHorizontalTableWidget.svg":"jakfX","./ProgressCircle":"c4KdT","react":"jEiK2","@react-stately/virtualizer":"emKZ4","../s2wf-icons/S2_Icon_SortDown_20_N.svg":"bj0Jo","../s2wf-icons/S2_Icon_SortUp_20_N.svg":"cJw0Q","@react-spectrum/utils":"bebxO","@react-aria/utils":"e9Yvo","@react-aria/i18n":"hFrKJ","./utils":"25Pnr","./useSpectrumContextProps":"ileU6","react-aria":"4BEis","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"ej7Hm":[function() {},{}],"cEHWK":[function() {},{}],"cNbS7":[function() {},{}],"my5oZ":[function() {},{}],"6nyIg":[function() {},{}],"ekijg":[function() {},{}],"inVVW":[function() {},{}],"giz8i":[function() {},{}],"gwUVD":[function() {},{}],"7Psn5":[function() {},{}],"jUeW6":[function() {},{}],"7CLpA":[function() {},{}],"de60f":[function() {},{}],"1VFM0":[function() {},{}],"bSlUF":[function() {},{}],"7hkCQ":[function() {},{}],"e6wp1":[function() {},{}],"9qlFv":[function() {},{}],"fKdKM":[function() {},{}],"lNvTI":[function() {},{}],"c8b6x":[function() {},{}],"bl06r":[function() {},{}],"hNw2C":[function() {},{}],"2BrW1":[function() {},{}],"3P04N":[function() {},{}],"jakfX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2MoveHorizontalTableWidget = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8,
                cy: 8,
                r: 8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, #fff)",
                d: "M10 11.75a.75.75 0 0 1-.53-1.28L11.94 8 9.47 5.53a.75.75 0 1 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-.53.22M6 11.75a.75.75 0 0 1-.53-.22l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 1 1 1.06 1.06L4.06 8l2.47 2.47A.75.75 0 0 1 6 11.75"
            })
        ]
    });
exports.default = SvgS2MoveHorizontalTableWidget;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"bj0Jo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.28 13.22c-.293-.293-.767-.293-1.06 0L16 14.44V3.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v10.69l-1.22-1.22c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l2.5 2.5q.105.105.243.162c.138.057.19.058.287.058s.195-.02.287-.058.174-.093.243-.162l2.5-2.5c.293-.293.293-.767 0-1.06M7.25 14.5h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75M9.25 10.5h-6.5c-.414 0-.75-.336-.75-.75S2.336 9 2.75 9h6.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.25 6.5h-8.5c-.414 0-.75-.336-.75-.75S2.336 5 2.75 5h8.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef, (0, _icon.IconContext));

},{"react/jsx-runtime":"2JzhG","~/src/Icon":"1OC2a","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"cJw0Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.28 5.72-2.5-2.5q-.105-.105-.243-.162c-.184-.076-.39-.076-.574 0q-.138.058-.243.162l-2.5 2.5c-.293.293-.293.767 0 1.06s.767.293 1.06 0l1.22-1.22v10.69c0 .414.336.75.75.75s.75-.336.75-.75V5.56l1.22 1.22c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M7.25 6.5h-4.5c-.414 0-.75-.336-.75-.75S2.336 5 2.75 5h4.5c.414 0 .75.336.75.75s-.336.75-.75.75M9.25 10.5h-6.5c-.414 0-.75-.336-.75-.75S2.336 9 2.75 9h6.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.25 14.5h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef, (0, _icon.IconContext));

},{"react/jsx-runtime":"2JzhG","~/src/Icon":"1OC2a","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"25Pnr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMobileDevice", ()=>useIsMobileDevice);
parcelHelpers.export(exports, "useScale", ()=>useScale);
var _utils = require("@react-spectrum/utils");
function useIsMobileDevice() {
    return (0, _utils.useMediaQuery)('(max-width: 640px)');
}
function useScale() {
    let matchesFine = (0, _utils.useMediaQuery)('not ((hover: hover) and (pointer: fine))');
    if (matchesFine) return 'large';
    return 'medium';
}

},{"@react-spectrum/utils":"bebxO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"2NbbN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagGroupContext", ()=>TagGroupContext);
parcelHelpers.export(exports, "TagGroup", ()=>_TagGroup);
parcelHelpers.export(exports, "Tag", ()=>_Tag);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _s2IconAlertTriangle20NSvg = require("../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg");
var _s2IconAlertTriangle20NSvgDefault = parcelHelpers.interopDefault(_s2IconAlertTriangle20NSvg);
var _reactAriaComponents = require("react-aria-components");
var _avatar = require("./Avatar");
var _centerBaseline = require("./CenterBaseline");
var _clearButton = require("./ClearButton");
var _collections = require("@react-aria/collections");
var _react = require("react");
var _field = require("./Field");
var _reactDom = require("react-dom");
var _form = require("./Form");
var _icon = require("./Icon");
var _image = require("./Image");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _pressScale = require("./pressScale");
var _content = require("./Content");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const TagGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const helpTextStyles = function anonymous(props) {
    let rules = " .";
    rules += ' __a-1oa8qr7';
    rules += ' __b-1oa8qr7';
    rules += ' __c-1oa8qr7';
    rules += ' __d-1oa8qr7';
    rules += ' _Zd';
    rules += ' _1d';
    rules += ' ibH';
    rules += ' iG';
    rules += ' jbH';
    rules += ' jG';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isInvalid) {
        if (props.isPressed) rules += ' aP';
        else if (props.isFocusVisible) rules += ' aP';
        else if (props.isHovered) rules += ' aP';
        else rules += ' aO';
    } else {
        if (props.isPressed) rules += ' an';
        else if (props.isFocusVisible) rules += ' an';
        else if (props.isHovered) rules += ' an';
        else rules += ' am';
    }
    rules += ' -rwx0fg_e-b';
    rules += ' __me';
    rules += ' E-1inj1bc';
    rules += ' __He';
    return rules;
};
const InternalTagGroupContext = /*#__PURE__*/ (0, _react.createContext)({});
function TagGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TagGroupContext);
    props = (0, _form.useFormProps)(props);
    let { onRemove } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalTagGroupContext.Provider, {
        value: {
            onRemove
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collections.CollectionBuilder), {
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collections.Collection), {
                ...props
            }),
            children: (collection)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TagGroupInner, {
                    props: props,
                    forwardedRef: ref,
                    collection: collection
                })
        })
    });
}
/** Tags allow users to categorize content. They can represent keywords or people, and are grouped to describe an item or a search request. */ let _TagGroup = /*#__PURE__*/ (0, _react.forwardRef)(TagGroup);
function TagGroupInner({ props: { label, description, labelPosition = 'top', labelAlign = 'start', isEmphasized, isInvalid, errorMessage, UNSAFE_className = '', UNSAFE_style, size = 'M', ...props1 }, forwardedRef: ref, collection }) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let { maxRows, groupActionLabel, onGroupAction, renderEmptyState = ()=>stringFormatter.format('tag.noTags'), ...otherProps } = props1;
    let { direction } = (0, _reactAriaComponents.useLocale)();
    let containerRef = (0, _react.useRef)(null);
    let tagsRef = (0, _react.useRef)(null);
    let actionsRef = (0, _react.useRef)(null);
    let hiddenTagsRef = (0, _react.useRef)(null);
    let [tagState, setTagState] = (0, _react.useState)({
        visibleTagCount: collection.size,
        showCollapseButton: false
    });
    let [isCollapsed, setIsCollapsed] = (0, _react.useState)(maxRows != null);
    let { onRemove } = (0, _react.useContext)(InternalTagGroupContext);
    let isEmpty = collection.size === 0;
    let showCollapseToggleButton = tagState.showCollapseButton || tagState.visibleTagCount < collection.size;
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    let domRef = (0, _utils.useDOMRef)(ref);
    let allItems = (0, _react.useMemo)(()=>Array.from(collection), [
        collection
    ]);
    let items = (0, _react.useMemo)(()=>Array.from(collection).slice(0, !isCollapsed ? collection.size : tagState.visibleTagCount), [
        collection,
        tagState.visibleTagCount,
        isCollapsed
    ]);
    let updateVisibleTagCount = (0, _utils1.useEffectEvent)(()=>{
        if (maxRows == null) setTagState({
            visibleTagCount: collection.size,
            showCollapseButton: false
        });
        if (maxRows != null && maxRows > 0) {
            let computeVisibleTagCount = ()=>{
                let currContainerRef = hiddenTagsRef.current;
                let currTagsRef = hiddenTagsRef.current;
                let currActionsRef = actionsRef.current;
                if (!currContainerRef || !currTagsRef || collection.size === 0 || currContainerRef.parentElement == null) return {
                    visibleTagCount: 0,
                    showCollapseButton: false
                };
                // Count rows and show tags until we hit the maxRows.
                // I think this is still a safe assumption, and we don't need to queryAll for role=tag
                let tags = [
                    ...currTagsRef.children
                ];
                let currY = -Infinity;
                let rowCount = 0;
                let index = 0;
                let tagWidths = [];
                for (let tag of tags){
                    let { width, y } = tag.getBoundingClientRect();
                    if (y !== currY) {
                        currY = y;
                        rowCount++;
                    }
                    if (rowCount > maxRows) break;
                    tagWidths.push(width);
                    index++;
                }
                // Remove tags until there is space for the collapse button and action button (if present) on the last row.
                let buttons = currActionsRef ? [
                    ...currActionsRef.children
                ] : [];
                if (buttons.length > 0 && rowCount >= maxRows) {
                    let buttonsWidth = buttons.reduce((acc, curr)=>acc += curr.getBoundingClientRect().width, 0);
                    let margins = parseFloat(getComputedStyle(buttons[0]).marginInlineStart);
                    buttonsWidth += margins * 2;
                    let end = direction === 'ltr' ? 'right' : 'left';
                    let containerEnd = currContainerRef.parentElement?.getBoundingClientRect()[end] - margins;
                    let lastTagEnd = tags[index - 1]?.getBoundingClientRect()[end];
                    lastTagEnd += margins;
                    let availableWidth = containerEnd - lastTagEnd;
                    while(availableWidth <= buttonsWidth && index > 0){
                        let tagWidth = tagWidths.pop();
                        if (tagWidth != null) availableWidth += tagWidth;
                        index--;
                    }
                }
                return {
                    visibleTagCount: Math.max(index, 1),
                    showCollapseButton: index < collection.size
                };
            };
            let result = computeVisibleTagCount();
            (0, _reactDom.flushSync)(()=>{
                setTagState(result);
            });
        }
    });
    (0, _utils1.useResizeObserver)({
        ref: maxRows != null ? containerRef : undefined,
        onResize: updateVisibleTagCount
    });
    (0, _utils1.useLayoutEffect)(()=>{
        if (collection.size > 0 && maxRows != null && maxRows > 0) queueMicrotask(updateVisibleTagCount);
    }, [
        collection.size,
        updateVisibleTagCount,
        maxRows
    ]);
    (0, _react.useEffect)(()=>{
        // Recalculate visible tags when fonts are loaded.
        document.fonts?.ready.then(()=>updateVisibleTagCount());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let handlePressCollapse = ()=>{
        setIsCollapsed((prevCollapsed)=>!prevCollapsed);
    };
    let helpText = null;
    if (!isInvalid && description) helpText = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
        slot: "description",
        styles: helpTextStyles({
            size
        }),
        children: description
    });
    else if (isInvalid) helpText = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: helpTextStyles({
            size,
            isInvalid
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconAlertTriangle20NSvgDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                slot: "errorMessage",
                children: errorMessage
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TagGroup), {
        ...otherProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " .";
            let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
            rules += matches.join('');
            let $__a = false;
            let $__b = false;
            for (let p of matches){
                if (/^\s*__a/.test(p)) $__a = true;
                if (/^\s*__b/.test(p)) $__b = true;
            }
            rules += ' _Zf';
            if (!$__a) {
                if (props.isInForm) rules += ' __a-3t1y';
            }
            if (!$__b) {
                if (props.isInForm) {
                    if (props.labelPosition === "side") rules += ' __b-7u9dhl';
                }
            }
            if (props.isInForm) rules += ' __h-1cwd7ud';
            else {
                if (props.labelPosition === "side") rules += ' __h-jyg4vb';
                else if (props.labelPosition === "top") rules += ' __h-375yi6';
            }
            if (props.labelPosition === "side") rules += ' __i-jyg4vb';
            else if (props.labelPosition === "top") rules += ' __i-fdenls';
            if (props.labelPosition === "side") rules += ' __j-5eez8j';
            else if (props.labelPosition === "top") rules += ' __j-xlaqir';
            if (props.size === "XL") {
                rules += ' _dbj';
                rules += ' _di';
            } else if (props.size === "L") {
                rules += ' _dbh';
                rules += ' _dg';
            } else if (props.size === "S") {
                rules += ' _dbd';
                rules += ' _dc';
            } else if (props.size === "XS") {
                rules += ' _dbb';
                rules += ' _da';
            } else {
                rules += ' _dbf';
                rules += ' _de';
            }
            rules += ' _1d';
            rules += ' _f-1x99dlob';
            rules += ' _fa';
            if (props.size === "XL") rules += ' -aqrvqh_k-j';
            else if (props.size === "L") rules += ' -aqrvqh_k-i';
            else if (props.size === "S") rules += ' -aqrvqh_k-h';
            else if (props.size === "XS") rules += ' -aqrvqh_k-g';
            else rules += ' -aqrvqh_k-f';
            rules += ' -_1inj1bc_i--prjw07';
            rules += ' je';
            rules += ' __R-yksgrp';
            return rules;
        }({
            size,
            labelPosition: labelPosition,
            isInForm: !!formContext
        }, props1.styles),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                size: size,
                labelPosition: labelPosition,
                labelAlign: labelAlign,
                contextualHelp: props1.contextualHelp,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ref: containerRef,
                className: function anonymous(props) {
                    let rules = " .";
                    rules += ' __a-4cfph1';
                    rules += ' __b-4cfph1';
                    rules += ' __c-4cfph1';
                    rules += ' __d-4cfph1';
                    rules += ' qb';
                    if (props.isEmpty) rules += ' ya';
                    else rules += ' yK';
                    if (props.isEmpty) rules += ' za';
                    else rules += ' zc';
                    rules += ' Uc';
                    return rules;
                }({
                    isEmpty
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FormContext).Provider, {
                    value: {
                        ...formContext,
                        size
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _reactAriaComponents.TextContext),
                                undefined
                            ],
                            [
                                TagGroupContext,
                                {
                                    size,
                                    isEmphasized
                                }
                            ]
                        ],
                        children: [
                            maxRows != null && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                // @ts-ignore
                                inert: "true",
                                ref: hiddenTagsRef,
                                className: " . _Zc _7a _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh Ua Xa Za __Eb __vb __wb _K-3t1x",
                                children: allItems.map((item)=>{
                                    // pull off individual props as an allow list, don't want refs or other props getting through
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        style: item.props.UNSAFE_style,
                                        className: item.props.className({
                                            size,
                                            allowsRemoving: Boolean(onRemove)
                                        }),
                                        children: item.props.children({
                                            size,
                                            allowsRemoving: Boolean(onRemove),
                                            isInCtx: true
                                        })
                                    }, item.key);
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TagList), {
                                ref: tagsRef,
                                items: items,
                                renderEmptyState: renderEmptyState,
                                className: " . _Zc qb _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _de _dbf _eb _fa _f-1x99dlob an",
                                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_Tag, {
                                        ...item.props,
                                        id: item.key,
                                        textValue: item.textValue
                                    })
                            }),
                            !isEmpty && (showCollapseToggleButton || groupActionLabel) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionGroup, {
                                collection: collection,
                                "aria-label": props1['aria-label'],
                                "aria-labelledby": props1['aria-labelledby'],
                                actionsRef: actionsRef,
                                tagState: tagState,
                                size: size,
                                isCollapsed: isCollapsed,
                                handlePressCollapse: handlePressCollapse,
                                onGroupAction: onGroupAction,
                                groupActionLabel: groupActionLabel
                            })
                        ]
                    })
                })
            }),
            helpText
        ]
    });
}
function ActionGroup(props) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let { actionsRef, tagState, size, isCollapsed, handlePressCollapse, onGroupAction, groupActionLabel, collection, // directly use aria-labelling from the TagGroup because we can't use the id from the TagList
    // and we can't supply an id to the TagList because it'll cause an issue where all the tag ids flip back
    // and forth with their prefix in an infinite loop
    'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy } = props;
    let actionsId = (0, _utils1.useId)();
    // might need to localize the aria-label which concatenates with this label
    let actionGroupLabel = stringFormatter.format('tag.actions');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        role: "group",
        ref: actionsRef,
        id: actionsId,
        "aria-label": ariaLabel ? `${ariaLabel} ${actionGroupLabel}` : actionGroupLabel,
        "aria-labelledby": ariaLabelledBy ? ariaLabelledBy : undefined,
        className: " . _Zc",
        children: [
            tagState.showCollapseButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                isQuiet: true,
                size: size,
                styles: " . Ac Bc yc zc",
                UNSAFE_style: {
                    display: 'inline-flex'
                },
                onPress: handlePressCollapse,
                children: isCollapsed ? stringFormatter.format('tag.showAllButtonLabel', {
                    tagCount: collection.size
                }) : stringFormatter.format('tag.hideButtonLabel')
            }),
            groupActionLabel && onGroupAction && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                isQuiet: true,
                size: size,
                styles: " . Ac Bc yc zc",
                UNSAFE_style: {
                    display: 'inline-flex'
                },
                onPress: ()=>onGroupAction?.(),
                children: groupActionLabel
            })
        ]
    });
}
const tagStyles = function anonymous(props) {
    let rules = " .";
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    rules += ' _Ze';
    rules += ' __na';
    rules += ' rb';
    rules += ' _kc';
    rules += ' _1c';
    rules += ' _2d';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) rules += ' aa_____B';
    else if (props.isSelected) rules += ' aa_____A';
    else rules += ' aa_____x';
    if (props.isDisabled) rules += ' aj';
    else if (props.isSelected) {
        if (props.isEmphasized) rules += ' ac';
        else rules += ' ad';
    } else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' k-375toq';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' qo';
    if (props.isSelected) rules += ' ba_____z';
    else rules += ' ba_____w';
    if (props.isDisabled) rules += ' bg';
    else if (props.isSelected) {
        if (props.isEmphasized) {
            if (props.isPressed) rules += ' b_____F';
            else if (props.isFocusVisible) rules += ' b_____F';
            else if (props.isHovered) rules += ' b_____F';
            else rules += ' b_____E';
        } else {
            if (props.isPressed) rules += ' bo';
            else if (props.isFocusVisible) rules += ' bo';
            else if (props.isHovered) rules += ' bo';
            else rules += ' bn';
        }
    } else if (props.isFocusVisible) rules += ' bh';
    else if (props.isHovered) rules += ' bh';
    else rules += ' bg';
    rules += ' wf';
    rules += ' CI';
    if (props.allowsRemoving) rules += ' Da';
    else rules += ' DI';
    rules += ' Ea';
    rules += ' Fa';
    rules += ' Ac';
    rules += ' Bc';
    rules += ' yc';
    rules += ' zc';
    rules += ' _vh';
    rules += ' _wh';
    rules += ' _xh';
    rules += ' _yh';
    if (props.isLink) rules += ' __Hc';
    else rules += ' __Hb';
    rules += ' -oelgqu_A--177861o';
    rules += ' -rwx0fg_e-b';
    if (props.size === "XL") rules += ' -_375toq_k-j';
    else if (props.size === "L") rules += ' -_375toq_k-i';
    else if (props.size === "S") rules += ' -_375toq_k-h';
    else if (props.size === "XS") rules += ' -_375toq_k-g';
    else rules += ' -_375toq_k-f';
    return rules;
};
const avatarSize = {
    S: 16,
    M: 20,
    L: 24
};
function Tag({ children, textValue, ...props }, ref) {
    textValue ||= typeof children === 'string' ? children : undefined;
    let ctx = (0, _reactAriaComponents.useSlottedContext)(TagGroupContext);
    let isInRealDOM = Boolean(ctx?.size);
    let { size, isEmphasized } = ctx ?? {};
    let domRef = (0, _utils.useDOMRef)(ref);
    let backupRef = (0, _react.useRef)(null);
    domRef = domRef || backupRef;
    let isLink = props.href != null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tag), {
        textValue: textValue,
        ...props,
        ref: domRef,
        style: (0, _pressScale.pressScale)(domRef),
        className: (renderProps)=>tagStyles({
                size,
                isEmphasized,
                isLink,
                ...renderProps
            }),
        children: (0, _reactAriaComponents.composeRenderProps)(children, (children, renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TagWrapper, {
                isInRealDOM: isInRealDOM,
                ...renderProps,
                children: typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            }))
    });
}
/** An individual Tag for TagGroups. */ let _Tag = /*#__PURE__*/ (0, _react.forwardRef)(Tag);
function TagWrapper({ children, isDisabled, allowsRemoving, isInRealDOM }) {
    let { size = 'M' } = (0, _reactAriaComponents.useSlottedContext)(TagGroupContext) ?? {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isInRealDOM && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " . _Zd qo _1c iG ibH jG jbH _zb ba",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                    values: [
                        [
                            (0, _content.TextContext),
                            {
                                styles: " . __A-3t1y __vb __wb _ma _pb"
                            }
                        ],
                        [
                            (0, _icon.IconContext),
                            {
                                render: (0, _centerBaseline.centerBaseline)({
                                    slot: 'icon',
                                    styles: " . __A-3t1x"
                                }),
                                styles: " . l-1sthc3k k-1sthc3k y-oelgqu _8-3t1x"
                            }
                        ],
                        [
                            (0, _avatar.AvatarContext),
                            {
                                size: avatarSize[size],
                                styles: " . __A-3t1x"
                            }
                        ],
                        [
                            (0, _image.ImageContext),
                            {
                                styles: " . l-1sthc3k k-1sthc3k _8-3t1x __A-3t1x _bb __Na _vb _wb _xb _yb"
                            }
                        ]
                    ],
                    children: children
                })
            }),
            !isInRealDOM && children,
            allowsRemoving && isInRealDOM && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearButton.ClearButton), {
                slot: "remove",
                size: size,
                isDisabled: isDisabled
            })
        ]
    });
}
try {
    // @ts-ignore
    TagGroupContext.displayName = "TagGroupContext";
    // @ts-ignore
    TagGroupContext.__docgenInfo = {
        "description": "",
        "displayName": "TagGroupContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<TagGroupProps<any>, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TagGroup.tsx#TagGroupContext"] = {
        docgenInfo: TagGroupContext.__docgenInfo,
        name: "TagGroupContext",
        path: "packages/@react-spectrum/s2/src/TagGroup.tsx#TagGroupContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _TagGroup.displayName = "_TagGroup";
    // @ts-ignore
    _TagGroup.__docgenInfo = {
        "description": "Tags allow users to categorize content. They can represent keywords or people, and are grouped to describe an item or a search request.",
        "displayName": "_TagGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The contents of the collection.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((item: T) => ReactNode)"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the tag group.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "groupActionLabel": {
                "defaultValue": null,
                "description": "The label to display on the action button.",
                "name": "groupActionLabel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the tags are displayed in an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the tags are displayed in a error state.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxRows": {
                "defaultValue": null,
                "description": "Limit the number of rows initially shown. This will render a button that allows the user to expand to show all tags.",
                "name": "maxRows",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "renderEmptyState": {
                "defaultValue": null,
                "description": "Provides content to display when there are no items in the tag group.",
                "name": "renderEmptyState",
                "required": false,
                "type": {
                    "name": "(() => ReactNode)"
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key> | \"all\""
                }
            },
            "selectionBehavior": {
                "defaultValue": null,
                "description": "How multiple selection should behave in the collection.",
                "name": "selectionBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"replace\""
                        },
                        {
                            "value": "\"toggle\""
                        }
                    ]
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "The type of selection that is allowed in the collection.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the tag group.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onGroupAction": {
                "defaultValue": null,
                "description": "Handler that is called when the action button is pressed.",
                "name": "onGroupAction",
                "required": false,
                "type": {
                    "name": "(() => void)"
                }
            },
            "onRemove": {
                "defaultValue": null,
                "description": "Handler that is called when a user deletes a tag.",
                "name": "onRemove",
                "required": false,
                "type": {
                    "name": "((keys: Set<Key>) => void)"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Selection) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TagGroup.tsx#_TagGroup"] = {
        docgenInfo: _TagGroup.__docgenInfo,
        name: "_TagGroup",
        path: "packages/@react-spectrum/s2/src/TagGroup.tsx#_TagGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"lHKb4","1":"8hPmY","2":"3CyIg","3":"fGHpy","4":"74Kxu","5":"hdmlA","6":"bi2tj","7":"fEWgI","8":"350wV","9":"z87AQ","10":"7HDvE","11":"9YQVV","12":"5eT0n","13":"aIC3p","14":"ilHSf","react/jsx-runtime":"2JzhG","./ActionButton":"hbuyN","../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg":"gH5vG","react-aria-components":"8nuKL","./Avatar":"3UH45","./CenterBaseline":"hXatv","./ClearButton":"ebNWz","@react-aria/collections":"1Wqew","react":"jEiK2","./Field":"9c1qW","react-dom":"a0ZmT","./Form":"gJckc","./Icon":"1OC2a","./Image":"l3wRP","../intl/*.json":"iU6xz","./pressScale":"6BiUY","./Content":"aBWEm","@react-spectrum/utils":"bebxO","@react-aria/utils":"e9Yvo","@react-aria/i18n":"hFrKJ","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"lHKb4":[function() {},{}],"8hPmY":[function() {},{}],"3CyIg":[function() {},{}],"fGHpy":[function() {},{}],"74Kxu":[function() {},{}],"hdmlA":[function() {},{}],"bi2tj":[function() {},{}],"fEWgI":[function() {},{}],"350wV":[function() {},{}],"z87AQ":[function() {},{}],"7HDvE":[function() {},{}],"9YQVV":[function() {},{}],"5eT0n":[function() {},{}],"aIC3p":[function() {},{}],"ilHSf":[function() {},{}],"7UnVx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextFieldContext", ()=>TextFieldContext);
parcelHelpers.export(exports, "TextField", ()=>_TextField);
parcelHelpers.export(exports, "TextAreaContext", ()=>TextAreaContext);
parcelHelpers.export(exports, "TextArea", ()=>_TextArea);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _field = require("./Field");
var _form = require("./Form");
var _utils1 = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const TextFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
function TextField(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TextFieldContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TextFieldBase, {
        ...props,
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {})
    });
}
/**
 * TextFields are text inputs that allow users to input custom text entries
 * with a keyboard. Various decorations can be displayed around the field to
 * communicate the entry requirements.
 */ let _TextField = /*#__PURE__*/ (0, _react.forwardRef)(TextField);
const TextAreaContext = /*#__PURE__*/ (0, _react.createContext)(null);
function TextArea(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TextAreaContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TextFieldBase, {
        ...props,
        ref: ref,
        fieldGroupCss: " . _1d ka",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TextAreaInput, {})
    });
}
/**
 * TextAreas are multiline text inputs, useful for cases where users have
 * a sizable amount of text to enter. They allow for all customizations that
 * are available to text fields.
 */ let _TextArea = /*#__PURE__*/ (0, _react.forwardRef)(TextArea);
function TextFieldBase(props, ref) {
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _react.useRef)(null);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { label, description, errorMessage, necessityIndicator, labelPosition = 'top', labelAlign = 'start', fieldGroupCss, UNSAFE_style, UNSAFE_className = '', ...textFieldProps } = props;
    // Expose imperative interface for ref
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TextField), {
        ...textFieldProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " .";
            let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
            rules += matches.join('');
            let $__a = false;
            let $__b = false;
            for (let p of matches){
                if (/^\s*__a/.test(p)) $__a = true;
                if (/^\s*__b/.test(p)) $__b = true;
            }
            rules += ' _Zf';
            if (!$__a) {
                if (props.isInForm) rules += ' __a-3t1y';
            }
            if (!$__b) {
                if (props.isInForm) {
                    if (props.labelPosition === "side") rules += ' __b-7u9dhl';
                }
            }
            if (props.isInForm) rules += ' __h-1cwd7ud';
            else {
                if (props.labelPosition === "side") rules += ' __h-jyg4vb';
                else if (props.labelPosition === "top") rules += ' __h-375yi6';
            }
            if (props.labelPosition === "side") rules += ' __i-jyg4vb';
            else if (props.labelPosition === "top") rules += ' __i-fdenls';
            if (props.labelPosition === "side") rules += ' __j-5eez8j';
            else if (props.labelPosition === "top") rules += ' __j-xlaqir';
            if (props.size === "XL") {
                rules += ' _dbj';
                rules += ' _di';
            } else if (props.size === "L") {
                rules += ' _dbh';
                rules += ' _dg';
            } else if (props.size === "S") {
                rules += ' _dbd';
                rules += ' _dc';
            } else if (props.size === "XS") {
                rules += ' _dbb';
                rules += ' _da';
            } else {
                rules += ' _dbf';
                rules += ' _de';
            }
            rules += ' _1d';
            rules += ' _f-1x99dlob';
            rules += ' _fa';
            if (props.size === "XL") rules += ' -aqrvqh_k-j';
            else if (props.size === "L") rules += ' -aqrvqh_k-i';
            else if (props.size === "S") rules += ' -aqrvqh_k-h';
            else if (props.size === "XS") rules += ' -aqrvqh_k-g';
            else rules += ' -aqrvqh_k-f';
            rules += ' -_1inj1bc_i--prjw07';
            rules += ' je';
            rules += ' __R-yksgrp';
            return rules;
        }({
            size: props.size,
            labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isDisabled, isInvalid })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: props.size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        role: "presentation",
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: props.size,
                        styles: fieldGroupCss,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.InputContext).Consumer, {
                                children: (ctx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.InputContext).Provider, {
                                        value: {
                                            ...ctx,
                                            ref: (0, _utils1.mergeRefs)(ctx?.ref, inputRef)
                                        },
                                        children: children
                                    })
                            }),
                            isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: props.size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        children: errorMessage
                    })
                ]
            }))
    });
}
let _TextFieldBase = /*#__PURE__*/ (0, _react.forwardRef)(TextFieldBase);
function TextAreaInput() {
    // Force re-render when value changes so we update the height.
    (0, _reactAriaComponents.useSlottedContext)((0, _reactAriaComponents.TextAreaContext));
    let onHeightChange = (input)=>{
        // TODO: only do this if an explicit height is not given?
        if (input) {
            let prevAlignment = input.style.alignSelf;
            let prevOverflow = input.style.overflow;
            // Firefox scroll position is lost when overflow: 'hidden' is applied so we skip applying it.
            // The measure/applied height is also incorrect/reset if we turn on and off
            // overflow: hidden in Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1787062
            let isFirefox = 'MozAppearance' in input.style;
            if (!isFirefox) input.style.overflow = 'hidden';
            input.style.alignSelf = 'start';
            input.style.height = 'auto';
            // offsetHeight - clientHeight accounts for the border/padding.
            input.style.height = `${input.scrollHeight + (input.offsetHeight - input.clientHeight)}px`;
            input.style.overflow = prevOverflow;
            input.style.alignSelf = prevAlignment;
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TextArea), {
        ref: onHeightChange,
        // Workaround for baseline alignment bug in Safari.
        // https://bugs.webkit.org/show_bug.cgi?id=142968
        placeholder: " ",
        className: function anonymous(props) {
            let rules = " .";
            rules += ' Ca';
            rules += ' Da';
            rules += ' E-1dbqcch';
            rules += ' F-1dbqcch';
            rules += ' o-375tou';
            rules += ' __na';
            rules += ' ba';
            rules += ' a-17zqamw';
            rules += ' _c-17zqamw';
            rules += ' _d-17zqamw';
            rules += ' _e-17zqamw';
            rules += ' _f-17zqamw';
            rules += ' _9-3t1y';
            rules += ' qo';
            rules += ' _La';
            rules += ' wf';
            rules += ' __Ia';
            rules += ' __vb';
            if (props.size === "XL") rules += ' -_375tou_o-j';
            else if (props.size === "L") rules += ' -_375tou_o-i';
            else if (props.size === "S") rules += ' -_375tou_o-h';
            else if (props.size === "XS") rules += ' -_375tou_o-g';
            else rules += ' -_375tou_o-f';
            return rules;
        }
    });
}
try {
    // @ts-ignore
    TextFieldContext.displayName = "TextFieldContext";
    // @ts-ignore
    TextFieldContext.__docgenInfo = {
        "description": "",
        "displayName": "TextFieldContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<TextFieldProps, TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TextField.tsx#TextFieldContext"] = {
        docgenInfo: TextFieldContext.__docgenInfo,
        name: "TextFieldContext",
        path: "packages/@react-spectrum/s2/src/TextField.tsx#TextFieldContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _TextField.displayName = "_TextField";
    // @ts-ignore
    _TextField.__docgenInfo = {
        "description": "TextFields are text inputs that allow users to input custom text entries\nwith a keyboard. Various decorations can be displayed around the field to\ncommunicate the entry requirements.",
        "displayName": "_TextField",
        "props": {
            "autoComplete": {
                "defaultValue": null,
                "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
                "name": "autoComplete",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inputMode": {
                "defaultValue": null,
                "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
                "name": "inputMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"decimal\""
                        },
                        {
                            "value": "\"text\""
                        },
                        {
                            "value": "\"url\""
                        },
                        {
                            "value": "\"tel\""
                        },
                        {
                            "value": "\"email\""
                        },
                        {
                            "value": "\"numeric\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxLength": {
                "defaultValue": null,
                "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
                "name": "maxLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minLength": {
                "defaultValue": null,
                "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
                "name": "minLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "pattern": {
                "defaultValue": null,
                "description": "Regex pattern that the value of the input must match to be valid. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefpattern).",
                "name": "pattern",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the text field.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "type": {
                "defaultValue": null,
                "description": "The type of input to render. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdeftype).",
                "name": "type",
                "required": false,
                "type": {
                    "name": "\"search\" | \"text\" | (string & {}) | \"url\" | \"tel\" | \"email\" | \"password\""
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: string) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: string) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<TextFieldRef<HTMLInputElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TextField.tsx#_TextField"] = {
        docgenInfo: _TextField.__docgenInfo,
        name: "_TextField",
        path: "packages/@react-spectrum/s2/src/TextField.tsx#_TextField"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    TextAreaContext.displayName = "TextAreaContext";
    // @ts-ignore
    TextAreaContext.__docgenInfo = {
        "description": "",
        "displayName": "TextAreaContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<TextAreaProps, TextFieldRef<HTMLTextAreaElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TextField.tsx#TextAreaContext"] = {
        docgenInfo: TextAreaContext.__docgenInfo,
        name: "TextAreaContext",
        path: "packages/@react-spectrum/s2/src/TextField.tsx#TextAreaContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _TextArea.displayName = "_TextArea";
    // @ts-ignore
    _TextArea.__docgenInfo = {
        "description": "TextAreas are multiline text inputs, useful for cases where users have\na sizable amount of text to enter. They allow for all customizations that\nare available to text fields.",
        "displayName": "_TextArea",
        "props": {
            "autoComplete": {
                "defaultValue": null,
                "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
                "name": "autoComplete",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "errorMessage": {
                "defaultValue": null,
                "description": "An error message for the field.",
                "name": "errorMessage",
                "required": false,
                "type": {
                    "name": "ReactNode | ((v: ValidationResult) => ReactNode)"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inputMode": {
                "defaultValue": null,
                "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
                "name": "inputMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"decimal\""
                        },
                        {
                            "value": "\"text\""
                        },
                        {
                            "value": "\"url\""
                        },
                        {
                            "value": "\"tel\""
                        },
                        {
                            "value": "\"email\""
                        },
                        {
                            "value": "\"numeric\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxLength": {
                "defaultValue": null,
                "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
                "name": "maxLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minLength": {
                "defaultValue": null,
                "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
                "name": "minLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the text field.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "((value: string) => true | ValidationError | null)"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((value: string) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<TextFieldRef<HTMLTextAreaElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/TextField.tsx#_TextArea"] = {
        docgenInfo: _TextArea.__docgenInfo,
        name: "_TextArea",
        path: "packages/@react-spectrum/s2/src/TextField.tsx#_TextArea"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"98HCm","1":"8dmA9","2":"ecYBI","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","react":"jEiK2","@react-spectrum/utils":"bebxO","./Field":"9c1qW","./Form":"gJckc","@react-aria/utils":"e9Yvo","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"98HCm":[function() {},{}],"8dmA9":[function() {},{}],"ecYBI":[function() {},{}],"adJsp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleButtonContext", ()=>ToggleButtonContext);
parcelHelpers.export(exports, "ToggleButton", ()=>_ToggleButton);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _centerBaseline = require("./CenterBaseline");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _icon = require("./Icon");
var _pressScale = require("./pressScale");
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _toggleButtonGroup = require("./ToggleButtonGroup");
var _utils = require("@react-spectrum/utils");
var _form = require("./Form");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ToggleButtonContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ToggleButton(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ToggleButtonContext);
    props = (0, _form.useFormProps)(props);
    let domRef = (0, _utils.useFocusableRef)(ref);
    let ctx = (0, _reactAriaComponents.useSlottedContext)((0, _toggleButtonGroup.ToggleButtonGroupContext));
    let isInGroup = !!ctx;
    let { density = 'regular', isJustified, orientation = 'horizontal', staticColor = props.staticColor, isQuiet = props.isQuiet, isEmphasized = props.isEmphasized, size = props.size || 'M', isDisabled = props.isDisabled } = ctx || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ToggleButton), {
        ...props,
        isDisabled: isDisabled,
        ref: domRef,
        style: (0, _pressScale.pressScale)(domRef, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + (0, _actionButton.btnStyles)({
                ...renderProps,
                staticColor,
                size,
                isQuiet,
                isEmphasized,
                isPending: false,
                density,
                isJustified,
                orientation,
                isInGroup
            }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _skeleton.SkeletonContext),
                    null
                ],
                [
                    (0, _content.TextContext),
                    {
                        styles: " . E-1gogtue F-1gogtue __A-3t1y __vb __wb _ma _pb"
                    }
                ],
                [
                    (0, _icon.IconContext),
                    {
                        render: (0, _centerBaseline.centerBaseline)({
                            slot: 'icon',
                            styles: " . __A-3t1x"
                        }),
                        styles: " . l-1sthc3k k-1sthc3k y-oelgqu _8-3t1x"
                    }
                ]
            ],
            children: typeof props.children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                children: props.children
            }) : props.children
        })
    });
}
/**
 * ToggleButtons allow users to toggle a selection on or off, for example
 * switching between two states or modes.
 */ let _ToggleButton = /*#__PURE__*/ (0, _react.forwardRef)(ToggleButton);
try {
    // @ts-ignore
    ToggleButtonContext.displayName = "ToggleButtonContext";
    // @ts-ignore
    ToggleButtonContext.__docgenInfo = {
        "description": "",
        "displayName": "ToggleButtonContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ToggleButtonProps, FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ToggleButton.tsx#ToggleButtonContext"] = {
        docgenInfo: ToggleButtonContext.__docgenInfo,
        name: "ToggleButtonContext",
        path: "packages/@react-spectrum/s2/src/ToggleButton.tsx#ToggleButtonContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ToggleButton.displayName = "_ToggleButton";
    // @ts-ignore
    _ToggleButton.__docgenInfo = {
        "description": "ToggleButtons allow users to toggle a selection on or off, for example\nswitching between two states or modes.",
        "displayName": "_ToggleButton",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The content to display in the button.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelected": {
                "defaultValue": null,
                "description": "Whether the element should be selected (uncontrolled).",
                "name": "defaultSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the button is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isSelected": {
                "defaultValue": null,
                "description": "Whether the element should be selected (controlled).",
                "name": "isSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "preventFocusOnPress": {
                "defaultValue": null,
                "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
                "name": "preventFocusOnPress",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ActionButton.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        },
                        {
                            "value": "\"XS\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the ActionButton appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"white\""
                        },
                        {
                            "value": "\"black\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "type": {
                "defaultValue": {
                    value: "'button'"
                },
                "description": "The behavior of the button when used in an HTML form.",
                "name": "type",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"button\""
                        },
                        {
                            "value": "\"submit\""
                        },
                        {
                            "value": "\"reset\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the element's selection state changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "((isSelected: boolean) => void)"
                }
            },
            "onPress": {
                "defaultValue": null,
                "description": "Handler that is called when the press is released over the target.",
                "name": "onPress",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressChange": {
                "defaultValue": null,
                "description": "Handler that is called when the press state changes.",
                "name": "onPressChange",
                "required": false,
                "type": {
                    "name": "((isPressed: boolean) => void)"
                }
            },
            "onPressEnd": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
                "name": "onPressEnd",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressStart": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction starts.",
                "name": "onPressStart",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "onPressUp": {
                "defaultValue": null,
                "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
                "name": "onPressUp",
                "required": false,
                "type": {
                    "name": "((e: PressEvent) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ToggleButton.tsx#_ToggleButton"] = {
        docgenInfo: _ToggleButton.__docgenInfo,
        name: "_ToggleButton",
        path: "packages/@react-spectrum/s2/src/ToggleButton.tsx#_ToggleButton"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"2xepu","1":"7SJHC","2":"3UfK9","react/jsx-runtime":"2JzhG","./ActionButton":"hbuyN","./CenterBaseline":"hXatv","react-aria-components":"8nuKL","react":"jEiK2","./Icon":"1OC2a","./pressScale":"6BiUY","./Skeleton":"2hWWB","./Content":"aBWEm","./ToggleButtonGroup":"7HzpN","@react-spectrum/utils":"bebxO","./Form":"gJckc","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"2xepu":[function() {},{}],"7SJHC":[function() {},{}],"3UfK9":[function() {},{}],"7HzpN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleButtonGroupContext", ()=>ToggleButtonGroupContext);
parcelHelpers.export(exports, "ToggleButtonGroup", ()=>_ToggleButtonGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButtonGroup = require("./ActionButtonGroup");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ToggleButtonGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ToggleButtonGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ToggleButtonGroupContext);
    let { density = 'regular', size = 'M', orientation = 'horizontal', isJustified, children, UNSAFE_className = '', UNSAFE_style, styles } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ToggleButtonGroup), {
        ...props,
        ref: ref,
        style: UNSAFE_style,
        className: UNSAFE_className + (0, _actionButtonGroup.actionGroupStyle)({
            size,
            density,
            orientation,
            isJustified
        }, styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToggleButtonGroupContext.Provider, {
            value: props,
            children: children
        })
    });
}
/**
 * A ToggleButtonGroup is a grouping of related ToggleButtons, with single or multiple selection.
 */ const _ToggleButtonGroup = /*#__PURE__*/ (0, _react.forwardRef)(ToggleButtonGroup);
try {
    // @ts-ignore
    ToggleButtonGroupContext.displayName = "ToggleButtonGroupContext";
    // @ts-ignore
    ToggleButtonGroupContext.__docgenInfo = {
        "description": "",
        "displayName": "ToggleButtonGroupContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ToggleButtonGroupProps, HTMLDivElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ToggleButtonGroup.tsx#ToggleButtonGroupContext"] = {
        docgenInfo: ToggleButtonGroupContext.__docgenInfo,
        name: "ToggleButtonGroupContext",
        path: "packages/@react-spectrum/s2/src/ToggleButtonGroup.tsx#ToggleButtonGroupContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ToggleButtonGroup.displayName = "_ToggleButtonGroup";
    // @ts-ignore
    _ToggleButtonGroup.__docgenInfo = {
        "description": "A ToggleButtonGroup is a grouping of related ToggleButtons, with single or multiple selection.",
        "displayName": "_ToggleButtonGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the group.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelectedKeys": {
                "defaultValue": null,
                "description": "The initial selected keys in the collection (uncontrolled).",
                "name": "defaultSelectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "density": {
                "defaultValue": {
                    value: "\"regular\""
                },
                "description": "Spacing between the buttons.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        }
                    ]
                }
            },
            "disallowEmptySelection": {
                "defaultValue": null,
                "description": "Whether the collection allows empty selection.",
                "name": "disallowEmptySelection",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the group is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isJustified": {
                "defaultValue": null,
                "description": "Whether the buttons should divide the container width equally.",
                "name": "isJustified",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'horizontal'"
                },
                "description": "The axis the group should align with.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"vertical\""
                        },
                        {
                            "value": "\"horizontal\""
                        }
                    ]
                }
            },
            "selectedKeys": {
                "defaultValue": null,
                "description": "The currently selected keys in the collection (controlled).",
                "name": "selectedKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "selectionMode": {
                "defaultValue": null,
                "description": "Whether single or multiple selection is enabled.",
                "name": "selectionMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"single\""
                        },
                        {
                            "value": "\"multiple\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "\"M\""
                },
                "description": "Size of the buttons.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        },
                        {
                            "value": "\"XS\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"white\""
                        },
                        {
                            "value": "\"black\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((keys: Set<Key>) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<HTMLDivElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ToggleButtonGroup.tsx#_ToggleButtonGroup"] = {
        docgenInfo: _ToggleButtonGroup.__docgenInfo,
        name: "_ToggleButtonGroup",
        path: "packages/@react-spectrum/s2/src/ToggleButtonGroup.tsx#_ToggleButtonGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"react/jsx-runtime":"2JzhG","./ActionButtonGroup":"7E1Ly","react-aria-components":"8nuKL","react":"jEiK2","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"cWXZX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * TooltipTrigger wraps around a trigger element and a Tooltip. It handles opening and closing
 * the Tooltip when the user hovers over or focuses the trigger, and positioning the Tooltip
 * relative to the trigger.
 */ parcelHelpers.export(exports, "TooltipTrigger", ()=>TooltipTrigger);
parcelHelpers.export(exports, "Tooltip", ()=>_Tooltip);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "CombinedTooltip", ()=>CombinedTooltip);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _provider = require("./Provider");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
const slide = "-d5xa23";
const tooltip = function anonymous(props) {
    let rules = " .";
    if (props.colorScheme === "dark") rules += ' _Ab';
    else if (props.colorScheme === "light") rules += ' _Aa';
    else if (props.colorScheme === "light dark") rules += ' _Ac';
    else rules += ' _A-10jn6wd';
    rules += ' _2d';
    rules += ' _1c';
    rules += ' r__Z';
    rules += ' o-375tou';
    rules += ' __na';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    rules += ' _dbd';
    rules += ' _dc';
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    rules += ' aa_____x';
    rules += ' ad';
    rules += ' u-375tp0';
    rules += ' v-375tp1';
    rules += ' sab';
    rules += ' tab';
    rules += ' waa';
    rules += ' caa';
    if (props.isPressed) rules += ' bo';
    else if (props.isFocusVisible) rules += ' bo';
    else if (props.isHovered) rules += ' bo';
    else rules += ' bn';
    rules += ' _vh';
    rules += ' _wh';
    rules += ' _xh';
    rules += ' _yh';
    rules += ' CI';
    rules += ' DI';
    rules += ' E-1dbqcch';
    rules += ' F-1dbqcch';
    rules += ' Ad';
    rules += ' Bd';
    rules += ' yd';
    rules += ' zd';
    if (props.isExiting) rules += ' _S-xkqmqx';
    else if (props.isEntering) rules += ' _S-xkqmqx';
    if (props.isExiting) rules += ' _T-375xx3';
    else if (props.isEntering) rules += ' _T-375xx3';
    if (props.isExiting) rules += ' _Yc';
    if (props.isExiting) rules += ' _Vb';
    else if (props.isEntering) rules += ' _Va';
    if (props.placement === "right") rules += ' -s75z33_A-K';
    else if (props.placement === "left") rules += ' -s75z33_A-c';
    else if (props.placement === "bottom") rules += ' -s75z33_A-a';
    else if (props.placement === "top") rules += ' -s75z33_A-a';
    if (props.placement === "right") rules += ' -s75z34_A-a';
    else if (props.placement === "left") rules += ' -s75z34_A-a';
    else if (props.placement === "bottom") rules += ' -s75z34_A-K';
    else if (props.placement === "top") rules += ' -s75z34_A-c';
    rules += ' -_375tou_o-M';
    rules += ' -_375tp0_u-ab';
    rules += ' -_375tp1_v-ab';
    return rules;
};
const arrowStyles = function anonymous(props) {
    let rules = " .";
    rules += ' _Za';
    rules += ' eL';
    if (props.placement === "right") rules += ' R-3d7kri';
    else if (props.placement === "left") rules += ' R-wggzbf';
    else if (props.placement === "bottom") rules += ' R-z0ysi6';
    else if (props.placement === "top") rules += ' R-3t1x';
    if (props.placement === "right") rules += ' P-375y1d';
    else if (props.placement === "left") rules += ' P-yj88ji';
    return rules;
};
let InternalTooltipTriggerContext = /*#__PURE__*/ (0, _react.createContext)({});
function Tooltip(props, ref) {
    let { children, UNSAFE_style, UNSAFE_className = '' } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let { containerPadding, crossOffset, offset, placement = 'top', shouldFlip } = (0, _react.useContext)(InternalTooltipTriggerContext);
    let colorScheme = (0, _react.useContext)((0, _provider.ColorSchemeContext));
    let { locale, direction } = (0, _reactAriaComponents.useLocale)();
    let [borderRadius, setBorderRadius] = (0, _react.useState)(0);
    // TODO: should we pass through lang and dir props in RAC?
    let tooltipRef = (0, _react.useCallback)((el)=>{
        domRef.current = el;
        if (el) {
            el.lang = locale;
            el.dir = direction;
            let spectrumBorderRadius = window.getComputedStyle(el).borderRadius;
            if (spectrumBorderRadius !== '') setBorderRadius(parseInt(spectrumBorderRadius, 10));
        }
    }, [
        locale,
        direction,
        domRef
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tooltip), {
        ...props,
        arrowBoundaryOffset: borderRadius,
        containerPadding: containerPadding,
        crossOffset: crossOffset,
        offset: offset,
        placement: placement,
        shouldFlip: shouldFlip,
        ref: tooltipRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + tooltip({
                ...renderProps,
                colorScheme
            }),
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayArrow), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            className: arrowStyles(renderProps),
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "10",
                            height: "5",
                            viewBox: "0 0 10 5",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M4.29289 4.29289L0 0H10L5.70711 4.29289C5.31658 4.68342 4.68342 4.68342 4.29289 4.29289Z"
                            })
                        })
                    }),
                    children
                ]
            })
    });
}
function TooltipTrigger(props) {
    let { containerPadding, crossOffset, offset, placement, shouldFlip, ...triggerProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TooltipTrigger), {
        ...triggerProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalTooltipTriggerContext.Provider, {
            value: {
                containerPadding: containerPadding,
                crossOffset: crossOffset,
                offset: offset,
                placement: placement,
                shouldFlip: shouldFlip
            },
            children: props.children
        })
    });
}
/**
 * Display container for Tooltip content. Has a directional arrow dependent on its placement.
 */ let _Tooltip = /*#__PURE__*/ (0, _react.forwardRef)(Tooltip);
function CombinedTooltip(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {});
}
try {
    // @ts-ignore
    TooltipTrigger.displayName = "TooltipTrigger";
    // @ts-ignore
    TooltipTrigger.__docgenInfo = {
        "description": "TooltipTrigger wraps around a trigger element and a Tooltip. It handles opening and closing\nthe Tooltip when the user hovers over or focuses the trigger, and positioning the Tooltip\nrelative to the trigger.",
        "displayName": "TooltipTrigger",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content of the tooltip.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "containerPadding": {
                "defaultValue": {
                    value: "12"
                },
                "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
                "name": "containerPadding",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "crossOffset": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
                "name": "crossOffset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "delay": {
                "defaultValue": {
                    value: "1500"
                },
                "description": "The delay time for the tooltip to show up. [See guidelines](https://spectrum.adobe.com/page/tooltip/#Immediate-or-delayed-appearance).",
                "name": "delay",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the tooltip should be disabled, independent from the trigger.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "offset": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
                "name": "offset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "placement": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The placement of the element with respect to its anchor element.",
                "name": "placement",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        }
                    ]
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "trigger": {
                "defaultValue": null,
                "description": "By default, opens for both focus and hover. Can be made to open only for focus.",
                "name": "trigger",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"focus\""
                        }
                    ]
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean) => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Tooltip.tsx#TooltipTrigger"] = {
        docgenInfo: TooltipTrigger.__docgenInfo,
        name: "TooltipTrigger",
        path: "packages/@react-spectrum/s2/src/Tooltip.tsx#TooltipTrigger"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    CombinedTooltip.displayName = "CombinedTooltip";
    // @ts-ignore
    CombinedTooltip.__docgenInfo = {
        "description": "",
        "displayName": "CombinedTooltip",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content of the tooltip.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "containerPadding": {
                "defaultValue": {
                    value: "12"
                },
                "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
                "name": "containerPadding",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "crossOffset": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
                "name": "crossOffset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "delay": {
                "defaultValue": {
                    value: "1500"
                },
                "description": "The delay time for the tooltip to show up. [See guidelines](https://spectrum.adobe.com/page/tooltip/#Immediate-or-delayed-appearance).",
                "name": "delay",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the tooltip should be disabled, independent from the trigger.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "offset": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
                "name": "offset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "placement": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The placement of the element with respect to its anchor element.",
                "name": "placement",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        }
                    ]
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "trigger": {
                "defaultValue": null,
                "description": "By default, opens for both focus and hover. Can be made to open only for focus.",
                "name": "trigger",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"focus\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "((isOpen: boolean) => void)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Tooltip.tsx#CombinedTooltip"] = {
        docgenInfo: CombinedTooltip.__docgenInfo,
        name: "CombinedTooltip",
        path: "packages/@react-spectrum/s2/src/Tooltip.tsx#CombinedTooltip"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Tooltip.displayName = "_Tooltip";
    // @ts-ignore
    _Tooltip.__docgenInfo = {
        "description": "Display container for Tooltip content. Has a directional arrow dependent on its placement.",
        "displayName": "_Tooltip",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content of the tooltip.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Tooltip.tsx#_Tooltip"] = {
        docgenInfo: _Tooltip.__docgenInfo,
        name: "_Tooltip",
        path: "packages/@react-spectrum/s2/src/Tooltip.tsx#_Tooltip"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"coGX8","1":"fgcmP","2":"aLeKV","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./Provider":"hIsCH","react":"jEiK2","@react-spectrum/utils":"bebxO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"coGX8":[function() {},{}],"fgcmP":[function() {},{}],"aLeKV":[function() {},{}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=Illustrations.87851465.js.map
